import logo from './logo.svg';
import './App.css';

import { ForceGraph3D } from 'react-force-graph';
import SpriteText from 'three-spritetext';

let myData = {
    "nodes": [
        {
            "id": "joe_rogan",
            "name": "joe rogan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "aaron_rodgers",
            "name": "aaron rodgers",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "abby_martin",
            "name": "abby martin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "abigail_shrier",
            "name": "abigail shrier",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "action_bronson",
            "name": "action bronson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_alter",
            "name": "adam alter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_carolla",
            "name": "adam carolla",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "adam_conover",
            "name": "adam conover",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_cropp",
            "name": "adam cropp",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_curry",
            "name": "adam curry",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_duritz",
            "name": "adam duritz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_eget",
            "name": "adam eget",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "adam_frank",
            "name": "adam frank",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_greentree",
            "name": "adam greentree",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_kokesh",
            "name": "adam kokesh",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_lowery",
            "name": "adam lowery",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_perry_lang",
            "name": "adam perry lang",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adam_scorgie",
            "name": "adam scorgie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "adrienne_iapalucci",
            "name": "adrienne iapalucci",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "akaash_singh",
            "name": "akaash singh",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "al_madrigal",
            "name": "al madrigal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alan_levinovitz",
            "name": "alan levinovitz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alex_berenson",
            "name": "alex berenson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "alex_grey",
            "name": "alex grey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alex_honnold",
            "name": "alex honnold",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alex_jones",
            "name": "alex jones",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "alex_ross",
            "name": "alex ross",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alex_winter",
            "name": "alex winter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alexander_gustafsson",
            "name": "alexander gustafsson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alexander_volkanovski",
            "name": "alexander volkanovski",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alexis_ohanian",
            "name": "alexis ohanian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ali_macofsky",
            "name": "ali macofsky",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ali_rizvi",
            "name": "ali rizvi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ali_siddiq",
            "name": "ali siddiq",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "alison_rosen",
            "name": "alison rosen",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "aljamain_sterling",
            "name": "aljamain sterling",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "alonzo_bodden",
            "name": "alonzo bodden",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "amanda_feilding",
            "name": "amanda feilding",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "amanda_knox",
            "name": "amanda knox",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "amber_lyon",
            "name": "amber lyon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "amishi_jha",
            "name": "amishi jha",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "amy_alkon",
            "name": "amy alkon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "amy_schumer",
            "name": "amy schumer",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ana_kasparian",
            "name": "ana kasparian",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "andre_ward",
            "name": "andre ward",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andreas_antonopoulos",
            "name": "andreas antonopoulos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_dessler",
            "name": "andrew dessler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_dice_clay",
            "name": "andrew dice clay",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_doyle",
            "name": "andrew doyle",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "andrew_hill",
            "name": "andrew hill",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_huberman",
            "name": "andrew huberman",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "andrew_marr",
            "name": "andrew marr",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_santino",
            "name": "andrew santino",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "andrew_schulz",
            "name": "andrew schulz",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "andrew_tate",
            "name": "andrew tate",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "andrew_yang",
            "name": "andrew yang",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "andy_ngo",
            "name": "andy ngo",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "andy_norman",
            "name": "andy norman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andy_ruiz",
            "name": "andy ruiz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andy_stumpf",
            "name": "andy stumpf",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "angela_hill",
            "name": "angela hill",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "anna_lembke",
            "name": "anna lembke",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "annie_jacobsen",
            "name": "annie jacobsen",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "annie_lederman",
            "name": "annie lederman",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "anthony_bourdain",
            "name": "anthony bourdain",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "anthony_cumia",
            "name": "anthony cumia",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "anthony_jeselnik",
            "name": "anthony jeselnik",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "anthony_kiedis",
            "name": "anthony kiedis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "antonio_garcia_martinez",
            "name": "antonio garcia martinez",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ari_shaffir",
            "name": "ari shaffir",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "arian_foster",
            "name": "arian foster",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "aron_snyder",
            "name": "aron snyder",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "artie_lange",
            "name": "artie lange",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ash_dykes",
            "name": "ash dykes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "aubrey_de_grey",
            "name": "aubrey de grey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "aubrey_marcus",
            "name": "aubrey marcus",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "avi_loeb",
            "name": "avi loeb",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ayaan_hirsi_ali",
            "name": "ayaan hirsi ali",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "aza_raskin",
            "name": "aza raskin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "b-real",
            "name": "b-real",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "banachek",
            "name": "banachek",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "barbara_freese",
            "name": "barbara freese",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bari_weiss",
            "name": "bari weiss",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "barry_crimmins",
            "name": "barry crimmins",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bartow_elmore",
            "name": "bartow elmore",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bas_rutten",
            "name": "bas rutten",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "beeple",
            "name": "beeple",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "belal_muhammad",
            "name": "belal muhammad",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_affleck",
            "name": "ben affleck",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ben_anderson",
            "name": "ben anderson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_askren",
            "name": "ben askren",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ben_burgis",
            "name": "ben burgis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_greenfield",
            "name": "ben greenfield",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_hoffman",
            "name": "ben hoffman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_o\u2019brien",
            "name": "ben o\u2019brien",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_patrick",
            "name": "ben patrick",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_shapiro",
            "name": "ben shapiro",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ben_van_kerkwyk",
            "name": "ben van kerkwyk",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_westhoff",
            "name": "ben westhoff",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bernard_hopkins",
            "name": "bernard hopkins",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bernie_sanders",
            "name": "bernie sanders",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bert_kreischer",
            "name": "bert kreischer",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "big_jay_oakerson",
            "name": "big jay oakerson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "big_john_mccarthy",
            "name": "big john mccarthy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bill_burr",
            "name": "bill burr",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bill_hader",
            "name": "bill hader",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bill_maher",
            "name": "bill maher",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bill_ottman",
            "name": "bill ottman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "billy_corben",
            "name": "billy corben",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "billy_corgan",
            "name": "billy corgan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bj_penn",
            "name": "bj penn",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bj\u00f8rn_lomborg",
            "name": "bj\u00f8rn lomborg",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "blaire_white",
            "name": "blaire white",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bo_burnham",
            "name": "bo burnham",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bo_nickal",
            "name": "bo nickal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bob_lazar",
            "name": "bob lazar",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bob_odenkirk",
            "name": "bob odenkirk",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bob_saget",
            "name": "bob saget",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bobby_azarian",
            "name": "bobby azarian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bobby_green",
            "name": "bobby green",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bobcat_goldthwait",
            "name": "bobcat goldthwait",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "boyan_slat",
            "name": "boyan slat",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brad_williams",
            "name": "brad williams",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brendan_burns",
            "name": "brendan burns",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brendan_schaub,),bret_weinstein",
            "name": "brendan schaub,),bret weinstein",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brian_cox",
            "name": "brian cox",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brian_dunning",
            "name": "brian dunning",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brian_grazer",
            "name": "brian grazer",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brian_greene",
            "name": "brian greene",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "brian_keating",
            "name": "brian keating",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "brian_moses",
            "name": "brian moses",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brian_muraresku",
            "name": "brian muraresku",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "brian_redban",
            "name": "brian redban",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brian_regan",
            "name": "brian regan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brian_simpson",
            "name": "brian simpson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brian_stann",
            "name": "brian stann",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bridget_phetasy",
            "name": "bridget phetasy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brigham_buhler",
            "name": "brigham buhler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brock_lesnar",
            "name": "brock lesnar",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "brody_stevens",
            "name": "brody stevens",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bruce_bryan",
            "name": "bruce bryan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bruce_damer",
            "name": "bruce damer",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bryan_callen",
            "name": "bryan callen",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "bryan_fogel",
            "name": "bryan fogel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bryan_richards",
            "name": "bryan richards",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "buck_angel",
            "name": "buck angel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "bud_brutsman",
            "name": "bud brutsman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "byron_bowers",
            "name": "byron bowers",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "c.k._chin",
            "name": "c.k. chin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "c.t._fletcher",
            "name": "c.t. fletcher",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cameron_hanes",
            "name": "cameron hanes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "campbell_mclaren",
            "name": "campbell mclaren",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "candice_thompson",
            "name": "candice thompson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cara_santa_maria",
            "name": "cara santa maria",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "carlos_condit",
            "name": "carlos condit",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "carole_hooven",
            "name": "carole hooven",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "carrot_top",
            "name": "carrot top",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cat_zingano",
            "name": "cat zingano",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ceara_lynch",
            "name": "ceara lynch",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cedric_doumbe",
            "name": "cedric doumbe",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cenk_uygur",
            "name": "cenk uygur",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chad_mendes",
            "name": "chad mendes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chad_stahelski",
            "name": "chad stahelski",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chael_sonnen",
            "name": "chael sonnen",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charlamagne_tha_god",
            "name": "charlamagne tha god",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charles_c._johnson",
            "name": "charles c. johnson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charles_wesley_godwin",
            "name": "charles wesley godwin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charlie_murphy",
            "name": "charlie murphy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charlie_walker",
            "name": "charlie walker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "charlize_theron",
            "name": "charlize theron",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chino_xl",
            "name": "chino xl",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_bell",
            "name": "chris bell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_best",
            "name": "chris best",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_cage",
            "name": "chris cage",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_d\u2019elia",
            "name": "chris d\u2019elia",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_distefano",
            "name": "chris distefano",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "chris_harris",
            "name": "chris harris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_kresser",
            "name": "chris kresser",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_martin",
            "name": "chris martin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_palmquist",
            "name": "chris palmquist",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_rock",
            "name": "chris rock",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_stapleton",
            "name": "chris stapleton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chris_williamson",
            "name": "chris williamson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "christina_pazsitzky",
            "name": "christina pazsitzky",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "christina_sommers",
            "name": "christina sommers",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "christine_hassler",
            "name": "christine hassler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "christopher_mellon",
            "name": "christopher mellon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "christopher_nolan",
            "name": "christopher nolan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "christopher_ryan",
            "name": "christopher ryan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "chuck_palahniuk",
            "name": "chuck palahniuk",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "cj_werleman",
            "name": "cj werleman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "claressa_shields",
            "name": "claressa shields",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "clay_newcomb",
            "name": "clay newcomb",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cliff_gray",
            "name": "cliff gray",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cliffy_b",
            "name": "cliffy b",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "clint_wattenberg",
            "name": "clint wattenberg",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cmdr._chris_hadfield",
            "name": "cmdr. chris hadfield",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cody_garbrandt",
            "name": "cody garbrandt",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "coffeezilla",
            "name": "coffeezilla",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "colby_brock",
            "name": "colby brock",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "coleman_hughes",
            "name": "coleman hughes",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "colin_moriarty",
            "name": "colin moriarty",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "colin_o'brady",
            "name": "colin o'brady",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "colin_quinn",
            "name": "colin quinn",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "colin_wright",
            "name": "colin wright",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "colion_noir",
            "name": "colion noir",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "conan_o'brien",
            "name": "conan o'brien",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "conor_mcgregor",
            "name": "conor mcgregor",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "corey_anderson",
            "name": "corey anderson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "corey_knowlton",
            "name": "corey knowlton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "corinne_fisher",
            "name": "corinne fisher",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cory_sandhagen",
            "name": "cory sandhagen",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "courtney_dauwalter",
            "name": "courtney dauwalter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "craig_jones",
            "name": "craig jones",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "craig_susser",
            "name": "craig susser",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "crash_from_float_lab",
            "name": "crash from float lab",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "cullen_hoback",
            "name": "cullen hoback",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dakota_meyer",
            "name": "dakota meyer",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dale_brisby",
            "name": "dale brisby",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dale_earnhardt_jr.",
            "name": "dale earnhardt jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_auerbach",
            "name": "dan auerbach",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_aykroyd",
            "name": "dan aykroyd",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_bilzerian",
            "name": "dan bilzerian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_carlin",
            "name": "dan carlin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dan_crenshaw",
            "name": "dan crenshaw",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "dan_doty",
            "name": "dan doty",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_flores",
            "name": "dan flores",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_gable",
            "name": "dan gable",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dan_hardy",
            "name": "dan hardy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_harris",
            "name": "dan harris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_henderson",
            "name": "dan henderson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_pe\u00f1a",
            "name": "dan pe\u00f1a",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dan_savage",
            "name": "dan savage",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dan_soder",
            "name": "dan soder",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "danica_patrick",
            "name": "danica patrick",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "daniel_cormier",
            "name": "daniel cormier",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "daniel_holzman",
            "name": "daniel holzman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "daniel_schmachtenberger",
            "name": "daniel schmachtenberger",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "daniel_straus",
            "name": "daniel straus",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "daniele_bolelli",
            "name": "daniele bolelli",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "danny_brown",
            "name": "danny brown",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "danny_philippou",
            "name": "danny philippou",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "daryl_davis",
            "name": "daryl davis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dave_asprey",
            "name": "dave asprey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dave_attell",
            "name": "dave attell",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "dave_chappelle",
            "name": "dave chappelle",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dave_foley",
            "name": "dave foley",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "dave_grohl",
            "name": "dave grohl",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dave_leduc",
            "name": "dave leduc",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dave_mustaine",
            "name": "dave mustaine",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dave_portnoy",
            "name": "dave portnoy",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dave_rubin",
            "name": "dave rubin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dave_smith",
            "name": "dave smith",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david_beckham",
            "name": "david beckham",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_blaine",
            "name": "david blaine",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_buss",
            "name": "david buss",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_choe",
            "name": "david choe",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_cross",
            "name": "david cross",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david_fravor",
            "name": "david fravor",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_goggins",
            "name": "david goggins",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_grusch",
            "name": "david grusch",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "david_holthouse",
            "name": "david holthouse",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_lee_roth",
            "name": "david lee roth",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_mamet",
            "name": "david mamet",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_mcmillan",
            "name": "david mcmillan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_pakman",
            "name": "david pakman",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_seaman",
            "name": "david seaman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "david_sinclair",
            "name": "david sinclair",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_spade",
            "name": "david spade",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "david_wallace-wells",
            "name": "david wallace-wells",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dean_delray",
            "name": "dean delray",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "demetrious_johnson",
            "name": "demetrious johnson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "demi_lovato",
            "name": "demi lovato",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dennis_mckenna",
            "name": "dennis mckenna",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "deontay_wilder",
            "name": "deontay wilder",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "derek_from_more_plates_more_dates",
            "name": "derek from more plates more dates",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "derek_wolfe",
            "name": "derek wolfe",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "derren_brown",
            "name": "derren brown",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "derrick_hamilton",
            "name": "derrick hamilton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "derrick_lewis",
            "name": "derrick lewis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "diamond_dallas_page",
            "name": "diamond dallas page",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "diana_rodgers",
            "name": "diana rodgers",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "din_thomas",
            "name": "din thomas",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dom_d\u2019agostino",
            "name": "dom d\u2019agostino",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dom_irrera",
            "name": "dom irrera",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dominic_monaghan",
            "name": "dominic monaghan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "dominick_cruz",
            "name": "dominick cruz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "don_frye",
            "name": "don frye",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "don_gavin",
            "name": "don gavin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "donald_cerrone",
            "name": "donald cerrone",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "donnell_rawlings",
            "name": "donnell rawlings",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "donnie_vincent",
            "name": "donnie vincent",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "dorian_yates",
            "name": "dorian yates",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "doug_benson",
            "name": "doug benson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "doug_duren",
            "name": "doug duren",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "doug_stanhope",
            "name": "doug stanhope",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "douglas_murray",
            "name": "douglas murray",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "douglas_rushkoff",
            "name": "douglas rushkoff",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "amit_goswami",
            "name": "amit goswami",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andrew_weil",
            "name": "andrew weil",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "andy_galpin",
            "name": "andy galpin",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "aseem_malhotra",
            "name": "aseem malhotra",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ben_goertzel",
            "name": "ben goertzel",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bradley_garrett",
            "name": "bradley garrett",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "carl_hart",
            "name": "carl hart",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "cornel_west",
            "name": "cornel west",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "debra_soh",
            "name": "debra soh",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gabor_mat\u00e9",
            "name": "gabor mat\u00e9",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joel_kahn",
            "name": "joel kahn",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_gordon",
            "name": "mark gordon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_hart",
            "name": "michael hart",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_a._mccullough",
            "name": "peter a. mccullough",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_hotez",
            "name": "peter hotez",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "phil",
            "name": "phil",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "pierre_kory",
            "name": "pierre kory",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rhonda_patrick",
            "name": "rhonda patrick",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_epstein",
            "name": "robert epstein",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_malone",
            "name": "robert malone",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "roddy_mcgee",
            "name": "roddy mcgee",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sanjay_gupta",
            "name": "sanjay gupta",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shanna_swan",
            "name": "shanna swan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shawn_baker",
            "name": "shawn baker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "duane_ludwig",
            "name": "duane ludwig",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "duke_roufus",
            "name": "duke roufus",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "duncan_french",
            "name": "duncan french",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "duncan_trussell",
            "name": "duncan trussell",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "dustin_poirier",
            "name": "dustin poirier",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "dwayne_'the_rock'_johnson",
            "name": "dwayne 'the rock' johnson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "earthquake",
            "name": "earthquake",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ed_calderon",
            "name": "ed calderon",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "eddie_bravo",
            "name": "eddie bravo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eddie_huang",
            "name": "eddie huang",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eddie_ifft",
            "name": "eddie ifft",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eddie_izzard",
            "name": "eddie izzard",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eddie_pepitone",
            "name": "eddie pepitone",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "edmond_tarverdyan",
            "name": "edmond tarverdyan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "edward_norton",
            "name": "edward norton",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "edward_slingerland",
            "name": "edward slingerland",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "edward_snowden",
            "name": "edward snowden",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ehsan_ahmad",
            "name": "ehsan ahmad",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "eleanor_kerrigan",
            "name": "eleanor kerrigan",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "elliott_west",
            "name": "elliott west",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "elon_musk",
            "name": "elon musk",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "emily_harrington",
            "name": "emily harrington",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "enson_inoue",
            "name": "enson inoue",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eric_albarracin",
            "name": "eric albarracin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eric_weinstein",
            "name": "eric weinstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "erik_griffin",
            "name": "erik griffin",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "erika_thompson",
            "name": "erika thompson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "erwan_le_corre",
            "name": "erwan le corre",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "eryk_anders",
            "name": "eryk anders",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "esther_ku",
            "name": "esther ku",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ethan_nadelmann",
            "name": "ethan nadelmann",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ethan_suplee",
            "name": "ethan suplee",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "evan_funke",
            "name": "evan funke",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "evan_hafer",
            "name": "evan hafer",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "evander_holyfield",
            "name": "evander holyfield",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "everlast",
            "name": "everlast",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "fahim_anwar",
            "name": "fahim anwar",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "fedor_gorst",
            "name": "fedor gorst",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "felipe_esparza",
            "name": "felipe esparza",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "firas_zahabi",
            "name": "firas zahabi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "floyd_mayweather_jr.",
            "name": "floyd mayweather jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "forrest_galante",
            "name": "forrest galante",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "forrest_griffin",
            "name": "forrest griffin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "fortune_feimster",
            "name": "fortune feimster",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "francis_foster",
            "name": "francis foster",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "francis_ngannou",
            "name": "francis ngannou",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "frank_castillo",
            "name": "frank castillo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "frank_von_hippel",
            "name": "frank von hippel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "frankie_edgar",
            "name": "frankie edgar",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "fred_morin",
            "name": "fred morin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "freddie_gibbs",
            "name": "freddie gibbs",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "gabriel_iglesias",
            "name": "gabriel iglesias",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gabrielle_reece",
            "name": "gabrielle reece",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gad_saad",
            "name": "gad saad",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "garrett_reisman",
            "name": "garrett reisman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_brecka",
            "name": "gary brecka",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "gary_clark",
            "name": "gary clark",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_clark_jr.",
            "name": "gary clark jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_johnson",
            "name": "gary johnson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_laderman",
            "name": "gary laderman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_taubes",
            "name": "gary taubes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gary_vaynerchuk",
            "name": "gary vaynerchuk",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gaston_bolanos",
            "name": "gaston bolanos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gavin_de_becker",
            "name": "gavin de becker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gavin_mcinnes",
            "name": "gavin mcinnes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gene_lebell",
            "name": "gene lebell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "general_h.r._mcmaster",
            "name": "general h.r. mcmaster",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "geoffrey_miller",
            "name": "geoffrey miller",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "george_kambosos",
            "name": "george kambosos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "george_knapp",
            "name": "george knapp",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "george_lockhart",
            "name": "george lockhart",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "george_perez",
            "name": "george perez",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "georges_st-pierre",
            "name": "georges st-pierre",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gerard_way",
            "name": "gerard way",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gilbert_gottfried",
            "name": "gilbert gottfried",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gillian_robertson",
            "name": "gillian robertson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gina_carano",
            "name": "gina carano",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gino_&_aj",
            "name": "gino & aj",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "giorgio_tsoukalos",
            "name": "giorgio tsoukalos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "glen_cordoza",
            "name": "glen cordoza",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "glenn_greenwald",
            "name": "glenn greenwald",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "glenn_villeneuve",
            "name": "glenn villeneuve",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "gordon_ryan",
            "name": "gordon ryan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "graham_hancock",
            "name": "graham hancock",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "greg_fitzsimmons",
            "name": "greg fitzsimmons",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "greg_proops",
            "name": "greg proops",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "guy_ritchie",
            "name": "guy ritchie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hamilton_morris",
            "name": "hamilton morris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hank_shaw",
            "name": "hank shaw",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hannibal_buress",
            "name": "hannibal buress",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hans_kim",
            "name": "hans kim",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "harrison_ford",
            "name": "harrison ford",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "heather_heying",
            "name": "heather heying",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "henry_cejudo",
            "name": "henry cejudo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "henry_rollins",
            "name": "henry rollins",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "herb_dean",
            "name": "herb dean",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "honey_honey",
            "name": "honey honey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hotep_jesus",
            "name": "hotep jesus",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "howard_bloom",
            "name": "howard bloom",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "howie_mandel",
            "name": "howie mandel",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "hugo_martin",
            "name": "hugo martin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "hulk_hogan",
            "name": "hulk hogan",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "ian_edwards",
            "name": "ian edwards",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ian_mccall",
            "name": "ian mccall",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ice_cube",
            "name": "ice cube",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "iliza_shlesinger",
            "name": "iliza shlesinger",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "immortal_technique",
            "name": "immortal technique",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ioan_grillo",
            "name": "ioan grillo",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "ira_glasser",
            "name": "ira glasser",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "isaac_haxton",
            "name": "isaac haxton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "israel_adesanya",
            "name": "israel adesanya",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "j._prince",
            "name": "j. prince",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jack_carr",
            "name": "jack carr",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jack_dorsey",
            "name": "jack dorsey",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jacob_ward",
            "name": "jacob ward",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jacques_vall\u00e9e",
            "name": "jacques vall\u00e9e",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jake_roberts",
            "name": "jake roberts",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jake_shields",
            "name": "jake shields",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jakob_dylan",
            "name": "jakob dylan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jamahal_hill",
            "name": "jamahal hill",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jamar_neighbors",
            "name": "jamar neighbors",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "james_\u201cbobo\u201d_fay",
            "name": "james \u201cbobo\u201d fay",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_damore",
            "name": "james damore",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_fox",
            "name": "james fox",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_hetfield",
            "name": "james hetfield",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_kingston",
            "name": "james kingston",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_lindsay",
            "name": "james lindsay",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "james_nestor",
            "name": "james nestor",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_reed",
            "name": "james reed",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "james_wilks",
            "name": "james wilks",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jamie_foxx",
            "name": "jamie foxx",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jamie_kilstein",
            "name": "jamie kilstein",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jamie_metzl",
            "name": "jamie metzl",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jane_mcgonigal",
            "name": "jane mcgonigal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "janet_zuccarini",
            "name": "janet zuccarini",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jann_wenner",
            "name": "jann wenner",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jared_cannonier",
            "name": "jared cannonier",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jason_everman",
            "name": "jason everman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jason_flom",
            "name": "jason flom",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jason_hairston",
            "name": "jason hairston",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jason_silva",
            "name": "jason silva",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jason_wilson",
            "name": "jason wilson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "javier_bardem",
            "name": "javier bardem",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jay_leno",
            "name": "jay leno",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jd_kelley",
            "name": "jd kelley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jd_witherspoon",
            "name": "jd witherspoon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jean_jacques_machado",
            "name": "jean jacques machado",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeff_evans",
            "name": "jeff evans",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeff_garlin",
            "name": "jeff garlin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jeff_novitzky",
            "name": "jeff novitzky",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeff_ross",
            "name": "jeff ross",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jeff_warren",
            "name": "jeff warren",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jelly_roll",
            "name": "jelly roll",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jenni_harris",
            "name": "jenni harris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jenny_johnson",
            "name": "jenny johnson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jenny_kleeman",
            "name": "jenny kleeman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeremy_corbell",
            "name": "jeremy corbell",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "jeremy_gerber",
            "name": "jeremy gerber",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeremy_jones",
            "name": "jeremy jones",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jeremy_stephens",
            "name": "jeremy stephens",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jerrod_carmichael",
            "name": "jerrod carmichael",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jerry_seinfeld",
            "name": "jerry seinfeld",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jesse_griffiths",
            "name": "jesse griffiths",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jesse_itzler",
            "name": "jesse itzler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jesse_singal",
            "name": "jesse singal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jesse_ventura",
            "name": "jesse ventura",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jessica_kirson",
            "name": "jessica kirson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jessica_rosenworcel",
            "name": "jessica rosenworcel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jessimae_peluso",
            "name": "jessimae peluso",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jesus_trejo",
            "name": "jesus trejo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jewel",
            "name": "jewel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jim_breuer",
            "name": "jim breuer",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jim_florentine",
            "name": "jim florentine",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jim_gaffigan",
            "name": "jim gaffigan",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jim_jefferies",
            "name": "jim jefferies",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jim_miller",
            "name": "jim miller",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jim_norton",
            "name": "jim norton",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jim_shockey",
            "name": "jim shockey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jimmy_carr",
            "name": "jimmy carr",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jimmy_corsetti",
            "name": "jimmy corsetti",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jimmy_dore",
            "name": "jimmy dore",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jimmy_o_yang",
            "name": "jimmy o yang",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jimmy_smith",
            "name": "jimmy smith",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joaquin_buckley",
            "name": "joaquin buckley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jocko_willink",
            "name": "jocko willink",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "joe_de_sena",
            "name": "joe de sena",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joe_derosa",
            "name": "joe derosa",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "joe_list",
            "name": "joe list",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "joe_perry",
            "name": "joe perry",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joe_pyfer",
            "name": "joe pyfer",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joe_quirk",
            "name": "joe quirk",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joe_schilling",
            "name": "joe schilling",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joel_salatin",
            "name": "joel salatin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joel_turner",
            "name": "joel turner",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joey_diaz",
            "name": "joey diaz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "johann_hari",
            "name": "johann hari",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_abramson",
            "name": "john abramson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_anthony_west",
            "name": "john anthony west",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_carmack",
            "name": "john carmack",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_danaher",
            "name": "john danaher",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "john_dudley",
            "name": "john dudley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_hackleman",
            "name": "john hackleman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_heffron",
            "name": "john heffron",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_hefron",
            "name": "john hefron",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_hennessey",
            "name": "john hennessey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_joseph",
            "name": "john joseph",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_kavanagh",
            "name": "john kavanagh",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_mackey",
            "name": "john mackey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_mulaney",
            "name": "john mulaney",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "john_nores",
            "name": "john nores",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_rallo",
            "name": "john rallo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_reeves",
            "name": "john reeves",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_terzian",
            "name": "john terzian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_wayne_parr",
            "name": "john wayne parr",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "john_witherspoon",
            "name": "john witherspoon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_bernthal",
            "name": "jon bernthal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_jones",
            "name": "jon jones",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_peters",
            "name": "jon peters",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_reep",
            "name": "jon reep",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_ronson",
            "name": "jon ronson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jon_stewart",
            "name": "jon stewart",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jonathan_gottschall",
            "name": "jonathan gottschall",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jonathan_haidt",
            "name": "jonathan haidt",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jonathan_ward",
            "name": "jonathan ward",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jonathan_zimmerman",
            "name": "jonathan zimmerman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jordan_burroughs",
            "name": "jordan burroughs",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jordan_e._cooper",
            "name": "jordan e. cooper",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jordan_gilbert_(0thing)",
            "name": "jordan gilbert (0thing)",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jordan_jonas",
            "name": "jordan jonas",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jordan_peterson",
            "name": "jordan peterson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jorge_masvidal",
            "name": "jorge masvidal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joseph_ledoux",
            "name": "joseph ledoux",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "joseph_valtellini",
            "name": "joseph valtellini",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_barnett",
            "name": "josh barnett",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "josh_brolin",
            "name": "josh brolin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "josh_dubin",
            "name": "josh dubin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_fox",
            "name": "josh fox",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_henning",
            "name": "josh henning",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_homme",
            "name": "josh homme",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_mcdermitt",
            "name": "josh mcdermitt",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_olin",
            "name": "josh olin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_rogin",
            "name": "josh rogin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_szeps",
            "name": "josh szeps",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_thomson",
            "name": "josh thomson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "josh_zepps",
            "name": "josh zepps",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "jr.",
            "name": "jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "judah_friedlander",
            "name": "judah friedlander",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "judd_apatow",
            "name": "judd apatow",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "julianna_pe\u00f1a",
            "name": "julianna pe\u00f1a",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "julie_kedzie",
            "name": "julie kedzie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_brown",
            "name": "justin brown",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_collett",
            "name": "justin collett",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_foster",
            "name": "justin foster",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_gaethje",
            "name": "justin gaethje",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_halpern",
            "name": "justin halpern",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "justin_martindale",
            "name": "justin martindale",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "justin_wren",
            "name": "justin wren",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kamaru_usman",
            "name": "kamaru usman",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kanye_west",
            "name": "kanye west",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kari_lake",
            "name": "kari lake",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kathleen_madigan",
            "name": "kathleen madigan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "katie_spotz",
            "name": "katie spotz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "katt_williams",
            "name": "katt williams",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "katy_bowman",
            "name": "katy bowman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "keanu_reeves",
            "name": "keanu reeves",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "keegan_kuhn",
            "name": "keegan kuhn",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "keith_weber",
            "name": "keith weber",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kelly_brogan",
            "name": "kelly brogan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kelly_pavlik",
            "name": "kelly pavlik",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kelly_slater",
            "name": "kelly slater",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kelly_starrett",
            "name": "kelly starrett",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kenton_carruth",
            "name": "kenton carruth",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kermit_pattison",
            "name": "kermit pattison",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_folta",
            "name": "kevin folta",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_hart",
            "name": "kevin hart",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kevin_holland",
            "name": "kevin holland",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_lee",
            "name": "kevin lee",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_pereira",
            "name": "kevin pereira",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_rose",
            "name": "kevin rose",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_ross",
            "name": "kevin ross",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kevin_smith",
            "name": "kevin smith",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "khabib_nurmagomedov",
            "name": "khabib nurmagomedov",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "khalil_rountree",
            "name": "khalil rountree",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "khalil_rountree_jr.",
            "name": "khalil rountree jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kid_cudi",
            "name": "kid cudi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "killer_mike",
            "name": "killer mike",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kim_congdon",
            "name": "kim congdon",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kip_andersen",
            "name": "kip andersen",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kirian_fitzgibbons",
            "name": "kirian fitzgibbons",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kirik_jenness",
            "name": "kirik jenness",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "konstantin_kisin",
            "name": "konstantin kisin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "konstantine_kisin",
            "name": "konstantine kisin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kristin_beck",
            "name": "kristin beck",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kron_gracie",
            "name": "kron gracie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "krystal_&_saagar",
            "name": "krystal & saagar",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "krystal_ball",
            "name": "krystal ball",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "krystyna_hutchinson",
            "name": "krystyna hutchinson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kurt_angle",
            "name": "kurt angle",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kurt_metzger",
            "name": "kurt metzger",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kyle_dunnigan",
            "name": "kyle dunnigan",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kyle_kinane",
            "name": "kyle kinane",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kyle_kingsbury",
            "name": "kyle kingsbury",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "kyle_kulinski",
            "name": "kyle kulinski",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "laird_hamilton",
            "name": "laird hamilton",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "lance_armstrong",
            "name": "lance armstrong",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lara_beitz",
            "name": "lara beitz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "larry_sharpe",
            "name": "larry sharpe",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lars_ulrich",
            "name": "lars ulrich",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "laurie_woolever",
            "name": "laurie woolever",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lawrence_krauss",
            "name": "lawrence krauss",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "lawrence_lessig",
            "name": "lawrence lessig",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lawrence_wright",
            "name": "lawrence wright",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "layne_norton",
            "name": "layne norton",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "leah_remini",
            "name": "leah remini",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lee_camp",
            "name": "lee camp",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "legion_of_skanks",
            "name": "legion of skanks",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lennox_lewis",
            "name": "lennox lewis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lenny_clarke",
            "name": "lenny clarke",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "leon_edwards",
            "name": "leon edwards",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "leonardo_dicaprio",
            "name": "leonardo dicaprio",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "les_stroud",
            "name": "les stroud",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lewis_from_unbox_therapy",
            "name": "lewis from unbox therapy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lex_fridman",
            "name": "lex fridman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "liam_&_dylan_resnekov",
            "name": "liam & dylan resnekov",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "liam_harrison",
            "name": "liam harrison",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lil_duval",
            "name": "lil duval",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lindsey_fitzharris",
            "name": "lindsey fitzharris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "liz_phair",
            "name": "liz phair",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "logan_paul",
            "name": "logan paul",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "lorenzo_hagerty",
            "name": "lorenzo hagerty",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "louie_psihoyos",
            "name": "louie psihoyos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "louie_simmons",
            "name": "louie simmons",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "louis_ck",
            "name": "louis ck",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "louis_theroux",
            "name": "louis theroux",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "luis_j._gomez",
            "name": "luis j. gomez",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "luke_combs",
            "name": "luke combs",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "luke_thomas",
            "name": "luke thomas",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "maajid_nawaz",
            "name": "maajid nawaz",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mac_danzig",
            "name": "mac danzig",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mac_lethal",
            "name": "mac lethal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "macaulay_culkin",
            "name": "macaulay culkin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "magnus_walker",
            "name": "magnus walker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "malcolm_gladwell",
            "name": "malcolm gladwell",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "marc_andreessen",
            "name": "marc andreessen",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "marc_maron",
            "name": "marc maron",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "marcus_luttrell",
            "name": "marcus luttrell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mareko_maumasi",
            "name": "mareko maumasi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mariana_van_zeller",
            "name": "mariana van zeller",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "marianne_williamson",
            "name": "marianne williamson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_calaway",
            "name": "mark calaway",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_bell",
            "name": "mark bell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_boal",
            "name": "mark boal",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_dellagrotte",
            "name": "mark dellagrotte",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_greaney",
            "name": "mark greaney",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_kendall",
            "name": "mark kendall",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_laita",
            "name": "mark laita",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_normand",
            "name": "mark normand",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mark_sisson",
            "name": "mark sisson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_smith",
            "name": "mark smith",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mark_zuckerberg",
            "name": "mark zuckerberg",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "marlon_vera",
            "name": "marlon vera",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "marques_brownlee",
            "name": "marques brownlee",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mary_lynn_rajskub",
            "name": "mary lynn rajskub",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mat_best",
            "name": "mat best",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mat_fraser",
            "name": "mat fraser",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_braunger",
            "name": "matt braunger",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_brown",
            "name": "matt brown",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_damon",
            "name": "matt damon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "matt_farah",
            "name": "matt farah",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_fulchiron",
            "name": "matt fulchiron",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "matt_mccusker",
            "name": "matt mccusker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_paxton",
            "name": "matt paxton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_rife",
            "name": "matt rife",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "matt_serra",
            "name": "matt serra",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matt_taibbi",
            "name": "matt taibbi",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matt_walsh",
            "name": "matt walsh",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matthew_lohmeier",
            "name": "matthew lohmeier",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matthew_mcconaughey",
            "name": "matthew mcconaughey",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "matthew_walker",
            "name": "matthew walker",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "matthew_yglesias",
            "name": "matthew yglesias",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "matty_matheson",
            "name": "matty matheson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mauro_ranallo",
            "name": "mauro ranallo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "max_holloway",
            "name": "max holloway",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "max_lugavere",
            "name": "max lugavere",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mayhem_miller",
            "name": "mayhem miller",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "maynard_james_keenan",
            "name": "maynard james keenan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mayor_steve_adler",
            "name": "mayor steve adler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "md",
            "name": "md",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "megan_phelps-roper",
            "name": "megan phelps-roper",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "meghan_murphy",
            "name": "meghan murphy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mel_gibson",
            "name": "mel gibson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "melissa_chen",
            "name": "melissa chen",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "merlin_tuttle",
            "name": "merlin tuttle",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_bisping",
            "name": "michael bisping",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_chandler",
            "name": "michael chandler",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "michael_dowd",
            "name": "michael dowd",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_easter",
            "name": "michael easter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_hunter",
            "name": "michael hunter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_imperioli",
            "name": "michael imperioli",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_jordan",
            "name": "michael jordan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_kosta",
            "name": "michael kosta",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_malice",
            "name": "michael malice",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "michael_osterholm",
            "name": "michael osterholm",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_philippou",
            "name": "michael philippou",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_pollan",
            "name": "michael pollan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_ruppert",
            "name": "michael ruppert",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_schiavello",
            "name": "michael schiavello",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_scott_moore",
            "name": "michael scott moore",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_shellenberger",
            "name": "michael shellenberger",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "michael_shermer",
            "name": "michael shermer",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "michael_stevens",
            "name": "michael stevens",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_wood",
            "name": "michael wood",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michael_yo",
            "name": "michael yo",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "michelle_waterson",
            "name": "michelle waterson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michelle_wolf",
            "name": "michelle wolf",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "michio_kaku",
            "name": "michio kaku",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "mick_west",
            "name": "mick west",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "miesha_tate",
            "name": "miesha tate",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_baker",
            "name": "mike baker",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mike_birbiglia",
            "name": "mike birbiglia",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mike_dolce",
            "name": "mike dolce",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_glover",
            "name": "mike glover",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "mike_judge",
            "name": "mike judge",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_perry",
            "name": "mike perry",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "mike_posner",
            "name": "mike posner",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_sarraille",
            "name": "mike sarraille",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_schmidt",
            "name": "mike schmidt",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_tyson",
            "name": "mike tyson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mike_vecchione",
            "name": "mike vecchione",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "mike_ward",
            "name": "mike ward",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mikey_musumeci",
            "name": "mikey musumeci",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mikhaila_peterson",
            "name": "mikhaila peterson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "miley_cyrus",
            "name": "miley cyrus",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "milo_yiannopoulos",
            "name": "milo yiannopoulos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "miriam_nakamoto",
            "name": "miriam nakamoto",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mo_jassim",
            "name": "mo jassim",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "molly_crabapple",
            "name": "molly crabapple",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "monty_franklin",
            "name": "monty franklin",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "morgan_fallon",
            "name": "morgan fallon",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "morgan_murphy",
            "name": "morgan murphy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "moshe_kasher",
            "name": "moshe kasher",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "moxie_marlinspike",
            "name": "moxie marlinspike",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "mr._beast",
            "name": "mr. beast",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ms._pat",
            "name": "ms. pat",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nancy_panza",
            "name": "nancy panza",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "natasha_leggero",
            "name": "natasha leggero",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nate_bargatze",
            "name": "nate bargatze",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nate_diaz",
            "name": "nate diaz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nathan_ihde",
            "name": "nathan ihde",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "naval_ravikant",
            "name": "naval ravikant",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "neal_brennan",
            "name": "neal brennan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "neil_degrasse_tyson",
            "name": "neil degrasse tyson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "neil_riordan",
            "name": "neil riordan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "neill_blomkamp",
            "name": "neill blomkamp",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nicholas_christakis",
            "name": "nicholas christakis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_bostrom",
            "name": "nick bostrom",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "nick_curson",
            "name": "nick curson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_cutter",
            "name": "nick cutter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_di_paolo",
            "name": "nick di paolo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_dipaolo",
            "name": "nick dipaolo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_kroll",
            "name": "nick kroll",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nick_swardson",
            "name": "nick swardson",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nick_yarris",
            "name": "nick yarris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nick_youssef",
            "name": "nick youssef",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nikki_glaser",
            "name": "nikki glaser",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nimesh_patel",
            "name": "nimesh patel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nims_purja",
            "name": "nims purja",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "nina_teicholz",
            "name": "nina teicholz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "oliver_anthony",
            "name": "oliver anthony",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "oliver_stone",
            "name": "oliver stone",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "owen_benjamin",
            "name": "owen benjamin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "owen_smith",
            "name": "owen smith",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "owen_wilson",
            "name": "owen wilson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pantelis",
            "name": "pantelis",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pat_barry",
            "name": "pat barry",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pat_magee",
            "name": "pat magee",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pat_mcnamara",
            "name": "pat mcnamara",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pat_miletich",
            "name": "pat miletich",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "patrick_bet-david",
            "name": "patrick bet-david",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "patrick_carney",
            "name": "patrick carney",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "patton_oswalt",
            "name": "patton oswalt",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_felder",
            "name": "paul felder",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_greenberg",
            "name": "paul greenberg",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_rosolie",
            "name": "paul rosolie",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "paul_saladino",
            "name": "paul saladino",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_stamets",
            "name": "paul stamets",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_stanley",
            "name": "paul stanley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "paul_virzi",
            "name": "paul virzi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pauly_shore",
            "name": "pauly shore",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "pavel_tsatsouline",
            "name": "pavel tsatsouline",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pedro_pascal",
            "name": "pedro pascal",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "penn_jillette",
            "name": "penn jillette",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "pete_dominick",
            "name": "pete dominick",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "pete_holmes",
            "name": "pete holmes",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "peter_attia",
            "name": "peter attia",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "peter_berg",
            "name": "peter berg",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_boghossian",
            "name": "peter boghossian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_giuliano",
            "name": "peter giuliano",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_joseph",
            "name": "peter joseph",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_mcgraw",
            "name": "peter mcgraw",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "peter_schiff",
            "name": "peter schiff",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "peter_zeihan",
            "name": "peter zeihan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "phil_demers",
            "name": "phil demers",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "phil_gerber",
            "name": "phil gerber",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "philip_defranco",
            "name": "philip defranco",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "philip_goff",
            "name": "philip goff",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "phillip_frankland_lee",
            "name": "phillip frankland lee",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "post_malone",
            "name": "post malone",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "punkie_johnson",
            "name": "punkie johnson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "python_cowboy",
            "name": "python cowboy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "quentin_tarantino",
            "name": "quentin tarantino",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "radio_rahim",
            "name": "radio rahim",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rafael_lovato_jr.",
            "name": "rafael lovato jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rafinha_bastos",
            "name": "rafinha bastos",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "raghunath_cappo",
            "name": "raghunath cappo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ralph_barbosa",
            "name": "ralph barbosa",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "randall_carlson",
            "name": "randall carlson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rashad_evans",
            "name": "rashad evans",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "reggie_watts",
            "name": "reggie watts",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "remi_warren",
            "name": "remi warren",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ren\u00e9e_diresta",
            "name": "ren\u00e9e diresta",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ric_flair",
            "name": "ric flair",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rich_benoit",
            "name": "rich benoit",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rich_roll",
            "name": "rich roll",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rich_vos",
            "name": "rich vos",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "richard_dawkins",
            "name": "richard dawkins",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "richard_rawlings",
            "name": "richard rawlings",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rick_baker",
            "name": "rick baker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rick_doblin",
            "name": "rick doblin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rick_rubin",
            "name": "rick rubin",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rick_strassman",
            "name": "rick strassman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rickson_gracie",
            "name": "rickson gracie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ricky_schroder",
            "name": "ricky schroder",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rico_verhoeven",
            "name": "rico verhoeven",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "riley_gaines",
            "name": "riley gaines",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rizwan_virk",
            "name": "rizwan virk",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rob_kearney",
            "name": "rob kearney",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rob_lowe",
            "name": "rob lowe",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rob_zombie",
            "name": "rob zombie",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robb_wolf",
            "name": "robb wolf",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_bigelow",
            "name": "robert bigelow",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_downey_jr.",
            "name": "robert downey jr.",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "robert_jones",
            "name": "robert jones",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_kelly",
            "name": "robert kelly",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "robert_kennedy_jr.",
            "name": "robert kennedy jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_oberst",
            "name": "robert oberst",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robert_sapolsky",
            "name": "robert sapolsky",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_schoch",
            "name": "robert schoch",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "robin_black",
            "name": "robin black",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "roger_waters",
            "name": "roger waters",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ron_desantis",
            "name": "ron desantis",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ron_finley",
            "name": "ron finley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ron_funches",
            "name": "ron funches",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ron_miscavige",
            "name": "ron miscavige",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ron_white",
            "name": "ron white",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ronda_rousey",
            "name": "ronda rousey",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ronnie_coleman",
            "name": "ronnie coleman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rory_albanese",
            "name": "rory albanese",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rory_macdonald",
            "name": "rory macdonald",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rory_scovel",
            "name": "rory scovel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rose_namajunas",
            "name": "rose namajunas",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "roseanne_barr",
            "name": "roseanne barr",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ross_edgley",
            "name": "ross edgley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "roy_jones_jr.",
            "name": "roy jones jr.",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "roy_wood_jr",
            "name": "roy wood jr",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "rupert_sheldrake",
            "name": "rupert sheldrake",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "russell_brand",
            "name": "russell brand",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "russell_peters",
            "name": "russell peters",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rutledge_wood",
            "name": "rutledge wood",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ryan_callaghan",
            "name": "ryan callaghan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ryan_graves",
            "name": "ryan graves",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ryan_holiday",
            "name": "ryan holiday",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ryan_long",
            "name": "ryan long",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ryan_parsons",
            "name": "ryan parsons",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ryan_sickler",
            "name": "ryan sickler",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rza",
            "name": "rza",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "s.c._gwynne",
            "name": "s.c. gwynne",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "saagar_enjeti",
            "name": "saagar enjeti",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sadhguru",
            "name": "sadhguru",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sam_altman",
            "name": "sam altman",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "sam_and_colby",
            "name": "sam and colby",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sam_golbach",
            "name": "sam golbach",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sam_harris",
            "name": "sam harris",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sam_morril",
            "name": "sam morril",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sam_sheridan",
            "name": "sam sheridan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sam_tallent",
            "name": "sam tallent",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sam_tripoli",
            "name": "sam tripoli",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sara_weinshenk",
            "name": "sara weinshenk",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sarah_silverman",
            "name": "sarah silverman",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sargon_of_akkad",
            "name": "sargon of akkad",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "scott_adams",
            "name": "scott adams",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "scott_eastwood",
            "name": "scott eastwood",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "scott_sigler",
            "name": "scott sigler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "scroobius_pip",
            "name": "scroobius pip",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sean_anders",
            "name": "sean anders",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sean_brady",
            "name": "sean brady",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sean_carroll",
            "name": "sean carroll",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sean_o\u2019malley",
            "name": "sean o\u2019malley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sean_strickland",
            "name": "sean strickland",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "sebastian_junger",
            "name": "sebastian junger",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sebastian_maniscalco",
            "name": "sebastian maniscalco",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "seth_dillon",
            "name": "seth dillon",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "shane_dorian",
            "name": "shane dorian",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shane_gillis",
            "name": "shane gillis",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "shane_mauss",
            "name": "shane mauss",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shane_smith",
            "name": "shane smith",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shannon_briggs",
            "name": "shannon briggs",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shannon_o'loughlin",
            "name": "shannon o'loughlin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shirley_manson",
            "name": "shirley manson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "shooter_jennings",
            "name": "shooter jennings",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "siddharth_kara",
            "name": "siddharth kara",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sir_roger_penrose",
            "name": "sir roger penrose",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "snoop_dogg",
            "name": "snoop dogg",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sonny_side",
            "name": "sonny side",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "stavros_halkias",
            "name": "stavros halkias",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "stefan_molyneux",
            "name": "stefan molyneux",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "stephan_guyenet",
            "name": "stephan guyenet",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "stephen_c._meyer",
            "name": "stephen c. meyer",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "stephen_dubner",
            "name": "stephen dubner",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "stephen_thompson",
            "name": "stephen thompson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_aoki",
            "name": "steve aoki",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "steve_buscemi",
            "name": "steve buscemi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_hilton",
            "name": "steve hilton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_hofstetter",
            "name": "steve hofstetter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_maxwell",
            "name": "steve maxwell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_schirripa",
            "name": "steve schirripa",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_strope",
            "name": "steve strope",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve_sweeney",
            "name": "steve sweeney",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steve-o",
            "name": "steve-o",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "steven_crowder",
            "name": "steven crowder",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "steven_e._koonin",
            "name": "steven e. koonin",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steven_hassan",
            "name": "steven hassan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steven_kotler",
            "name": "steven kotler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steven_pinker",
            "name": "steven pinker",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "steven_pressfield",
            "name": "steven pressfield",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "steven_rinella",
            "name": "steven rinella",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steven_tyler",
            "name": "steven tyler",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "steven_wright",
            "name": "steven wright",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "stipe_miocic",
            "name": "stipe miocic",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sturgill_simpson",
            "name": "sturgill simpson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "sue_aikens",
            "name": "sue aikens",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "suzanne_santo",
            "name": "suzanne santo",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tait_fletcher",
            "name": "tait fletcher",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "taylor_sheridan",
            "name": "taylor sheridan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "ted_nugent",
            "name": "ted nugent",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "teddy_atlas",
            "name": "teddy atlas",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "terence_crawford",
            "name": "terence crawford",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "terry_virts",
            "name": "terry virts",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "thaddeus_russell",
            "name": "thaddeus russell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "the_black_keys",
            "name": "the black keys",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "theo_von",
            "name": "theo von",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "tiller_russell",
            "name": "tiller russell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tim_burnett",
            "name": "tim burnett",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tim_dillon",
            "name": "tim dillon",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tim_ferriss",
            "name": "tim ferriss",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tim_kennedy",
            "name": "tim kennedy",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tim_pool",
            "name": "tim pool",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "tim_robbins",
            "name": "tim robbins",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tim_welch",
            "name": "tim welch",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "timothy_olyphant",
            "name": "timothy olyphant",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tito_ortiz",
            "name": "tito ortiz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tj_dillashaw",
            "name": "tj dillashaw",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tj_english",
            "name": "tj english",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tj_kirk",
            "name": "tj kirk",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "todd_glass",
            "name": "todd glass",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "todd_white",
            "name": "todd white",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_bilyeu",
            "name": "tom bilyeu",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_delonge",
            "name": "tom delonge",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_green",
            "name": "tom green",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_o'neill",
            "name": "tom o'neill",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_papa",
            "name": "tom papa",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tom_rhodes",
            "name": "tom rhodes",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tom_segura",
            "name": "tom segura",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tommy_chong",
            "name": "tommy chong",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tony_hawk",
            "name": "tony hawk",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tony_hinchcliffe",
            "name": "tony hinchcliffe",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tony_rock",
            "name": "tony rock",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tony_woods",
            "name": "tony woods",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tovar_cerulli",
            "name": "tovar cerulli",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "trae_tha_truth",
            "name": "trae tha truth",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "travis_barker",
            "name": "travis barker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "travis_lutter",
            "name": "travis lutter",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "travis_walton",
            "name": "travis walton",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "trevor_moore",
            "name": "trevor moore",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "trevor_thompson",
            "name": "trevor thompson",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "trevor_valle",
            "name": "trevor valle",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "trevor_wittman",
            "name": "trevor wittman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tristan_harris",
            "name": "tristan harris",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "tucker_carlson",
            "name": "tucker carlson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "tulsi_gabbard",
            "name": "tulsi gabbard",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tyron_woodley",
            "name": "tyron woodley",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "tyson_fury",
            "name": "tyson fury",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "urijah_faber",
            "name": "urijah faber",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "valentina_schevchenko",
            "name": "valentina schevchenko",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "valentine_thomas",
            "name": "valentine thomas",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "vijaya_gadde",
            "name": "vijaya gadde",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "vince_&_emily_horn",
            "name": "vince & emily horn",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "vinnie_paz",
            "name": "vinnie paz",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "vinny_shoreman",
            "name": "vinny shoreman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "w._kamau_bell",
            "name": "w. kamau bell",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "w._keith_campbell",
            "name": "w. keith campbell",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "war_machine",
            "name": "war machine",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "wayne_federman",
            "name": "wayne federman",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "wesley_hunt",
            "name": "wesley hunt",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "wheeler_walker",
            "name": "wheeler walker",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "whitney_cummings",
            "name": "whitney cummings",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "will_harris",
            "name": "will harris",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "will_macaskill",
            "name": "will macaskill",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "william_von_hippel",
            "name": "william von hippel",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "willie_d",
            "name": "willie d",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "wim_hof",
            "name": "wim hof",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "wiz_khalifa",
            "name": "wiz khalifa",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "yannis_pappas",
            "name": "yannis pappas",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "yeonmi_park",
            "name": "yeonmi park",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "yoel_romero",
            "name": "yoel romero",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "yves_edwards",
            "name": "yves edwards",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "yvette_d\u2019entremont",
            "name": "yvette d\u2019entremont",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "zach_bitter",
            "name": "zach bitter",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "zach_braff",
            "name": "zach braff",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "zach_bryan",
            "name": "zach bryan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "zach_leary",
            "name": "zach leary",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "zachary_levi",
            "name": "zachary levi",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "zoltan_istvan",
            "name": "zoltan istvan",
            "val": 1,
            "color1": 0,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 0
        },
        {
            "id": "zuby",
            "name": "zuby",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "tony_robbins",
            "name": "tony robbins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "kat_von_d",
            "name": "kat von d",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "ernest",
            "name": "ernest",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "wayne_gretzky",
            "name": "wayne gretzky",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "dana_white",
            "name": "dana white",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nyc_garbage_man",
            "name": "nyc garbage man",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "sexyy_red",
            "name": "sexyy red",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "robert_f._kennedy_jr.",
            "name": "robert f. kennedy jr.",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "bobby_lee",
            "name": "bobby lee",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "john_vervaeke",
            "name": "john vervaeke",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "the_last_sun",
            "name": "the last sun",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jordan_b._peterson",
            "name": "jordan b. peterson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "a_coroner",
            "name": "a coroner",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "flea_market",
            "name": "flea market",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "yg",
            "name": "yg",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "door_to_door",
            "name": "door to door",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "adam_devine",
            "name": "adam devine",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "roseanne",
            "name": "roseanne",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "trevor_wallace",
            "name": "trevor wallace",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brianna_chickenfry",
            "name": "brianna chickenfry",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "will_sasso",
            "name": "will sasso",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "that_lord_portal",
            "name": "that lord portal",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "rainn_wilson",
            "name": "rainn wilson",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "glenny_balls",
            "name": "glenny balls",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "man_in_here",
            "name": "man in here",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "caleb_pressley",
            "name": "caleb pressley",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "george_kittle",
            "name": "george kittle",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "funny_marco",
            "name": "funny marco",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "hardy",
            "name": "hardy",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "logic",
            "name": "logic",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "dialed_in",
            "name": "dialed in",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "lainey_wilson",
            "name": "lainey wilson",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "druski",
            "name": "druski",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "back_from_france",
            "name": "back from france",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "kyle_forgeard",
            "name": "kyle forgeard",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "louis_c.k.",
            "name": "louis c.k.",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "james_blake",
            "name": "james blake",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "merry_lloyd_christmas",
            "name": "merry lloyd christmas",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "yung_gravy",
            "name": "yung gravy",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "retired_police_officer",
            "name": "retired police officer",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "gangsgiving",
            "name": "gangsgiving",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "dana_carvey",
            "name": "dana carvey",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mike_rowe",
            "name": "mike rowe",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bubba_sparxxx",
            "name": "bubba sparxxx",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "andrew_callaghan",
            "name": "andrew callaghan",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "cold_beach",
            "name": "cold beach",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "scott_stapp",
            "name": "scott stapp",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "rail_baby",
            "name": "rail baby",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "tony_kanaan",
            "name": "tony kanaan",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "max_more",
            "name": "max more",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "that_hot_heat",
            "name": "that hot heat",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "riff_raff",
            "name": "riff raff",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "off_the_bike",
            "name": "off the bike",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "parker_mccollum",
            "name": "parker mccollum",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "albuquerque",
            "name": "albuquerque",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "sal_vulcano",
            "name": "sal vulcano",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "maui_milkshake",
            "name": "maui milkshake",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "trauma_restoration_man",
            "name": "trauma restoration man",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "belated_bunny",
            "name": "belated bunny",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "bird_neckin",
            "name": "bird neckin",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "sean_o'malley",
            "name": "sean o'malley",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "brotherly_love",
            "name": "brotherly love",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "teenage_easter",
            "name": "teenage easter",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "brandon_moreno",
            "name": "brandon moreno",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "belated_valentine's",
            "name": "belated valentine's",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "blair_socci",
            "name": "blair socci",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jason_ellis",
            "name": "jason ellis",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "bryce_mitchell",
            "name": "bryce mitchell",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "ryan_williams",
            "name": "ryan williams",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "brian_barczyk",
            "name": "brian barczyk",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jay_cutler",
            "name": "jay cutler",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jeff_wittek",
            "name": "jeff wittek",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "limited_alphabet",
            "name": "limited alphabet",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "john_crist",
            "name": "john crist",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "last_words",
            "name": "last words",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "biggie_smallsberg",
            "name": "biggie smallsberg",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "a_jockey",
            "name": "a jockey",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "gravel_on_the_road",
            "name": "gravel on the road",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "casey_frey",
            "name": "casey frey",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "close_frisbee",
            "name": "close frisbee",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jason_pooler",
            "name": "jason pooler",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "todd_graves",
            "name": "todd graves",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "check_ball",
            "name": "check ball",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "khalyla",
            "name": "khalyla",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "us_border_patrol_agent",
            "name": "us border patrol agent",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "heather_mcmahan",
            "name": "heather mcmahan",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mid-sized_animal_control_man",
            "name": "mid-sized animal control man",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "easter_oyster",
            "name": "easter oyster",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "travis_tritt",
            "name": "travis tritt",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "josh_wolf",
            "name": "josh wolf",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kane_brown",
            "name": "kane brown",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "turtleneck_soup",
            "name": "turtleneck soup",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "iron_man_chris_nikic",
            "name": "iron man chris nikic",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "round_italians",
            "name": "round italians",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "virtual_gnomes",
            "name": "virtual gnomes",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jimmy_john_liautaud",
            "name": "jimmy john liautaud",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "tony_mandarich",
            "name": "tony mandarich",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "thanksliving",
            "name": "thanksliving",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "morgan_wallen",
            "name": "morgan wallen",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "medium_debbie",
            "name": "medium debbie",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "a_female_trucker",
            "name": "a female trucker",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "robert_f_kennedy_jr",
            "name": "robert f kennedy jr",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "booty_hawk",
            "name": "booty hawk",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jo_koy_3",
            "name": "jo koy 3",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "elevator_baby",
            "name": "elevator baby",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "a_mortician",
            "name": "a mortician",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "fence_rabbits",
            "name": "fence rabbits",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "adult_asthma",
            "name": "adult asthma",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "egg_hunt",
            "name": "egg hunt",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "bobby_lee_4",
            "name": "bobby lee 4",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "taut_baby",
            "name": "taut baby",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nashville",
            "name": "nashville",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "david_arquette",
            "name": "david arquette",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "back_to_our_roots",
            "name": "back to our roots",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "chelcie_lynn",
            "name": "chelcie lynn",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "when_flavor_hits",
            "name": "when flavor hits",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "andrew_santino_3",
            "name": "andrew santino 3",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "through_the_sprinkler",
            "name": "through the sprinkler",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "tim_dillon_2",
            "name": "tim dillon 2",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "china_dragon",
            "name": "china dragon",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "hot_bass",
            "name": "hot bass",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "dodgers_pitcher_walker_buehler",
            "name": "dodgers pitcher walker buehler",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "diplo",
            "name": "diplo",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "working_from_home",
            "name": "working from home",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "suga_sean_o'malley",
            "name": "suga sean o'malley",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "edit_content:_raise_your_hand",
            "name": "edit content: raise your hand",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "boosie_badazz",
            "name": "boosie badazz",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nomichael_rosenbaum",
            "name": "nomichael rosenbaum",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "chris_ryan",
            "name": "chris ryan",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jamie_kennedy",
            "name": "jamie kennedy",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "nicole_arbour",
            "name": "nicole arbour",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "robin_tran",
            "name": "robin tran",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jay_mohr",
            "name": "jay mohr",
            "val": 1,
            "color1": 5,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "sean_mackey",
            "name": "sean mackey",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "karen_parker",
            "name": "karen parker",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_greene",
            "name": "robert greene",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "adam_grant",
            "name": "adam grant",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "natalie_crawford",
            "name": "natalie crawford",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "michael_eisenberg",
            "name": "michael eisenberg",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chris_voss",
            "name": "chris voss",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "paul_conti",
            "name": "paul conti",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "vivek_murthy",
            "name": "vivek murthy",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "goals_toolkit",
            "name": "goals toolkit",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_linden",
            "name": "david linden",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rena_malik",
            "name": "rena malik",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "maya_shankar",
            "name": "maya shankar",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_malenka",
            "name": "robert malenka",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jeffrey_goldberg",
            "name": "jeffrey goldberg",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "immordino-yang",
            "name": "immordino-yang",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robin_carhart-harris",
            "name": "robin carhart-harris",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "susanna_s\u00f8berg",
            "name": "susanna s\u00f8berg",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "noam_sobel",
            "name": "noam sobel",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "satchin_panda",
            "name": "satchin panda",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "oded_rechavi",
            "name": "oded rechavi",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "gina_poe",
            "name": "gina poe",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sara_gottfried",
            "name": "sara gottfried",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "kyle_gillett",
            "name": "kyle gillett",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "using_caffeine",
            "name": "using caffeine",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chris_palmer",
            "name": "chris palmer",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "eddie_chang",
            "name": "eddie chang",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "fitness_toolkit",
            "name": "fitness toolkit",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "nolan_williams",
            "name": "nolan williams",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "casey_halpern",
            "name": "casey halpern",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_anderson",
            "name": "david anderson",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "erich_jarvis",
            "name": "erich jarvis",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "emily_balcetis",
            "name": "emily balcetis",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "charles_zuker",
            "name": "charles zuker",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jeff_cavaliere",
            "name": "jeff cavaliere",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ido_portal",
            "name": "ido portal",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "wendy_suzuki",
            "name": "wendy suzuki",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "justin_sonnenburg",
            "name": "justin sonnenburg",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_spiegel",
            "name": "david spiegel",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "alia_crum",
            "name": "alia crum",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jack_feldman",
            "name": "jack feldman",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_berson",
            "name": "david berson",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "samer_hattar",
            "name": "samer hattar",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "craig_heller",
            "name": "craig heller",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "matthew_johnson",
            "name": "matthew johnson",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "karl_deisseroth",
            "name": "karl deisseroth",
            "val": 1,
            "color1": 1,
            "color2": 4,
            "color04": 1,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "darren_beattie",
            "name": "darren beattie",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "dennis_quaid",
            "name": "dennis quaid",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "willie_soon",
            "name": "willie soon",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "rep._clay_higgins",
            "name": "rep. clay higgins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "brett_weinstein",
            "name": "brett weinstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "mark_epstein",
            "name": "mark epstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "jordan_belfort",
            "name": "jordan belfort",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "colby_covington",
            "name": "colby covington",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "john_daly",
            "name": "john daly",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "kid_rock",
            "name": "kid rock",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 1,
            "color075": 1
        },
        {
            "id": "alex_cooper",
            "name": "alex cooper",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "trisha_paytas",
            "name": "trisha paytas",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "laren",
            "name": "laren",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "rene\u00e9_rapp",
            "name": "rene\u00e9 rapp",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "john_mayer",
            "name": "john mayer",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "paris_hilton",
            "name": "paris hilton",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "kelsea_ballerini",
            "name": "kelsea ballerini",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "jack_harlow",
            "name": "jack harlow",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "holly",
            "name": "holly",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "bridget",
            "name": "bridget",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "lucy_hale",
            "name": "lucy hale",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "offset",
            "name": "offset",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "bella_poarch",
            "name": "bella poarch",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "ciara",
            "name": "ciara",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "madeline_argy_debrief",
            "name": "madeline argy debrief",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "madeline_argy",
            "name": "madeline argy",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "alix_earle",
            "name": "alix earle",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "kristin_cavallari",
            "name": "kristin cavallari",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "janelle_mon\u00e1e",
            "name": "janelle mon\u00e1e",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "coi_leray",
            "name": "coi leray",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "harry_jowsey",
            "name": "harry jowsey",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "zayn",
            "name": "zayn",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "kim_petras",
            "name": "kim petras",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "stassi_schroeder",
            "name": "stassi schroeder",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "shay_mitchell",
            "name": "shay mitchell",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "anitta",
            "name": "anitta",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "priyanka_chopra_jonas",
            "name": "priyanka chopra jonas",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "gwyneth_paltrow",
            "name": "gwyneth paltrow",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "madison_beer",
            "name": "madison beer",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "lil_dicky",
            "name": "lil dicky",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "christina_aguilera",
            "name": "christina aguilera",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "john_legend",
            "name": "john legend",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "cole_sprouse",
            "name": "cole sprouse",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "rebel_wilson",
            "name": "rebel wilson",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "jane_fonda",
            "name": "jane fonda",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "chelsea_handler",
            "name": "chelsea handler",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jay_shetty",
            "name": "jay shetty",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "the_chainsmokers",
            "name": "the chainsmokers",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "keke_palmer",
            "name": "keke palmer",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "jackie_schimmel",
            "name": "jackie schimmel",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "elizabeth_banks",
            "name": "elizabeth banks",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "morgan_stewart_mcgraw",
            "name": "morgan stewart mcgraw",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "la_la_anthony",
            "name": "la la anthony",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "james_donald_forbes_mccann",
            "name": "james donald forbes mccann",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "lemaire_lee",
            "name": "lemaire lee",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tommy_pope",
            "name": "tommy pope",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "warmode",
            "name": "warmode",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "colum_tyrrell",
            "name": "colum tyrrell",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "billy",
            "name": "billy",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tim_butterly",
            "name": "tim butterly",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "naim_ali",
            "name": "naim ali",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "nate_marshall",
            "name": "nate marshall",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "lil_sasquatch",
            "name": "lil sasquatch",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kevin_iso",
            "name": "kevin iso",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "anthony_moore",
            "name": "anthony moore",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "will_compton",
            "name": "will compton",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "danny_mcbride",
            "name": "danny mcbride",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "chris_o'connor",
            "name": "chris o'connor",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "francis_ellis",
            "name": "francis ellis",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rob_crews",
            "name": "rob crews",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "dru_montana",
            "name": "dru montana",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "oz_pearlman",
            "name": "oz pearlman",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rone",
            "name": "rone",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "billy_mccusker",
            "name": "billy mccusker",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mike_rainey",
            "name": "mike rainey",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "james_mccann",
            "name": "james mccann",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "swim",
            "name": "swim",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "stuff_island",
            "name": "stuff island",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "nick_mullen",
            "name": "nick mullen",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "adam_friedland",
            "name": "adam friedland",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david_james",
            "name": "david james",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "burke",
            "name": "burke",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "spud",
            "name": "spud",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "andy_malafarina",
            "name": "andy malafarina",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "and_mystery_guest",
            "name": "and mystery guest",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "nick_bryant",
            "name": "nick bryant",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jon_delcollo",
            "name": "jon delcollo",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "charles_blyzniuk",
            "name": "charles blyzniuk",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brian_six",
            "name": "brian six",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sidney_gantt",
            "name": "sidney gantt",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ryan_shaner",
            "name": "ryan shaner",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sidney_gant",
            "name": "sidney gant",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mike_recine",
            "name": "mike recine",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sean_mccarthy",
            "name": "sean mccarthy",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ep_1347",
            "name": "ep 1347",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "shane",
            "name": "shane",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "shawn_ryan",
            "name": "shawn ryan",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "ryan_hendrickson",
            "name": "ryan hendrickson",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tim_parlatore",
            "name": "tim parlatore",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "chris_miller",
            "name": "chris miller",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "bryce_case_jr.",
            "name": "bryce case jr.",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "victor_marx",
            "name": "victor marx",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "luis_chaparro",
            "name": "luis chaparro",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "sarah_adams",
            "name": "sarah adams",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "john_lovell",
            "name": "john lovell",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "sean_webb",
            "name": "sean webb",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tim_burchett",
            "name": "tim burchett",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tom_satterly",
            "name": "tom satterly",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "erik_prince",
            "name": "erik prince",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "mark_oz_geist",
            "name": "mark oz geist",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "bedros_keuilian",
            "name": "bedros keuilian",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tony_cowden",
            "name": "tony cowden",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "vivek_ramaswamy",
            "name": "vivek ramaswamy",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "brandon_fugal",
            "name": "brandon fugal",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "don_graves",
            "name": "don graves",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tyler_vargas-andrews",
            "name": "tyler vargas-andrews",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "eli_crane",
            "name": "eli crane",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "eric_hecker",
            "name": "eric hecker",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "dc_long",
            "name": "dc long",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "michael_herrera",
            "name": "michael herrera",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "steven_greer",
            "name": "steven greer",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "jim_caviezel",
            "name": "jim caviezel",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tyler_grey",
            "name": "tyler grey",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "david_tice",
            "name": "david tice",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "michael_bagnell",
            "name": "michael bagnell",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "buck_sexton",
            "name": "buck sexton",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "nick_kefalides",
            "name": "nick kefalides",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "ryan_montgomery",
            "name": "ryan montgomery",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "prime_hall",
            "name": "prime hall",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "david_mccormick",
            "name": "david mccormick",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "andrew_bustamante",
            "name": "andrew bustamante",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "chris_vansant",
            "name": "chris vansant",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "dallas_alexander",
            "name": "dallas alexander",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "bob_ninja_poras",
            "name": "bob ninja poras",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "solbere",
            "name": "solbere",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "eddie_penney",
            "name": "eddie penney",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "rob_luna",
            "name": "rob luna",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "kyle_morgan",
            "name": "kyle morgan",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "mark_turner",
            "name": "mark turner",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "struggle_jennings",
            "name": "struggle jennings",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "roger_reaves",
            "name": "roger reaves",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "machine_gun_preacher",
            "name": "machine gun preacher",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "lt._col._scott_mann",
            "name": "lt. col. scott mann",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "john_delony",
            "name": "john delony",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "cody_alford",
            "name": "cody alford",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "lily_tang_williams",
            "name": "lily tang williams",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "jason_redman",
            "name": "jason redman",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "marc_polymeropoulos",
            "name": "marc polymeropoulos",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "trevor_millar",
            "name": "trevor millar",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "nick_machine_lavery",
            "name": "nick machine lavery",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "rob_o'neill",
            "name": "rob o'neill",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "alex_epstein",
            "name": "alex epstein",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "david_rodriguez",
            "name": "david rodriguez",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "peter_schweizer",
            "name": "peter schweizer",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "robby_starbuck",
            "name": "robby starbuck",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "mikal_vega",
            "name": "mikal vega",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "chief_hallgrimson",
            "name": "chief hallgrimson",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "dj_shipley",
            "name": "dj shipley",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "alan_cooper",
            "name": "alan cooper",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "bernie_kerik",
            "name": "bernie kerik",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "marcus_capone",
            "name": "marcus capone",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "tu_lam",
            "name": "tu lam",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "eddie_gallagher",
            "name": "eddie gallagher",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "travis_howze",
            "name": "travis howze",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "mike_ritland",
            "name": "mike ritland",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "don_bradley",
            "name": "don bradley",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "travis_kennedy",
            "name": "travis kennedy",
            "val": 1,
            "color1": 9,
            "color2": 5,
            "color04": 0,
            "color02": 0,
            "color075": 7
        },
        {
            "id": "trevor_noah",
            "name": "trevor noah",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "mark_cuban",
            "name": "mark cuban",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "nick_kyrgios",
            "name": "nick kyrgios",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "mayor_karen_bass",
            "name": "mayor karen bass",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "dababy",
            "name": "dababy",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "bill_gates",
            "name": "bill gates",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "kerry_washington",
            "name": "kerry washington",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "dwayne_the_rock_johnson",
            "name": "dwayne the rock johnson",
            "val": 1,
            "color1": 8,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 6
        },
        {
            "id": "jason_bateman",
            "name": "jason bateman",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sean_hayes",
            "name": "sean hayes",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "will_arnett",
            "name": "will arnett",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "selena_gomez",
            "name": "selena gomez",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "arnold_schwarzenegger",
            "name": "arnold schwarzenegger",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "santa",
            "name": "santa",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "carey_mulligan",
            "name": "carey mulligan",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emma_stone",
            "name": "emma stone",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ronan_farrow",
            "name": "ronan farrow",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "taika_waititi",
            "name": "taika waititi",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stephen_curry",
            "name": "stephen curry",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_stipe",
            "name": "michael stipe",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "marshawn_lynch",
            "name": "marshawn lynch",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_mcenroe",
            "name": "john mcenroe",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rachel_maddow",
            "name": "rachel maddow",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "peyton_manning",
            "name": "peyton manning",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_simon",
            "name": "paul simon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bill_simmons",
            "name": "bill simmons",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kara_swisher",
            "name": "kara swisher",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "willem_dafoe",
            "name": "willem dafoe",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jimmy_kimmel",
            "name": "jimmy kimmel",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jen_psaki",
            "name": "jen psaki",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rose_byrne",
            "name": "rose byrne",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jessica_chastain",
            "name": "jessica chastain",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_giamatti",
            "name": "paul giamatti",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "andy_richter",
            "name": "andy richter",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "greta_gerwig",
            "name": "greta gerwig",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "aoc",
            "name": "aoc",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steven_soderbergh",
            "name": "steven soderbergh",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_letterman",
            "name": "david letterman",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "max_tegmark",
            "name": "max tegmark",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tom_holland",
            "name": "tom holland",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "conan_o\u2019brien",
            "name": "conan o\u2019brien",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "idris_elba",
            "name": "idris elba",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "will_ferrell",
            "name": "will ferrell",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "simon_pegg",
            "name": "simon pegg",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennifer_garner",
            "name": "jennifer garner",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kaley_cuoco",
            "name": "kaley cuoco",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "depeche_mode",
            "name": "depeche mode",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "matthew_rhys",
            "name": "matthew rhys",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_anka",
            "name": "paul anka",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "the_russo_brothers",
            "name": "the russo brothers",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joaquin_phoenix",
            "name": "joaquin phoenix",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "simon_le_bon",
            "name": "simon le bon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jon_favreau",
            "name": "jon favreau",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "al_michaels",
            "name": "al michaels",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "natasha_lyonne",
            "name": "natasha lyonne",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brendan_fraser",
            "name": "brendan fraser",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "billy_crudup",
            "name": "billy crudup",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eugene_levy",
            "name": "eugene levy",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tracee_ellis_ross",
            "name": "tracee ellis ross",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bono",
            "name": "bono",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steven_spielberg",
            "name": "steven spielberg",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_krasinski",
            "name": "john krasinski",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alejandro_i\u00f1\u00e1rritu",
            "name": "alejandro i\u00f1\u00e1rritu",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "james_cameron",
            "name": "james cameron",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emily_blunt",
            "name": "emily blunt",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sigourney_weaver",
            "name": "sigourney weaver",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rian_johnson",
            "name": "rian johnson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kumail_nanjiani",
            "name": "kumail nanjiani",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "president_joe_biden",
            "name": "president joe biden",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "elisabeth_moss",
            "name": "elisabeth moss",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steve_carell",
            "name": "steve carell",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tony_hale",
            "name": "tony hale",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kevin_bacon",
            "name": "kevin bacon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "anderson_cooper",
            "name": "anderson cooper",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "allison_janney",
            "name": "allison janney",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "katy_perry",
            "name": "katy perry",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ethan_hawke",
            "name": "ethan hawke",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ewan_mcgregor",
            "name": "ewan mcgregor",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kenan_thompson",
            "name": "kenan thompson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shawn_levy",
            "name": "shawn levy",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "arcade_fire",
            "name": "arcade fire",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jordan_peele",
            "name": "jordan peele",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "james_burrows",
            "name": "james burrows",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jack_black",
            "name": "jack black",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jeff_bridges",
            "name": "jeff bridges",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jenny_slate",
            "name": "jenny slate",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chris_pratt",
            "name": "chris pratt",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bradley_cooper",
            "name": "bradley cooper",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "phil_lord",
            "name": "phil lord",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "christopher_miller",
            "name": "christopher miller",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kristen_wiig",
            "name": "kristen wiig",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ben_stiller",
            "name": "ben stiller",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_mulaneymike_myers",
            "name": "john mulaneymike myers",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "liam_neeson",
            "name": "liam neeson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "craig_robinson",
            "name": "craig robinson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_lewis",
            "name": "michael lewis",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jon_hamm",
            "name": "jon hamm",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "cate_blanchett",
            "name": "cate blanchett",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_thomas_anderson",
            "name": "paul thomas anderson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "charlie_day",
            "name": "charlie day",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "courteney_cox",
            "name": "courteney cox",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eddie_vedder",
            "name": "eddie vedder",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_mckay",
            "name": "adam mckay",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "johnny_knoxville",
            "name": "johnny knoxville",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_moore",
            "name": "michael moore",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_byrne",
            "name": "david byrne",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kathryn_hahn",
            "name": "kathryn hahn",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "barry_sonnenfeld",
            "name": "barry sonnenfeld",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "woody_harrelson",
            "name": "woody harrelson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "will_forte",
            "name": "will forte",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jimmy_fallon",
            "name": "jimmy fallon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sandra_bullock",
            "name": "sandra bullock",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "halle_berry",
            "name": "halle berry",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tom_hanks",
            "name": "tom hanks",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joe_buck",
            "name": "joe buck",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_remnick",
            "name": "david remnick",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jeff_daniels",
            "name": "jeff daniels",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ken_burns",
            "name": "ken burns",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tiffany_haddish",
            "name": "tiffany haddish",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "fred_armisen",
            "name": "fred armisen",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sean_penn",
            "name": "sean penn",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "octavia_spencer",
            "name": "octavia spencer",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "daniel_ricciardo",
            "name": "daniel ricciardo",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "j.j._abrams",
            "name": "j.j. abrams",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joy_reid",
            "name": "joy reid",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ryan_reynolds",
            "name": "ryan reynolds",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lebron_james",
            "name": "lebron james",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jos\u00e9_andr\u00e9s",
            "name": "jos\u00e9 andr\u00e9s",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "justin_theroux",
            "name": "justin theroux",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rob_mcelhenney",
            "name": "rob mcelhenney",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mitch_hurwitz",
            "name": "mitch hurwitz",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jake_tapper",
            "name": "jake tapper",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "zach_galifianakis",
            "name": "zach galifianakis",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tina_fey",
            "name": "tina fey",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "amy_sedaris",
            "name": "amy sedaris",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jessica_meir",
            "name": "jessica meir",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ted_sarandos",
            "name": "ted sarandos",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stephen_colbert",
            "name": "stephen colbert",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brad_paisley",
            "name": "brad paisley",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "george_clooney",
            "name": "george clooney",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "awkwafina",
            "name": "awkwafina",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "billie_eilish",
            "name": "billie eilish",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "finneas_o'connell",
            "name": "finneas o'connell",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "darius_rucker",
            "name": "darius rucker",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "julia_louis-dreyfus",
            "name": "julia louis-dreyfus",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bryan_cranston",
            "name": "bryan cranston",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "martin_short",
            "name": "martin short",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "megan_rapinoe",
            "name": "megan rapinoe",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "james_corden",
            "name": "james corden",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ron_howard",
            "name": "ron howard",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ricky_gervais",
            "name": "ricky gervais",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_mccartney",
            "name": "paul mccartney",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_chang",
            "name": "david chang",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brendan_shanahan",
            "name": "brendan shanahan",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "reese_witherspoon",
            "name": "reese witherspoon",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stacey_abrams",
            "name": "stacey abrams",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_sandler",
            "name": "adam sandler",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "clayton_kershaw",
            "name": "clayton kershaw",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennifer_aniston",
            "name": "jennifer aniston",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gustavo_dudamel",
            "name": "gustavo dudamel",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "maya_rudolph",
            "name": "maya rudolph",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kamala_harris",
            "name": "kamala harris",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "seth_rogen",
            "name": "seth rogen",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "melissa_mccarthy",
            "name": "melissa mccarthy",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dax_shepard",
            "name": "dax shepard",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "vanessa_marin",
            "name": "vanessa marin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "wyatt",
            "name": "wyatt",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kurt_russell",
            "name": "kurt russell",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "matthew_desmond",
            "name": "matthew desmond",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "billie_joe_armstrong",
            "name": "billie joe armstrong",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "taraji_p._henson",
            "name": "taraji p. henson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "maria_sharapova",
            "name": "maria sharapova",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jon_batiste",
            "name": "jon batiste",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "daniel_markovits",
            "name": "daniel markovits",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eva_longoria",
            "name": "eva longoria",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "barbara_kingsolver",
            "name": "barbara kingsolver",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tom_hansen",
            "name": "tom hansen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dan_ariely",
            "name": "dan ariely",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "craig_ferguson",
            "name": "craig ferguson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jada_pinkett_smith",
            "name": "jada pinkett smith",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "morgan_neville",
            "name": "morgan neville",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jonathan_van_ness",
            "name": "jonathan van ness",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "prachi_gupta",
            "name": "prachi gupta",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mustafa_suleyman",
            "name": "mustafa suleyman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "idina_menzel",
            "name": "idina menzel",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amy_edmondson",
            "name": "amy edmondson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jake_johnson",
            "name": "jake johnson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jim_farley:_jim_farley",
            "name": "jim farley: jim farley",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tig_notaro",
            "name": "tig notaro",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_derulo",
            "name": "jason derulo",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "wendy_mogel",
            "name": "wendy mogel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nurture_vs_nurture",
            "name": "nurture vs nurture",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kristen_bell",
            "name": "kristen bell",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "allyson_felix",
            "name": "allyson felix",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kate_mara",
            "name": "kate mara",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennifer_ackerman",
            "name": "jennifer ackerman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "terry_crews",
            "name": "terry crews",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "neil_theise",
            "name": "neil theise",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_shannon",
            "name": "michael shannon",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "valerie_fridland",
            "name": "valerie fridland",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "minka_kelly",
            "name": "minka kelly",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "peter_singer",
            "name": "peter singer",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chris_paul",
            "name": "chris paul",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "natalie_portman",
            "name": "natalie portman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lee_hood",
            "name": "lee hood",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nathan_price",
            "name": "nathan price",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lizzy_caplan",
            "name": "lizzy caplan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "james_comey",
            "name": "james comey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_waldman",
            "name": "michael waldman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jonas_brothers",
            "name": "jonas brothers",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nicholas_braun",
            "name": "nicholas braun",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shonda_rhimes",
            "name": "shonda rhimes",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_katims",
            "name": "jason katims",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_sedaris",
            "name": "david sedaris",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nita_farahany",
            "name": "nita farahany",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jake_gyllenhaal",
            "name": "jake gyllenhaal",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_bloom",
            "name": "paul bloom",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "barbie_ferreira",
            "name": "barbie ferreira",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alison_roman",
            "name": "alison roman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_magsamen",
            "name": "susan magsamen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ivy_ross",
            "name": "ivy ross",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kurtwood_smith",
            "name": "kurtwood smith",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jenna_ortega",
            "name": "jenna ortega",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shania_twain",
            "name": "shania twain",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_rudd",
            "name": "paul rudd",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "andrew_newberg",
            "name": "andrew newberg",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tess_wilkinson-ryan",
            "name": "tess wilkinson-ryan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ramy_youssef",
            "name": "ramy youssef",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "pamela_anderson",
            "name": "pamela anderson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "scott_galloway",
            "name": "scott galloway",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_scheer",
            "name": "paul scheer",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sue_johnson",
            "name": "sue johnson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "anna_kendrick",
            "name": "anna kendrick",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "phil_stutz",
            "name": "phil stutz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gabrielle_union",
            "name": "gabrielle union",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "esther_perel",
            "name": "esther perel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "richard_branson",
            "name": "richard branson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "post_retrieval",
            "name": "post retrieval",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gloria_mark",
            "name": "gloria mark",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "andrew_solomon",
            "name": "andrew solomon",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "victoria_beckham",
            "name": "victoria beckham",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "yuval_harari",
            "name": "yuval harari",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dana",
            "name": "dana",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_stamos",
            "name": "john stamos",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "constance_wu",
            "name": "constance wu",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "will_bunch",
            "name": "will bunch",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eve_wiley",
            "name": "eve wiley",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bee",
            "name": "bee",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gwen_stefani",
            "name": "gwen stefani",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "felix_gillette",
            "name": "felix gillette",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_koblin",
            "name": "john koblin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emily_oster",
            "name": "emily oster",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "january_jones",
            "name": "january jones",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "hasan_minhaj",
            "name": "hasan minhaj",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "siddhartha_mukherjee",
            "name": "siddhartha mukherjee",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "douglas_nejamie",
            "name": "douglas nejamie",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dre",
            "name": "dre",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rachel",
            "name": "rachel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "reza_aslan",
            "name": "reza aslan",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "scarlett_johansson",
            "name": "scarlett johansson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jonathan_abrams",
            "name": "jonathan abrams",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "saul_kassin",
            "name": "saul kassin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennette_mccurdy",
            "name": "jennette mccurdy",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ice-t",
            "name": "ice-t",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lili_reinhart",
            "name": "lili reinhart",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jamie_fiore_higgins",
            "name": "jamie fiore higgins",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "erin_kimmerle",
            "name": "erin kimmerle",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "george_monbiot",
            "name": "george monbiot",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "zoey_deutch",
            "name": "zoey deutch",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "woo-kyoung_ahn",
            "name": "woo-kyoung ahn",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_lieberman",
            "name": "david lieberman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jesse_tyler_ferguson",
            "name": "jesse tyler ferguson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tracy_dennis-tiwary",
            "name": "tracy dennis-tiwary",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shaun_white",
            "name": "shaun white",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_early",
            "name": "john early",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rick_glassman",
            "name": "rick glassman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "seirian_sumner",
            "name": "seirian sumner",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kathleen_belew",
            "name": "kathleen belew",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "connie_britton",
            "name": "connie britton",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brett_scott",
            "name": "brett scott",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steve_brusatte",
            "name": "steve brusatte",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "laura_linney",
            "name": "laura linney",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "reggie_fils-aim\u00e9",
            "name": "reggie fils-aim\u00e9",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ed_yong",
            "name": "ed yong",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "zazie_beetz",
            "name": "zazie beetz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_cain",
            "name": "susan cain",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ike_barinholtz",
            "name": "ike barinholtz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ray_dalio",
            "name": "ray dalio",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lord",
            "name": "lord",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "miller",
            "name": "miller",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "colson_baker",
            "name": "colson baker",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_farrier",
            "name": "david farrier",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "cathy_o'neil",
            "name": "cathy o'neil",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "molly_shannon",
            "name": "molly shannon",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joseph_henrich",
            "name": "joseph henrich",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emmy_rossum",
            "name": "emmy rossum",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "a.j._jacobs",
            "name": "a.j. jacobs",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "floyd_abrams",
            "name": "floyd abrams",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "armchair_stories",
            "name": "armchair stories",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "paul_feig",
            "name": "paul feig",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "cillian_murphy",
            "name": "cillian murphy",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mandy_moore",
            "name": "mandy moore",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "daniel_pink",
            "name": "daniel pink",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sam_jones",
            "name": "sam jones",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "monica_aldama",
            "name": "monica aldama",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "seth_meyers",
            "name": "seth meyers",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "roy_choi",
            "name": "roy choi",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jacqueline_novogratz",
            "name": "jacqueline novogratz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alia_shawkat",
            "name": "alia shawkat",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nicholas_hoult",
            "name": "nicholas hoult",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bren\u00e9_brown",
            "name": "bren\u00e9 brown",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_schur",
            "name": "michael schur",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brian_klaas",
            "name": "brian klaas",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kristen_stewart",
            "name": "kristen stewart",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "max_greenfield",
            "name": "max greenfield",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jeremy_renner",
            "name": "jeremy renner",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eric_schmidt",
            "name": "eric schmidt",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dwyane_wade",
            "name": "dwyane wade",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brooke_shields",
            "name": "brooke shields",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "reid_hoffman",
            "name": "reid hoffman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chris_wallace",
            "name": "chris wallace",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nick_offerman",
            "name": "nick offerman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "erin_lee_carr",
            "name": "erin lee carr",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rachael_ray",
            "name": "rachael ray",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "secret_societies",
            "name": "secret societies",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "khalil_gibran_muhammad",
            "name": "khalil gibran muhammad",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stanley_tucci",
            "name": "stanley tucci",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ed_sheeran",
            "name": "ed sheeran",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_copperfield",
            "name": "david copperfield",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ted_bundy",
            "name": "ted bundy",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "van_jones",
            "name": "van jones",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "b.j._novak",
            "name": "b.j. novak",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "elijah_wood",
            "name": "elijah wood",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "drew_barrymore",
            "name": "drew barrymore",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alicia_vikander",
            "name": "alicia vikander",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "harold_s._koplewicz",
            "name": "harold s. koplewicz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "amanda_peet",
            "name": "amanda peet",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dark_tourism",
            "name": "dark tourism",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kate_bowler",
            "name": "kate bowler",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "carmelo_anthony",
            "name": "carmelo anthony",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brie_larson",
            "name": "brie larson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "samantha_bee",
            "name": "samantha bee",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "padma_lakshmi",
            "name": "padma lakshmi",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "cecily_strong",
            "name": "cecily strong",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "qanon",
            "name": "qanon",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "daryl_hall",
            "name": "daryl hall",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mark_ronson",
            "name": "mark ronson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "leon_bridges",
            "name": "leon bridges",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tim_grover",
            "name": "tim grover",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mila_kunis",
            "name": "mila kunis",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ashton_kutcher",
            "name": "ashton kutcher",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kate_beckinsale",
            "name": "kate beckinsale",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "medical_misinformation",
            "name": "medical misinformation",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "barack_obama",
            "name": "barack obama",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "j.b._smoove",
            "name": "j.b. smoove",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tara_stoinski",
            "name": "tara stoinski",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "luke_wilson",
            "name": "luke wilson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "fresh",
            "name": "fresh",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "barry_meier",
            "name": "barry meier",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jessica_biel",
            "name": "jessica biel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chris_bosh",
            "name": "chris bosh",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ufos",
            "name": "ufos",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bubba_wallace",
            "name": "bubba wallace",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "vincent_d'onofrio",
            "name": "vincent d'onofrio",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_stryker",
            "name": "susan stryker",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "julianna_margulies",
            "name": "julianna margulies",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "yusef_salaam",
            "name": "yusef salaam",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ethan_herisse",
            "name": "ethan herisse",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "daniel_kahneman",
            "name": "daniel kahneman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jonathan_tucker",
            "name": "jonathan tucker",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "prince_harry",
            "name": "prince harry",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "simulation_theorykwame_onwuachi",
            "name": "simulation theorykwame onwuachi",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kelly_osbourne",
            "name": "kelly osbourne",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "alexi_pappas",
            "name": "alexi pappas",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "william_jackson_harper",
            "name": "william jackson harper",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dorothy_brown",
            "name": "dorothy brown",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "macklemore",
            "name": "macklemore",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_moss",
            "name": "michael moss",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "hank_azaria",
            "name": "hank azaria",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "daniel_goleman",
            "name": "daniel goleman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lamorne_morris",
            "name": "lamorne morris",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "walter_isaacson",
            "name": "walter isaacson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rachel_bilson",
            "name": "rachel bilson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sam_pollard",
            "name": "sam pollard",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_liautaud",
            "name": "susan liautaud",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "robin_thicke",
            "name": "robin thicke",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ethan_kross",
            "name": "ethan kross",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ben_schwartz",
            "name": "ben schwartz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "george_saunders",
            "name": "george saunders",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rupert_grint",
            "name": "rupert grint",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_eric_dyson",
            "name": "michael eric dyson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "amy_poehler",
            "name": "amy poehler",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chad_sanders",
            "name": "chad sanders",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jane_goodall",
            "name": "jane goodall",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "viggo_mortensen",
            "name": "viggo mortensen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "erin_meyer",
            "name": "erin meyer",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "salma_hayek",
            "name": "salma hayek",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emily_morse",
            "name": "emily morse",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_segel",
            "name": "jason segel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_grant_returns",
            "name": "adam grant returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "robert_livingston",
            "name": "robert livingston",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jethro_bovingdon",
            "name": "jethro bovingdon",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rob_corddry",
            "name": "rob corddry",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "justin_timberlake",
            "name": "justin timberlake",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jamil_zaki",
            "name": "jamil zaki",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "common",
            "name": "common",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "brad_grossman",
            "name": "brad grossman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "randy_jackson",
            "name": "randy jackson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sanjay_gupta_returns",
            "name": "sanjay gupta returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jackie_tohn",
            "name": "jackie tohn",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_o._brennan",
            "name": "john o. brennan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "shawn_mendes",
            "name": "shawn mendes",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dov_fox",
            "name": "dov fox",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emmanuel_acho",
            "name": "emmanuel acho",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "scott_kelly",
            "name": "scott kelly",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "hillary_clinton",
            "name": "hillary clinton",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_david",
            "name": "susan david",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "halsey",
            "name": "halsey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "yuval_harari_returns",
            "name": "yuval harari returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_brody",
            "name": "adam brody",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joseph_laycock",
            "name": "joseph laycock",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "erin_geiger_smith",
            "name": "erin geiger smith",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chelsea_handler_returns",
            "name": "chelsea handler returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "isabel_wilkerson",
            "name": "isabel wilkerson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eric_lander",
            "name": "eric lander",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sara_gilbert",
            "name": "sara gilbert",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bob_woodward",
            "name": "bob woodward",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jon_bon_jovi",
            "name": "jon bon jovi",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "aly_raisman",
            "name": "aly raisman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sofia_coppola",
            "name": "sofia coppola",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sara_bareilles",
            "name": "sara bareilles",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "leah_plunkett",
            "name": "leah plunkett",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "keith_urban",
            "name": "keith urban",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "susan_burton",
            "name": "susan burton",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tom_brady",
            "name": "tom brady",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "seth_macfarlane",
            "name": "seth macfarlane",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lenore_skenazy",
            "name": "lenore skenazy",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ellen_pompeo",
            "name": "ellen pompeo",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_tubbs",
            "name": "michael tubbs",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "atul_gawande",
            "name": "atul gawande",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "colin_jost",
            "name": "colin jost",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bradley_edwards",
            "name": "bradley edwards",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "leslie_odom_jr.",
            "name": "leslie odom jr.",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "angela_duckworth",
            "name": "angela duckworth",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dave_franco",
            "name": "dave franco",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "travis_pastrana",
            "name": "travis pastrana",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jud_brewer",
            "name": "jud brewer",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emily_mortimer",
            "name": "emily mortimer",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennifer_eberhardt",
            "name": "jennifer eberhardt",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nina_vasan",
            "name": "nina vasan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "juliette_lewis",
            "name": "juliette lewis",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jeffrey_sachs",
            "name": "jeffrey sachs",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "blake_griffin",
            "name": "blake griffin",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "beastie_boys",
            "name": "beastie boys",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alanis_morissette",
            "name": "alanis morissette",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ibram_x._kendi",
            "name": "ibram x. kendi",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bradley_whitford",
            "name": "bradley whitford",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "heather_mcghee",
            "name": "heather mcghee",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jon_meacham",
            "name": "jon meacham",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "laurie_santos",
            "name": "laurie santos",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "50_cent",
            "name": "50 cent",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rajiv_shah",
            "name": "rajiv shah",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "america_ferrera",
            "name": "america ferrera",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dan_heath",
            "name": "dan heath",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "zo\u00eb_kravitz",
            "name": "zo\u00eb kravitz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "glennon_doyle",
            "name": "glennon doyle",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sheryl_crow",
            "name": "sheryl crow",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jessica_lahey",
            "name": "jessica lahey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ed_helms",
            "name": "ed helms",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "andrew_marantz",
            "name": "andrew marantz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joy_bryant_returns",
            "name": "joy bryant returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lydia_denworth",
            "name": "lydia denworth",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sanjay_gupta_on_covid-19",
            "name": "sanjay gupta on covid-19",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tom_silver",
            "name": "tom silver",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lennon_parham",
            "name": "lennon parham",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_mosseri",
            "name": "adam mosseri",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bj_fogg",
            "name": "bj fogg",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "peggy_orenstein",
            "name": "peggy orenstein",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ashton_kutcher_returns",
            "name": "ashton kutcher returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_de_le\u00f3n",
            "name": "jason de le\u00f3n",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alison_brie",
            "name": "alison brie",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "monica",
            "name": "monica",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ezra_klein",
            "name": "ezra klein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "introducing:_monica",
            "name": "introducing: monica",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jess_love_boys",
            "name": "jess love boys",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "josh_gad",
            "name": "josh gad",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jared_cohen",
            "name": "jared cohen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "claire_danes",
            "name": "claire danes",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dierks_bentley",
            "name": "dierks bentley",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "drew_carey",
            "name": "drew carey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sam_harris_returns",
            "name": "sam harris returns",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "keri_russell",
            "name": "keri russell",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rhys_darby_(live)",
            "name": "rhys darby (live)",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "t.i.",
            "name": "t.i.",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sam_elliott",
            "name": "sam elliott",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "laura_beil",
            "name": "laura beil",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "martina_mcbride",
            "name": "martina mcbride",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "emilia_clarke",
            "name": "emilia clarke",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jonathan_safran_foer",
            "name": "jonathan safran foer",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kate",
            "name": "kate",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "oliver_hudson",
            "name": "oliver hudson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "liz_plank",
            "name": "liz plank",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "edward_nortonandrew_zimmern",
            "name": "edward nortonandrew zimmern",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nadine_burke_harris",
            "name": "nadine burke harris",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lori_gottlieb",
            "name": "lori gottlieb",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "the_avett_brothers",
            "name": "the avett brothers",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "monica_potter",
            "name": "monica potter",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "dog_the_bounty_hunter",
            "name": "dog the bounty hunter",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joseph_gordon-levitt",
            "name": "joseph gordon-levitt",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "pete_carroll",
            "name": "pete carroll",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kal_penn",
            "name": "kal penn",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_koechner",
            "name": "david koechner",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "beanie_feldstein",
            "name": "beanie feldstein",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steven_gundry",
            "name": "steven gundry",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "tal_ben-shahar",
            "name": "tal ben-shahar",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "busy_philipps",
            "name": "busy philipps",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "peter_krause",
            "name": "peter krause",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "casey_affleck",
            "name": "casey affleck",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ben_platt",
            "name": "ben platt",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mayor_eric_garcetti",
            "name": "mayor eric garcetti",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lake_bell",
            "name": "lake bell",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "rahul_jandial",
            "name": "rahul jandial",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "fred_savage",
            "name": "fred savage",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jennifer_newsom",
            "name": "jennifer newsom",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "steve_madden",
            "name": "steve madden",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "aubrey_plaza",
            "name": "aubrey plaza",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "alex_katehakis",
            "name": "alex katehakis",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_walton",
            "name": "david walton",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "elizabeth_gilbert",
            "name": "elizabeth gilbert",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "samin_nosrat",
            "name": "samin nosrat",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "craig_t._nelson",
            "name": "craig t. nelson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "monica_padman",
            "name": "monica padman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "justin_long",
            "name": "justin long",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bill_nye",
            "name": "bill nye",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stephen_merchant",
            "name": "stephen merchant",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "eric_topol",
            "name": "eric topol",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "norah_jones",
            "name": "norah jones",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_gervais",
            "name": "michael gervais",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_pally",
            "name": "adam pally",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_rosenbaum",
            "name": "michael rosenbaum",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_kim",
            "name": "john kim",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chris_d'elia",
            "name": "chris d'elia",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "thomas_middleditch",
            "name": "thomas middleditch",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "evan_rachel_wood",
            "name": "evan rachel wood",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "reshma_saujani",
            "name": "reshma saujani",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_gottman",
            "name": "john gottman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gillian_flynn",
            "name": "gillian flynn",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "chelsea_peretti",
            "name": "chelsea peretti",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_mantzoukas",
            "name": "jason mantzoukas",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ryan_hansen",
            "name": "ryan hansen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "todd_rose",
            "name": "todd rose",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "michael_pe\u00f1a",
            "name": "michael pe\u00f1a",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bret_weinstein",
            "name": "bret weinstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "lil_rel",
            "name": "lil rel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "scott_harrison",
            "name": "scott harrison",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "josh_hutcherson",
            "name": "josh hutcherson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "josh_duhamel",
            "name": "josh duhamel",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jason_biggs",
            "name": "jason biggs",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sophia_bush",
            "name": "sophia bush",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "andrea_savage",
            "name": "andrea savage",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "debby_ryan",
            "name": "debby ryan",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gordon_keith",
            "name": "gordon keith",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ira_glass",
            "name": "ira glass",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jerry_buting",
            "name": "jerry buting",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mark_duplass",
            "name": "mark duplass",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lena_dunhambren\u00e9_brown",
            "name": "lena dunhambren\u00e9 brown",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "drew",
            "name": "drew",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "yuval_noah_harari",
            "name": "yuval noah harari",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "wendi_mclendon-covey",
            "name": "wendi mclendon-covey",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mike_schur",
            "name": "mike schur",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "d'arcy_carden",
            "name": "d'arcy carden",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ted_danson",
            "name": "ted danson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "keith_morrison",
            "name": "keith morrison",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "matthew_lillard",
            "name": "matthew lillard",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "colin_hanks",
            "name": "colin hanks",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "allison_tolman",
            "name": "allison tolman",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "david_harbour",
            "name": "david harbour",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "john_gourley",
            "name": "john gourley",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "zachary_carothers)",
            "name": "zachary carothers)",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "laura_labo",
            "name": "laura labo",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "mae_whitman",
            "name": "mae whitman",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kaitlin_olson",
            "name": "kaitlin olson",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "talib_kweli",
            "name": "talib kweli",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "erika_christensen",
            "name": "erika christensen",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bob_mervak",
            "name": "bob mervak",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joel_mchale",
            "name": "joel mchale",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "chris_hardwick",
            "name": "chris hardwick",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "seth_green",
            "name": "seth green",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "katie_couric",
            "name": "katie couric",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lauren_graham",
            "name": "lauren graham",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "anna_faris",
            "name": "anna faris",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "van_hunt",
            "name": "van hunt",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ellen_degeneres",
            "name": "ellen degeneres",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "adam_scott",
            "name": "adam scott",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "pete_wentz",
            "name": "pete wentz",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "joy_bryant",
            "name": "joy bryant",
            "val": 1,
            "color1": 11,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "amanda_hirsch",
            "name": "amanda hirsch",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sam_feher",
            "name": "sam feher",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "danielle_olivera",
            "name": "danielle olivera",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "olivia_flowers",
            "name": "olivia flowers",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rita_ora",
            "name": "rita ora",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ziwe",
            "name": "ziwe",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "alyson_stoner",
            "name": "alyson stoner",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jvn",
            "name": "jvn",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tyler_cameron",
            "name": "tyler cameron",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brynn_whitfield",
            "name": "brynn whitfield",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "stacy_snyder",
            "name": "stacy snyder",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "charli_d'amelio",
            "name": "charli d'amelio",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bre_tiesi",
            "name": "bre tiesi",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bella_twins",
            "name": "bella twins",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "elizabeth_chambers",
            "name": "elizabeth chambers",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "julia_haart",
            "name": "julia haart",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jared_freid",
            "name": "jared freid",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "molly",
            "name": "molly",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "zach",
            "name": "zach",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "erin_dana_lichy",
            "name": "erin dana lichy",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cody_rigsby",
            "name": "cody rigsby",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "angie_pumps_sullivan",
            "name": "angie pumps sullivan",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jennifer_welch",
            "name": "jennifer welch",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bethenny_frankel",
            "name": "bethenny frankel",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "maria_menounos",
            "name": "maria menounos",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jemima_kirke",
            "name": "jemima kirke",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chrisell_stause",
            "name": "chrisell stause",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lilly_singh",
            "name": "lilly singh",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andy_cohen",
            "name": "andy cohen",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "zoe_lister_jones",
            "name": "zoe lister jones",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "katie_maloney",
            "name": "katie maloney",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lindsay_hubbard",
            "name": "lindsay hubbard",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "carl_radke",
            "name": "carl radke",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "charlotte_lawrence",
            "name": "charlotte lawrence",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sarah_shahi",
            "name": "sarah shahi",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sarah_michelle_gellar",
            "name": "sarah michelle gellar",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brianne_howey",
            "name": "brianne howey",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "steve_howey",
            "name": "steve howey",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ava_max",
            "name": "ava max",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sarah_lampert",
            "name": "sarah lampert",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bill_lawrence",
            "name": "bill lawrence",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "christa_miller",
            "name": "christa miller",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kaitlyn_bristowe",
            "name": "kaitlyn bristowe",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "robert_brotherton",
            "name": "robert brotherton",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ra\u2019ed_saade",
            "name": "ra\u2019ed saade",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "remi_bader",
            "name": "remi bader",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "simon_huck",
            "name": "simon huck",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amanda_kloots",
            "name": "amanda kloots",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cole_barnett",
            "name": "cole barnett",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "karamo_brown",
            "name": "karamo brown",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "olivia_culpo",
            "name": "olivia culpo",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tembi_locke",
            "name": "tembi locke",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amy_loughren",
            "name": "amy loughren",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ashley_tisdale",
            "name": "ashley tisdale",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jackson_white",
            "name": "jackson white",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kelly_ripa",
            "name": "kelly ripa",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kourtney_kardashian",
            "name": "kourtney kardashian",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "arielle_vandenberg",
            "name": "arielle vandenberg",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "meghan_trainor",
            "name": "meghan trainor",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "clayton_echard",
            "name": "clayton echard",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "audrina_patridge",
            "name": "audrina patridge",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "aj_mclean",
            "name": "aj mclean",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "hannah_berner",
            "name": "hannah berner",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "leah_mcsweeney",
            "name": "leah mcsweeney",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "khlo\u00e9_kardashian",
            "name": "khlo\u00e9 kardashian",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emily_baker",
            "name": "emily baker",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jenny_mollen",
            "name": "jenny mollen",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mya_allen",
            "name": "mya allen",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kim_kardashian",
            "name": "kim kardashian",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "the_birds_papaya",
            "name": "the birds papaya",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jason_tartick",
            "name": "jason tartick",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "pete__arielle_hirsch",
            "name": "pete  arielle hirsch",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mrs_dow_jones",
            "name": "mrs dow jones",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "scheana_shay",
            "name": "scheana shay",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "julia_fox",
            "name": "julia fox",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jamie_lynn",
            "name": "jamie lynn",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "davina_potratz",
            "name": "davina potratz",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emma_hernan",
            "name": "emma hernan",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lala_kent",
            "name": "lala kent",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "justin_anderson",
            "name": "justin anderson",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "pete_davidson",
            "name": "pete davidson",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "alyssa_amoroso",
            "name": "alyssa amoroso",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jared_lipscomb",
            "name": "jared lipscomb",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "maddison_brown",
            "name": "maddison brown",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "addison_rae",
            "name": "addison rae",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jade_roper_tolbert",
            "name": "jade roper tolbert",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mystic_michaela",
            "name": "mystic michaela",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kamanda",
            "name": "kamanda",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bat_sheva_haart",
            "name": "bat sheva haart",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sami_sage",
            "name": "sami sage",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nick_viall",
            "name": "nick viall",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "loren_brovarnik",
            "name": "loren brovarnik",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chrishell_stause",
            "name": "chrishell stause",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andrea_lavinthal",
            "name": "andrea lavinthal",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andrea_lopez",
            "name": "andrea lopez",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "pia_baroncini",
            "name": "pia baroncini",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "claire_holt",
            "name": "claire holt",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "erin_foster",
            "name": "erin foster",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sara_foster",
            "name": "sara foster",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "comments_by_celebs",
            "name": "comments by celebs",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "justin_sylvester",
            "name": "justin sylvester",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "paige_desorbo",
            "name": "paige desorbo",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "victoria_larson",
            "name": "victoria larson",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "carole_radziwill",
            "name": "carole radziwill",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jackie_goldschneider",
            "name": "jackie goldschneider",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chris_burns",
            "name": "chris burns",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "craig_conover",
            "name": "craig conover",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "violet_benson",
            "name": "violet benson",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bekah_martinez",
            "name": "bekah martinez",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "taylor_strecker",
            "name": "taylor strecker",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lilliana_vazquez",
            "name": "lilliana vazquez",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "shannon_ford",
            "name": "shannon ford",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "blake_horstmann",
            "name": "blake horstmann",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "heather_rae_young",
            "name": "heather rae young",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tarek_el_moussa",
            "name": "tarek el moussa",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "dylan_barbour",
            "name": "dylan barbour",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "reality_steve",
            "name": "reality steve",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "deuxmoi",
            "name": "deuxmoi",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kate_casey",
            "name": "kate casey",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ashley_i",
            "name": "ashley i",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "countess_luann_de_lesseps",
            "name": "countess luann de lesseps",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "christine_quinn",
            "name": "christine quinn",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "maya_vander",
            "name": "maya vander",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "francesca_farago",
            "name": "francesca farago",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mary_fitzgerald",
            "name": "mary fitzgerald",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "heather_mcdonald",
            "name": "heather mcdonald",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "danica_dow",
            "name": "danica dow",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "luke_gulbranson",
            "name": "luke gulbranson",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "daryn_carp",
            "name": "daryn carp",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "perez_hilton",
            "name": "perez hilton",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "what_do_j.lo",
            "name": "what do j.lo",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chris_appleton",
            "name": "chris appleton",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jackie",
            "name": "jackie",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "the_daily_dish",
            "name": "the daily dish",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "diana_espir",
            "name": "diana espir",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bravo_historian",
            "name": "bravo historian",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "justine_marjan",
            "name": "justine marjan",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rachael_o'brien",
            "name": "rachael o'brien",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "danny_pellegrino",
            "name": "danny pellegrino",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "anthony_lario",
            "name": "anthony lario",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "enty_lawyer",
            "name": "enty lawyer",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kelly_keegs",
            "name": "kelly keegs",
            "val": 1,
            "color1": 12,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "gabrielle_lyon",
            "name": "gabrielle lyon",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "paul_barattiero",
            "name": "paul barattiero",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "carrie_carda_md",
            "name": "carrie carda md",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jigar_gandhi",
            "name": "jigar gandhi",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "cedric_gervais",
            "name": "cedric gervais",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "jeff_davidson",
            "name": "jeff davidson",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "steve_harvey",
            "name": "steve harvey",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "stephen_a._smith",
            "name": "stephen a. smith",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "david_grutman",
            "name": "david grutman",
            "val": 1,
            "color1": 3,
            "color2": 2,
            "color04": 2,
            "color02": 1,
            "color075": 3
        },
        {
            "id": "adam_sosnick",
            "name": "adam sosnick",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "tom_ellsworth",
            "name": "tom ellsworth",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "incent_oshana",
            "name": "incent oshana",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bassem_youssef",
            "name": "bassem youssef",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "alina_habba",
            "name": "alina habba",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "emily_austin",
            "name": "emily austin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "@realcharliekirk",
            "name": "@realcharliekirk",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mar_mari_emmanuel",
            "name": "mar mari emmanuel",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "george_janko",
            "name": "george janko",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chris_cuomo",
            "name": "chris cuomo",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jeremy_boreing",
            "name": "jeremy boreing",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "roger_stone",
            "name": "roger stone",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "judge_joe_brown",
            "name": "judge joe brown",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "terrell_owens",
            "name": "terrell owens",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "nouriel_roubini",
            "name": "nouriel roubini",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bob_woodson",
            "name": "bob woodson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "charlie_kirk",
            "name": "charlie kirk",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ann_coulter",
            "name": "ann coulter",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "liz_wheeler",
            "name": "liz wheeler",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "steve_schmidt",
            "name": "steve schmidt",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "religious_roundtable",
            "name": "religious roundtable",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "candace_owens",
            "name": "candace owens",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "larry_elder",
            "name": "larry elder",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "general_michael_flynn",
            "name": "general michael flynn",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "brian",
            "name": "brian",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ed_krassenstein",
            "name": "ed krassenstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "francis_suarez",
            "name": "francis suarez",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "graham_stephen",
            "name": "graham stephen",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "anthony_weiner",
            "name": "anthony weiner",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "lauren_chen",
            "name": "lauren chen",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "col._douglas_macgregor",
            "name": "col. douglas macgregor",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "peter_navarro",
            "name": "peter navarro",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "elizabeth_pipko",
            "name": "elizabeth pipko",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "clay_travis",
            "name": "clay travis",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bjorn_lomborg",
            "name": "bjorn lomborg",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "allen_west",
            "name": "allen west",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "frank_rodriguez",
            "name": "frank rodriguez",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "barry_habib",
            "name": "barry habib",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ed_dowd",
            "name": "ed dowd",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "marian_tupy",
            "name": "marian tupy",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kevin_o'leary",
            "name": "kevin o'leary",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dennis_prager",
            "name": "dennis prager",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "home_team",
            "name": "home team",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "sam_sorbo",
            "name": "sam sorbo",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "destiny",
            "name": "destiny",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_rubenstein",
            "name": "david rubenstein",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "michael_saylor",
            "name": "michael saylor",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ari_fleischer",
            "name": "ari fleischer",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kevin_sorbo",
            "name": "kevin sorbo",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mike_rowepatrick_bet-david",
            "name": "mike rowepatrick bet-david",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rod_blagojevich",
            "name": "rod blagojevich",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dinesh_d'souza",
            "name": "dinesh d'souza",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "doug_ellin",
            "name": "doug ellin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "whitney_webb",
            "name": "whitney webb",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chet_hanx",
            "name": "chet hanx",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "katie_hopkins",
            "name": "katie hopkins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "curt_schilling",
            "name": "curt schilling",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "lt._col._stuart_scheller",
            "name": "lt. col. stuart scheller",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "nazanin_nour",
            "name": "nazanin nour",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mike_rinder",
            "name": "mike rinder",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "philip_mudd",
            "name": "philip mudd",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "stuart_kaplan",
            "name": "stuart kaplan",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ricardo_aguilar",
            "name": "ricardo aguilar",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "scott_perry",
            "name": "scott perry",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "the_hodgetwins",
            "name": "the hodgetwins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kerry_killinger",
            "name": "kerry killinger",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "papa_john",
            "name": "papa john",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "richard_gage",
            "name": "richard gage",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "shaq",
            "name": "shaq",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_anderson",
            "name": "john anderson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "vincent_oshana",
            "name": "vincent oshana",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "father_vincent_lampert",
            "name": "father vincent lampert",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ben_carson",
            "name": "ben carson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "royce_white",
            "name": "royce white",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "joe_walsh",
            "name": "joe walsh",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "batya_ungar-sargon",
            "name": "batya ungar-sargon",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "patrick_moore",
            "name": "patrick moore",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_paul_mac_issac",
            "name": "john paul mac issac",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rick_sanchez",
            "name": "rick sanchez",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jedediah_bila",
            "name": "jedediah bila",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ric_prado",
            "name": "ric prado",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "michael_franzese",
            "name": "michael franzese",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "catalina_lauf",
            "name": "catalina lauf",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "richard_werner",
            "name": "richard werner",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "peter_pry",
            "name": "peter pry",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "georges_st._pierre",
            "name": "georges st. pierre",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matt_walton",
            "name": "matt walton",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "paul_manafort",
            "name": "paul manafort",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rick_macci",
            "name": "rick macci",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_berlinski",
            "name": "david berlinski",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jo_jorgensen",
            "name": "jo jorgensen",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kevin_farley",
            "name": "kevin farley",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ken_goldin",
            "name": "ken goldin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "will_witt",
            "name": "will witt",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "leon_cooperman",
            "name": "leon cooperman",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chris_hansen",
            "name": "chris hansen",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "peter_mccullough",
            "name": "peter mccullough",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jack_barsky",
            "name": "jack barsky",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "gianni_russo",
            "name": "gianni russo",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jason_miller",
            "name": "jason miller",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_perkins",
            "name": "john perkins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rollo_tomassi",
            "name": "rollo tomassi",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "james_o'keefe",
            "name": "james o'keefe",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "christina_pushaw",
            "name": "christina pushaw",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_stossel",
            "name": "john stossel",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "danielle_dimartino_booth",
            "name": "danielle dimartino booth",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "nic_mckinley",
            "name": "nic mckinley",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "brendan_schaub",
            "name": "brendan schaub",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "danielle_dimartino-booth",
            "name": "danielle dimartino-booth",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "john_e._deaton",
            "name": "john e. deaton",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matt_zeller",
            "name": "matt zeller",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "e.b._tucker",
            "name": "e.b. tucker",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kurt_wuckert_jr.",
            "name": "kurt wuckert jr.",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "alec_baldwin",
            "name": "alec baldwin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "sammy_the_bull_gravano",
            "name": "sammy the bull gravano",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chazz_palminteri",
            "name": "chazz palminteri",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_harris_jr.",
            "name": "david harris jr.",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "general_spalding",
            "name": "general spalding",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "phil_heath",
            "name": "phil heath",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "meet_kevin",
            "name": "meet kevin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bernard_kerik",
            "name": "bernard kerik",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "major_williams",
            "name": "major williams",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matt_sapaula",
            "name": "matt sapaula",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bet-david_podcast",
            "name": "bet-david podcast",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "patrick",
            "name": "patrick",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "donald_trump",
            "name": "donald trump",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "steve_murphy",
            "name": "steve murphy",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "robert_kiyosaki",
            "name": "robert kiyosaki",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jerah_hutchins",
            "name": "jerah hutchins",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "matthew_cox",
            "name": "matthew cox",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeff_bezos",
            "name": "jeff bezos",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lee_cronin",
            "name": "lee cronin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lisa_randall",
            "name": "lisa randall",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "john_mearsheimer",
            "name": "john mearsheimer",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jared_kushner",
            "name": "jared kushner",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "greg_lukianoff",
            "name": "greg lukianoff",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "james_sexton",
            "name": "james sexton",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "neri_oxman",
            "name": "neri oxman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "joscha_bach",
            "name": "joscha bach",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "mohammed_el-kurd",
            "name": "mohammed el-kurd",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "benjamin_netanyahu",
            "name": "benjamin netanyahu",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "robert_f._kennedy_jr",
            "name": "robert f. kennedy jr",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "george_hotz",
            "name": "george hotz",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jimmy_wales",
            "name": "jimmy wales",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chris_lattner",
            "name": "chris lattner",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "neil_gershenfeld",
            "name": "neil gershenfeld",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "randall_kennedy",
            "name": "randall kennedy",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "anna_frebel",
            "name": "anna frebel",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "harvey_silverglate",
            "name": "harvey silverglate",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "stephen_wolfram",
            "name": "stephen wolfram",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "robert_playter",
            "name": "robert playter",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "manolis_kellis",
            "name": "manolis kellis",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "simone_giertz",
            "name": "simone giertz",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "edward_frenkel",
            "name": "edward frenkel",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "eliezer_yudkowsky",
            "name": "eliezer yudkowsky",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "shannon_curry",
            "name": "shannon curry",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ginni_rometty",
            "name": "ginni rometty",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "aaron_smith-levin",
            "name": "aaron smith-levin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tim_urban",
            "name": "tim urban",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "andrew_strominger",
            "name": "andrew strominger",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "aella",
            "name": "aella",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tim_dodd",
            "name": "tim dodd",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_kipping",
            "name": "david kipping",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeremi_suri",
            "name": "jeremi suri",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dennis_whyte",
            "name": "dennis whyte",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "omar_suleiman",
            "name": "omar suleiman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "mrbeast",
            "name": "mrbeast",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bet\u00fcl_ka\u00e7ar",
            "name": "bet\u00fcl ka\u00e7ar",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bhaskar_sunkara",
            "name": "bhaskar sunkara",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "nathalie_cabrol",
            "name": "nathalie cabrol",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "noam_brown",
            "name": "noam brown",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "roger_gracie",
            "name": "roger gracie",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "todd_howard",
            "name": "todd howard",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "guido_van_rossum",
            "name": "guido van rossum",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chris_tarbell",
            "name": "chris tarbell",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chamath_palihapitiya",
            "name": "chamath palihapitiya",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "fiona_hill",
            "name": "fiona hill",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "abbas_amanat",
            "name": "abbas amanat",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "andrej_karpathy",
            "name": "andrej karpathy",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kanye_'ye'_west",
            "name": "kanye 'ye' west",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "balaji_srinivasan",
            "name": "balaji srinivasan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "hikaru_nakamura",
            "name": "hikaru nakamura",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kate_darling",
            "name": "kate darling",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gothamchess",
            "name": "gothamchess",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "annaka_harris",
            "name": "annaka harris",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_levin",
            "name": "michael levin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "daniel_negreanu",
            "name": "daniel negreanu",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rana_el_kaliouby",
            "name": "rana el kaliouby",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ray_kurzweil",
            "name": "ray kurzweil",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "christopher_capozzola",
            "name": "christopher capozzola",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "botez_sisters",
            "name": "botez sisters",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "nick_lane",
            "name": "nick lane",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "noam_chomsky",
            "name": "noam chomsky",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "magnus_carlsen",
            "name": "magnus carlsen",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "liv_boeree",
            "name": "liv boeree",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "magatte_wade",
            "name": "magatte wade",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "brian_armstrong",
            "name": "brian armstrong",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "oriol_vinyals",
            "name": "oriol vinyals",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "martin_rees",
            "name": "martin rees",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bishop_robert_barron",
            "name": "bishop robert barron",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "steve_keen",
            "name": "steve keen",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "richard_haier",
            "name": "richard haier",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "demis_hassabis",
            "name": "demis hassabis",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jonathan_reisman",
            "name": "jonathan reisman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "richard_wolff",
            "name": "richard wolff",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tony_fadell",
            "name": "tony fadell",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "donald_hoffman",
            "name": "donald hoffman",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robin_hanson",
            "name": "robin hanson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dan_reynolds",
            "name": "dan reynolds",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "stephen_kotkin",
            "name": "stephen kotkin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sarma_melngailis",
            "name": "sarma melngailis",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "glenn_loury",
            "name": "glenn loury",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "saifedean_ammous",
            "name": "saifedean ammous",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chris_mason",
            "name": "chris mason",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "grimes",
            "name": "grimes",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "cristiano_amon",
            "name": "cristiano amon",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "skye_fitzgerald",
            "name": "skye fitzgerald",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chris_blattman",
            "name": "chris blattman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "brett_johnson",
            "name": "brett johnson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ariel_ekblaw",
            "name": "ariel ekblaw",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_wolpe",
            "name": "david wolpe",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "robert_proctor",
            "name": "robert proctor",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "nicole_perlroth",
            "name": "nicole perlroth",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "devon_larratt",
            "name": "devon larratt",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "garry_nolan",
            "name": "garry nolan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "thomas_tull",
            "name": "thomas tull",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "yann_lecun",
            "name": "yann lecun",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jay_bhattacharya",
            "name": "jay bhattacharya",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "peter_wang",
            "name": "peter wang",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "albert_bourla",
            "name": "albert bourla",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "norman_naimark",
            "name": "norman naimark",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "peter_woit",
            "name": "peter woit",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tom_brands",
            "name": "tom brands",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "robert_crews",
            "name": "robert crews",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kevin_systrom",
            "name": "kevin systrom",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "boris_sofman",
            "name": "boris sofman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "neal_stephenson",
            "name": "neal stephenson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "niall_ferguson",
            "name": "niall ferguson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "francis_collins",
            "name": "francis collins",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "steve_viscelli",
            "name": "steve viscelli",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jimmy_pedro",
            "name": "jimmy pedro",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_mina",
            "name": "michael mina",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "alex_gladstein",
            "name": "alex gladstein",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kelsi_sheren",
            "name": "kelsi sheren",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "richard_wrangham",
            "name": "richard wrangham",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sean_kelly",
            "name": "sean kelly",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jo_boaler",
            "name": "jo boaler",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeffrey_shainline",
            "name": "jeffrey shainline",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "travis_oliphant",
            "name": "travis oliphant",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "travis_stevens",
            "name": "travis stevens",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jay_mcclelland",
            "name": "jay mcclelland",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "douglas_lenat",
            "name": "douglas lenat",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "niels_jorgensen",
            "name": "niels jorgensen",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "donald_knuth",
            "name": "donald knuth",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jaron_lanier",
            "name": "jaron lanier",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rodney_brooks",
            "name": "rodney brooks",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "vincent_racaniello",
            "name": "vincent racaniello",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "wojciech_zaremba",
            "name": "wojciech zaremba",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jed_buchwald",
            "name": "jed buchwald",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "barry_barish",
            "name": "barry barish",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ishan_misra",
            "name": "ishan misra",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "cumrun_vafa",
            "name": "cumrun vafa",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "anya_fernald",
            "name": "anya fernald",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "konstantin_batygin",
            "name": "konstantin batygin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sara_walker",
            "name": "sara walker",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "clara_sousa-silva",
            "name": "clara sousa-silva",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rob_reid",
            "name": "rob reid",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "charles_hoskinson",
            "name": "charles hoskinson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jordan_ellenberg",
            "name": "jordan ellenberg",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "vitalik_buterin",
            "name": "vitalik buterin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "frank_wilczek",
            "name": "frank wilczek",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bryan_johnson",
            "name": "bryan johnson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "katherine_de_kleer",
            "name": "katherine de kleer",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "po-shen_loh",
            "name": "po-shen loh",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sergey_nazarov",
            "name": "sergey nazarov",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "yaron_brook",
            "name": "yaron brook",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "risto_miikkulainen",
            "name": "risto miikkulainen",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "robert_breedlove",
            "name": "robert breedlove",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tyler_cowen",
            "name": "tyler cowen",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "nic_carter",
            "name": "nic carter",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ryan_schiller",
            "name": "ryan schiller",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "anthony_pompliano",
            "name": "anthony pompliano",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ronald_sullivan",
            "name": "ronald sullivan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ryan_hall",
            "name": "ryan hall",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "silvio_micali",
            "name": "silvio micali",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "cal_newport",
            "name": "cal newport",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jim_keller",
            "name": "jim keller",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jason_calacanis",
            "name": "jason calacanis",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "brendan_eich",
            "name": "brendan eich",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "richard_craib",
            "name": "richard craib",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "zev_weinstein",
            "name": "zev weinstein",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "natalya_bailey",
            "name": "natalya bailey",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dmitry_korkin",
            "name": "dmitry korkin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dan_kokotov",
            "name": "dan kokotov",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "diana_walsh_pasulka",
            "name": "diana walsh pasulka",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "charles_isbell",
            "name": "charles isbell",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_littman",
            "name": "michael littman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dmitri_dolgov",
            "name": "dmitri dolgov",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "john_clarke",
            "name": "john clarke",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "erik_brynjolfsson",
            "name": "erik brynjolfsson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lisa_feldman_barrett",
            "name": "lisa feldman barrett",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "alex_filippenko",
            "name": "alex filippenko",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "scott_aaronson",
            "name": "scott aaronson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "james_gosling",
            "name": "james gosling",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lex_solo",
            "name": "lex solo",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "eugenia_kuyda",
            "name": "eugenia kuyda",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "francois_chollet",
            "name": "francois chollet",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_eagleman",
            "name": "david eagleman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "grant_sanderson",
            "name": "grant sanderson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sheldon_solomon",
            "name": "sheldon solomon",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sara_seager",
            "name": "sara seager",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dileep_george",
            "name": "dileep george",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "richard_karp",
            "name": "richard karp",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jitendra_malik",
            "name": "jitendra malik",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "brian_kernighan",
            "name": "brian kernighan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sergey_levine",
            "name": "sergey levine",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "matt_botvinick",
            "name": "matt botvinick",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "robert_langer",
            "name": "robert langer",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_patterson",
            "name": "david patterson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "karl_friston",
            "name": "karl friston",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sertac_karaman",
            "name": "sertac karaman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "stephen_schwarzman",
            "name": "stephen schwarzman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dawn_song",
            "name": "dawn song",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ilya_sutskever",
            "name": "ilya sutskever",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "daphne_koller",
            "name": "daphne koller",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "harry_cliff",
            "name": "harry cliff",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_silver",
            "name": "david silver",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "roger_penrose",
            "name": "roger penrose",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "simon_sinek",
            "name": "simon sinek",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "anca_dragan",
            "name": "anca dragan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "lee_smolin",
            "name": "lee smolin",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ann_druyan",
            "name": "ann druyan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "alex_garland",
            "name": "alex garland",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "john_hopfield",
            "name": "john hopfield",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "marcus_hutter",
            "name": "marcus hutter",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_i._jordan",
            "name": "michael i. jordan",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "andrew_ng",
            "name": "andrew ng",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "vladimir_vapnik",
            "name": "vladimir vapnik",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_chalmers",
            "name": "david chalmers",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "cristos_goodrow",
            "name": "cristos goodrow",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "paul_krugman",
            "name": "paul krugman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ayanna_howard",
            "name": "ayanna howard",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "melanie_mitchell",
            "name": "melanie mitchell",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jim_gates",
            "name": "jim gates",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "sebastian_thrun",
            "name": "sebastian thrun",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rohit_prasad",
            "name": "rohit prasad",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "judea_pearl",
            "name": "judea pearl",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gilbert_strang",
            "name": "gilbert strang",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "dava_newman",
            "name": "dava newman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "michael_kearns",
            "name": "michael kearns",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "bjarne_stroustrup",
            "name": "bjarne stroustrup",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "garry_kasparov",
            "name": "garry kasparov",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "david_ferrucci",
            "name": "david ferrucci",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gary_marcus",
            "name": "gary marcus",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "peter_norvig",
            "name": "peter norvig",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "leonard_susskind",
            "name": "leonard susskind",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "regina_barzilay",
            "name": "regina barzilay",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "colin_angle",
            "name": "colin angle",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "vijay_kumar",
            "name": "vijay kumar",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeremy_howard",
            "name": "jeremy howard",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "pamela_mccorduck",
            "name": "pamela mccorduck",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "keoki_jackson",
            "name": "keoki jackson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "paola_arlotta",
            "name": "paola arlotta",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kevin_scott",
            "name": "kevin scott",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gustav_soderstrom",
            "name": "gustav soderstrom",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "chris_urmson",
            "name": "chris urmson",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kai-fu_lee",
            "name": "kai-fu lee",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeff_hawkins",
            "name": "jeff hawkins",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rosalind_picard",
            "name": "rosalind picard",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "gavin_miller",
            "name": "gavin miller",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "rajat_monga",
            "name": "rajat monga",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "ian_goodfellow",
            "name": "ian goodfellow",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "greg_brockman",
            "name": "greg brockman",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "leslie_kaelbling",
            "name": "leslie kaelbling",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "kyle_vogt",
            "name": "kyle vogt",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tomaso_poggio",
            "name": "tomaso poggio",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tuomas_sandholm",
            "name": "tuomas sandholm",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "juergen_schmidhuber",
            "name": "juergen schmidhuber",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "pieter_abbeel",
            "name": "pieter abbeel",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "stuart_russell",
            "name": "stuart russell",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "jeff_atwood",
            "name": "jeff atwood",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "yoshua_bengio",
            "name": "yoshua bengio",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "christof_koch",
            "name": "christof koch",
            "val": 1,
            "color1": 4,
            "color2": 1,
            "color04": 1,
            "color02": 0,
            "color075": 2
        },
        {
            "id": "tana_mongeau",
            "name": "tana mongeau",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brooke",
            "name": "brooke",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tana",
            "name": "tana",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "james_charles",
            "name": "james charles",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mike_majlak",
            "name": "mike majlak",
            "val": 1,
            "color1": 8,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kirk_fox",
            "name": "kirk fox",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "the_regulars",
            "name": "the regulars",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "steveo",
            "name": "steveo",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "lil'_hobo",
            "name": "lil' hobo",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mike_feeney",
            "name": "mike feeney",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kam_patterson",
            "name": "kam patterson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david_jolly",
            "name": "david jolly",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jamar_neighboors",
            "name": "jamar neighboors",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "phil_(adam_ray)",
            "name": "phil (adam ray)",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "luis_j_gomez",
            "name": "luis j gomez",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "zac_amico",
            "name": "zac amico",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "h._foley",
            "name": "h. foley",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kevin_ryan",
            "name": "kevin ryan",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david_lucas",
            "name": "david lucas",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "thai_rivera",
            "name": "thai rivera",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "matthew_broussard",
            "name": "matthew broussard",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "don_barris",
            "name": "don barris",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rich_vos_-_adam_ray",
            "name": "rich vos - adam ray",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "tom_segura_[10_year_anniversary]",
            "name": "tom segura [10 year anniversary]",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brian_holtzman",
            "name": "brian holtzman",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ian_fidance",
            "name": "ian fidance",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "joy_hinchcliffe",
            "name": "joy hinchcliffe",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "adam_ray",
            "name": "adam ray",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "h_foley",
            "name": "h foley",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "sarah_weinshenk",
            "name": "sarah weinshenk",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jessie_johnson",
            "name": "jessie johnson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "david",
            "name": "david",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "luna_lucas",
            "name": "luna lucas",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "deadmau5",
            "name": "deadmau5",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "chris_faga",
            "name": "chris faga",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "deric_poston",
            "name": "deric poston",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "william_montgomery",
            "name": "william montgomery",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "aaron_berg",
            "name": "aaron berg",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "the_montgomery's",
            "name": "the montgomery's",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "gary_clark_jr",
            "name": "gary clark jr",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "rachel_wolfson",
            "name": "rachel wolfson",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mat_edgar",
            "name": "mat edgar",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "dicey",
            "name": "dicey",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "willie_hunter",
            "name": "willie hunter",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "brendon_walsh",
            "name": "brendon walsh",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "benji_aflalo",
            "name": "benji aflalo",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ryan_j_ebelt",
            "name": "ryan j ebelt",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "dylan_sullivan",
            "name": "dylan sullivan",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "chris_tellez",
            "name": "chris tellez",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "arielle_isaac_norman",
            "name": "arielle isaac norman",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "dom_irerra",
            "name": "dom irerra",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mitch_burrow",
            "name": "mitch burrow",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jimmy_shubert",
            "name": "jimmy shubert",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "michael_lehrer",
            "name": "michael lehrer",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "josh_martin",
            "name": "josh martin",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jessica_michelle_singleton",
            "name": "jessica michelle singleton",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "derric_poston",
            "name": "derric poston",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "jade_catta-preta",
            "name": "jade catta-preta",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "mae_martin",
            "name": "mae martin",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "stephanie_allynne",
            "name": "stephanie allynne",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "nina_west",
            "name": "nina west",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lance_bass",
            "name": "lance bass",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "kim_dickens",
            "name": "kim dickens",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "elliot_page",
            "name": "elliot page",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "neil_patrick_harris",
            "name": "neil patrick harris",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "natalie_maines",
            "name": "natalie maines",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "lil_rel_howery",
            "name": "lil rel howery",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jamie_lee_curtis",
            "name": "jamie lee curtis",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "jameela_jamil",
            "name": "jameela jamil",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "bella_ramsey",
            "name": "bella ramsey",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "ty_burrell",
            "name": "ty burrell",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "sarah_paulson",
            "name": "sarah paulson",
            "val": 1,
            "color1": 10,
            "color2": 6,
            "color04": 4,
            "color02": 2,
            "color075": 8
        },
        {
            "id": "gabby_windey",
            "name": "gabby windey",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nick",
            "name": "nick",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "gypsy_rose_blanchard",
            "name": "gypsy rose blanchard",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ryan_anderson",
            "name": "ryan anderson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "dayna_kathan",
            "name": "dayna kathan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ciara_robinson",
            "name": "ciara robinson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rachel_lindsay",
            "name": "rachel lindsay",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "josh",
            "name": "josh",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "paige_peck",
            "name": "paige peck",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lewis_howes",
            "name": "lewis howes",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "charli_burnett",
            "name": "charli burnett",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "crystal_kung_minkoff",
            "name": "crystal kung minkoff",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "madeleine_byrne",
            "name": "madeleine byrne",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "phalisia",
            "name": "phalisia",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "susie_evans",
            "name": "susie evans",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "aly",
            "name": "aly",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "aj",
            "name": "aj",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "wells_adams",
            "name": "wells adams",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kamie_crawford",
            "name": "kamie crawford",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "blac_chyna_(angela_white)",
            "name": "blac chyna (angela white)",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "aricia",
            "name": "aricia",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emily_longeretta",
            "name": "emily longeretta",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "eli_rallo",
            "name": "eli rallo",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "heather_dubrow",
            "name": "heather dubrow",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "izzy_zapata",
            "name": "izzy zapata",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amy_kaufman",
            "name": "amy kaufman",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "raven-symon",
            "name": "raven-symon",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "miranda_maday",
            "name": "miranda maday",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rachel_recchia",
            "name": "rachel recchia",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "dustin_lynch",
            "name": "dustin lynch",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "savannah_chrisley",
            "name": "savannah chrisley",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "natalie_joy",
            "name": "natalie joy",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "justin_glaze",
            "name": "justin glaze",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emma_slater",
            "name": "emma slater",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bobby_berk",
            "name": "bobby berk",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jojo_siwa",
            "name": "jojo siwa",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andrew_spencer",
            "name": "andrew spencer",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "gina_kirschenheiter",
            "name": "gina kirschenheiter",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "manon_mathews",
            "name": "manon mathews",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "scott_evans",
            "name": "scott evans",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "marie_forleo",
            "name": "marie forleo",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cathy_kelley",
            "name": "cathy kelley",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "girls_gotta_eat",
            "name": "girls gotta eat",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "arden_myrin",
            "name": "arden myrin",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "eilise_guilfoyle",
            "name": "eilise guilfoyle",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "danielle_fishel_karp",
            "name": "danielle fishel karp",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brad_kearns",
            "name": "brad kearns",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mary_(fitzgerald)_bonnet",
            "name": "mary (fitzgerald) bonnet",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "g_flip",
            "name": "g flip",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kate_aurthur",
            "name": "kate aurthur",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "anjelah_johnson-reyes",
            "name": "anjelah johnson-reyes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chloe_veitch",
            "name": "chloe veitch",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "dave_holmes",
            "name": "dave holmes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "barbara_corcoran",
            "name": "barbara corcoran",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "johnny_lowe",
            "name": "johnny lowe",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ashley_gavin",
            "name": "ashley gavin",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ariel_frenkel",
            "name": "ariel frenkel",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kristen_doute",
            "name": "kristen doute",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rozzi",
            "name": "rozzi",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jason_ritter",
            "name": "jason ritter",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "raven_ross",
            "name": "raven ross",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "julia_cunningham",
            "name": "julia cunningham",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "joey_zauzig",
            "name": "joey zauzig",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "elizabeth_wagmeister",
            "name": "elizabeth wagmeister",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brad_goreski",
            "name": "brad goreski",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ariana_madix",
            "name": "ariana madix",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lisa_schwartz",
            "name": "lisa schwartz",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "justin_baldoni",
            "name": "justin baldoni",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "keaton_milburn",
            "name": "keaton milburn",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "heath_hussar",
            "name": "heath hussar",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chloe_bale",
            "name": "chloe bale",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tara_schuster",
            "name": "tara schuster",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "serena_kerrigan",
            "name": "serena kerrigan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "girlbosstown",
            "name": "girlbosstown",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jason_nash",
            "name": "jason nash",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jake_miller",
            "name": "jake miller",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nancy",
            "name": "nancy",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bartise",
            "name": "bartise",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "and_raven",
            "name": "and raven",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "natasha_bure",
            "name": "natasha bure",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tino_franco",
            "name": "tino franco",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kit_keenan",
            "name": "kit keenan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "bri_springs",
            "name": "bri springs",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "camille_kostek",
            "name": "camille kostek",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "greg_grippo",
            "name": "greg grippo",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ellie_zeiler",
            "name": "ellie zeiler",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "becca_moore",
            "name": "becca moore",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cheryl_burke",
            "name": "cheryl burke",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "achieng_agutu",
            "name": "achieng agutu",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "hayley_hasselhoff",
            "name": "hayley hasselhoff",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "holly_madison",
            "name": "holly madison",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "hayley_orrantia",
            "name": "hayley orrantia",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "allison_raskin",
            "name": "allison raskin",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nick_lehmann",
            "name": "nick lehmann",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "morgan_absher",
            "name": "morgan absher",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brian_austin_green",
            "name": "brian austin green",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sharna_burgess",
            "name": "sharna burgess",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sophia",
            "name": "sophia",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sistine_stallone",
            "name": "sistine stallone",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "peta_murgatroyd",
            "name": "peta murgatroyd",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "madison_watkins",
            "name": "madison watkins",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "josh_peck",
            "name": "josh peck",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "erika_priscilla",
            "name": "erika priscilla",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "darcy",
            "name": "darcy",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "clayton",
            "name": "clayton",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "susie",
            "name": "susie",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kail_lowry",
            "name": "kail lowry",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "april_marie",
            "name": "april marie",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chloe_cherry",
            "name": "chloe cherry",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andrea_russett",
            "name": "andrea russett",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "shayne",
            "name": "shayne",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cathy_kelly",
            "name": "cathy kelly",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ali_barthwell",
            "name": "ali barthwell",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "christina_harris",
            "name": "christina harris",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ashley_greene",
            "name": "ashley greene",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "deepti",
            "name": "deepti",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "shaina",
            "name": "shaina",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "elyse_myers",
            "name": "elyse myers",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ryan",
            "name": "ryan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mariel_molino",
            "name": "mariel molino",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "taylor_tomlinson",
            "name": "taylor tomlinson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "greg_g",
            "name": "greg g",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andrew_s",
            "name": "andrew s",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "plus_clayton",
            "name": "plus clayton",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "alexandra_hunt",
            "name": "alexandra hunt",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "west_elm_caleb",
            "name": "west elm caleb",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "morgan_cohen",
            "name": "morgan cohen",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "hello_tefi",
            "name": "hello tefi",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "naz_perez",
            "name": "naz perez",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ian_wallace",
            "name": "ian wallace",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rod_thill",
            "name": "rod thill",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tefi_pessoa",
            "name": "tefi pessoa",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emma_gray",
            "name": "emma gray",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "charly_jordan",
            "name": "charly jordan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "michelle_young",
            "name": "michelle young",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ali",
            "name": "ali",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amanda",
            "name": "amanda",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "diane_strachowski",
            "name": "diane strachowski",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "glozell_green",
            "name": "glozell green",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "zuri_hall",
            "name": "zuri hall",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "connor_wood",
            "name": "connor wood",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tim_simons",
            "name": "tim simons",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ivan_hall",
            "name": "ivan hall",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "emily_didonato",
            "name": "emily didonato",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "manny_gutierrez",
            "name": "manny gutierrez",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amelie_zilber",
            "name": "amelie zilber",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "amen",
            "name": "amen",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "christian_long",
            "name": "christian long",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "michael_allio",
            "name": "michael allio",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tyler_merritt",
            "name": "tyler merritt",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "matt_king",
            "name": "matt king",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cnco",
            "name": "cnco",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "mina_kimes",
            "name": "mina kimes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "missi_pyle",
            "name": "missi pyle",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tristan_watson",
            "name": "tristan watson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "max",
            "name": "max",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "billy_boyd",
            "name": "billy boyd",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "katie_thurston",
            "name": "katie thurston",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "andy_grammer",
            "name": "andy grammer",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tinx",
            "name": "tinx",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "teddi_mellencamp",
            "name": "teddi mellencamp",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brian_baumgartner",
            "name": "brian baumgartner",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ben_folds",
            "name": "ben folds",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "molly_sims",
            "name": "molly sims",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sheila_kelley",
            "name": "sheila kelley",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "christa_allen",
            "name": "christa allen",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jeff_beacher",
            "name": "jeff beacher",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "logan_ury",
            "name": "logan ury",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sarah_edmondson",
            "name": "sarah edmondson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nippy_from_the_vow",
            "name": "nippy from the vow",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jackelyn_shultz",
            "name": "jackelyn shultz",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jenna_zoe",
            "name": "jenna zoe",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chris_medina",
            "name": "chris medina",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "natasha_parker",
            "name": "natasha parker",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "laura_berman",
            "name": "laura berman",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jordan_weiss",
            "name": "jordan weiss",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kelly_mi_li",
            "name": "kelly mi li",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rachael_harris",
            "name": "rachael harris",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ricky_williams",
            "name": "ricky williams",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lauren_zima",
            "name": "lauren zima",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "alexandra_solomon",
            "name": "alexandra solomon",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cazzie_david",
            "name": "cazzie david",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "noah_erb",
            "name": "noah erb",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kevin_dillon",
            "name": "kevin dillon",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "raven_gates",
            "name": "raven gates",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jodi_rodgers",
            "name": "jodi rodgers",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "russell_dickerson",
            "name": "russell dickerson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lala_milan",
            "name": "lala milan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "joe_park",
            "name": "joe park",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "manny_mua",
            "name": "manny mua",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kalen_allen",
            "name": "kalen allen",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sharleen_joynt",
            "name": "sharleen joynt",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ryan_haddon",
            "name": "ryan haddon",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rob_mills",
            "name": "rob mills",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "daisy_fuentes",
            "name": "daisy fuentes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "richard_marx",
            "name": "richard marx",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "rachel_platten",
            "name": "rachel platten",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jvckj_aka_jack_j",
            "name": "jvckj aka jack j",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "michael_moloney",
            "name": "michael moloney",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "esther_povitsky",
            "name": "esther povitsky",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "victoria_fuller",
            "name": "victoria fuller",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "nikki_ferrell",
            "name": "nikki ferrell",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "constance_nunes",
            "name": "constance nunes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kevin_hines",
            "name": "kevin hines",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "garcelle_beauvais",
            "name": "garcelle beauvais",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "pastor_miles_mcpherson",
            "name": "pastor miles mcpherson",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jonathan_bennett",
            "name": "jonathan bennett",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ali_manno_(fedotowsky)",
            "name": "ali manno (fedotowsky)",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "paul_de_gelder",
            "name": "paul de gelder",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jp_rosenbaum",
            "name": "jp rosenbaum",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chris_kattan",
            "name": "chris kattan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "candis_cayne",
            "name": "candis cayne",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "trista_sutter",
            "name": "trista sutter",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "trent_shelton",
            "name": "trent shelton",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "little_big_wells",
            "name": "little big wells",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "kaitlynn_carter",
            "name": "kaitlynn carter",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sarah_colonna",
            "name": "sarah colonna",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ben_higgins",
            "name": "ben higgins",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "maria_viall",
            "name": "maria viall",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jill_moran",
            "name": "jill moran",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "jared_haibon",
            "name": "jared haibon",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "tanner_tolbert",
            "name": "tanner tolbert",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "brett_vergara",
            "name": "brett vergara",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "sean",
            "name": "sean",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "catherine",
            "name": "catherine",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "joe_thomas",
            "name": "joe thomas",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "meghan_tonjes",
            "name": "meghan tonjes",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "laura_marano",
            "name": "laura marano",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "raja_kumari",
            "name": "raja kumari",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "claudia_oshry",
            "name": "claudia oshry",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "shan_boodram",
            "name": "shan boodram",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "chris_harrison",
            "name": "chris harrison",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "ginger_zee",
            "name": "ginger zee",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "peter_weber",
            "name": "peter weber",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "hannah_ann",
            "name": "hannah ann",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "lady_gang",
            "name": "lady gang",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "drew_scott",
            "name": "drew scott",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "linda_phan",
            "name": "linda phan",
            "val": 1,
            "color1": 13,
            "color2": 7,
            "color04": 5,
            "color02": 3,
            "color075": 9
        },
        {
            "id": "cipha_sounds",
            "name": "cipha sounds",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "cory_henry",
            "name": "cory henry",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "kountry_wayne",
            "name": "kountry wayne",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "ryan_blaney",
            "name": "ryan blaney",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "adriana_chechik",
            "name": "adriana chechik",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "nosteve-o",
            "name": "nosteve-o",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "christina_p",
            "name": "christina p",
            "val": 1,
            "color1": 6,
            "color2": 3,
            "color04": 3,
            "color02": 1,
            "color075": 4
        },
        {
            "id": "scott_mcmahon",
            "name": "scott mcmahon",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ritchie_shoemaker",
            "name": "ritchie shoemaker",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "laurence_fox",
            "name": "laurence fox",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "terrence_keeley",
            "name": "terrence keeley",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "adeel_khan",
            "name": "adeel khan",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "aaron_stark",
            "name": "aaron stark",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sarah_hill",
            "name": "sarah hill",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "saeed_al_nazari",
            "name": "saeed al nazari",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "nick_alexander",
            "name": "nick alexander",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ambassador_robert_o'brien",
            "name": "ambassador robert o'brien",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "kevin_roberts",
            "name": "kevin roberts",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "frank_stronach",
            "name": "frank stronach",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "adam_smith",
            "name": "adam smith",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "john_lennox",
            "name": "john lennox",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tony_abbott",
            "name": "tony abbott",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rikki_schlott",
            "name": "rikki schlott",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "miranda_devine",
            "name": "miranda devine",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "willie",
            "name": "willie",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "korie_robertson",
            "name": "korie robertson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "peter_arcidiacono",
            "name": "peter arcidiacono",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chris_christie",
            "name": "chris christie",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ellen_langer",
            "name": "ellen langer",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jbp_reacts_to_court_decision",
            "name": "jbp reacts to court decision",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "helen_joyce",
            "name": "helen joyce",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_bryce",
            "name": "robert bryce",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "eric_edmeades",
            "name": "eric edmeades",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tim_ballard",
            "name": "tim ballard",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "eric_metaxas",
            "name": "eric metaxas",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "zach_lahn",
            "name": "zach lahn",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tamara_lich",
            "name": "tamara lich",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tammy_peterson",
            "name": "tammy peterson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "mike_pence",
            "name": "mike pence",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "steve_templeton",
            "name": "steve templeton",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jonathan_pageau",
            "name": "jonathan pageau",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "senator_josh_hawley",
            "name": "senator josh hawley",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "nigel_biggar",
            "name": "nigel biggar",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "anthony_furey",
            "name": "anthony furey",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "brian_roemmele",
            "name": "brian roemmele",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "karol_markowicz",
            "name": "karol markowicz",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_zweig",
            "name": "david zweig",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "joe_hage",
            "name": "joe hage",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "naomi_wolf",
            "name": "naomi wolf",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "heather_mac_donald",
            "name": "heather mac donald",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "scott_jensen",
            "name": "scott jensen",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "miriam_grossman_md",
            "name": "miriam grossman md",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "senator_mike_lee",
            "name": "senator mike lee",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "derek_kreifels",
            "name": "derek kreifels",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rafe_kelley",
            "name": "rafe kelley",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "sara_stockton",
            "name": "sara stockton",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "michael_yon",
            "name": "michael yon",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "eva_vlaardingerbroek",
            "name": "eva vlaardingerbroek",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "stephen_j_shaw",
            "name": "stephen j shaw",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jeff_sandefer",
            "name": "jeff sandefer",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "christopher_rufo",
            "name": "christopher rufo",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jayanta_bhattacharya",
            "name": "jayanta bhattacharya",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "louise_perry",
            "name": "louise perry",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "roy_sebag",
            "name": "roy sebag",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "judith_curry",
            "name": "judith curry",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "daniel_higgins",
            "name": "daniel higgins",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_o._pihl",
            "name": "robert o. pihl",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "del_paulhus",
            "name": "del paulhus",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "walter_russell_mead",
            "name": "walter russell mead",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "victor_davis_hanson",
            "name": "victor davis hanson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "masih_alinejad",
            "name": "masih alinejad",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "steven_koonin",
            "name": "steven koonin",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "richard_lindzen",
            "name": "richard lindzen",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chloe_cole",
            "name": "chloe cole",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "temple_grandin",
            "name": "temple grandin",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "amala_ekpunobi",
            "name": "amala ekpunobi",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "stephanie_davies-arai",
            "name": "stephanie davies-arai",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "pm-elect_benjamin_netanyahu",
            "name": "pm-elect benjamin netanyahu",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "matt_ridley",
            "name": "matt ridley",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "congressman_mike_johnson",
            "name": "congressman mike johnson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "danielle_smith",
            "name": "danielle smith",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "yoram_hazony",
            "name": "yoram hazony",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jean_twenge",
            "name": "jean twenge",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "newt_gingrich",
            "name": "newt gingrich",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mohammad_hijab",
            "name": "mohammad hijab",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "piers_morgan",
            "name": "piers morgan",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "alex_story",
            "name": "alex story",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "stella_assange",
            "name": "stella assange",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "matthieu_pageau",
            "name": "matthieu pageau",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "peter_kreeft",
            "name": "peter kreeft",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "eric_duhaime",
            "name": "eric duhaime",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ron_dermer",
            "name": "ron dermer",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "ralph_schoellhammer",
            "name": "ralph schoellhammer",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "gale_pooley",
            "name": "gale pooley",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "leslyn_lewis",
            "name": "leslyn lewis",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "pageau",
            "name": "pageau",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "hurwitz",
            "name": "hurwitz",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "david_friedman",
            "name": "david friedman",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "iain_mcgilchrist",
            "name": "iain mcgilchrist",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "vervaeke",
            "name": "vervaeke",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "larry_p._arnn",
            "name": "larry p. arnn",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "roman_baber",
            "name": "roman baber",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_trivers",
            "name": "robert trivers",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "frans_de_waal",
            "name": "frans de waal",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rod_dreher",
            "name": "rod dreher",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rex_murphy",
            "name": "rex murphy",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "adrian_wooldridge",
            "name": "adrian wooldridge",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "walter_peterson",
            "name": "walter peterson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "warren_farrell",
            "name": "warren farrell",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "julian_peterson",
            "name": "julian peterson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "vishal_mangalwadi",
            "name": "vishal mangalwadi",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "hamza_yusuf",
            "name": "hamza yusuf",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "pierre_poilievre",
            "name": "pierre poilievre",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "franciscan_university",
            "name": "franciscan university",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "claire_lehmann",
            "name": "claire lehmann",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "cambridge",
            "name": "cambridge",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "john_mcwhorter",
            "name": "john mcwhorter",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "pardy",
            "name": "pardy",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "haskell",
            "name": "haskell",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "kay",
            "name": "kay",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "frederick_kagan",
            "name": "frederick kagan",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "curt_jaimungal",
            "name": "curt jaimungal",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "greg_ellis",
            "name": "greg ellis",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "jordan",
            "name": "jordan",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tammy",
            "name": "tammy",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rav_arora",
            "name": "rav arora",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "charles_joseph",
            "name": "charles joseph",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "norman_doidge",
            "name": "norman doidge",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "brian_peckford",
            "name": "brian peckford",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "chlo\u00e9_valdary",
            "name": "chlo\u00e9 valdary",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "james_orr",
            "name": "james orr",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "arif_ahmed",
            "name": "arif ahmed",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "mikhail_avdeev",
            "name": "mikhail avdeev",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "word_on_fire",
            "name": "word on fire",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "preston_manning",
            "name": "preston manning",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "mohammed_hijab",
            "name": "mohammed hijab",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "gregg_hurwitz",
            "name": "gregg hurwitz",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rick_geddes",
            "name": "rick geddes",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "angus_fletcher",
            "name": "angus fletcher",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "bishop_barron",
            "name": "bishop barron",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "and_jonathan_pageau",
            "name": "and jonathan pageau",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "mustafa_akyol",
            "name": "mustafa akyol",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "clay_routledge",
            "name": "clay routledge",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "mohamedou_ould_slahi",
            "name": "mohamedou ould slahi",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "rob_henderson",
            "name": "rob henderson",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "maxime_bernier",
            "name": "maxime bernier",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "prager",
            "name": "prager",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "carolla",
            "name": "carolla",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "robert_murphy",
            "name": "robert murphy",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "stephen_blackwood",
            "name": "stephen blackwood",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "randy_thornhill",
            "name": "randy thornhill",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "prof._carl_ruck",
            "name": "prof. carl ruck",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "lord_conrad_black",
            "name": "lord conrad black",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "samuel_andreyev",
            "name": "samuel andreyev",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "scott_barry_kaufman",
            "name": "scott barry kaufman",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "dr_rima_azar",
            "name": "dr rima azar",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "richard_tremblay",
            "name": "richard tremblay",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "theodore_dalrymple",
            "name": "theodore dalrymple",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "anthony_daniels",
            "name": "anthony daniels",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "stephen_fry",
            "name": "stephen fry",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "roland_griffiths",
            "name": "roland griffiths",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "randall_wallace",
            "name": "randall wallace",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "paul_rossi",
            "name": "paul rossi",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "tom_amarque",
            "name": "tom amarque",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "james_w_pennebaker",
            "name": "james w pennebaker",
            "val": 1,
            "color1": 7,
            "color2": 4,
            "color04": 0,
            "color02": 0,
            "color075": 5
        },
        {
            "id": "naftali_bennett",
            "name": "naftali bennett",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ted_cruz",
            "name": "ted cruz",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "thomas_sowell",
            "name": "thomas sowell",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rudy_rochman",
            "name": "rudy rochman",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "doug_brunt",
            "name": "doug brunt",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chris_rufo",
            "name": "chris rufo",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "voddie_baucham",
            "name": "voddie baucham",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "gov._ron_desantis",
            "name": "gov. ron desantis",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "andrew_klavan",
            "name": "andrew klavan",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "megyn_kelly",
            "name": "megyn kelly",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "nick_rolovich",
            "name": "nick rolovich",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jair_bolsonaro",
            "name": "jair bolsonaro",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "shapiro",
            "name": "shapiro",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "peterson",
            "name": "peterson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jonathan_isaac",
            "name": "jonathan isaac",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "william_barr",
            "name": "william barr",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "avichal_garg",
            "name": "avichal garg",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dave_ramsey",
            "name": "dave ramsey",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "condoleezza_rice",
            "name": "condoleezza rice",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_horowitz",
            "name": "david horowitz",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dallas_sonnier",
            "name": "dallas sonnier",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "j.d._vance",
            "name": "j.d. vance",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "shelby_steele",
            "name": "shelby steele",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jon_voight",
            "name": "jon voight",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "sarah_huckabee_sanders",
            "name": "sarah huckabee sanders",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ravi_zacharias",
            "name": "ravi zacharias",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "william_lane_craig",
            "name": "william lane craig",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "franklin_graham",
            "name": "franklin graham",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jason_blum",
            "name": "jason blum",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "alan_dershowitz",
            "name": "alan dershowitz",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "gloria_allred",
            "name": "gloria allred",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kirk_cameron",
            "name": "kirk cameron",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "frank_luntz",
            "name": "frank luntz",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "lila_rose",
            "name": "lila rose",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rich_lowry",
            "name": "rich lowry",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "george_will",
            "name": "george will",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "peter_robinson",
            "name": "peter robinson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "preet_bharara",
            "name": "preet bharara",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dana_perino",
            "name": "dana perino",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "meghan_mccain",
            "name": "meghan mccain",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "ramesh_ponnuru",
            "name": "ramesh ponnuru",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "kennedy",
            "name": "kennedy",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "michael_knowles",
            "name": "michael knowles",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "bret_easton_ellis",
            "name": "bret easton ellis",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "daniel_hannan",
            "name": "daniel hannan",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "shannon_bream",
            "name": "shannon bream",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_barton",
            "name": "david barton",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "mark_levin",
            "name": "mark levin",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "larry_wilmore",
            "name": "larry wilmore",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "carly_fiorina",
            "name": "carly fiorina",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "nikki_haley",
            "name": "nikki haley",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "allie_stuckey",
            "name": "allie stuckey",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "dennis_miller",
            "name": "dennis miller",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "phil_mcgraw",
            "name": "phil mcgraw",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "arthur_brooks",
            "name": "arthur brooks",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "rep._dan_crenshaw",
            "name": "rep. dan crenshaw",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "daniel_krauthammer",
            "name": "daniel krauthammer",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "gary_sinise",
            "name": "gary sinise",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "general_stanley_mcchrystal",
            "name": "general stanley mcchrystal",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "david_limbaugh",
            "name": "david limbaugh",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "pastor_john_macarthur",
            "name": "pastor john macarthur",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "stephen_harper",
            "name": "stephen harper",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "cameron_kasky",
            "name": "cameron kasky",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "glenn_beck",
            "name": "glenn beck",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "christina_hoff_sommers",
            "name": "christina hoff sommers",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "edward_feser",
            "name": "edward feser",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "greg_gutfeld",
            "name": "greg gutfeld",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "tai_lopez",
            "name": "tai lopez",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jason_whitlock",
            "name": "jason whitlock",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jonah_goldberg",
            "name": "jonah goldberg",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "drew_pinsky",
            "name": "drew pinsky",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "jordan_b_peterson",
            "name": "jordan b peterson",
            "val": 1,
            "color1": 2,
            "color2": 0,
            "color04": 0,
            "color02": 0,
            "color075": 1
        },
        {
            "id": "chris_chatman",
            "name": "chris chatman",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "richard_dolan",
            "name": "richard dolan",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "john_b._alexander",
            "name": "john b. alexander",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "chris_sharp",
            "name": "chris sharp",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "col._phillip_corso",
            "name": "col. phillip corso",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "joe_murgia",
            "name": "joe murgia",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "rep._tim_burchett",
            "name": "rep. tim burchett",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "lacatski",
            "name": "lacatski",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "james_lacatski",
            "name": "james lacatski",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "colm_kelleher",
            "name": "colm kelleher",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "chris_ramsay",
            "name": "chris ramsay",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "jules_urbach",
            "name": "jules urbach",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "john_lear",
            "name": "john lear",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "wayne_pacelle",
            "name": "wayne pacelle",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "ross_coulthart",
            "name": "ross coulthart",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "bryce_zabel",
            "name": "bryce zabel",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "cdr_chad_underwood",
            "name": "cdr chad underwood",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "whitley_strieber",
            "name": "whitley strieber",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "ben_schneider",
            "name": "ben schneider",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "john_long",
            "name": "john long",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "john_jay_stratton",
            "name": "john jay stratton",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        },
        {
            "id": "john_gutierrez",
            "name": "john gutierrez",
            "val": 1,
            "color1": 14,
            "color2": 8,
            "color04": 6,
            "color02": 1,
            "color075": 10
        }
    ],
  "links": [
    {
      "source": "joe_rogan",
      "target": "aaron_rodgers"
    },
    {
      "source": "joe_rogan",
      "target": "abby_martin"
    },
    {
      "source": "joe_rogan",
      "target": "abigail_shrier"
    },
    {
      "source": "joe_rogan",
      "target": "action_bronson"
    },
    {
      "source": "joe_rogan",
      "target": "adam_alter"
    },
    {
      "source": "joe_rogan",
      "target": "adam_carolla"
    },
    {
      "source": "joe_rogan",
      "target": "adam_conover"
    },
    {
      "source": "joe_rogan",
      "target": "adam_cropp"
    },
    {
      "source": "joe_rogan",
      "target": "adam_curry"
    },
    {
      "source": "joe_rogan",
      "target": "adam_duritz"
    },
    {
      "source": "joe_rogan",
      "target": "adam_eget"
    },
    {
      "source": "joe_rogan",
      "target": "adam_frank"
    },
    {
      "source": "joe_rogan",
      "target": "adam_greentree"
    },
    {
      "source": "joe_rogan",
      "target": "adam_kokesh"
    },
    {
      "source": "joe_rogan",
      "target": "adam_lowery"
    },
    {
      "source": "joe_rogan",
      "target": "adam_perry_lang"
    },
    {
      "source": "joe_rogan",
      "target": "adam_scorgie"
    },
    {
      "source": "joe_rogan",
      "target": "adrienne_iapalucci"
    },
    {
      "source": "joe_rogan",
      "target": "akaash_singh"
    },
    {
      "source": "joe_rogan",
      "target": "al_madrigal"
    },
    {
      "source": "joe_rogan",
      "target": "alan_levinovitz"
    },
    {
      "source": "joe_rogan",
      "target": "alex_berenson"
    },
    {
      "source": "joe_rogan",
      "target": "alex_grey"
    },
    {
      "source": "joe_rogan",
      "target": "alex_honnold"
    },
    {
      "source": "joe_rogan",
      "target": "alex_jones"
    },
    {
      "source": "joe_rogan",
      "target": "alex_ross"
    },
    {
      "source": "joe_rogan",
      "target": "alex_winter"
    },
    {
      "source": "joe_rogan",
      "target": "alexander_gustafsson"
    },
    {
      "source": "joe_rogan",
      "target": "alexander_volkanovski"
    },
    {
      "source": "joe_rogan",
      "target": "alexis_ohanian"
    },
    {
      "source": "joe_rogan",
      "target": "ali_macofsky"
    },
    {
      "source": "joe_rogan",
      "target": "ali_rizvi"
    },
    {
      "source": "joe_rogan",
      "target": "ali_siddiq"
    },
    {
      "source": "joe_rogan",
      "target": "alison_rosen"
    },
    {
      "source": "joe_rogan",
      "target": "aljamain_sterling"
    },
    {
      "source": "joe_rogan",
      "target": "alonzo_bodden"
    },
    {
      "source": "joe_rogan",
      "target": "amanda_feilding"
    },
    {
      "source": "joe_rogan",
      "target": "amanda_knox"
    },
    {
      "source": "joe_rogan",
      "target": "amber_lyon"
    },
    {
      "source": "joe_rogan",
      "target": "amishi_jha"
    },
    {
      "source": "joe_rogan",
      "target": "amy_alkon"
    },
    {
      "source": "joe_rogan",
      "target": "amy_schumer"
    },
    {
      "source": "joe_rogan",
      "target": "ana_kasparian"
    },
    {
      "source": "joe_rogan",
      "target": "andre_ward"
    },
    {
      "source": "joe_rogan",
      "target": "andreas_antonopoulos"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_dessler"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_dice_clay"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_doyle"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_hill"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_huberman"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_marr"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_santino"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_schulz"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_tate"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_yang"
    },
    {
      "source": "joe_rogan",
      "target": "andy_ngo"
    },
    {
      "source": "joe_rogan",
      "target": "andy_norman"
    },
    {
      "source": "joe_rogan",
      "target": "andy_ruiz"
    },
    {
      "source": "joe_rogan",
      "target": "andy_stumpf"
    },
    {
      "source": "joe_rogan",
      "target": "angela_hill"
    },
    {
      "source": "joe_rogan",
      "target": "anna_lembke"
    },
    {
      "source": "joe_rogan",
      "target": "annie_jacobsen"
    },
    {
      "source": "joe_rogan",
      "target": "annie_lederman"
    },
    {
      "source": "joe_rogan",
      "target": "anthony_bourdain"
    },
    {
      "source": "joe_rogan",
      "target": "anthony_cumia"
    },
    {
      "source": "joe_rogan",
      "target": "anthony_jeselnik"
    },
    {
      "source": "joe_rogan",
      "target": "anthony_kiedis"
    },
    {
      "source": "joe_rogan",
      "target": "antonio_garcia_martinez"
    },
    {
      "source": "joe_rogan",
      "target": "ari_shaffir"
    },
    {
      "source": "joe_rogan",
      "target": "arian_foster"
    },
    {
      "source": "joe_rogan",
      "target": "aron_snyder"
    },
    {
      "source": "joe_rogan",
      "target": "artie_lange"
    },
    {
      "source": "joe_rogan",
      "target": "ash_dykes"
    },
    {
      "source": "joe_rogan",
      "target": "aubrey_de_grey"
    },
    {
      "source": "joe_rogan",
      "target": "aubrey_marcus"
    },
    {
      "source": "joe_rogan",
      "target": "avi_loeb"
    },
    {
      "source": "joe_rogan",
      "target": "ayaan_hirsi_ali"
    },
    {
      "source": "joe_rogan",
      "target": "aza_raskin"
    },
    {
      "source": "joe_rogan",
      "target": "b-real"
    },
    {
      "source": "joe_rogan",
      "target": "banachek"
    },
    {
      "source": "joe_rogan",
      "target": "barbara_freese"
    },
    {
      "source": "joe_rogan",
      "target": "bari_weiss"
    },
    {
      "source": "joe_rogan",
      "target": "barry_crimmins"
    },
    {
      "source": "joe_rogan",
      "target": "bartow_elmore"
    },
    {
      "source": "joe_rogan",
      "target": "bas_rutten"
    },
    {
      "source": "joe_rogan",
      "target": "beeple"
    },
    {
      "source": "joe_rogan",
      "target": "belal_muhammad"
    },
    {
      "source": "joe_rogan",
      "target": "ben_affleck"
    },
    {
      "source": "joe_rogan",
      "target": "ben_anderson"
    },
    {
      "source": "joe_rogan",
      "target": "ben_askren"
    },
    {
      "source": "joe_rogan",
      "target": "ben_burgis"
    },
    {
      "source": "joe_rogan",
      "target": "ben_greenfield"
    },
    {
      "source": "joe_rogan",
      "target": "ben_hoffman"
    },
    {
      "source": "joe_rogan",
      "target": "ben_o\u2019brien"
    },
    {
      "source": "joe_rogan",
      "target": "ben_patrick"
    },
    {
      "source": "joe_rogan",
      "target": "ben_shapiro"
    },
    {
      "source": "joe_rogan",
      "target": "ben_van_kerkwyk"
    },
    {
      "source": "joe_rogan",
      "target": "ben_westhoff"
    },
    {
      "source": "joe_rogan",
      "target": "bernard_hopkins"
    },
    {
      "source": "joe_rogan",
      "target": "bernie_sanders"
    },
    {
      "source": "joe_rogan",
      "target": "bert_kreischer"
    },
    {
      "source": "joe_rogan",
      "target": "big_jay_oakerson"
    },
    {
      "source": "joe_rogan",
      "target": "big_john_mccarthy"
    },
    {
      "source": "joe_rogan",
      "target": "bill_burr"
    },
    {
      "source": "joe_rogan",
      "target": "bill_hader"
    },
    {
      "source": "joe_rogan",
      "target": "bill_maher"
    },
    {
      "source": "joe_rogan",
      "target": "bill_ottman"
    },
    {
      "source": "joe_rogan",
      "target": "billy_corben"
    },
    {
      "source": "joe_rogan",
      "target": "billy_corgan"
    },
    {
      "source": "joe_rogan",
      "target": "bj_penn"
    },
    {
      "source": "joe_rogan",
      "target": "bj\u00f8rn_lomborg"
    },
    {
      "source": "joe_rogan",
      "target": "blaire_white"
    },
    {
      "source": "joe_rogan",
      "target": "bo_burnham"
    },
    {
      "source": "joe_rogan",
      "target": "bo_nickal"
    },
    {
      "source": "joe_rogan",
      "target": "bob_lazar"
    },
    {
      "source": "joe_rogan",
      "target": "bob_odenkirk"
    },
    {
      "source": "joe_rogan",
      "target": "bob_saget"
    },
    {
      "source": "joe_rogan",
      "target": "bobby_azarian"
    },
    {
      "source": "joe_rogan",
      "target": "bobby_green"
    },
    {
      "source": "joe_rogan",
      "target": "bobcat_goldthwait"
    },
    {
      "source": "joe_rogan",
      "target": "boyan_slat"
    },
    {
      "source": "joe_rogan",
      "target": "brad_williams"
    },
    {
      "source": "joe_rogan",
      "target": "brendan_burns"
    },
    {
      "source": "joe_rogan",
      "target": "brendan_schaub,),bret_weinstein"
    },
    {
      "source": "joe_rogan",
      "target": "brian_cox"
    },
    {
      "source": "joe_rogan",
      "target": "brian_dunning"
    },
    {
      "source": "joe_rogan",
      "target": "brian_grazer"
    },
    {
      "source": "joe_rogan",
      "target": "brian_greene"
    },
    {
      "source": "joe_rogan",
      "target": "brian_keating"
    },
    {
      "source": "joe_rogan",
      "target": "brian_moses"
    },
    {
      "source": "joe_rogan",
      "target": "brian_muraresku"
    },
    {
      "source": "joe_rogan",
      "target": "brian_redban"
    },
    {
      "source": "joe_rogan",
      "target": "brian_regan"
    },
    {
      "source": "joe_rogan",
      "target": "brian_simpson"
    },
    {
      "source": "joe_rogan",
      "target": "brian_stann"
    },
    {
      "source": "joe_rogan",
      "target": "bridget_phetasy"
    },
    {
      "source": "joe_rogan",
      "target": "brigham_buhler"
    },
    {
      "source": "joe_rogan",
      "target": "brock_lesnar"
    },
    {
      "source": "joe_rogan",
      "target": "brody_stevens"
    },
    {
      "source": "joe_rogan",
      "target": "bruce_bryan"
    },
    {
      "source": "joe_rogan",
      "target": "bruce_damer"
    },
    {
      "source": "joe_rogan",
      "target": "bryan_callen"
    },
    {
      "source": "joe_rogan",
      "target": "bryan_fogel"
    },
    {
      "source": "joe_rogan",
      "target": "bryan_richards"
    },
    {
      "source": "joe_rogan",
      "target": "buck_angel"
    },
    {
      "source": "joe_rogan",
      "target": "bud_brutsman"
    },
    {
      "source": "joe_rogan",
      "target": "byron_bowers"
    },
    {
      "source": "joe_rogan",
      "target": "c.k._chin"
    },
    {
      "source": "joe_rogan",
      "target": "c.t._fletcher"
    },
    {
      "source": "joe_rogan",
      "target": "cameron_hanes"
    },
    {
      "source": "joe_rogan",
      "target": "campbell_mclaren"
    },
    {
      "source": "joe_rogan",
      "target": "candice_thompson"
    },
    {
      "source": "joe_rogan",
      "target": "cara_santa_maria"
    },
    {
      "source": "joe_rogan",
      "target": "carlos_condit"
    },
    {
      "source": "joe_rogan",
      "target": "carole_hooven"
    },
    {
      "source": "joe_rogan",
      "target": "carrot_top"
    },
    {
      "source": "joe_rogan",
      "target": "cat_zingano"
    },
    {
      "source": "joe_rogan",
      "target": "ceara_lynch"
    },
    {
      "source": "joe_rogan",
      "target": "cedric_doumbe"
    },
    {
      "source": "joe_rogan",
      "target": "cenk_uygur"
    },
    {
      "source": "joe_rogan",
      "target": "chad_mendes"
    },
    {
      "source": "joe_rogan",
      "target": "chad_stahelski"
    },
    {
      "source": "joe_rogan",
      "target": "chael_sonnen"
    },
    {
      "source": "joe_rogan",
      "target": "charlamagne_tha_god"
    },
    {
      "source": "joe_rogan",
      "target": "charles_c._johnson"
    },
    {
      "source": "joe_rogan",
      "target": "charles_wesley_godwin"
    },
    {
      "source": "joe_rogan",
      "target": "charlie_murphy"
    },
    {
      "source": "joe_rogan",
      "target": "charlie_walker"
    },
    {
      "source": "joe_rogan",
      "target": "charlize_theron"
    },
    {
      "source": "joe_rogan",
      "target": "chino_xl"
    },
    {
      "source": "joe_rogan",
      "target": "chris_bell"
    },
    {
      "source": "joe_rogan",
      "target": "chris_best"
    },
    {
      "source": "joe_rogan",
      "target": "chris_cage"
    },
    {
      "source": "joe_rogan",
      "target": "chris_d\u2019elia"
    },
    {
      "source": "joe_rogan",
      "target": "chris_distefano"
    },
    {
      "source": "joe_rogan",
      "target": "chris_harris"
    },
    {
      "source": "joe_rogan",
      "target": "chris_kresser"
    },
    {
      "source": "joe_rogan",
      "target": "chris_martin"
    },
    {
      "source": "joe_rogan",
      "target": "chris_palmquist"
    },
    {
      "source": "joe_rogan",
      "target": "chris_rock"
    },
    {
      "source": "joe_rogan",
      "target": "chris_stapleton"
    },
    {
      "source": "joe_rogan",
      "target": "chris_williamson"
    },
    {
      "source": "joe_rogan",
      "target": "christina_pazsitzky"
    },
    {
      "source": "joe_rogan",
      "target": "christina_sommers"
    },
    {
      "source": "joe_rogan",
      "target": "christine_hassler"
    },
    {
      "source": "joe_rogan",
      "target": "christopher_mellon"
    },
    {
      "source": "joe_rogan",
      "target": "christopher_nolan"
    },
    {
      "source": "joe_rogan",
      "target": "christopher_ryan"
    },
    {
      "source": "joe_rogan",
      "target": "chuck_palahniuk"
    },
    {
      "source": "joe_rogan",
      "target": "cj_werleman"
    },
    {
      "source": "joe_rogan",
      "target": "claressa_shields"
    },
    {
      "source": "joe_rogan",
      "target": "clay_newcomb"
    },
    {
      "source": "joe_rogan",
      "target": "cliff_gray"
    },
    {
      "source": "joe_rogan",
      "target": "cliffy_b"
    },
    {
      "source": "joe_rogan",
      "target": "clint_wattenberg"
    },
    {
      "source": "joe_rogan",
      "target": "cmdr._chris_hadfield"
    },
    {
      "source": "joe_rogan",
      "target": "cody_garbrandt"
    },
    {
      "source": "joe_rogan",
      "target": "coffeezilla"
    },
    {
      "source": "joe_rogan",
      "target": "colby_brock"
    },
    {
      "source": "joe_rogan",
      "target": "coleman_hughes"
    },
    {
      "source": "joe_rogan",
      "target": "colin_moriarty"
    },
    {
      "source": "joe_rogan",
      "target": "colin_o'brady"
    },
    {
      "source": "joe_rogan",
      "target": "colin_quinn"
    },
    {
      "source": "joe_rogan",
      "target": "colin_wright"
    },
    {
      "source": "joe_rogan",
      "target": "colion_noir"
    },
    {
      "source": "joe_rogan",
      "target": "conan_o'brien"
    },
    {
      "source": "joe_rogan",
      "target": "conor_mcgregor"
    },
    {
      "source": "joe_rogan",
      "target": "corey_anderson"
    },
    {
      "source": "joe_rogan",
      "target": "corey_knowlton"
    },
    {
      "source": "joe_rogan",
      "target": "corinne_fisher"
    },
    {
      "source": "joe_rogan",
      "target": "cory_sandhagen"
    },
    {
      "source": "joe_rogan",
      "target": "courtney_dauwalter"
    },
    {
      "source": "joe_rogan",
      "target": "craig_jones"
    },
    {
      "source": "joe_rogan",
      "target": "craig_susser"
    },
    {
      "source": "joe_rogan",
      "target": "crash_from_float_lab"
    },
    {
      "source": "joe_rogan",
      "target": "cullen_hoback"
    },
    {
      "source": "joe_rogan",
      "target": "dakota_meyer"
    },
    {
      "source": "joe_rogan",
      "target": "dale_brisby"
    },
    {
      "source": "joe_rogan",
      "target": "dale_earnhardt_jr."
    },
    {
      "source": "joe_rogan",
      "target": "dan_auerbach"
    },
    {
      "source": "joe_rogan",
      "target": "dan_aykroyd"
    },
    {
      "source": "joe_rogan",
      "target": "dan_bilzerian"
    },
    {
      "source": "joe_rogan",
      "target": "dan_carlin"
    },
    {
      "source": "joe_rogan",
      "target": "dan_crenshaw"
    },
    {
      "source": "joe_rogan",
      "target": "dan_doty"
    },
    {
      "source": "joe_rogan",
      "target": "dan_flores"
    },
    {
      "source": "joe_rogan",
      "target": "dan_gable"
    },
    {
      "source": "joe_rogan",
      "target": "dan_hardy"
    },
    {
      "source": "joe_rogan",
      "target": "dan_harris"
    },
    {
      "source": "joe_rogan",
      "target": "dan_henderson"
    },
    {
      "source": "joe_rogan",
      "target": "dan_pe\u00f1a"
    },
    {
      "source": "joe_rogan",
      "target": "dan_savage"
    },
    {
      "source": "joe_rogan",
      "target": "dan_soder"
    },
    {
      "source": "joe_rogan",
      "target": "danica_patrick"
    },
    {
      "source": "joe_rogan",
      "target": "daniel_cormier"
    },
    {
      "source": "joe_rogan",
      "target": "daniel_holzman"
    },
    {
      "source": "joe_rogan",
      "target": "daniel_schmachtenberger"
    },
    {
      "source": "joe_rogan",
      "target": "daniel_straus"
    },
    {
      "source": "joe_rogan",
      "target": "daniele_bolelli"
    },
    {
      "source": "joe_rogan",
      "target": "danny_brown"
    },
    {
      "source": "joe_rogan",
      "target": "danny_philippou"
    },
    {
      "source": "joe_rogan",
      "target": "daryl_davis"
    },
    {
      "source": "joe_rogan",
      "target": "dave_asprey"
    },
    {
      "source": "joe_rogan",
      "target": "dave_attell"
    },
    {
      "source": "joe_rogan",
      "target": "dave_chappelle"
    },
    {
      "source": "joe_rogan",
      "target": "dave_foley"
    },
    {
      "source": "joe_rogan",
      "target": "dave_grohl"
    },
    {
      "source": "joe_rogan",
      "target": "dave_leduc"
    },
    {
      "source": "joe_rogan",
      "target": "dave_mustaine"
    },
    {
      "source": "joe_rogan",
      "target": "dave_portnoy"
    },
    {
      "source": "joe_rogan",
      "target": "dave_rubin"
    },
    {
      "source": "joe_rogan",
      "target": "dave_smith"
    },
    {
      "source": "joe_rogan",
      "target": "david_beckham"
    },
    {
      "source": "joe_rogan",
      "target": "david_blaine"
    },
    {
      "source": "joe_rogan",
      "target": "david_buss"
    },
    {
      "source": "joe_rogan",
      "target": "david_choe"
    },
    {
      "source": "joe_rogan",
      "target": "david_cross"
    },
    {
      "source": "joe_rogan",
      "target": "david_fravor"
    },
    {
      "source": "joe_rogan",
      "target": "david_goggins"
    },
    {
      "source": "joe_rogan",
      "target": "david_grusch"
    },
    {
      "source": "joe_rogan",
      "target": "david_holthouse"
    },
    {
      "source": "joe_rogan",
      "target": "david_lee_roth"
    },
    {
      "source": "joe_rogan",
      "target": "david_mamet"
    },
    {
      "source": "joe_rogan",
      "target": "david_mcmillan"
    },
    {
      "source": "joe_rogan",
      "target": "david_pakman"
    },
    {
      "source": "joe_rogan",
      "target": "david_seaman"
    },
    {
      "source": "joe_rogan",
      "target": "david_sinclair"
    },
    {
      "source": "joe_rogan",
      "target": "david_spade"
    },
    {
      "source": "joe_rogan",
      "target": "david_wallace-wells"
    },
    {
      "source": "joe_rogan",
      "target": "dean_delray"
    },
    {
      "source": "joe_rogan",
      "target": "demetrious_johnson"
    },
    {
      "source": "joe_rogan",
      "target": "demi_lovato"
    },
    {
      "source": "joe_rogan",
      "target": "dennis_mckenna"
    },
    {
      "source": "joe_rogan",
      "target": "deontay_wilder"
    },
    {
      "source": "joe_rogan",
      "target": "derek_from_more_plates_more_dates"
    },
    {
      "source": "joe_rogan",
      "target": "derek_wolfe"
    },
    {
      "source": "joe_rogan",
      "target": "derren_brown"
    },
    {
      "source": "joe_rogan",
      "target": "derrick_hamilton"
    },
    {
      "source": "joe_rogan",
      "target": "derrick_lewis"
    },
    {
      "source": "joe_rogan",
      "target": "diamond_dallas_page"
    },
    {
      "source": "joe_rogan",
      "target": "diana_rodgers"
    },
    {
      "source": "joe_rogan",
      "target": "din_thomas"
    },
    {
      "source": "joe_rogan",
      "target": "dom_d\u2019agostino"
    },
    {
      "source": "joe_rogan",
      "target": "dom_irrera"
    },
    {
      "source": "joe_rogan",
      "target": "dominic_monaghan"
    },
    {
      "source": "joe_rogan",
      "target": "dominick_cruz"
    },
    {
      "source": "joe_rogan",
      "target": "don_frye"
    },
    {
      "source": "joe_rogan",
      "target": "don_gavin"
    },
    {
      "source": "joe_rogan",
      "target": "donald_cerrone"
    },
    {
      "source": "joe_rogan",
      "target": "donnell_rawlings"
    },
    {
      "source": "joe_rogan",
      "target": "donnie_vincent"
    },
    {
      "source": "joe_rogan",
      "target": "dorian_yates"
    },
    {
      "source": "joe_rogan",
      "target": "doug_benson"
    },
    {
      "source": "joe_rogan",
      "target": "doug_duren"
    },
    {
      "source": "joe_rogan",
      "target": "doug_stanhope"
    },
    {
      "source": "joe_rogan",
      "target": "douglas_murray"
    },
    {
      "source": "joe_rogan",
      "target": "douglas_rushkoff"
    },
    {
      "source": "joe_rogan",
      "target": "amit_goswami"
    },
    {
      "source": "joe_rogan",
      "target": "andrew_weil"
    },
    {
      "source": "joe_rogan",
      "target": "andy_galpin"
    },
    {
      "source": "joe_rogan",
      "target": "aseem_malhotra"
    },
    {
      "source": "joe_rogan",
      "target": "ben_goertzel"
    },
    {
      "source": "joe_rogan",
      "target": "bradley_garrett"
    },
    {
      "source": "joe_rogan",
      "target": "carl_hart"
    },
    {
      "source": "joe_rogan",
      "target": "cornel_west"
    },
    {
      "source": "joe_rogan",
      "target": "debra_soh"
    },
    {
      "source": "joe_rogan",
      "target": "gabor_mat\u00e9"
    },
    {
      "source": "joe_rogan",
      "target": "joel_kahn"
    },
    {
      "source": "joe_rogan",
      "target": "mark_gordon"
    },
    {
      "source": "joe_rogan",
      "target": "michael_hart"
    },
    {
      "source": "joe_rogan",
      "target": "peter_a._mccullough"
    },
    {
      "source": "joe_rogan",
      "target": "peter_hotez"
    },
    {
      "source": "joe_rogan",
      "target": "phil"
    },
    {
      "source": "joe_rogan",
      "target": "pierre_kory"
    },
    {
      "source": "joe_rogan",
      "target": "rhonda_patrick"
    },
    {
      "source": "joe_rogan",
      "target": "robert_epstein"
    },
    {
      "source": "joe_rogan",
      "target": "robert_malone"
    },
    {
      "source": "joe_rogan",
      "target": "roddy_mcgee"
    },
    {
      "source": "joe_rogan",
      "target": "sanjay_gupta"
    },
    {
      "source": "joe_rogan",
      "target": "shanna_swan"
    },
    {
      "source": "joe_rogan",
      "target": "shawn_baker"
    },
    {
      "source": "joe_rogan",
      "target": "duane_ludwig"
    },
    {
      "source": "joe_rogan",
      "target": "duke_roufus"
    },
    {
      "source": "joe_rogan",
      "target": "duncan_french"
    },
    {
      "source": "joe_rogan",
      "target": "duncan_trussell"
    },
    {
      "source": "joe_rogan",
      "target": "dustin_poirier"
    },
    {
      "source": "joe_rogan",
      "target": "dwayne_'the_rock'_johnson"
    },
    {
      "source": "joe_rogan",
      "target": "earthquake"
    },
    {
      "source": "joe_rogan",
      "target": "ed_calderon"
    },
    {
      "source": "joe_rogan",
      "target": "eddie_bravo"
    },
    {
      "source": "joe_rogan",
      "target": "eddie_huang"
    },
    {
      "source": "joe_rogan",
      "target": "eddie_ifft"
    },
    {
      "source": "joe_rogan",
      "target": "eddie_izzard"
    },
    {
      "source": "joe_rogan",
      "target": "eddie_pepitone"
    },
    {
      "source": "joe_rogan",
      "target": "edmond_tarverdyan"
    },
    {
      "source": "joe_rogan",
      "target": "edward_norton"
    },
    {
      "source": "joe_rogan",
      "target": "edward_slingerland"
    },
    {
      "source": "joe_rogan",
      "target": "edward_snowden"
    },
    {
      "source": "joe_rogan",
      "target": "ehsan_ahmad"
    },
    {
      "source": "joe_rogan",
      "target": "eleanor_kerrigan"
    },
    {
      "source": "joe_rogan",
      "target": "elliott_west"
    },
    {
      "source": "joe_rogan",
      "target": "elon_musk"
    },
    {
      "source": "joe_rogan",
      "target": "emily_harrington"
    },
    {
      "source": "joe_rogan",
      "target": "enson_inoue"
    },
    {
      "source": "joe_rogan",
      "target": "eric_albarracin"
    },
    {
      "source": "joe_rogan",
      "target": "eric_weinstein"
    },
    {
      "source": "joe_rogan",
      "target": "erik_griffin"
    },
    {
      "source": "joe_rogan",
      "target": "erika_thompson"
    },
    {
      "source": "joe_rogan",
      "target": "erwan_le_corre"
    },
    {
      "source": "joe_rogan",
      "target": "eryk_anders"
    },
    {
      "source": "joe_rogan",
      "target": "esther_ku"
    },
    {
      "source": "joe_rogan",
      "target": "ethan_nadelmann"
    },
    {
      "source": "joe_rogan",
      "target": "ethan_suplee"
    },
    {
      "source": "joe_rogan",
      "target": "evan_funke"
    },
    {
      "source": "joe_rogan",
      "target": "evan_hafer"
    },
    {
      "source": "joe_rogan",
      "target": "evander_holyfield"
    },
    {
      "source": "joe_rogan",
      "target": "everlast"
    },
    {
      "source": "joe_rogan",
      "target": "fahim_anwar"
    },
    {
      "source": "joe_rogan",
      "target": "fedor_gorst"
    },
    {
      "source": "joe_rogan",
      "target": "felipe_esparza"
    },
    {
      "source": "joe_rogan",
      "target": "firas_zahabi"
    },
    {
      "source": "joe_rogan",
      "target": "floyd_mayweather_jr."
    },
    {
      "source": "joe_rogan",
      "target": "forrest_galante"
    },
    {
      "source": "joe_rogan",
      "target": "forrest_griffin"
    },
    {
      "source": "joe_rogan",
      "target": "fortune_feimster"
    },
    {
      "source": "joe_rogan",
      "target": "francis_foster"
    },
    {
      "source": "joe_rogan",
      "target": "francis_ngannou"
    },
    {
      "source": "joe_rogan",
      "target": "frank_castillo"
    },
    {
      "source": "joe_rogan",
      "target": "frank_von_hippel"
    },
    {
      "source": "joe_rogan",
      "target": "frankie_edgar"
    },
    {
      "source": "joe_rogan",
      "target": "fred_morin"
    },
    {
      "source": "joe_rogan",
      "target": "freddie_gibbs"
    },
    {
      "source": "joe_rogan",
      "target": "gabriel_iglesias"
    },
    {
      "source": "joe_rogan",
      "target": "gabrielle_reece"
    },
    {
      "source": "joe_rogan",
      "target": "gad_saad"
    },
    {
      "source": "joe_rogan",
      "target": "garrett_reisman"
    },
    {
      "source": "joe_rogan",
      "target": "gary_brecka"
    },
    {
      "source": "joe_rogan",
      "target": "gary_clark"
    },
    {
      "source": "joe_rogan",
      "target": "gary_clark_jr."
    },
    {
      "source": "joe_rogan",
      "target": "gary_johnson"
    },
    {
      "source": "joe_rogan",
      "target": "gary_laderman"
    },
    {
      "source": "joe_rogan",
      "target": "gary_taubes"
    },
    {
      "source": "joe_rogan",
      "target": "gary_vaynerchuk"
    },
    {
      "source": "joe_rogan",
      "target": "gaston_bolanos"
    },
    {
      "source": "joe_rogan",
      "target": "gavin_de_becker"
    },
    {
      "source": "joe_rogan",
      "target": "gavin_mcinnes"
    },
    {
      "source": "joe_rogan",
      "target": "gene_lebell"
    },
    {
      "source": "joe_rogan",
      "target": "general_h.r._mcmaster"
    },
    {
      "source": "joe_rogan",
      "target": "geoffrey_miller"
    },
    {
      "source": "joe_rogan",
      "target": "george_kambosos"
    },
    {
      "source": "joe_rogan",
      "target": "george_knapp"
    },
    {
      "source": "joe_rogan",
      "target": "george_lockhart"
    },
    {
      "source": "joe_rogan",
      "target": "george_perez"
    },
    {
      "source": "joe_rogan",
      "target": "georges_st-pierre"
    },
    {
      "source": "joe_rogan",
      "target": "gerard_way"
    },
    {
      "source": "joe_rogan",
      "target": "gilbert_gottfried"
    },
    {
      "source": "joe_rogan",
      "target": "gillian_robertson"
    },
    {
      "source": "joe_rogan",
      "target": "gina_carano"
    },
    {
      "source": "joe_rogan",
      "target": "gino_&_aj"
    },
    {
      "source": "joe_rogan",
      "target": "giorgio_tsoukalos"
    },
    {
      "source": "joe_rogan",
      "target": "glen_cordoza"
    },
    {
      "source": "joe_rogan",
      "target": "glenn_greenwald"
    },
    {
      "source": "joe_rogan",
      "target": "glenn_villeneuve"
    },
    {
      "source": "joe_rogan",
      "target": "gordon_ryan"
    },
    {
      "source": "joe_rogan",
      "target": "graham_hancock"
    },
    {
      "source": "joe_rogan",
      "target": "greg_fitzsimmons"
    },
    {
      "source": "joe_rogan",
      "target": "greg_proops"
    },
    {
      "source": "joe_rogan",
      "target": "guy_ritchie"
    },
    {
      "source": "joe_rogan",
      "target": "hamilton_morris"
    },
    {
      "source": "joe_rogan",
      "target": "hank_shaw"
    },
    {
      "source": "joe_rogan",
      "target": "hannibal_buress"
    },
    {
      "source": "joe_rogan",
      "target": "hans_kim"
    },
    {
      "source": "joe_rogan",
      "target": "harrison_ford"
    },
    {
      "source": "joe_rogan",
      "target": "heather_heying"
    },
    {
      "source": "joe_rogan",
      "target": "henry_cejudo"
    },
    {
      "source": "joe_rogan",
      "target": "henry_rollins"
    },
    {
      "source": "joe_rogan",
      "target": "herb_dean"
    },
    {
      "source": "joe_rogan",
      "target": "honey_honey"
    },
    {
      "source": "joe_rogan",
      "target": "hotep_jesus"
    },
    {
      "source": "joe_rogan",
      "target": "howard_bloom"
    },
    {
      "source": "joe_rogan",
      "target": "howie_mandel"
    },
    {
      "source": "joe_rogan",
      "target": "hugo_martin"
    },
    {
      "source": "joe_rogan",
      "target": "hulk_hogan"
    },
    {
      "source": "joe_rogan",
      "target": "ian_edwards"
    },
    {
      "source": "joe_rogan",
      "target": "ian_mccall"
    },
    {
      "source": "joe_rogan",
      "target": "ice_cube"
    },
    {
      "source": "joe_rogan",
      "target": "iliza_shlesinger"
    },
    {
      "source": "joe_rogan",
      "target": "immortal_technique"
    },
    {
      "source": "joe_rogan",
      "target": "ioan_grillo"
    },
    {
      "source": "joe_rogan",
      "target": "ira_glasser"
    },
    {
      "source": "joe_rogan",
      "target": "isaac_haxton"
    },
    {
      "source": "joe_rogan",
      "target": "israel_adesanya"
    },
    {
      "source": "joe_rogan",
      "target": "j._prince"
    },
    {
      "source": "joe_rogan",
      "target": "jack_carr"
    },
    {
      "source": "joe_rogan",
      "target": "jack_dorsey"
    },
    {
      "source": "joe_rogan",
      "target": "jacob_ward"
    },
    {
      "source": "joe_rogan",
      "target": "jacques_vall\u00e9e"
    },
    {
      "source": "joe_rogan",
      "target": "jake_roberts"
    },
    {
      "source": "joe_rogan",
      "target": "jake_shields"
    },
    {
      "source": "joe_rogan",
      "target": "jakob_dylan"
    },
    {
      "source": "joe_rogan",
      "target": "jamahal_hill"
    },
    {
      "source": "joe_rogan",
      "target": "jamar_neighbors"
    },
    {
      "source": "joe_rogan",
      "target": "james_\u201cbobo\u201d_fay"
    },
    {
      "source": "joe_rogan",
      "target": "james_damore"
    },
    {
      "source": "joe_rogan",
      "target": "james_fox"
    },
    {
      "source": "joe_rogan",
      "target": "james_hetfield"
    },
    {
      "source": "joe_rogan",
      "target": "james_kingston"
    },
    {
      "source": "joe_rogan",
      "target": "james_lindsay"
    },
    {
      "source": "joe_rogan",
      "target": "james_nestor"
    },
    {
      "source": "joe_rogan",
      "target": "james_reed"
    },
    {
      "source": "joe_rogan",
      "target": "james_wilks"
    },
    {
      "source": "joe_rogan",
      "target": "jamie_foxx"
    },
    {
      "source": "joe_rogan",
      "target": "jamie_kilstein"
    },
    {
      "source": "joe_rogan",
      "target": "jamie_metzl"
    },
    {
      "source": "joe_rogan",
      "target": "jane_mcgonigal"
    },
    {
      "source": "joe_rogan",
      "target": "janet_zuccarini"
    },
    {
      "source": "joe_rogan",
      "target": "jann_wenner"
    },
    {
      "source": "joe_rogan",
      "target": "jared_cannonier"
    },
    {
      "source": "joe_rogan",
      "target": "jason_everman"
    },
    {
      "source": "joe_rogan",
      "target": "jason_flom"
    },
    {
      "source": "joe_rogan",
      "target": "jason_hairston"
    },
    {
      "source": "joe_rogan",
      "target": "jason_silva"
    },
    {
      "source": "joe_rogan",
      "target": "jason_wilson"
    },
    {
      "source": "joe_rogan",
      "target": "javier_bardem"
    },
    {
      "source": "joe_rogan",
      "target": "jay_leno"
    },
    {
      "source": "joe_rogan",
      "target": "jd_kelley"
    },
    {
      "source": "joe_rogan",
      "target": "jd_witherspoon"
    },
    {
      "source": "joe_rogan",
      "target": "jean_jacques_machado"
    },
    {
      "source": "joe_rogan",
      "target": "jeff_evans"
    },
    {
      "source": "joe_rogan",
      "target": "jeff_garlin"
    },
    {
      "source": "joe_rogan",
      "target": "jeff_novitzky"
    },
    {
      "source": "joe_rogan",
      "target": "jeff_ross"
    },
    {
      "source": "joe_rogan",
      "target": "jeff_warren"
    },
    {
      "source": "joe_rogan",
      "target": "jelly_roll"
    },
    {
      "source": "joe_rogan",
      "target": "jenni_harris"
    },
    {
      "source": "joe_rogan",
      "target": "jenny_johnson"
    },
    {
      "source": "joe_rogan",
      "target": "jenny_kleeman"
    },
    {
      "source": "joe_rogan",
      "target": "jeremy_corbell"
    },
    {
      "source": "joe_rogan",
      "target": "jeremy_gerber"
    },
    {
      "source": "joe_rogan",
      "target": "jeremy_jones"
    },
    {
      "source": "joe_rogan",
      "target": "jeremy_stephens"
    },
    {
      "source": "joe_rogan",
      "target": "jerrod_carmichael"
    },
    {
      "source": "joe_rogan",
      "target": "jerry_seinfeld"
    },
    {
      "source": "joe_rogan",
      "target": "jesse_griffiths"
    },
    {
      "source": "joe_rogan",
      "target": "jesse_itzler"
    },
    {
      "source": "joe_rogan",
      "target": "jesse_singal"
    },
    {
      "source": "joe_rogan",
      "target": "jesse_ventura"
    },
    {
      "source": "joe_rogan",
      "target": "jessica_kirson"
    },
    {
      "source": "joe_rogan",
      "target": "jessica_rosenworcel"
    },
    {
      "source": "joe_rogan",
      "target": "jessimae_peluso"
    },
    {
      "source": "joe_rogan",
      "target": "jesus_trejo"
    },
    {
      "source": "joe_rogan",
      "target": "jewel"
    },
    {
      "source": "joe_rogan",
      "target": "jim_breuer"
    },
    {
      "source": "joe_rogan",
      "target": "jim_florentine"
    },
    {
      "source": "joe_rogan",
      "target": "jim_gaffigan"
    },
    {
      "source": "joe_rogan",
      "target": "jim_jefferies"
    },
    {
      "source": "joe_rogan",
      "target": "jim_miller"
    },
    {
      "source": "joe_rogan",
      "target": "jim_norton"
    },
    {
      "source": "joe_rogan",
      "target": "jim_shockey"
    },
    {
      "source": "joe_rogan",
      "target": "jimmy_carr"
    },
    {
      "source": "joe_rogan",
      "target": "jimmy_corsetti"
    },
    {
      "source": "joe_rogan",
      "target": "jimmy_dore"
    },
    {
      "source": "joe_rogan",
      "target": "jimmy_o_yang"
    },
    {
      "source": "joe_rogan",
      "target": "jimmy_smith"
    },
    {
      "source": "joe_rogan",
      "target": "joaquin_buckley"
    },
    {
      "source": "joe_rogan",
      "target": "jocko_willink"
    },
    {
      "source": "joe_rogan",
      "target": "joe_de_sena"
    },
    {
      "source": "joe_rogan",
      "target": "joe_derosa"
    },
    {
      "source": "joe_rogan",
      "target": "joe_list"
    },
    {
      "source": "joe_rogan",
      "target": "joe_perry"
    },
    {
      "source": "joe_rogan",
      "target": "joe_pyfer"
    },
    {
      "source": "joe_rogan",
      "target": "joe_quirk"
    },
    {
      "source": "joe_rogan",
      "target": "joe_schilling"
    },
    {
      "source": "joe_rogan",
      "target": "joel_salatin"
    },
    {
      "source": "joe_rogan",
      "target": "joel_turner"
    },
    {
      "source": "joe_rogan",
      "target": "joey_diaz"
    },
    {
      "source": "joe_rogan",
      "target": "johann_hari"
    },
    {
      "source": "joe_rogan",
      "target": "john_abramson"
    },
    {
      "source": "joe_rogan",
      "target": "john_anthony_west"
    },
    {
      "source": "joe_rogan",
      "target": "john_carmack"
    },
    {
      "source": "joe_rogan",
      "target": "john_danaher"
    },
    {
      "source": "joe_rogan",
      "target": "john_dudley"
    },
    {
      "source": "joe_rogan",
      "target": "john_hackleman"
    },
    {
      "source": "joe_rogan",
      "target": "john_heffron"
    },
    {
      "source": "joe_rogan",
      "target": "john_hefron"
    },
    {
      "source": "joe_rogan",
      "target": "john_hennessey"
    },
    {
      "source": "joe_rogan",
      "target": "john_joseph"
    },
    {
      "source": "joe_rogan",
      "target": "john_kavanagh"
    },
    {
      "source": "joe_rogan",
      "target": "john_mackey"
    },
    {
      "source": "joe_rogan",
      "target": "john_mulaney"
    },
    {
      "source": "joe_rogan",
      "target": "john_nores"
    },
    {
      "source": "joe_rogan",
      "target": "john_rallo"
    },
    {
      "source": "joe_rogan",
      "target": "john_reeves"
    },
    {
      "source": "joe_rogan",
      "target": "john_terzian"
    },
    {
      "source": "joe_rogan",
      "target": "john_wayne_parr"
    },
    {
      "source": "joe_rogan",
      "target": "john_witherspoon"
    },
    {
      "source": "joe_rogan",
      "target": "jon_bernthal"
    },
    {
      "source": "joe_rogan",
      "target": "jon_jones"
    },
    {
      "source": "joe_rogan",
      "target": "jon_peters"
    },
    {
      "source": "joe_rogan",
      "target": "jon_reep"
    },
    {
      "source": "joe_rogan",
      "target": "jon_ronson"
    },
    {
      "source": "joe_rogan",
      "target": "jon_stewart"
    },
    {
      "source": "joe_rogan",
      "target": "jonathan_gottschall"
    },
    {
      "source": "joe_rogan",
      "target": "jonathan_haidt"
    },
    {
      "source": "joe_rogan",
      "target": "jonathan_ward"
    },
    {
      "source": "joe_rogan",
      "target": "jonathan_zimmerman"
    },
    {
      "source": "joe_rogan",
      "target": "jordan_burroughs"
    },
    {
      "source": "joe_rogan",
      "target": "jordan_e._cooper"
    },
    {
      "source": "joe_rogan",
      "target": "jordan_gilbert_(0thing)"
    },
    {
      "source": "joe_rogan",
      "target": "jordan_jonas"
    },
    {
      "source": "joe_rogan",
      "target": "jordan_peterson"
    },
    {
      "source": "joe_rogan",
      "target": "jorge_masvidal"
    },
    {
      "source": "joe_rogan",
      "target": "joseph_ledoux"
    },
    {
      "source": "joe_rogan",
      "target": "joseph_valtellini"
    },
    {
      "source": "joe_rogan",
      "target": "josh_barnett"
    },
    {
      "source": "joe_rogan",
      "target": "josh_brolin"
    },
    {
      "source": "joe_rogan",
      "target": "josh_dubin"
    },
    {
      "source": "joe_rogan",
      "target": "josh_fox"
    },
    {
      "source": "joe_rogan",
      "target": "josh_henning"
    },
    {
      "source": "joe_rogan",
      "target": "josh_homme"
    },
    {
      "source": "joe_rogan",
      "target": "josh_mcdermitt"
    },
    {
      "source": "joe_rogan",
      "target": "josh_olin"
    },
    {
      "source": "joe_rogan",
      "target": "josh_rogin"
    },
    {
      "source": "joe_rogan",
      "target": "josh_szeps"
    },
    {
      "source": "joe_rogan",
      "target": "josh_thomson"
    },
    {
      "source": "joe_rogan",
      "target": "josh_zepps"
    },
    {
      "source": "joe_rogan",
      "target": "jr."
    },
    {
      "source": "joe_rogan",
      "target": "judah_friedlander"
    },
    {
      "source": "joe_rogan",
      "target": "judd_apatow"
    },
    {
      "source": "joe_rogan",
      "target": "julianna_pe\u00f1a"
    },
    {
      "source": "joe_rogan",
      "target": "julie_kedzie"
    },
    {
      "source": "joe_rogan",
      "target": "justin_brown"
    },
    {
      "source": "joe_rogan",
      "target": "justin_collett"
    },
    {
      "source": "joe_rogan",
      "target": "justin_foster"
    },
    {
      "source": "joe_rogan",
      "target": "justin_gaethje"
    },
    {
      "source": "joe_rogan",
      "target": "justin_halpern"
    },
    {
      "source": "joe_rogan",
      "target": "justin_martindale"
    },
    {
      "source": "joe_rogan",
      "target": "justin_wren"
    },
    {
      "source": "joe_rogan",
      "target": "kamaru_usman"
    },
    {
      "source": "joe_rogan",
      "target": "kanye_west"
    },
    {
      "source": "joe_rogan",
      "target": "kari_lake"
    },
    {
      "source": "joe_rogan",
      "target": "kathleen_madigan"
    },
    {
      "source": "joe_rogan",
      "target": "katie_spotz"
    },
    {
      "source": "joe_rogan",
      "target": "katt_williams"
    },
    {
      "source": "joe_rogan",
      "target": "katy_bowman"
    },
    {
      "source": "joe_rogan",
      "target": "keanu_reeves"
    },
    {
      "source": "joe_rogan",
      "target": "keegan_kuhn"
    },
    {
      "source": "joe_rogan",
      "target": "keith_weber"
    },
    {
      "source": "joe_rogan",
      "target": "kelly_brogan"
    },
    {
      "source": "joe_rogan",
      "target": "kelly_pavlik"
    },
    {
      "source": "joe_rogan",
      "target": "kelly_slater"
    },
    {
      "source": "joe_rogan",
      "target": "kelly_starrett"
    },
    {
      "source": "joe_rogan",
      "target": "kenton_carruth"
    },
    {
      "source": "joe_rogan",
      "target": "kermit_pattison"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_folta"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_hart"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_holland"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_lee"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_pereira"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_rose"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_ross"
    },
    {
      "source": "joe_rogan",
      "target": "kevin_smith"
    },
    {
      "source": "joe_rogan",
      "target": "khabib_nurmagomedov"
    },
    {
      "source": "joe_rogan",
      "target": "khalil_rountree"
    },
    {
      "source": "joe_rogan",
      "target": "khalil_rountree_jr."
    },
    {
      "source": "joe_rogan",
      "target": "kid_cudi"
    },
    {
      "source": "joe_rogan",
      "target": "killer_mike"
    },
    {
      "source": "joe_rogan",
      "target": "kim_congdon"
    },
    {
      "source": "joe_rogan",
      "target": "kip_andersen"
    },
    {
      "source": "joe_rogan",
      "target": "kirian_fitzgibbons"
    },
    {
      "source": "joe_rogan",
      "target": "kirik_jenness"
    },
    {
      "source": "joe_rogan",
      "target": "konstantin_kisin"
    },
    {
      "source": "joe_rogan",
      "target": "konstantine_kisin"
    },
    {
      "source": "joe_rogan",
      "target": "kristin_beck"
    },
    {
      "source": "joe_rogan",
      "target": "kron_gracie"
    },
    {
      "source": "joe_rogan",
      "target": "krystal_&_saagar"
    },
    {
      "source": "joe_rogan",
      "target": "krystal_ball"
    },
    {
      "source": "joe_rogan",
      "target": "krystyna_hutchinson"
    },
    {
      "source": "joe_rogan",
      "target": "kurt_angle"
    },
    {
      "source": "joe_rogan",
      "target": "kurt_metzger"
    },
    {
      "source": "joe_rogan",
      "target": "kyle_dunnigan"
    },
    {
      "source": "joe_rogan",
      "target": "kyle_kinane"
    },
    {
      "source": "joe_rogan",
      "target": "kyle_kingsbury"
    },
    {
      "source": "joe_rogan",
      "target": "kyle_kulinski"
    },
    {
      "source": "joe_rogan",
      "target": "laird_hamilton"
    },
    {
      "source": "joe_rogan",
      "target": "lance_armstrong"
    },
    {
      "source": "joe_rogan",
      "target": "lara_beitz"
    },
    {
      "source": "joe_rogan",
      "target": "larry_sharpe"
    },
    {
      "source": "joe_rogan",
      "target": "lars_ulrich"
    },
    {
      "source": "joe_rogan",
      "target": "laurie_woolever"
    },
    {
      "source": "joe_rogan",
      "target": "lawrence_krauss"
    },
    {
      "source": "joe_rogan",
      "target": "lawrence_lessig"
    },
    {
      "source": "joe_rogan",
      "target": "lawrence_wright"
    },
    {
      "source": "joe_rogan",
      "target": "layne_norton"
    },
    {
      "source": "joe_rogan",
      "target": "leah_remini"
    },
    {
      "source": "joe_rogan",
      "target": "lee_camp"
    },
    {
      "source": "joe_rogan",
      "target": "legion_of_skanks"
    },
    {
      "source": "joe_rogan",
      "target": "lennox_lewis"
    },
    {
      "source": "joe_rogan",
      "target": "lenny_clarke"
    },
    {
      "source": "joe_rogan",
      "target": "leon_edwards"
    },
    {
      "source": "joe_rogan",
      "target": "leonardo_dicaprio"
    },
    {
      "source": "joe_rogan",
      "target": "les_stroud"
    },
    {
      "source": "joe_rogan",
      "target": "lewis_from_unbox_therapy"
    },
    {
      "source": "joe_rogan",
      "target": "lex_fridman"
    },
    {
      "source": "joe_rogan",
      "target": "liam_&_dylan_resnekov"
    },
    {
      "source": "joe_rogan",
      "target": "liam_harrison"
    },
    {
      "source": "joe_rogan",
      "target": "lil_duval"
    },
    {
      "source": "joe_rogan",
      "target": "lindsey_fitzharris"
    },
    {
      "source": "joe_rogan",
      "target": "liz_phair"
    },
    {
      "source": "joe_rogan",
      "target": "logan_paul"
    },
    {
      "source": "joe_rogan",
      "target": "lorenzo_hagerty"
    },
    {
      "source": "joe_rogan",
      "target": "louie_psihoyos"
    },
    {
      "source": "joe_rogan",
      "target": "louie_simmons"
    },
    {
      "source": "joe_rogan",
      "target": "louis_ck"
    },
    {
      "source": "joe_rogan",
      "target": "louis_theroux"
    },
    {
      "source": "joe_rogan",
      "target": "luis_j._gomez"
    },
    {
      "source": "joe_rogan",
      "target": "luke_combs"
    },
    {
      "source": "joe_rogan",
      "target": "luke_thomas"
    },
    {
      "source": "joe_rogan",
      "target": "maajid_nawaz"
    },
    {
      "source": "joe_rogan",
      "target": "mac_danzig"
    },
    {
      "source": "joe_rogan",
      "target": "mac_lethal"
    },
    {
      "source": "joe_rogan",
      "target": "macaulay_culkin"
    },
    {
      "source": "joe_rogan",
      "target": "magnus_walker"
    },
    {
      "source": "joe_rogan",
      "target": "malcolm_gladwell"
    },
    {
      "source": "joe_rogan",
      "target": "marc_andreessen"
    },
    {
      "source": "joe_rogan",
      "target": "marc_maron"
    },
    {
      "source": "joe_rogan",
      "target": "marcus_luttrell"
    },
    {
      "source": "joe_rogan",
      "target": "mareko_maumasi"
    },
    {
      "source": "joe_rogan",
      "target": "mariana_van_zeller"
    },
    {
      "source": "joe_rogan",
      "target": "marianne_williamson"
    },
    {
      "source": "joe_rogan",
      "target": "mark_calaway"
    },
    {
      "source": "joe_rogan",
      "target": "mark_bell"
    },
    {
      "source": "joe_rogan",
      "target": "mark_boal"
    },
    {
      "source": "joe_rogan",
      "target": "mark_dellagrotte"
    },
    {
      "source": "joe_rogan",
      "target": "mark_gordon"
    },
    {
      "source": "joe_rogan",
      "target": "mark_greaney"
    },
    {
      "source": "joe_rogan",
      "target": "mark_kendall"
    },
    {
      "source": "joe_rogan",
      "target": "mark_laita"
    },
    {
      "source": "joe_rogan",
      "target": "mark_normand"
    },
    {
      "source": "joe_rogan",
      "target": "mark_sisson"
    },
    {
      "source": "joe_rogan",
      "target": "mark_smith"
    },
    {
      "source": "joe_rogan",
      "target": "mark_zuckerberg"
    },
    {
      "source": "joe_rogan",
      "target": "marlon_vera"
    },
    {
      "source": "joe_rogan",
      "target": "marques_brownlee"
    },
    {
      "source": "joe_rogan",
      "target": "mary_lynn_rajskub"
    },
    {
      "source": "joe_rogan",
      "target": "mat_best"
    },
    {
      "source": "joe_rogan",
      "target": "mat_fraser"
    },
    {
      "source": "joe_rogan",
      "target": "matt_braunger"
    },
    {
      "source": "joe_rogan",
      "target": "matt_brown"
    },
    {
      "source": "joe_rogan",
      "target": "matt_damon"
    },
    {
      "source": "joe_rogan",
      "target": "matt_farah"
    },
    {
      "source": "joe_rogan",
      "target": "matt_fulchiron"
    },
    {
      "source": "joe_rogan",
      "target": "matt_mccusker"
    },
    {
      "source": "joe_rogan",
      "target": "matt_paxton"
    },
    {
      "source": "joe_rogan",
      "target": "matt_rife"
    },
    {
      "source": "joe_rogan",
      "target": "matt_serra"
    },
    {
      "source": "joe_rogan",
      "target": "matt_taibbi"
    },
    {
      "source": "joe_rogan",
      "target": "matt_walsh"
    },
    {
      "source": "joe_rogan",
      "target": "matthew_lohmeier"
    },
    {
      "source": "joe_rogan",
      "target": "matthew_mcconaughey"
    },
    {
      "source": "joe_rogan",
      "target": "matthew_walker"
    },
    {
      "source": "joe_rogan",
      "target": "matthew_yglesias"
    },
    {
      "source": "joe_rogan",
      "target": "matty_matheson"
    },
    {
      "source": "joe_rogan",
      "target": "mauro_ranallo"
    },
    {
      "source": "joe_rogan",
      "target": "max_holloway"
    },
    {
      "source": "joe_rogan",
      "target": "max_lugavere"
    },
    {
      "source": "joe_rogan",
      "target": "mayhem_miller"
    },
    {
      "source": "joe_rogan",
      "target": "maynard_james_keenan"
    },
    {
      "source": "joe_rogan",
      "target": "mayor_steve_adler"
    },
    {
      "source": "joe_rogan",
      "target": "md"
    },
    {
      "source": "joe_rogan",
      "target": "megan_phelps-roper"
    },
    {
      "source": "joe_rogan",
      "target": "meghan_murphy"
    },
    {
      "source": "joe_rogan",
      "target": "mel_gibson"
    },
    {
      "source": "joe_rogan",
      "target": "melissa_chen"
    },
    {
      "source": "joe_rogan",
      "target": "merlin_tuttle"
    },
    {
      "source": "joe_rogan",
      "target": "michael_bisping"
    },
    {
      "source": "joe_rogan",
      "target": "michael_chandler"
    },
    {
      "source": "joe_rogan",
      "target": "michael_dowd"
    },
    {
      "source": "joe_rogan",
      "target": "michael_easter"
    },
    {
      "source": "joe_rogan",
      "target": "michael_hunter"
    },
    {
      "source": "joe_rogan",
      "target": "michael_imperioli"
    },
    {
      "source": "joe_rogan",
      "target": "michael_jordan"
    },
    {
      "source": "joe_rogan",
      "target": "michael_kosta"
    },
    {
      "source": "joe_rogan",
      "target": "michael_malice"
    },
    {
      "source": "joe_rogan",
      "target": "michael_osterholm"
    },
    {
      "source": "joe_rogan",
      "target": "michael_philippou"
    },
    {
      "source": "joe_rogan",
      "target": "michael_pollan"
    },
    {
      "source": "joe_rogan",
      "target": "michael_ruppert"
    },
    {
      "source": "joe_rogan",
      "target": "michael_schiavello"
    },
    {
      "source": "joe_rogan",
      "target": "michael_scott_moore"
    },
    {
      "source": "joe_rogan",
      "target": "michael_shellenberger"
    },
    {
      "source": "joe_rogan",
      "target": "michael_shermer"
    },
    {
      "source": "joe_rogan",
      "target": "michael_stevens"
    },
    {
      "source": "joe_rogan",
      "target": "michael_wood"
    },
    {
      "source": "joe_rogan",
      "target": "michael_yo"
    },
    {
      "source": "joe_rogan",
      "target": "michelle_waterson"
    },
    {
      "source": "joe_rogan",
      "target": "michelle_wolf"
    },
    {
      "source": "joe_rogan",
      "target": "michio_kaku"
    },
    {
      "source": "joe_rogan",
      "target": "mick_west"
    },
    {
      "source": "joe_rogan",
      "target": "miesha_tate"
    },
    {
      "source": "joe_rogan",
      "target": "mike_baker"
    },
    {
      "source": "joe_rogan",
      "target": "mike_birbiglia"
    },
    {
      "source": "joe_rogan",
      "target": "mike_dolce"
    },
    {
      "source": "joe_rogan",
      "target": "mike_glover"
    },
    {
      "source": "joe_rogan",
      "target": "mike_judge"
    },
    {
      "source": "joe_rogan",
      "target": "mike_perry"
    },
    {
      "source": "joe_rogan",
      "target": "mike_posner"
    },
    {
      "source": "joe_rogan",
      "target": "mike_sarraille"
    },
    {
      "source": "joe_rogan",
      "target": "mike_schmidt"
    },
    {
      "source": "joe_rogan",
      "target": "mike_tyson"
    },
    {
      "source": "joe_rogan",
      "target": "mike_vecchione"
    },
    {
      "source": "joe_rogan",
      "target": "mike_ward"
    },
    {
      "source": "joe_rogan",
      "target": "mikey_musumeci"
    },
    {
      "source": "joe_rogan",
      "target": "mikhaila_peterson"
    },
    {
      "source": "joe_rogan",
      "target": "miley_cyrus"
    },
    {
      "source": "joe_rogan",
      "target": "milo_yiannopoulos"
    },
    {
      "source": "joe_rogan",
      "target": "miriam_nakamoto"
    },
    {
      "source": "joe_rogan",
      "target": "mo_jassim"
    },
    {
      "source": "joe_rogan",
      "target": "molly_crabapple"
    },
    {
      "source": "joe_rogan",
      "target": "monty_franklin"
    },
    {
      "source": "joe_rogan",
      "target": "morgan_fallon"
    },
    {
      "source": "joe_rogan",
      "target": "morgan_murphy"
    },
    {
      "source": "joe_rogan",
      "target": "moshe_kasher"
    },
    {
      "source": "joe_rogan",
      "target": "moxie_marlinspike"
    },
    {
      "source": "joe_rogan",
      "target": "mr._beast"
    },
    {
      "source": "joe_rogan",
      "target": "ms._pat"
    },
    {
      "source": "joe_rogan",
      "target": "nancy_panza"
    },
    {
      "source": "joe_rogan",
      "target": "natasha_leggero"
    },
    {
      "source": "joe_rogan",
      "target": "nate_bargatze"
    },
    {
      "source": "joe_rogan",
      "target": "nate_diaz"
    },
    {
      "source": "joe_rogan",
      "target": "nathan_ihde"
    },
    {
      "source": "joe_rogan",
      "target": "naval_ravikant"
    },
    {
      "source": "joe_rogan",
      "target": "neal_brennan"
    },
    {
      "source": "joe_rogan",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "joe_rogan",
      "target": "neil_riordan"
    },
    {
      "source": "joe_rogan",
      "target": "neill_blomkamp"
    },
    {
      "source": "joe_rogan",
      "target": "nicholas_christakis"
    },
    {
      "source": "joe_rogan",
      "target": "nick_bostrom"
    },
    {
      "source": "joe_rogan",
      "target": "nick_curson"
    },
    {
      "source": "joe_rogan",
      "target": "nick_cutter"
    },
    {
      "source": "joe_rogan",
      "target": "nick_di_paolo"
    },
    {
      "source": "joe_rogan",
      "target": "nick_dipaolo"
    },
    {
      "source": "joe_rogan",
      "target": "nick_kroll"
    },
    {
      "source": "joe_rogan",
      "target": "nick_swardson"
    },
    {
      "source": "joe_rogan",
      "target": "nick_yarris"
    },
    {
      "source": "joe_rogan",
      "target": "nick_youssef"
    },
    {
      "source": "joe_rogan",
      "target": "nikki_glaser"
    },
    {
      "source": "joe_rogan",
      "target": "nimesh_patel"
    },
    {
      "source": "joe_rogan",
      "target": "nims_purja"
    },
    {
      "source": "joe_rogan",
      "target": "nina_teicholz"
    },
    {
      "source": "joe_rogan",
      "target": "oliver_anthony"
    },
    {
      "source": "joe_rogan",
      "target": "oliver_stone"
    },
    {
      "source": "joe_rogan",
      "target": "owen_benjamin"
    },
    {
      "source": "joe_rogan",
      "target": "owen_smith"
    },
    {
      "source": "joe_rogan",
      "target": "owen_wilson"
    },
    {
      "source": "joe_rogan",
      "target": "pantelis"
    },
    {
      "source": "joe_rogan",
      "target": "pat_barry"
    },
    {
      "source": "joe_rogan",
      "target": "pat_magee"
    },
    {
      "source": "joe_rogan",
      "target": "pat_mcnamara"
    },
    {
      "source": "joe_rogan",
      "target": "pat_miletich"
    },
    {
      "source": "joe_rogan",
      "target": "patrick_bet-david"
    },
    {
      "source": "joe_rogan",
      "target": "patrick_carney"
    },
    {
      "source": "joe_rogan",
      "target": "patton_oswalt"
    },
    {
      "source": "joe_rogan",
      "target": "paul_felder"
    },
    {
      "source": "joe_rogan",
      "target": "paul_greenberg"
    },
    {
      "source": "joe_rogan",
      "target": "paul_rosolie"
    },
    {
      "source": "joe_rogan",
      "target": "paul_saladino"
    },
    {
      "source": "joe_rogan",
      "target": "paul_stamets"
    },
    {
      "source": "joe_rogan",
      "target": "paul_stanley"
    },
    {
      "source": "joe_rogan",
      "target": "paul_virzi"
    },
    {
      "source": "joe_rogan",
      "target": "pauly_shore"
    },
    {
      "source": "joe_rogan",
      "target": "pavel_tsatsouline"
    },
    {
      "source": "joe_rogan",
      "target": "pedro_pascal"
    },
    {
      "source": "joe_rogan",
      "target": "penn_jillette"
    },
    {
      "source": "joe_rogan",
      "target": "pete_dominick"
    },
    {
      "source": "joe_rogan",
      "target": "pete_holmes"
    },
    {
      "source": "joe_rogan",
      "target": "peter_attia"
    },
    {
      "source": "joe_rogan",
      "target": "peter_berg"
    },
    {
      "source": "joe_rogan",
      "target": "peter_boghossian"
    },
    {
      "source": "joe_rogan",
      "target": "peter_giuliano"
    },
    {
      "source": "joe_rogan",
      "target": "peter_hotez"
    },
    {
      "source": "joe_rogan",
      "target": "peter_joseph"
    },
    {
      "source": "joe_rogan",
      "target": "peter_mcgraw"
    },
    {
      "source": "joe_rogan",
      "target": "peter_schiff"
    },
    {
      "source": "joe_rogan",
      "target": "peter_zeihan"
    },
    {
      "source": "joe_rogan",
      "target": "phil_demers"
    },
    {
      "source": "joe_rogan",
      "target": "phil_gerber"
    },
    {
      "source": "joe_rogan",
      "target": "philip_defranco"
    },
    {
      "source": "joe_rogan",
      "target": "philip_goff"
    },
    {
      "source": "joe_rogan",
      "target": "phillip_frankland_lee"
    },
    {
      "source": "joe_rogan",
      "target": "post_malone"
    },
    {
      "source": "joe_rogan",
      "target": "punkie_johnson"
    },
    {
      "source": "joe_rogan",
      "target": "python_cowboy"
    },
    {
      "source": "joe_rogan",
      "target": "quentin_tarantino"
    },
    {
      "source": "joe_rogan",
      "target": "radio_rahim"
    },
    {
      "source": "joe_rogan",
      "target": "rafael_lovato_jr."
    },
    {
      "source": "joe_rogan",
      "target": "rafinha_bastos"
    },
    {
      "source": "joe_rogan",
      "target": "raghunath_cappo"
    },
    {
      "source": "joe_rogan",
      "target": "ralph_barbosa"
    },
    {
      "source": "joe_rogan",
      "target": "randall_carlson"
    },
    {
      "source": "joe_rogan",
      "target": "rashad_evans"
    },
    {
      "source": "joe_rogan",
      "target": "reggie_watts"
    },
    {
      "source": "joe_rogan",
      "target": "remi_warren"
    },
    {
      "source": "joe_rogan",
      "target": "ren\u00e9e_diresta"
    },
    {
      "source": "joe_rogan",
      "target": "ric_flair"
    },
    {
      "source": "joe_rogan",
      "target": "rich_benoit"
    },
    {
      "source": "joe_rogan",
      "target": "rich_roll"
    },
    {
      "source": "joe_rogan",
      "target": "rich_vos"
    },
    {
      "source": "joe_rogan",
      "target": "richard_dawkins"
    },
    {
      "source": "joe_rogan",
      "target": "richard_rawlings"
    },
    {
      "source": "joe_rogan",
      "target": "rick_baker"
    },
    {
      "source": "joe_rogan",
      "target": "rick_doblin"
    },
    {
      "source": "joe_rogan",
      "target": "rick_rubin"
    },
    {
      "source": "joe_rogan",
      "target": "rick_strassman"
    },
    {
      "source": "joe_rogan",
      "target": "rickson_gracie"
    },
    {
      "source": "joe_rogan",
      "target": "ricky_schroder"
    },
    {
      "source": "joe_rogan",
      "target": "rico_verhoeven"
    },
    {
      "source": "joe_rogan",
      "target": "riley_gaines"
    },
    {
      "source": "joe_rogan",
      "target": "rizwan_virk"
    },
    {
      "source": "joe_rogan",
      "target": "rob_kearney"
    },
    {
      "source": "joe_rogan",
      "target": "rob_lowe"
    },
    {
      "source": "joe_rogan",
      "target": "rob_zombie"
    },
    {
      "source": "joe_rogan",
      "target": "robb_wolf"
    },
    {
      "source": "joe_rogan",
      "target": "robert_bigelow"
    },
    {
      "source": "joe_rogan",
      "target": "robert_downey_jr."
    },
    {
      "source": "joe_rogan",
      "target": "robert_jones"
    },
    {
      "source": "joe_rogan",
      "target": "robert_kelly"
    },
    {
      "source": "joe_rogan",
      "target": "robert_kennedy_jr."
    },
    {
      "source": "joe_rogan",
      "target": "robert_oberst"
    },
    {
      "source": "joe_rogan",
      "target": "robert_sapolsky"
    },
    {
      "source": "joe_rogan",
      "target": "robert_schoch"
    },
    {
      "source": "joe_rogan",
      "target": "robin_black"
    },
    {
      "source": "joe_rogan",
      "target": "roger_waters"
    },
    {
      "source": "joe_rogan",
      "target": "ron_desantis"
    },
    {
      "source": "joe_rogan",
      "target": "ron_finley"
    },
    {
      "source": "joe_rogan",
      "target": "ron_funches"
    },
    {
      "source": "joe_rogan",
      "target": "ron_miscavige"
    },
    {
      "source": "joe_rogan",
      "target": "ron_white"
    },
    {
      "source": "joe_rogan",
      "target": "ronda_rousey"
    },
    {
      "source": "joe_rogan",
      "target": "ronnie_coleman"
    },
    {
      "source": "joe_rogan",
      "target": "rory_albanese"
    },
    {
      "source": "joe_rogan",
      "target": "rory_macdonald"
    },
    {
      "source": "joe_rogan",
      "target": "rory_scovel"
    },
    {
      "source": "joe_rogan",
      "target": "rose_namajunas"
    },
    {
      "source": "joe_rogan",
      "target": "roseanne_barr"
    },
    {
      "source": "joe_rogan",
      "target": "ross_edgley"
    },
    {
      "source": "joe_rogan",
      "target": "roy_jones_jr."
    },
    {
      "source": "joe_rogan",
      "target": "roy_wood_jr"
    },
    {
      "source": "joe_rogan",
      "target": "rupert_sheldrake"
    },
    {
      "source": "joe_rogan",
      "target": "russell_brand"
    },
    {
      "source": "joe_rogan",
      "target": "russell_peters"
    },
    {
      "source": "joe_rogan",
      "target": "rutledge_wood"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_callaghan"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_graves"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_holiday"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_long"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_parsons"
    },
    {
      "source": "joe_rogan",
      "target": "ryan_sickler"
    },
    {
      "source": "joe_rogan",
      "target": "rza"
    },
    {
      "source": "joe_rogan",
      "target": "s.c._gwynne"
    },
    {
      "source": "joe_rogan",
      "target": "saagar_enjeti"
    },
    {
      "source": "joe_rogan",
      "target": "sadhguru"
    },
    {
      "source": "joe_rogan",
      "target": "sam_altman"
    },
    {
      "source": "joe_rogan",
      "target": "sam_and_colby"
    },
    {
      "source": "joe_rogan",
      "target": "sam_golbach"
    },
    {
      "source": "joe_rogan",
      "target": "sam_harris"
    },
    {
      "source": "joe_rogan",
      "target": "sam_morril"
    },
    {
      "source": "joe_rogan",
      "target": "sam_sheridan"
    },
    {
      "source": "joe_rogan",
      "target": "sam_tallent"
    },
    {
      "source": "joe_rogan",
      "target": "sam_tripoli"
    },
    {
      "source": "joe_rogan",
      "target": "sara_weinshenk"
    },
    {
      "source": "joe_rogan",
      "target": "sarah_silverman"
    },
    {
      "source": "joe_rogan",
      "target": "sargon_of_akkad"
    },
    {
      "source": "joe_rogan",
      "target": "scott_adams"
    },
    {
      "source": "joe_rogan",
      "target": "scott_eastwood"
    },
    {
      "source": "joe_rogan",
      "target": "scott_sigler"
    },
    {
      "source": "joe_rogan",
      "target": "scroobius_pip"
    },
    {
      "source": "joe_rogan",
      "target": "sean_anders"
    },
    {
      "source": "joe_rogan",
      "target": "sean_brady"
    },
    {
      "source": "joe_rogan",
      "target": "sean_carroll"
    },
    {
      "source": "joe_rogan",
      "target": "sean_o\u2019malley"
    },
    {
      "source": "joe_rogan",
      "target": "sean_strickland"
    },
    {
      "source": "joe_rogan",
      "target": "sebastian_junger"
    },
    {
      "source": "joe_rogan",
      "target": "sebastian_maniscalco"
    },
    {
      "source": "joe_rogan",
      "target": "seth_dillon"
    },
    {
      "source": "joe_rogan",
      "target": "shane_dorian"
    },
    {
      "source": "joe_rogan",
      "target": "shane_gillis"
    },
    {
      "source": "joe_rogan",
      "target": "shane_mauss"
    },
    {
      "source": "joe_rogan",
      "target": "shane_smith"
    },
    {
      "source": "joe_rogan",
      "target": "shannon_briggs"
    },
    {
      "source": "joe_rogan",
      "target": "shannon_o'loughlin"
    },
    {
      "source": "joe_rogan",
      "target": "shirley_manson"
    },
    {
      "source": "joe_rogan",
      "target": "shooter_jennings"
    },
    {
      "source": "joe_rogan",
      "target": "siddharth_kara"
    },
    {
      "source": "joe_rogan",
      "target": "sir_roger_penrose"
    },
    {
      "source": "joe_rogan",
      "target": "snoop_dogg"
    },
    {
      "source": "joe_rogan",
      "target": "sonny_side"
    },
    {
      "source": "joe_rogan",
      "target": "stavros_halkias"
    },
    {
      "source": "joe_rogan",
      "target": "stefan_molyneux"
    },
    {
      "source": "joe_rogan",
      "target": "stephan_guyenet"
    },
    {
      "source": "joe_rogan",
      "target": "stephen_c._meyer"
    },
    {
      "source": "joe_rogan",
      "target": "stephen_dubner"
    },
    {
      "source": "joe_rogan",
      "target": "stephen_thompson"
    },
    {
      "source": "joe_rogan",
      "target": "steve_aoki"
    },
    {
      "source": "joe_rogan",
      "target": "steve_buscemi"
    },
    {
      "source": "joe_rogan",
      "target": "steve_hilton"
    },
    {
      "source": "joe_rogan",
      "target": "steve_hofstetter"
    },
    {
      "source": "joe_rogan",
      "target": "steve_maxwell"
    },
    {
      "source": "joe_rogan",
      "target": "steve_schirripa"
    },
    {
      "source": "joe_rogan",
      "target": "steve_strope"
    },
    {
      "source": "joe_rogan",
      "target": "steve_sweeney"
    },
    {
      "source": "joe_rogan",
      "target": "steve-o"
    },
    {
      "source": "joe_rogan",
      "target": "steven_crowder"
    },
    {
      "source": "joe_rogan",
      "target": "steven_e._koonin"
    },
    {
      "source": "joe_rogan",
      "target": "steven_hassan"
    },
    {
      "source": "joe_rogan",
      "target": "steven_kotler"
    },
    {
      "source": "joe_rogan",
      "target": "steven_pinker"
    },
    {
      "source": "joe_rogan",
      "target": "steven_pressfield"
    },
    {
      "source": "joe_rogan",
      "target": "steven_rinella"
    },
    {
      "source": "joe_rogan",
      "target": "steven_tyler"
    },
    {
      "source": "joe_rogan",
      "target": "steven_wright"
    },
    {
      "source": "joe_rogan",
      "target": "stipe_miocic"
    },
    {
      "source": "joe_rogan",
      "target": "sturgill_simpson"
    },
    {
      "source": "joe_rogan",
      "target": "sue_aikens"
    },
    {
      "source": "joe_rogan",
      "target": "suzanne_santo"
    },
    {
      "source": "joe_rogan",
      "target": "tait_fletcher"
    },
    {
      "source": "joe_rogan",
      "target": "taylor_sheridan"
    },
    {
      "source": "joe_rogan",
      "target": "ted_nugent"
    },
    {
      "source": "joe_rogan",
      "target": "teddy_atlas"
    },
    {
      "source": "joe_rogan",
      "target": "terence_crawford"
    },
    {
      "source": "joe_rogan",
      "target": "terry_virts"
    },
    {
      "source": "joe_rogan",
      "target": "thaddeus_russell"
    },
    {
      "source": "joe_rogan",
      "target": "the_black_keys"
    },
    {
      "source": "joe_rogan",
      "target": "theo_von"
    },
    {
      "source": "joe_rogan",
      "target": "tiller_russell"
    },
    {
      "source": "joe_rogan",
      "target": "tim_burnett"
    },
    {
      "source": "joe_rogan",
      "target": "tim_dillon"
    },
    {
      "source": "joe_rogan",
      "target": "tim_ferriss"
    },
    {
      "source": "joe_rogan",
      "target": "tim_kennedy"
    },
    {
      "source": "joe_rogan",
      "target": "tim_pool"
    },
    {
      "source": "joe_rogan",
      "target": "tim_robbins"
    },
    {
      "source": "joe_rogan",
      "target": "tim_welch"
    },
    {
      "source": "joe_rogan",
      "target": "timothy_olyphant"
    },
    {
      "source": "joe_rogan",
      "target": "tito_ortiz"
    },
    {
      "source": "joe_rogan",
      "target": "tj_dillashaw"
    },
    {
      "source": "joe_rogan",
      "target": "tj_english"
    },
    {
      "source": "joe_rogan",
      "target": "tj_kirk"
    },
    {
      "source": "joe_rogan",
      "target": "todd_glass"
    },
    {
      "source": "joe_rogan",
      "target": "todd_white"
    },
    {
      "source": "joe_rogan",
      "target": "tom_bilyeu"
    },
    {
      "source": "joe_rogan",
      "target": "tom_delonge"
    },
    {
      "source": "joe_rogan",
      "target": "tom_green"
    },
    {
      "source": "joe_rogan",
      "target": "tom_o'neill"
    },
    {
      "source": "joe_rogan",
      "target": "tom_papa"
    },
    {
      "source": "joe_rogan",
      "target": "tom_rhodes"
    },
    {
      "source": "joe_rogan",
      "target": "tom_segura"
    },
    {
      "source": "joe_rogan",
      "target": "tommy_chong"
    },
    {
      "source": "joe_rogan",
      "target": "tony_hawk"
    },
    {
      "source": "joe_rogan",
      "target": "tony_hinchcliffe"
    },
    {
      "source": "joe_rogan",
      "target": "tony_rock"
    },
    {
      "source": "joe_rogan",
      "target": "tony_woods"
    },
    {
      "source": "joe_rogan",
      "target": "tovar_cerulli"
    },
    {
      "source": "joe_rogan",
      "target": "trae_tha_truth"
    },
    {
      "source": "joe_rogan",
      "target": "travis_barker"
    },
    {
      "source": "joe_rogan",
      "target": "travis_lutter"
    },
    {
      "source": "joe_rogan",
      "target": "travis_walton"
    },
    {
      "source": "joe_rogan",
      "target": "trevor_moore"
    },
    {
      "source": "joe_rogan",
      "target": "trevor_thompson"
    },
    {
      "source": "joe_rogan",
      "target": "trevor_valle"
    },
    {
      "source": "joe_rogan",
      "target": "trevor_wittman"
    },
    {
      "source": "joe_rogan",
      "target": "tristan_harris"
    },
    {
      "source": "joe_rogan",
      "target": "tucker_carlson"
    },
    {
      "source": "joe_rogan",
      "target": "tulsi_gabbard"
    },
    {
      "source": "joe_rogan",
      "target": "tyron_woodley"
    },
    {
      "source": "joe_rogan",
      "target": "tyson_fury"
    },
    {
      "source": "joe_rogan",
      "target": "urijah_faber"
    },
    {
      "source": "joe_rogan",
      "target": "valentina_schevchenko"
    },
    {
      "source": "joe_rogan",
      "target": "valentine_thomas"
    },
    {
      "source": "joe_rogan",
      "target": "vijaya_gadde"
    },
    {
      "source": "joe_rogan",
      "target": "vince_&_emily_horn"
    },
    {
      "source": "joe_rogan",
      "target": "vinnie_paz"
    },
    {
      "source": "joe_rogan",
      "target": "vinny_shoreman"
    },
    {
      "source": "joe_rogan",
      "target": "w._kamau_bell"
    },
    {
      "source": "joe_rogan",
      "target": "w._keith_campbell"
    },
    {
      "source": "joe_rogan",
      "target": "war_machine"
    },
    {
      "source": "joe_rogan",
      "target": "wayne_federman"
    },
    {
      "source": "joe_rogan",
      "target": "wesley_hunt"
    },
    {
      "source": "joe_rogan",
      "target": "wheeler_walker"
    },
    {
      "source": "joe_rogan",
      "target": "whitney_cummings"
    },
    {
      "source": "joe_rogan",
      "target": "will_harris"
    },
    {
      "source": "joe_rogan",
      "target": "will_macaskill"
    },
    {
      "source": "joe_rogan",
      "target": "william_von_hippel"
    },
    {
      "source": "joe_rogan",
      "target": "willie_d"
    },
    {
      "source": "joe_rogan",
      "target": "wim_hof"
    },
    {
      "source": "joe_rogan",
      "target": "wiz_khalifa"
    },
    {
      "source": "joe_rogan",
      "target": "yannis_pappas"
    },
    {
      "source": "joe_rogan",
      "target": "yeonmi_park"
    },
    {
      "source": "joe_rogan",
      "target": "yoel_romero"
    },
    {
      "source": "joe_rogan",
      "target": "yves_edwards"
    },
    {
      "source": "joe_rogan",
      "target": "yvette_d\u2019entremont"
    },
    {
      "source": "joe_rogan",
      "target": "zach_bitter"
    },
    {
      "source": "joe_rogan",
      "target": "zach_braff"
    },
    {
      "source": "joe_rogan",
      "target": "zach_bryan"
    },
    {
      "source": "joe_rogan",
      "target": "zach_leary"
    },
    {
      "source": "joe_rogan",
      "target": "zachary_levi"
    },
    {
      "source": "joe_rogan",
      "target": "zoltan_istvan"
    },
    {
      "source": "joe_rogan",
      "target": "zuby"
    },
    {
      "source": "theo_von",
      "target": "tony_robbins"
    },
    {
      "source": "theo_von",
      "target": "sean_strickland"
    },
    {
      "source": "theo_von",
      "target": "kat_von_d"
    },
    {
      "source": "theo_von",
      "target": "jelly_roll"
    },
    {
      "source": "theo_von",
      "target": "ernest"
    },
    {
      "source": "theo_von",
      "target": "stavros_halkias"
    },
    {
      "source": "theo_von",
      "target": "wayne_gretzky"
    },
    {
      "source": "theo_von",
      "target": "dana_white"
    },
    {
      "source": "theo_von",
      "target": "tucker_carlson"
    },
    {
      "source": "theo_von",
      "target": "nyc_garbage_man"
    },
    {
      "source": "theo_von",
      "target": "anthony_jeselnik"
    },
    {
      "source": "theo_von",
      "target": "sexyy_red"
    },
    {
      "source": "theo_von",
      "target": "robert_f._kennedy_jr."
    },
    {
      "source": "theo_von",
      "target": "bobby_lee"
    },
    {
      "source": "theo_von",
      "target": "john_vervaeke"
    },
    {
      "source": "theo_von",
      "target": "the_last_sun"
    },
    {
      "source": "theo_von",
      "target": "jordan_b._peterson"
    },
    {
      "source": "theo_von",
      "target": "a_coroner"
    },
    {
      "source": "theo_von",
      "target": "flea_market"
    },
    {
      "source": "theo_von",
      "target": "ric_flair"
    },
    {
      "source": "theo_von",
      "target": "yg"
    },
    {
      "source": "theo_von",
      "target": "hulk_hogan"
    },
    {
      "source": "theo_von",
      "target": "mark_normand"
    },
    {
      "source": "theo_von",
      "target": "jim_gaffigan"
    },
    {
      "source": "theo_von",
      "target": "door_to_door"
    },
    {
      "source": "theo_von",
      "target": "adam_devine"
    },
    {
      "source": "theo_von",
      "target": "tom_segura"
    },
    {
      "source": "theo_von",
      "target": "duncan_trussell"
    },
    {
      "source": "theo_von",
      "target": "roseanne"
    },
    {
      "source": "theo_von",
      "target": "trevor_wallace"
    },
    {
      "source": "theo_von",
      "target": "malcolm_gladwell"
    },
    {
      "source": "theo_von",
      "target": "brianna_chickenfry"
    },
    {
      "source": "theo_von",
      "target": "will_sasso"
    },
    {
      "source": "theo_von",
      "target": "that_lord_portal"
    },
    {
      "source": "theo_von",
      "target": "rainn_wilson"
    },
    {
      "source": "theo_von",
      "target": "glenny_balls"
    },
    {
      "source": "theo_von",
      "target": "john_mulaney"
    },
    {
      "source": "theo_von",
      "target": "man_in_here"
    },
    {
      "source": "theo_von",
      "target": "nate_bargatze"
    },
    {
      "source": "theo_von",
      "target": "mike_vecchione"
    },
    {
      "source": "theo_von",
      "target": "caleb_pressley"
    },
    {
      "source": "theo_von",
      "target": "george_kittle"
    },
    {
      "source": "theo_von",
      "target": "funny_marco"
    },
    {
      "source": "theo_von",
      "target": "hardy"
    },
    {
      "source": "theo_von",
      "target": "logic"
    },
    {
      "source": "theo_von",
      "target": "dialed_in"
    },
    {
      "source": "theo_von",
      "target": "lainey_wilson"
    },
    {
      "source": "theo_von",
      "target": "dave_portnoy"
    },
    {
      "source": "theo_von",
      "target": "druski"
    },
    {
      "source": "theo_von",
      "target": "back_from_france"
    },
    {
      "source": "theo_von",
      "target": "kyle_forgeard"
    },
    {
      "source": "theo_von",
      "target": "louis_c.k."
    },
    {
      "source": "theo_von",
      "target": "james_blake"
    },
    {
      "source": "theo_von",
      "target": "merry_lloyd_christmas"
    },
    {
      "source": "theo_von",
      "target": "yung_gravy"
    },
    {
      "source": "theo_von",
      "target": "retired_police_officer"
    },
    {
      "source": "theo_von",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "theo_von",
      "target": "gangsgiving"
    },
    {
      "source": "theo_von",
      "target": "ari_shaffir"
    },
    {
      "source": "theo_von",
      "target": "dana_carvey"
    },
    {
      "source": "theo_von",
      "target": "mike_rowe"
    },
    {
      "source": "theo_von",
      "target": "bubba_sparxxx"
    },
    {
      "source": "theo_von",
      "target": "andrew_callaghan"
    },
    {
      "source": "theo_von",
      "target": "cold_beach"
    },
    {
      "source": "theo_von",
      "target": "scott_stapp"
    },
    {
      "source": "theo_von",
      "target": "tony_hinchcliffe"
    },
    {
      "source": "theo_von",
      "target": "rail_baby"
    },
    {
      "source": "theo_von",
      "target": "bert_kreischer"
    },
    {
      "source": "theo_von",
      "target": "tony_kanaan"
    },
    {
      "source": "theo_von",
      "target": "nick_swardson"
    },
    {
      "source": "theo_von",
      "target": "max_more"
    },
    {
      "source": "theo_von",
      "target": "joe_rogan"
    },
    {
      "source": "theo_von",
      "target": "that_hot_heat"
    },
    {
      "source": "theo_von",
      "target": "nikki_glaser"
    },
    {
      "source": "theo_von",
      "target": "riff_raff"
    },
    {
      "source": "theo_von",
      "target": "mike_perry"
    },
    {
      "source": "theo_von",
      "target": "off_the_bike"
    },
    {
      "source": "theo_von",
      "target": "parker_mccollum"
    },
    {
      "source": "theo_von",
      "target": "albuquerque"
    },
    {
      "source": "theo_von",
      "target": "sal_vulcano"
    },
    {
      "source": "theo_von",
      "target": "yannis_pappas"
    },
    {
      "source": "theo_von",
      "target": "maui_milkshake"
    },
    {
      "source": "theo_von",
      "target": "trauma_restoration_man"
    },
    {
      "source": "theo_von",
      "target": "shane_gillis"
    },
    {
      "source": "theo_von",
      "target": "david_spade"
    },
    {
      "source": "theo_von",
      "target": "belated_bunny"
    },
    {
      "source": "theo_von",
      "target": "kyle_dunnigan"
    },
    {
      "source": "theo_von",
      "target": "bird_neckin"
    },
    {
      "source": "theo_von",
      "target": "sean_o'malley"
    },
    {
      "source": "theo_von",
      "target": "tim_welch"
    },
    {
      "source": "theo_von",
      "target": "brotherly_love"
    },
    {
      "source": "theo_von",
      "target": "ms._pat"
    },
    {
      "source": "theo_von",
      "target": "teenage_easter"
    },
    {
      "source": "theo_von",
      "target": "brandon_moreno"
    },
    {
      "source": "theo_von",
      "target": "belated_valentine's"
    },
    {
      "source": "theo_von",
      "target": "blair_socci"
    },
    {
      "source": "theo_von",
      "target": "tony_hawk"
    },
    {
      "source": "theo_von",
      "target": "jason_ellis"
    },
    {
      "source": "theo_von",
      "target": "bryce_mitchell"
    },
    {
      "source": "theo_von",
      "target": "ryan_williams"
    },
    {
      "source": "theo_von",
      "target": "jesse_ventura"
    },
    {
      "source": "theo_von",
      "target": "brian_barczyk"
    },
    {
      "source": "theo_von",
      "target": "jay_cutler"
    },
    {
      "source": "theo_von",
      "target": "howie_mandel"
    },
    {
      "source": "theo_von",
      "target": "jeff_wittek"
    },
    {
      "source": "theo_von",
      "target": "limited_alphabet"
    },
    {
      "source": "theo_von",
      "target": "john_crist"
    },
    {
      "source": "theo_von",
      "target": "last_words"
    },
    {
      "source": "theo_von",
      "target": "biggie_smallsberg"
    },
    {
      "source": "theo_von",
      "target": "a_jockey"
    },
    {
      "source": "theo_von",
      "target": "gravel_on_the_road"
    },
    {
      "source": "theo_von",
      "target": "casey_frey"
    },
    {
      "source": "theo_von",
      "target": "close_frisbee"
    },
    {
      "source": "theo_von",
      "target": "jason_pooler"
    },
    {
      "source": "theo_von",
      "target": "todd_graves"
    },
    {
      "source": "theo_von",
      "target": "check_ball"
    },
    {
      "source": "theo_von",
      "target": "khalyla"
    },
    {
      "source": "theo_von",
      "target": "us_border_patrol_agent"
    },
    {
      "source": "theo_von",
      "target": "heather_mcmahan"
    },
    {
      "source": "theo_von",
      "target": "andrew_schulz"
    },
    {
      "source": "theo_von",
      "target": "mid-sized_animal_control_man"
    },
    {
      "source": "theo_von",
      "target": "easter_oyster"
    },
    {
      "source": "theo_von",
      "target": "travis_tritt"
    },
    {
      "source": "theo_von",
      "target": "bryan_callen"
    },
    {
      "source": "theo_von",
      "target": "cory_sandhagen"
    },
    {
      "source": "theo_von",
      "target": "josh_wolf"
    },
    {
      "source": "theo_von",
      "target": "kane_brown"
    },
    {
      "source": "theo_von",
      "target": "jim_breuer"
    },
    {
      "source": "theo_von",
      "target": "turtleneck_soup"
    },
    {
      "source": "theo_von",
      "target": "iron_man_chris_nikic"
    },
    {
      "source": "theo_von",
      "target": "round_italians"
    },
    {
      "source": "theo_von",
      "target": "dustin_poirier"
    },
    {
      "source": "theo_von",
      "target": "virtual_gnomes"
    },
    {
      "source": "theo_von",
      "target": "jimmy_john_liautaud"
    },
    {
      "source": "theo_von",
      "target": "tony_mandarich"
    },
    {
      "source": "theo_von",
      "target": "thanksliving"
    },
    {
      "source": "theo_von",
      "target": "morgan_wallen"
    },
    {
      "source": "theo_von",
      "target": "medium_debbie"
    },
    {
      "source": "theo_von",
      "target": "a_female_trucker"
    },
    {
      "source": "theo_von",
      "target": "robert_f_kennedy_jr"
    },
    {
      "source": "theo_von",
      "target": "michael_chandler"
    },
    {
      "source": "theo_von",
      "target": "booty_hawk"
    },
    {
      "source": "theo_von",
      "target": "jo_koy_3"
    },
    {
      "source": "theo_von",
      "target": "elevator_baby"
    },
    {
      "source": "theo_von",
      "target": "a_mortician"
    },
    {
      "source": "theo_von",
      "target": "fence_rabbits"
    },
    {
      "source": "theo_von",
      "target": "adult_asthma"
    },
    {
      "source": "theo_von",
      "target": "egg_hunt"
    },
    {
      "source": "theo_von",
      "target": "bobby_lee_4"
    },
    {
      "source": "theo_von",
      "target": "taut_baby"
    },
    {
      "source": "theo_von",
      "target": "nashville"
    },
    {
      "source": "theo_von",
      "target": "david_arquette"
    },
    {
      "source": "theo_von",
      "target": "back_to_our_roots"
    },
    {
      "source": "theo_von",
      "target": "chelcie_lynn"
    },
    {
      "source": "theo_von",
      "target": "when_flavor_hits"
    },
    {
      "source": "theo_von",
      "target": "andrew_santino_3"
    },
    {
      "source": "theo_von",
      "target": "through_the_sprinkler"
    },
    {
      "source": "theo_von",
      "target": "tim_dillon_2"
    },
    {
      "source": "theo_von",
      "target": "china_dragon"
    },
    {
      "source": "theo_von",
      "target": "hot_bass"
    },
    {
      "source": "theo_von",
      "target": "dodgers_pitcher_walker_buehler"
    },
    {
      "source": "theo_von",
      "target": "diplo"
    },
    {
      "source": "theo_von",
      "target": "working_from_home"
    },
    {
      "source": "theo_von",
      "target": "suga_sean_o'malley"
    },
    {
      "source": "theo_von",
      "target": "edit_content:_raise_your_hand"
    },
    {
      "source": "theo_von",
      "target": "boosie_badazz"
    },
    {
      "source": "theo_von",
      "target": "theo_von"
    },
    {
      "source": "theo_von",
      "target": "nomichael_rosenbaum"
    },
    {
      "source": "theo_von",
      "target": "chris_ryan"
    },
    {
      "source": "theo_von",
      "target": "jamie_kennedy"
    },
    {
      "source": "theo_von",
      "target": "nicole_arbour"
    },
    {
      "source": "theo_von",
      "target": "robin_tran"
    },
    {
      "source": "theo_von",
      "target": "jay_mohr"
    },
    {
      "source": "andrew_huberman",
      "target": "sean_mackey"
    },
    {
      "source": "andrew_huberman",
      "target": "david_goggins"
    },
    {
      "source": "andrew_huberman",
      "target": "rick_rubin"
    },
    {
      "source": "andrew_huberman",
      "target": "andrew_huberman"
    },
    {
      "source": "andrew_huberman",
      "target": "karen_parker"
    },
    {
      "source": "andrew_huberman",
      "target": "robert_greene"
    },
    {
      "source": "andrew_huberman",
      "target": "adam_grant"
    },
    {
      "source": "andrew_huberman",
      "target": "natalie_crawford"
    },
    {
      "source": "andrew_huberman",
      "target": "michael_eisenberg"
    },
    {
      "source": "andrew_huberman",
      "target": "chris_voss"
    },
    {
      "source": "andrew_huberman",
      "target": "paul_conti"
    },
    {
      "source": "andrew_huberman",
      "target": "vivek_murthy"
    },
    {
      "source": "andrew_huberman",
      "target": "peter_attia"
    },
    {
      "source": "andrew_huberman",
      "target": "marc_andreessen"
    },
    {
      "source": "andrew_huberman",
      "target": "goals_toolkit"
    },
    {
      "source": "andrew_huberman",
      "target": "david_linden"
    },
    {
      "source": "andrew_huberman",
      "target": "rena_malik"
    },
    {
      "source": "andrew_huberman",
      "target": "tony_hawk"
    },
    {
      "source": "andrew_huberman",
      "target": "maya_shankar"
    },
    {
      "source": "andrew_huberman",
      "target": "robert_malenka"
    },
    {
      "source": "andrew_huberman",
      "target": "jeffrey_goldberg"
    },
    {
      "source": "andrew_huberman",
      "target": "tim_ferriss"
    },
    {
      "source": "andrew_huberman",
      "target": "immordino-yang"
    },
    {
      "source": "andrew_huberman",
      "target": "robin_carhart-harris"
    },
    {
      "source": "andrew_huberman",
      "target": "susanna_s\u00f8berg"
    },
    {
      "source": "andrew_huberman",
      "target": "noam_sobel"
    },
    {
      "source": "andrew_huberman",
      "target": "satchin_panda"
    },
    {
      "source": "andrew_huberman",
      "target": "oded_rechavi"
    },
    {
      "source": "andrew_huberman",
      "target": "andy_galpin"
    },
    {
      "source": "andrew_huberman",
      "target": "gina_poe"
    },
    {
      "source": "andrew_huberman",
      "target": "sara_gottfried"
    },
    {
      "source": "andrew_huberman",
      "target": "sam_harris"
    },
    {
      "source": "andrew_huberman",
      "target": "jocko_willink"
    },
    {
      "source": "andrew_huberman",
      "target": "kyle_gillett"
    },
    {
      "source": "andrew_huberman",
      "target": "using_caffeine"
    },
    {
      "source": "andrew_huberman",
      "target": "lex_fridman"
    },
    {
      "source": "andrew_huberman",
      "target": "chris_palmer"
    },
    {
      "source": "andrew_huberman",
      "target": "layne_norton"
    },
    {
      "source": "andrew_huberman",
      "target": "eddie_chang"
    },
    {
      "source": "andrew_huberman",
      "target": "fitness_toolkit"
    },
    {
      "source": "andrew_huberman",
      "target": "nolan_williams"
    },
    {
      "source": "andrew_huberman",
      "target": "casey_halpern"
    },
    {
      "source": "andrew_huberman",
      "target": "david_anderson"
    },
    {
      "source": "andrew_huberman",
      "target": "erich_jarvis"
    },
    {
      "source": "andrew_huberman",
      "target": "emily_balcetis"
    },
    {
      "source": "andrew_huberman",
      "target": "charles_zuker"
    },
    {
      "source": "andrew_huberman",
      "target": "jeff_cavaliere"
    },
    {
      "source": "andrew_huberman",
      "target": "ido_portal"
    },
    {
      "source": "andrew_huberman",
      "target": "wendy_suzuki"
    },
    {
      "source": "andrew_huberman",
      "target": "rhonda_patrick"
    },
    {
      "source": "andrew_huberman",
      "target": "justin_sonnenburg"
    },
    {
      "source": "andrew_huberman",
      "target": "david_spiegel"
    },
    {
      "source": "andrew_huberman",
      "target": "alia_crum"
    },
    {
      "source": "andrew_huberman",
      "target": "jack_feldman"
    },
    {
      "source": "andrew_huberman",
      "target": "david_sinclair"
    },
    {
      "source": "andrew_huberman",
      "target": "david_berson"
    },
    {
      "source": "andrew_huberman",
      "target": "david_buss"
    },
    {
      "source": "andrew_huberman",
      "target": "duncan_french"
    },
    {
      "source": "andrew_huberman",
      "target": "samer_hattar"
    },
    {
      "source": "andrew_huberman",
      "target": "craig_heller"
    },
    {
      "source": "andrew_huberman",
      "target": "matthew_johnson"
    },
    {
      "source": "andrew_huberman",
      "target": "robert_sapolsky"
    },
    {
      "source": "andrew_huberman",
      "target": "anna_lembke"
    },
    {
      "source": "andrew_huberman",
      "target": "matthew_walker"
    },
    {
      "source": "andrew_huberman",
      "target": "karl_deisseroth"
    },
    {
      "source": "tucker_carlson",
      "target": "tony_robbins"
    },
    {
      "source": "tucker_carlson",
      "target": "darren_beattie"
    },
    {
      "source": "tucker_carlson",
      "target": "dennis_quaid"
    },
    {
      "source": "tucker_carlson",
      "target": "alex_berenson"
    },
    {
      "source": "tucker_carlson",
      "target": "willie_soon"
    },
    {
      "source": "tucker_carlson",
      "target": "rep._clay_higgins"
    },
    {
      "source": "tucker_carlson",
      "target": "brett_weinstein"
    },
    {
      "source": "tucker_carlson",
      "target": "mark_epstein"
    },
    {
      "source": "tucker_carlson",
      "target": "jordan_belfort"
    },
    {
      "source": "tucker_carlson",
      "target": "colby_covington"
    },
    {
      "source": "tucker_carlson",
      "target": "seth_dillon"
    },
    {
      "source": "tucker_carlson",
      "target": "alex_jones"
    },
    {
      "source": "tucker_carlson",
      "target": "john_daly"
    },
    {
      "source": "tucker_carlson",
      "target": "dana_white"
    },
    {
      "source": "tucker_carlson",
      "target": "kid_rock"
    },
    {
      "source": "alex_cooper",
      "target": "trisha_paytas"
    },
    {
      "source": "alex_cooper",
      "target": "laren"
    },
    {
      "source": "alex_cooper",
      "target": "rene\u00e9_rapp"
    },
    {
      "source": "alex_cooper",
      "target": "john_mayer"
    },
    {
      "source": "alex_cooper",
      "target": "paris_hilton"
    },
    {
      "source": "alex_cooper",
      "target": "kelsea_ballerini"
    },
    {
      "source": "alex_cooper",
      "target": "jack_harlow"
    },
    {
      "source": "alex_cooper",
      "target": "holly"
    },
    {
      "source": "alex_cooper",
      "target": "bridget"
    },
    {
      "source": "alex_cooper",
      "target": "lucy_hale"
    },
    {
      "source": "alex_cooper",
      "target": "offset"
    },
    {
      "source": "alex_cooper",
      "target": "bella_poarch"
    },
    {
      "source": "alex_cooper",
      "target": "ciara"
    },
    {
      "source": "alex_cooper",
      "target": "madeline_argy_debrief"
    },
    {
      "source": "alex_cooper",
      "target": "madeline_argy"
    },
    {
      "source": "alex_cooper",
      "target": "alix_earle"
    },
    {
      "source": "alex_cooper",
      "target": "adam_devine"
    },
    {
      "source": "alex_cooper",
      "target": "kristin_cavallari"
    },
    {
      "source": "alex_cooper",
      "target": "janelle_mon\u00e1e"
    },
    {
      "source": "alex_cooper",
      "target": "post_malone"
    },
    {
      "source": "alex_cooper",
      "target": "coi_leray"
    },
    {
      "source": "alex_cooper",
      "target": "harry_jowsey"
    },
    {
      "source": "alex_cooper",
      "target": "zayn"
    },
    {
      "source": "alex_cooper",
      "target": "kim_petras"
    },
    {
      "source": "alex_cooper",
      "target": "stassi_schroeder"
    },
    {
      "source": "alex_cooper",
      "target": "shay_mitchell"
    },
    {
      "source": "alex_cooper",
      "target": "anitta"
    },
    {
      "source": "alex_cooper",
      "target": "priyanka_chopra_jonas"
    },
    {
      "source": "alex_cooper",
      "target": "gwyneth_paltrow"
    },
    {
      "source": "alex_cooper",
      "target": "madison_beer"
    },
    {
      "source": "alex_cooper",
      "target": "lil_dicky"
    },
    {
      "source": "alex_cooper",
      "target": "christina_aguilera"
    },
    {
      "source": "alex_cooper",
      "target": "john_legend"
    },
    {
      "source": "alex_cooper",
      "target": "cole_sprouse"
    },
    {
      "source": "alex_cooper",
      "target": "rebel_wilson"
    },
    {
      "source": "alex_cooper",
      "target": "jane_fonda"
    },
    {
      "source": "alex_cooper",
      "target": "chelsea_handler"
    },
    {
      "source": "alex_cooper",
      "target": "jay_shetty"
    },
    {
      "source": "alex_cooper",
      "target": "the_chainsmokers"
    },
    {
      "source": "alex_cooper",
      "target": "keke_palmer"
    },
    {
      "source": "alex_cooper",
      "target": "amanda_knox"
    },
    {
      "source": "alex_cooper",
      "target": "jackie_schimmel"
    },
    {
      "source": "alex_cooper",
      "target": "elizabeth_banks"
    },
    {
      "source": "alex_cooper",
      "target": "morgan_stewart_mcgraw"
    },
    {
      "source": "alex_cooper",
      "target": "la_la_anthony"
    },
    {
      "source": "shane_gillis",
      "target": "theo_von"
    },
    {
      "source": "shane_gillis",
      "target": "james_donald_forbes_mccann"
    },
    {
      "source": "shane_gillis",
      "target": "lemaire_lee"
    },
    {
      "source": "shane_gillis",
      "target": "duncan_trussell"
    },
    {
      "source": "shane_gillis",
      "target": "howie_mandel"
    },
    {
      "source": "shane_gillis",
      "target": "sam_tallent"
    },
    {
      "source": "shane_gillis",
      "target": "tommy_pope"
    },
    {
      "source": "shane_gillis",
      "target": "tim_dillon"
    },
    {
      "source": "shane_gillis",
      "target": "warmode"
    },
    {
      "source": "shane_gillis",
      "target": "tony_hinchcliffe"
    },
    {
      "source": "shane_gillis",
      "target": "mark_normand"
    },
    {
      "source": "shane_gillis",
      "target": "ari_shaffir"
    },
    {
      "source": "shane_gillis",
      "target": "rich_vos"
    },
    {
      "source": "shane_gillis",
      "target": "colum_tyrrell"
    },
    {
      "source": "shane_gillis",
      "target": "billy"
    },
    {
      "source": "shane_gillis",
      "target": "tim_butterly"
    },
    {
      "source": "shane_gillis",
      "target": "naim_ali"
    },
    {
      "source": "shane_gillis",
      "target": "dan_soder"
    },
    {
      "source": "shane_gillis",
      "target": "nate_marshall"
    },
    {
      "source": "shane_gillis",
      "target": "tom_segura"
    },
    {
      "source": "shane_gillis",
      "target": "lil_sasquatch"
    },
    {
      "source": "shane_gillis",
      "target": "kevin_iso"
    },
    {
      "source": "shane_gillis",
      "target": "anthony_moore"
    },
    {
      "source": "shane_gillis",
      "target": "will_compton"
    },
    {
      "source": "shane_gillis",
      "target": "danny_mcbride"
    },
    {
      "source": "shane_gillis",
      "target": "chris_o'connor"
    },
    {
      "source": "shane_gillis",
      "target": "bert_kreischer"
    },
    {
      "source": "shane_gillis",
      "target": "francis_ellis"
    },
    {
      "source": "shane_gillis",
      "target": "joe_derosa"
    },
    {
      "source": "shane_gillis",
      "target": "rob_crews"
    },
    {
      "source": "shane_gillis",
      "target": "dru_montana"
    },
    {
      "source": "shane_gillis",
      "target": "oz_pearlman"
    },
    {
      "source": "shane_gillis",
      "target": "rone"
    },
    {
      "source": "shane_gillis",
      "target": "robert_kelly"
    },
    {
      "source": "shane_gillis",
      "target": "billy_mccusker"
    },
    {
      "source": "shane_gillis",
      "target": "mike_rainey"
    },
    {
      "source": "shane_gillis",
      "target": "adam_eget"
    },
    {
      "source": "shane_gillis",
      "target": "james_mccann"
    },
    {
      "source": "shane_gillis",
      "target": "danny_brown"
    },
    {
      "source": "shane_gillis",
      "target": "swim"
    },
    {
      "source": "shane_gillis",
      "target": "stuff_island"
    },
    {
      "source": "shane_gillis",
      "target": "nick_mullen"
    },
    {
      "source": "shane_gillis",
      "target": "adam_friedland"
    },
    {
      "source": "shane_gillis",
      "target": "david_james"
    },
    {
      "source": "shane_gillis",
      "target": "colin_quinn"
    },
    {
      "source": "shane_gillis",
      "target": "burke"
    },
    {
      "source": "shane_gillis",
      "target": "spud"
    },
    {
      "source": "shane_gillis",
      "target": "louis_c.k."
    },
    {
      "source": "shane_gillis",
      "target": "andy_malafarina"
    },
    {
      "source": "shane_gillis",
      "target": "and_mystery_guest"
    },
    {
      "source": "shane_gillis",
      "target": "nick_bryant"
    },
    {
      "source": "shane_gillis",
      "target": "ryan_long"
    },
    {
      "source": "shane_gillis",
      "target": "jon_delcollo"
    },
    {
      "source": "shane_gillis",
      "target": "charles_blyzniuk"
    },
    {
      "source": "shane_gillis",
      "target": "brian_six"
    },
    {
      "source": "shane_gillis",
      "target": "sidney_gantt"
    },
    {
      "source": "shane_gillis",
      "target": "ryan_shaner"
    },
    {
      "source": "shane_gillis",
      "target": "sidney_gant"
    },
    {
      "source": "shane_gillis",
      "target": "mike_recine"
    },
    {
      "source": "shane_gillis",
      "target": "sean_mccarthy"
    },
    {
      "source": "shane_gillis",
      "target": "ep_1347"
    },
    {
      "source": "shane_gillis",
      "target": "shane"
    },
    {
      "source": "shawn_ryan",
      "target": "ryan_hendrickson"
    },
    {
      "source": "shawn_ryan",
      "target": "tim_parlatore"
    },
    {
      "source": "shawn_ryan",
      "target": "chris_miller"
    },
    {
      "source": "shawn_ryan",
      "target": "michael_shellenberger"
    },
    {
      "source": "shawn_ryan",
      "target": "laird_hamilton"
    },
    {
      "source": "shawn_ryan",
      "target": "bryce_case_jr."
    },
    {
      "source": "shawn_ryan",
      "target": "nick_bryant"
    },
    {
      "source": "shawn_ryan",
      "target": "victor_marx"
    },
    {
      "source": "shawn_ryan",
      "target": "luis_chaparro"
    },
    {
      "source": "shawn_ryan",
      "target": "sarah_adams"
    },
    {
      "source": "shawn_ryan",
      "target": "john_lovell"
    },
    {
      "source": "shawn_ryan",
      "target": "sean_webb"
    },
    {
      "source": "shawn_ryan",
      "target": "tim_burchett"
    },
    {
      "source": "shawn_ryan",
      "target": "tom_satterly"
    },
    {
      "source": "shawn_ryan",
      "target": "erik_prince"
    },
    {
      "source": "shawn_ryan",
      "target": "mark_oz_geist"
    },
    {
      "source": "shawn_ryan",
      "target": "bedros_keuilian"
    },
    {
      "source": "shawn_ryan",
      "target": "tony_cowden"
    },
    {
      "source": "shawn_ryan",
      "target": "vivek_ramaswamy"
    },
    {
      "source": "shawn_ryan",
      "target": "brandon_fugal"
    },
    {
      "source": "shawn_ryan",
      "target": "don_graves"
    },
    {
      "source": "shawn_ryan",
      "target": "tyler_vargas-andrews"
    },
    {
      "source": "shawn_ryan",
      "target": "eli_crane"
    },
    {
      "source": "shawn_ryan",
      "target": "eric_hecker"
    },
    {
      "source": "shawn_ryan",
      "target": "dc_long"
    },
    {
      "source": "shawn_ryan",
      "target": "michael_herrera"
    },
    {
      "source": "shawn_ryan",
      "target": "steven_greer"
    },
    {
      "source": "shawn_ryan",
      "target": "jim_caviezel"
    },
    {
      "source": "shawn_ryan",
      "target": "shawn_ryan"
    },
    {
      "source": "shawn_ryan",
      "target": "tyler_grey"
    },
    {
      "source": "shawn_ryan",
      "target": "david_tice"
    },
    {
      "source": "shawn_ryan",
      "target": "michael_bagnell"
    },
    {
      "source": "shawn_ryan",
      "target": "buck_sexton"
    },
    {
      "source": "shawn_ryan",
      "target": "nick_kefalides"
    },
    {
      "source": "shawn_ryan",
      "target": "ryan_montgomery"
    },
    {
      "source": "shawn_ryan",
      "target": "prime_hall"
    },
    {
      "source": "shawn_ryan",
      "target": "yeonmi_park"
    },
    {
      "source": "shawn_ryan",
      "target": "david_mccormick"
    },
    {
      "source": "shawn_ryan",
      "target": "andrew_bustamante"
    },
    {
      "source": "shawn_ryan",
      "target": "chris_vansant"
    },
    {
      "source": "shawn_ryan",
      "target": "dallas_alexander"
    },
    {
      "source": "shawn_ryan",
      "target": "ioan_grillo"
    },
    {
      "source": "shawn_ryan",
      "target": "bob_ninja_poras"
    },
    {
      "source": "shawn_ryan",
      "target": "solbere"
    },
    {
      "source": "shawn_ryan",
      "target": "eddie_penney"
    },
    {
      "source": "shawn_ryan",
      "target": "rob_luna"
    },
    {
      "source": "shawn_ryan",
      "target": "kyle_morgan"
    },
    {
      "source": "shawn_ryan",
      "target": "mark_turner"
    },
    {
      "source": "shawn_ryan",
      "target": "struggle_jennings"
    },
    {
      "source": "shawn_ryan",
      "target": "roger_reaves"
    },
    {
      "source": "shawn_ryan",
      "target": "machine_gun_preacher"
    },
    {
      "source": "shawn_ryan",
      "target": "lt._col._scott_mann"
    },
    {
      "source": "shawn_ryan",
      "target": "john_delony"
    },
    {
      "source": "shawn_ryan",
      "target": "cody_alford"
    },
    {
      "source": "shawn_ryan",
      "target": "lily_tang_williams"
    },
    {
      "source": "shawn_ryan",
      "target": "jason_redman"
    },
    {
      "source": "shawn_ryan",
      "target": "marc_polymeropoulos"
    },
    {
      "source": "shawn_ryan",
      "target": "trevor_millar"
    },
    {
      "source": "shawn_ryan",
      "target": "nick_machine_lavery"
    },
    {
      "source": "shawn_ryan",
      "target": "rob_o'neill"
    },
    {
      "source": "shawn_ryan",
      "target": "alex_epstein"
    },
    {
      "source": "shawn_ryan",
      "target": "david_rodriguez"
    },
    {
      "source": "shawn_ryan",
      "target": "peter_schweizer"
    },
    {
      "source": "shawn_ryan",
      "target": "robby_starbuck"
    },
    {
      "source": "shawn_ryan",
      "target": "mikal_vega"
    },
    {
      "source": "shawn_ryan",
      "target": "chief_hallgrimson"
    },
    {
      "source": "shawn_ryan",
      "target": "dj_shipley"
    },
    {
      "source": "shawn_ryan",
      "target": "alan_cooper"
    },
    {
      "source": "shawn_ryan",
      "target": "bernie_kerik"
    },
    {
      "source": "shawn_ryan",
      "target": "marcus_capone"
    },
    {
      "source": "shawn_ryan",
      "target": "tu_lam"
    },
    {
      "source": "shawn_ryan",
      "target": "ed_calderon"
    },
    {
      "source": "shawn_ryan",
      "target": "eddie_gallagher"
    },
    {
      "source": "shawn_ryan",
      "target": "travis_howze"
    },
    {
      "source": "shawn_ryan",
      "target": "mike_ritland"
    },
    {
      "source": "shawn_ryan",
      "target": "don_bradley"
    },
    {
      "source": "shawn_ryan",
      "target": "travis_kennedy"
    },
    {
      "source": "shawn_ryan",
      "target": "mike_glover"
    },
    {
      "source": "trevor_noah",
      "target": "mark_cuban"
    },
    {
      "source": "trevor_noah",
      "target": "nick_kyrgios"
    },
    {
      "source": "trevor_noah",
      "target": "mayor_karen_bass"
    },
    {
      "source": "trevor_noah",
      "target": "tristan_harris"
    },
    {
      "source": "trevor_noah",
      "target": "janelle_mon\u00e1e"
    },
    {
      "source": "trevor_noah",
      "target": "sam_altman"
    },
    {
      "source": "trevor_noah",
      "target": "dababy"
    },
    {
      "source": "trevor_noah",
      "target": "bill_gates"
    },
    {
      "source": "trevor_noah",
      "target": "kerry_washington"
    },
    {
      "source": "trevor_noah",
      "target": "dwayne_the_rock_johnson"
    },
    {
      "source": "jason_bateman",
      "target": "sean_hayes"
    },
    {
      "source": "jason_bateman",
      "target": "will_arnett"
    },
    {
      "source": "jason_bateman",
      "target": "mike_birbiglia"
    },
    {
      "source": "jason_bateman",
      "target": "selena_gomez"
    },
    {
      "source": "jason_bateman",
      "target": "arnold_schwarzenegger"
    },
    {
      "source": "jason_bateman",
      "target": "santa"
    },
    {
      "source": "jason_bateman",
      "target": "carey_mulligan"
    },
    {
      "source": "jason_bateman",
      "target": "emma_stone"
    },
    {
      "source": "jason_bateman",
      "target": "ronan_farrow"
    },
    {
      "source": "jason_bateman",
      "target": "taika_waititi"
    },
    {
      "source": "jason_bateman",
      "target": "stephen_curry"
    },
    {
      "source": "jason_bateman",
      "target": "michael_stipe"
    },
    {
      "source": "jason_bateman",
      "target": "marshawn_lynch"
    },
    {
      "source": "jason_bateman",
      "target": "john_mcenroe"
    },
    {
      "source": "jason_bateman",
      "target": "rachel_maddow"
    },
    {
      "source": "jason_bateman",
      "target": "peyton_manning"
    },
    {
      "source": "jason_bateman",
      "target": "paul_simon"
    },
    {
      "source": "jason_bateman",
      "target": "bill_simmons"
    },
    {
      "source": "jason_bateman",
      "target": "lars_ulrich"
    },
    {
      "source": "jason_bateman",
      "target": "matthew_mcconaughey"
    },
    {
      "source": "jason_bateman",
      "target": "kara_swisher"
    },
    {
      "source": "jason_bateman",
      "target": "willem_dafoe"
    },
    {
      "source": "jason_bateman",
      "target": "jimmy_kimmel"
    },
    {
      "source": "jason_bateman",
      "target": "jen_psaki"
    },
    {
      "source": "jason_bateman",
      "target": "kevin_hart"
    },
    {
      "source": "jason_bateman",
      "target": "rose_byrne"
    },
    {
      "source": "jason_bateman",
      "target": "matt_damon"
    },
    {
      "source": "jason_bateman",
      "target": "jessica_chastain"
    },
    {
      "source": "jason_bateman",
      "target": "mark_cuban"
    },
    {
      "source": "jason_bateman",
      "target": "paul_giamatti"
    },
    {
      "source": "jason_bateman",
      "target": "andy_richter"
    },
    {
      "source": "jason_bateman",
      "target": "greta_gerwig"
    },
    {
      "source": "jason_bateman",
      "target": "aoc"
    },
    {
      "source": "jason_bateman",
      "target": "steven_soderbergh"
    },
    {
      "source": "jason_bateman",
      "target": "david_letterman"
    },
    {
      "source": "jason_bateman",
      "target": "danny_mcbride"
    },
    {
      "source": "jason_bateman",
      "target": "max_tegmark"
    },
    {
      "source": "jason_bateman",
      "target": "tom_holland"
    },
    {
      "source": "jason_bateman",
      "target": "conan_o\u2019brien"
    },
    {
      "source": "jason_bateman",
      "target": "idris_elba"
    },
    {
      "source": "jason_bateman",
      "target": "will_ferrell"
    },
    {
      "source": "jason_bateman",
      "target": "simon_pegg"
    },
    {
      "source": "jason_bateman",
      "target": "jennifer_garner"
    },
    {
      "source": "jason_bateman",
      "target": "pedro_pascal"
    },
    {
      "source": "jason_bateman",
      "target": "kaley_cuoco"
    },
    {
      "source": "jason_bateman",
      "target": "depeche_mode"
    },
    {
      "source": "jason_bateman",
      "target": "matthew_rhys"
    },
    {
      "source": "jason_bateman",
      "target": "paul_anka"
    },
    {
      "source": "jason_bateman",
      "target": "bill_hader"
    },
    {
      "source": "jason_bateman",
      "target": "the_russo_brothers"
    },
    {
      "source": "jason_bateman",
      "target": "joaquin_phoenix"
    },
    {
      "source": "jason_bateman",
      "target": "simon_le_bon"
    },
    {
      "source": "jason_bateman",
      "target": "rob_lowe"
    },
    {
      "source": "jason_bateman",
      "target": "ben_affleck"
    },
    {
      "source": "jason_bateman",
      "target": "keanu_reeves"
    },
    {
      "source": "jason_bateman",
      "target": "jon_favreau"
    },
    {
      "source": "jason_bateman",
      "target": "al_michaels"
    },
    {
      "source": "jason_bateman",
      "target": "natasha_lyonne"
    },
    {
      "source": "jason_bateman",
      "target": "brendan_fraser"
    },
    {
      "source": "jason_bateman",
      "target": "billy_crudup"
    },
    {
      "source": "jason_bateman",
      "target": "eugene_levy"
    },
    {
      "source": "jason_bateman",
      "target": "tracee_ellis_ross"
    },
    {
      "source": "jason_bateman",
      "target": "dana_carvey"
    },
    {
      "source": "jason_bateman",
      "target": "bono"
    },
    {
      "source": "jason_bateman",
      "target": "steven_spielberg"
    },
    {
      "source": "jason_bateman",
      "target": "john_krasinski"
    },
    {
      "source": "jason_bateman",
      "target": "alejandro_i\u00f1\u00e1rritu"
    },
    {
      "source": "jason_bateman",
      "target": "edward_norton"
    },
    {
      "source": "jason_bateman",
      "target": "james_cameron"
    },
    {
      "source": "jason_bateman",
      "target": "emily_blunt"
    },
    {
      "source": "jason_bateman",
      "target": "sigourney_weaver"
    },
    {
      "source": "jason_bateman",
      "target": "rian_johnson"
    },
    {
      "source": "jason_bateman",
      "target": "kumail_nanjiani"
    },
    {
      "source": "jason_bateman",
      "target": "charlize_theron"
    },
    {
      "source": "jason_bateman",
      "target": "wayne_gretzky"
    },
    {
      "source": "jason_bateman",
      "target": "president_joe_biden"
    },
    {
      "source": "jason_bateman",
      "target": "elisabeth_moss"
    },
    {
      "source": "jason_bateman",
      "target": "steve_carell"
    },
    {
      "source": "jason_bateman",
      "target": "tony_hale"
    },
    {
      "source": "jason_bateman",
      "target": "kevin_bacon"
    },
    {
      "source": "jason_bateman",
      "target": "anderson_cooper"
    },
    {
      "source": "jason_bateman",
      "target": "allison_janney"
    },
    {
      "source": "jason_bateman",
      "target": "katy_perry"
    },
    {
      "source": "jason_bateman",
      "target": "ethan_hawke"
    },
    {
      "source": "jason_bateman",
      "target": "john_legend"
    },
    {
      "source": "jason_bateman",
      "target": "ewan_mcgregor"
    },
    {
      "source": "jason_bateman",
      "target": "kenan_thompson"
    },
    {
      "source": "jason_bateman",
      "target": "shawn_levy"
    },
    {
      "source": "jason_bateman",
      "target": "arcade_fire"
    },
    {
      "source": "jason_bateman",
      "target": "kerry_washington"
    },
    {
      "source": "jason_bateman",
      "target": "jordan_peele"
    },
    {
      "source": "jason_bateman",
      "target": "james_burrows"
    },
    {
      "source": "jason_bateman",
      "target": "jack_black"
    },
    {
      "source": "jason_bateman",
      "target": "jeff_bridges"
    },
    {
      "source": "jason_bateman",
      "target": "jenny_slate"
    },
    {
      "source": "jason_bateman",
      "target": "chris_pratt"
    },
    {
      "source": "jason_bateman",
      "target": "bradley_cooper"
    },
    {
      "source": "jason_bateman",
      "target": "phil_lord"
    },
    {
      "source": "jason_bateman",
      "target": "christopher_miller"
    },
    {
      "source": "jason_bateman",
      "target": "kristen_wiig"
    },
    {
      "source": "jason_bateman",
      "target": "ben_stiller"
    },
    {
      "source": "jason_bateman",
      "target": "john_mulaneymike_myers"
    },
    {
      "source": "jason_bateman",
      "target": "liam_neeson"
    },
    {
      "source": "jason_bateman",
      "target": "bill_maher"
    },
    {
      "source": "jason_bateman",
      "target": "craig_robinson"
    },
    {
      "source": "jason_bateman",
      "target": "michael_lewis"
    },
    {
      "source": "jason_bateman",
      "target": "jon_hamm"
    },
    {
      "source": "jason_bateman",
      "target": "david_spade"
    },
    {
      "source": "jason_bateman",
      "target": "cate_blanchett"
    },
    {
      "source": "jason_bateman",
      "target": "paul_thomas_anderson"
    },
    {
      "source": "jason_bateman",
      "target": "charlie_day"
    },
    {
      "source": "jason_bateman",
      "target": "courteney_cox"
    },
    {
      "source": "jason_bateman",
      "target": "eddie_vedder"
    },
    {
      "source": "jason_bateman",
      "target": "adam_mckay"
    },
    {
      "source": "jason_bateman",
      "target": "johnny_knoxville"
    },
    {
      "source": "jason_bateman",
      "target": "michael_moore"
    },
    {
      "source": "jason_bateman",
      "target": "david_byrne"
    },
    {
      "source": "jason_bateman",
      "target": "kathryn_hahn"
    },
    {
      "source": "jason_bateman",
      "target": "barry_sonnenfeld"
    },
    {
      "source": "jason_bateman",
      "target": "woody_harrelson"
    },
    {
      "source": "jason_bateman",
      "target": "will_forte"
    },
    {
      "source": "jason_bateman",
      "target": "jimmy_fallon"
    },
    {
      "source": "jason_bateman",
      "target": "sandra_bullock"
    },
    {
      "source": "jason_bateman",
      "target": "dave_grohl"
    },
    {
      "source": "jason_bateman",
      "target": "halle_berry"
    },
    {
      "source": "jason_bateman",
      "target": "vivek_murthy"
    },
    {
      "source": "jason_bateman",
      "target": "jerry_seinfeld"
    },
    {
      "source": "jason_bateman",
      "target": "tom_hanks"
    },
    {
      "source": "jason_bateman",
      "target": "joe_buck"
    },
    {
      "source": "jason_bateman",
      "target": "chelsea_handler"
    },
    {
      "source": "jason_bateman",
      "target": "david_remnick"
    },
    {
      "source": "jason_bateman",
      "target": "jeff_daniels"
    },
    {
      "source": "jason_bateman",
      "target": "jon_stewart"
    },
    {
      "source": "jason_bateman",
      "target": "ken_burns"
    },
    {
      "source": "jason_bateman",
      "target": "tiffany_haddish"
    },
    {
      "source": "jason_bateman",
      "target": "fred_armisen"
    },
    {
      "source": "jason_bateman",
      "target": "sean_penn"
    },
    {
      "source": "jason_bateman",
      "target": "octavia_spencer"
    },
    {
      "source": "jason_bateman",
      "target": "daniel_ricciardo"
    },
    {
      "source": "jason_bateman",
      "target": "tony_hawk"
    },
    {
      "source": "jason_bateman",
      "target": "j.j._abrams"
    },
    {
      "source": "jason_bateman",
      "target": "joy_reid"
    },
    {
      "source": "jason_bateman",
      "target": "ryan_reynolds"
    },
    {
      "source": "jason_bateman",
      "target": "lebron_james"
    },
    {
      "source": "jason_bateman",
      "target": "elizabeth_banks"
    },
    {
      "source": "jason_bateman",
      "target": "jos\u00e9_andr\u00e9s"
    },
    {
      "source": "jason_bateman",
      "target": "david_cross"
    },
    {
      "source": "jason_bateman",
      "target": "justin_theroux"
    },
    {
      "source": "jason_bateman",
      "target": "rob_mcelhenney"
    },
    {
      "source": "jason_bateman",
      "target": "mitch_hurwitz"
    },
    {
      "source": "jason_bateman",
      "target": "jake_tapper"
    },
    {
      "source": "jason_bateman",
      "target": "zach_galifianakis"
    },
    {
      "source": "jason_bateman",
      "target": "tina_fey"
    },
    {
      "source": "jason_bateman",
      "target": "gwyneth_paltrow"
    },
    {
      "source": "jason_bateman",
      "target": "amy_sedaris"
    },
    {
      "source": "jason_bateman",
      "target": "jessica_meir"
    },
    {
      "source": "jason_bateman",
      "target": "bob_odenkirk"
    },
    {
      "source": "jason_bateman",
      "target": "ted_sarandos"
    },
    {
      "source": "jason_bateman",
      "target": "stephen_colbert"
    },
    {
      "source": "jason_bateman",
      "target": "w._kamau_bell"
    },
    {
      "source": "jason_bateman",
      "target": "brad_paisley"
    },
    {
      "source": "jason_bateman",
      "target": "george_clooney"
    },
    {
      "source": "jason_bateman",
      "target": "awkwafina"
    },
    {
      "source": "jason_bateman",
      "target": "david_sinclair"
    },
    {
      "source": "jason_bateman",
      "target": "billie_eilish"
    },
    {
      "source": "jason_bateman",
      "target": "finneas_o'connell"
    },
    {
      "source": "jason_bateman",
      "target": "judd_apatow"
    },
    {
      "source": "jason_bateman",
      "target": "darius_rucker"
    },
    {
      "source": "jason_bateman",
      "target": "sam_harris"
    },
    {
      "source": "jason_bateman",
      "target": "julia_louis-dreyfus"
    },
    {
      "source": "jason_bateman",
      "target": "bryan_cranston"
    },
    {
      "source": "jason_bateman",
      "target": "martin_short"
    },
    {
      "source": "jason_bateman",
      "target": "megan_rapinoe"
    },
    {
      "source": "jason_bateman",
      "target": "james_corden"
    },
    {
      "source": "jason_bateman",
      "target": "ron_howard"
    },
    {
      "source": "jason_bateman",
      "target": "ricky_gervais"
    },
    {
      "source": "jason_bateman",
      "target": "sarah_silverman"
    },
    {
      "source": "jason_bateman",
      "target": "paul_mccartney"
    },
    {
      "source": "jason_bateman",
      "target": "david_chang"
    },
    {
      "source": "jason_bateman",
      "target": "conan_o'brien"
    },
    {
      "source": "jason_bateman",
      "target": "brendan_shanahan"
    },
    {
      "source": "jason_bateman",
      "target": "reese_witherspoon"
    },
    {
      "source": "jason_bateman",
      "target": "stacey_abrams"
    },
    {
      "source": "jason_bateman",
      "target": "adam_sandler"
    },
    {
      "source": "jason_bateman",
      "target": "clayton_kershaw"
    },
    {
      "source": "jason_bateman",
      "target": "jennifer_aniston"
    },
    {
      "source": "jason_bateman",
      "target": "gustavo_dudamel"
    },
    {
      "source": "jason_bateman",
      "target": "maya_rudolph"
    },
    {
      "source": "jason_bateman",
      "target": "robert_downey_jr."
    },
    {
      "source": "jason_bateman",
      "target": "kamala_harris"
    },
    {
      "source": "jason_bateman",
      "target": "seth_rogen"
    },
    {
      "source": "jason_bateman",
      "target": "melissa_mccarthy"
    },
    {
      "source": "jason_bateman",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "jason_bateman",
      "target": "dax_shepard"
    },
    {
      "source": "dax_shepard",
      "target": "vanessa_marin"
    },
    {
      "source": "dax_shepard",
      "target": "wyatt"
    },
    {
      "source": "dax_shepard",
      "target": "kurt_russell"
    },
    {
      "source": "dax_shepard",
      "target": "matthew_desmond"
    },
    {
      "source": "dax_shepard",
      "target": "paul_giamatti"
    },
    {
      "source": "dax_shepard",
      "target": "billie_joe_armstrong"
    },
    {
      "source": "dax_shepard",
      "target": "taraji_p._henson"
    },
    {
      "source": "dax_shepard",
      "target": "adam_frank"
    },
    {
      "source": "dax_shepard",
      "target": "willem_dafoe"
    },
    {
      "source": "dax_shepard",
      "target": "maria_sharapova"
    },
    {
      "source": "dax_shepard",
      "target": "jon_batiste"
    },
    {
      "source": "dax_shepard",
      "target": "daniel_markovits"
    },
    {
      "source": "dax_shepard",
      "target": "eva_longoria"
    },
    {
      "source": "dax_shepard",
      "target": "barbara_kingsolver"
    },
    {
      "source": "dax_shepard",
      "target": "tom_hansen"
    },
    {
      "source": "dax_shepard",
      "target": "dan_ariely"
    },
    {
      "source": "dax_shepard",
      "target": "craig_ferguson"
    },
    {
      "source": "dax_shepard",
      "target": "adam_grant"
    },
    {
      "source": "dax_shepard",
      "target": "the_chainsmokers"
    },
    {
      "source": "dax_shepard",
      "target": "robert_sapolsky"
    },
    {
      "source": "dax_shepard",
      "target": "jada_pinkett_smith"
    },
    {
      "source": "dax_shepard",
      "target": "morgan_neville"
    },
    {
      "source": "dax_shepard",
      "target": "kerry_washington"
    },
    {
      "source": "dax_shepard",
      "target": "gabor_mat\u00e9"
    },
    {
      "source": "dax_shepard",
      "target": "jonathan_van_ness"
    },
    {
      "source": "dax_shepard",
      "target": "prachi_gupta"
    },
    {
      "source": "dax_shepard",
      "target": "jimmy_kimmel"
    },
    {
      "source": "dax_shepard",
      "target": "mustafa_suleyman"
    },
    {
      "source": "dax_shepard",
      "target": "idina_menzel"
    },
    {
      "source": "dax_shepard",
      "target": "amy_edmondson"
    },
    {
      "source": "dax_shepard",
      "target": "jake_johnson"
    },
    {
      "source": "dax_shepard",
      "target": "jim_farley:_jim_farley"
    },
    {
      "source": "dax_shepard",
      "target": "tig_notaro"
    },
    {
      "source": "dax_shepard",
      "target": "jason_derulo"
    },
    {
      "source": "dax_shepard",
      "target": "wendy_mogel"
    },
    {
      "source": "dax_shepard",
      "target": "nurture_vs_nurture"
    },
    {
      "source": "dax_shepard",
      "target": "kristen_bell"
    },
    {
      "source": "dax_shepard",
      "target": "peter_attia"
    },
    {
      "source": "dax_shepard",
      "target": "ethan_hawke"
    },
    {
      "source": "dax_shepard",
      "target": "allyson_felix"
    },
    {
      "source": "dax_shepard",
      "target": "kate_mara"
    },
    {
      "source": "dax_shepard",
      "target": "jennifer_ackerman"
    },
    {
      "source": "dax_shepard",
      "target": "terry_crews"
    },
    {
      "source": "dax_shepard",
      "target": "jake_tapper"
    },
    {
      "source": "dax_shepard",
      "target": "elizabeth_banks"
    },
    {
      "source": "dax_shepard",
      "target": "neil_theise"
    },
    {
      "source": "dax_shepard",
      "target": "michael_shannon"
    },
    {
      "source": "dax_shepard",
      "target": "valerie_fridland"
    },
    {
      "source": "dax_shepard",
      "target": "minka_kelly"
    },
    {
      "source": "dax_shepard",
      "target": "peter_singer"
    },
    {
      "source": "dax_shepard",
      "target": "chris_paul"
    },
    {
      "source": "dax_shepard",
      "target": "robert_downey_jr."
    },
    {
      "source": "dax_shepard",
      "target": "megan_phelps-roper"
    },
    {
      "source": "dax_shepard",
      "target": "natalie_portman"
    },
    {
      "source": "dax_shepard",
      "target": "lee_hood"
    },
    {
      "source": "dax_shepard",
      "target": "nathan_price"
    },
    {
      "source": "dax_shepard",
      "target": "lizzy_caplan"
    },
    {
      "source": "dax_shepard",
      "target": "james_comey"
    },
    {
      "source": "dax_shepard",
      "target": "charlie_day"
    },
    {
      "source": "dax_shepard",
      "target": "michael_waldman"
    },
    {
      "source": "dax_shepard",
      "target": "jonas_brothers"
    },
    {
      "source": "dax_shepard",
      "target": "tim_ferriss"
    },
    {
      "source": "dax_shepard",
      "target": "jane_fonda"
    },
    {
      "source": "dax_shepard",
      "target": "nicholas_braun"
    },
    {
      "source": "dax_shepard",
      "target": "shonda_rhimes"
    },
    {
      "source": "dax_shepard",
      "target": "paris_hilton"
    },
    {
      "source": "dax_shepard",
      "target": "jason_katims"
    },
    {
      "source": "dax_shepard",
      "target": "david_sedaris"
    },
    {
      "source": "dax_shepard",
      "target": "nita_farahany"
    },
    {
      "source": "dax_shepard",
      "target": "jake_gyllenhaal"
    },
    {
      "source": "dax_shepard",
      "target": "rick_rubin"
    },
    {
      "source": "dax_shepard",
      "target": "matthew_mcconaughey"
    },
    {
      "source": "dax_shepard",
      "target": "paul_bloom"
    },
    {
      "source": "dax_shepard",
      "target": "barbie_ferreira"
    },
    {
      "source": "dax_shepard",
      "target": "alison_roman"
    },
    {
      "source": "dax_shepard",
      "target": "priyanka_chopra_jonas"
    },
    {
      "source": "dax_shepard",
      "target": "susan_magsamen"
    },
    {
      "source": "dax_shepard",
      "target": "ivy_ross"
    },
    {
      "source": "dax_shepard",
      "target": "david_letterman"
    },
    {
      "source": "dax_shepard",
      "target": "jay_shetty"
    },
    {
      "source": "dax_shepard",
      "target": "kurtwood_smith"
    },
    {
      "source": "dax_shepard",
      "target": "jenna_ortega"
    },
    {
      "source": "dax_shepard",
      "target": "david_remnick"
    },
    {
      "source": "dax_shepard",
      "target": "shania_twain"
    },
    {
      "source": "dax_shepard",
      "target": "kelly_slater"
    },
    {
      "source": "dax_shepard",
      "target": "paul_rudd"
    },
    {
      "source": "dax_shepard",
      "target": "andrew_newberg"
    },
    {
      "source": "dax_shepard",
      "target": "natasha_lyonne"
    },
    {
      "source": "dax_shepard",
      "target": "tess_wilkinson-ryan"
    },
    {
      "source": "dax_shepard",
      "target": "ramy_youssef"
    },
    {
      "source": "dax_shepard",
      "target": "chris_palmer"
    },
    {
      "source": "dax_shepard",
      "target": "pamela_anderson"
    },
    {
      "source": "dax_shepard",
      "target": "scott_galloway"
    },
    {
      "source": "dax_shepard",
      "target": "octavia_spencer"
    },
    {
      "source": "dax_shepard",
      "target": "jos\u00e9_andr\u00e9s"
    },
    {
      "source": "dax_shepard",
      "target": "paul_scheer"
    },
    {
      "source": "dax_shepard",
      "target": "sue_johnson"
    },
    {
      "source": "dax_shepard",
      "target": "anna_kendrick"
    },
    {
      "source": "dax_shepard",
      "target": "phil_stutz"
    },
    {
      "source": "dax_shepard",
      "target": "gabrielle_union"
    },
    {
      "source": "dax_shepard",
      "target": "esther_perel"
    },
    {
      "source": "dax_shepard",
      "target": "richard_branson"
    },
    {
      "source": "dax_shepard",
      "target": "post_retrieval"
    },
    {
      "source": "dax_shepard",
      "target": "edward_norton"
    },
    {
      "source": "dax_shepard",
      "target": "gloria_mark"
    },
    {
      "source": "dax_shepard",
      "target": "andrew_solomon"
    },
    {
      "source": "dax_shepard",
      "target": "victoria_beckham"
    },
    {
      "source": "dax_shepard",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "dax_shepard",
      "target": "chelsea_handler"
    },
    {
      "source": "dax_shepard",
      "target": "jerry_seinfeld"
    },
    {
      "source": "dax_shepard",
      "target": "yuval_harari"
    },
    {
      "source": "dax_shepard",
      "target": "dana"
    },
    {
      "source": "dax_shepard",
      "target": "john_stamos"
    },
    {
      "source": "dax_shepard",
      "target": "layne_norton"
    },
    {
      "source": "dax_shepard",
      "target": "andrew_huberman"
    },
    {
      "source": "dax_shepard",
      "target": "constance_wu"
    },
    {
      "source": "dax_shepard",
      "target": "will_bunch"
    },
    {
      "source": "dax_shepard",
      "target": "eve_wiley"
    },
    {
      "source": "dax_shepard",
      "target": "bee"
    },
    {
      "source": "dax_shepard",
      "target": "gwen_stefani"
    },
    {
      "source": "dax_shepard",
      "target": "felix_gillette"
    },
    {
      "source": "dax_shepard",
      "target": "john_koblin"
    },
    {
      "source": "dax_shepard",
      "target": "emily_oster"
    },
    {
      "source": "dax_shepard",
      "target": "january_jones"
    },
    {
      "source": "dax_shepard",
      "target": "hasan_minhaj"
    },
    {
      "source": "dax_shepard",
      "target": "siddhartha_mukherjee"
    },
    {
      "source": "dax_shepard",
      "target": "douglas_nejamie"
    },
    {
      "source": "dax_shepard",
      "target": "dre"
    },
    {
      "source": "dax_shepard",
      "target": "rachel"
    },
    {
      "source": "dax_shepard",
      "target": "elisabeth_moss"
    },
    {
      "source": "dax_shepard",
      "target": "reza_aslan"
    },
    {
      "source": "dax_shepard",
      "target": "scarlett_johansson"
    },
    {
      "source": "dax_shepard",
      "target": "jonathan_abrams"
    },
    {
      "source": "dax_shepard",
      "target": "kevin_bacon"
    },
    {
      "source": "dax_shepard",
      "target": "saul_kassin"
    },
    {
      "source": "dax_shepard",
      "target": "jennette_mccurdy"
    },
    {
      "source": "dax_shepard",
      "target": "ice-t"
    },
    {
      "source": "dax_shepard",
      "target": "lili_reinhart"
    },
    {
      "source": "dax_shepard",
      "target": "jamie_fiore_higgins"
    },
    {
      "source": "dax_shepard",
      "target": "tom_hanks"
    },
    {
      "source": "dax_shepard",
      "target": "erin_kimmerle"
    },
    {
      "source": "dax_shepard",
      "target": "george_monbiot"
    },
    {
      "source": "dax_shepard",
      "target": "zoey_deutch"
    },
    {
      "source": "dax_shepard",
      "target": "woo-kyoung_ahn"
    },
    {
      "source": "dax_shepard",
      "target": "ben_stiller"
    },
    {
      "source": "dax_shepard",
      "target": "david_lieberman"
    },
    {
      "source": "dax_shepard",
      "target": "jesse_tyler_ferguson"
    },
    {
      "source": "dax_shepard",
      "target": "tracy_dennis-tiwary"
    },
    {
      "source": "dax_shepard",
      "target": "shaun_white"
    },
    {
      "source": "dax_shepard",
      "target": "malcolm_gladwell"
    },
    {
      "source": "dax_shepard",
      "target": "john_early"
    },
    {
      "source": "dax_shepard",
      "target": "rick_glassman"
    },
    {
      "source": "dax_shepard",
      "target": "seirian_sumner"
    },
    {
      "source": "dax_shepard",
      "target": "kathleen_belew"
    },
    {
      "source": "dax_shepard",
      "target": "connie_britton"
    },
    {
      "source": "dax_shepard",
      "target": "brett_scott"
    },
    {
      "source": "dax_shepard",
      "target": "bryan_cranston"
    },
    {
      "source": "dax_shepard",
      "target": "steve_brusatte"
    },
    {
      "source": "dax_shepard",
      "target": "laura_linney"
    },
    {
      "source": "dax_shepard",
      "target": "reggie_fils-aim\u00e9"
    },
    {
      "source": "dax_shepard",
      "target": "daniel_ricciardo"
    },
    {
      "source": "dax_shepard",
      "target": "ed_yong"
    },
    {
      "source": "dax_shepard",
      "target": "zazie_beetz"
    },
    {
      "source": "dax_shepard",
      "target": "susan_cain"
    },
    {
      "source": "dax_shepard",
      "target": "ike_barinholtz"
    },
    {
      "source": "dax_shepard",
      "target": "ray_dalio"
    },
    {
      "source": "dax_shepard",
      "target": "jerrod_carmichael"
    },
    {
      "source": "dax_shepard",
      "target": "lord"
    },
    {
      "source": "dax_shepard",
      "target": "miller"
    },
    {
      "source": "dax_shepard",
      "target": "colson_baker"
    },
    {
      "source": "dax_shepard",
      "target": "david_farrier"
    },
    {
      "source": "dax_shepard",
      "target": "cathy_o'neil"
    },
    {
      "source": "dax_shepard",
      "target": "molly_shannon"
    },
    {
      "source": "dax_shepard",
      "target": "joseph_henrich"
    },
    {
      "source": "dax_shepard",
      "target": "emmy_rossum"
    },
    {
      "source": "dax_shepard",
      "target": "a.j._jacobs"
    },
    {
      "source": "dax_shepard",
      "target": "josh_brolin"
    },
    {
      "source": "dax_shepard",
      "target": "floyd_abrams"
    },
    {
      "source": "dax_shepard",
      "target": "craig_robinson"
    },
    {
      "source": "dax_shepard",
      "target": "armchair_stories"
    },
    {
      "source": "dax_shepard",
      "target": "paul_feig"
    },
    {
      "source": "dax_shepard",
      "target": "cillian_murphy"
    },
    {
      "source": "dax_shepard",
      "target": "anna_lembke"
    },
    {
      "source": "dax_shepard",
      "target": "mandy_moore"
    },
    {
      "source": "dax_shepard",
      "target": "brian_cox"
    },
    {
      "source": "dax_shepard",
      "target": "jimmy_fallon"
    },
    {
      "source": "dax_shepard",
      "target": "daniel_pink"
    },
    {
      "source": "dax_shepard",
      "target": "tony_hawk"
    },
    {
      "source": "dax_shepard",
      "target": "sam_jones"
    },
    {
      "source": "dax_shepard",
      "target": "monica_aldama"
    },
    {
      "source": "dax_shepard",
      "target": "seth_meyers"
    },
    {
      "source": "dax_shepard",
      "target": "roy_choi"
    },
    {
      "source": "dax_shepard",
      "target": "bob_odenkirk"
    },
    {
      "source": "dax_shepard",
      "target": "jacqueline_novogratz"
    },
    {
      "source": "dax_shepard",
      "target": "alia_shawkat"
    },
    {
      "source": "dax_shepard",
      "target": "chuck_palahniuk"
    },
    {
      "source": "dax_shepard",
      "target": "nicholas_hoult"
    },
    {
      "source": "dax_shepard",
      "target": "bill_gates"
    },
    {
      "source": "dax_shepard",
      "target": "bren\u00e9_brown"
    },
    {
      "source": "dax_shepard",
      "target": "michael_schur"
    },
    {
      "source": "dax_shepard",
      "target": "david_arquette"
    },
    {
      "source": "dax_shepard",
      "target": "brian_klaas"
    },
    {
      "source": "dax_shepard",
      "target": "kristen_stewart"
    },
    {
      "source": "dax_shepard",
      "target": "michael_moore"
    },
    {
      "source": "dax_shepard",
      "target": "max_greenfield"
    },
    {
      "source": "dax_shepard",
      "target": "stacey_abrams"
    },
    {
      "source": "dax_shepard",
      "target": "jeremy_renner"
    },
    {
      "source": "dax_shepard",
      "target": "eric_schmidt"
    },
    {
      "source": "dax_shepard",
      "target": "dwyane_wade"
    },
    {
      "source": "dax_shepard",
      "target": "anderson_cooper"
    },
    {
      "source": "dax_shepard",
      "target": "brooke_shields"
    },
    {
      "source": "dax_shepard",
      "target": "reid_hoffman"
    },
    {
      "source": "dax_shepard",
      "target": "bradley_cooper"
    },
    {
      "source": "dax_shepard",
      "target": "chris_wallace"
    },
    {
      "source": "dax_shepard",
      "target": "nick_offerman"
    },
    {
      "source": "dax_shepard",
      "target": "erin_lee_carr"
    },
    {
      "source": "dax_shepard",
      "target": "rachael_ray"
    },
    {
      "source": "dax_shepard",
      "target": "secret_societies"
    },
    {
      "source": "dax_shepard",
      "target": "khalil_gibran_muhammad"
    },
    {
      "source": "dax_shepard",
      "target": "stanley_tucci"
    },
    {
      "source": "dax_shepard",
      "target": "ed_sheeran"
    },
    {
      "source": "dax_shepard",
      "target": "david_copperfield"
    },
    {
      "source": "dax_shepard",
      "target": "gwyneth_paltrow"
    },
    {
      "source": "dax_shepard",
      "target": "amishi_jha"
    },
    {
      "source": "dax_shepard",
      "target": "ron_howard"
    },
    {
      "source": "dax_shepard",
      "target": "ted_bundy"
    },
    {
      "source": "dax_shepard",
      "target": "van_jones"
    },
    {
      "source": "dax_shepard",
      "target": "b.j._novak"
    },
    {
      "source": "dax_shepard",
      "target": "elijah_wood"
    },
    {
      "source": "dax_shepard",
      "target": "steven_pinker"
    },
    {
      "source": "dax_shepard",
      "target": "drew_barrymore"
    },
    {
      "source": "dax_shepard",
      "target": "alicia_vikander"
    },
    {
      "source": "dax_shepard",
      "target": "harold_s._koplewicz"
    },
    {
      "source": "dax_shepard",
      "target": "amanda_peet"
    },
    {
      "source": "dax_shepard",
      "target": "dark_tourism"
    },
    {
      "source": "dax_shepard",
      "target": "kate_bowler"
    },
    {
      "source": "dax_shepard",
      "target": "awkwafina"
    },
    {
      "source": "dax_shepard",
      "target": "carmelo_anthony"
    },
    {
      "source": "dax_shepard",
      "target": "brie_larson"
    },
    {
      "source": "dax_shepard",
      "target": "samantha_bee"
    },
    {
      "source": "dax_shepard",
      "target": "matthew_rhys"
    },
    {
      "source": "dax_shepard",
      "target": "padma_lakshmi"
    },
    {
      "source": "dax_shepard",
      "target": "cecily_strong"
    },
    {
      "source": "dax_shepard",
      "target": "maya_shankar"
    },
    {
      "source": "dax_shepard",
      "target": "qanon"
    },
    {
      "source": "dax_shepard",
      "target": "daryl_hall"
    },
    {
      "source": "dax_shepard",
      "target": "matt_damon"
    },
    {
      "source": "dax_shepard",
      "target": "mark_ronson"
    },
    {
      "source": "dax_shepard",
      "target": "leon_bridges"
    },
    {
      "source": "dax_shepard",
      "target": "tim_grover"
    },
    {
      "source": "dax_shepard",
      "target": "mila_kunis"
    },
    {
      "source": "dax_shepard",
      "target": "ashton_kutcher"
    },
    {
      "source": "dax_shepard",
      "target": "kate_beckinsale"
    },
    {
      "source": "dax_shepard",
      "target": "medical_misinformation"
    },
    {
      "source": "dax_shepard",
      "target": "michael_pollan"
    },
    {
      "source": "dax_shepard",
      "target": "quentin_tarantino"
    },
    {
      "source": "dax_shepard",
      "target": "barack_obama"
    },
    {
      "source": "dax_shepard",
      "target": "j.b._smoove"
    },
    {
      "source": "dax_shepard",
      "target": "tara_stoinski"
    },
    {
      "source": "dax_shepard",
      "target": "luke_wilson"
    },
    {
      "source": "dax_shepard",
      "target": "fresh"
    },
    {
      "source": "dax_shepard",
      "target": "barry_meier"
    },
    {
      "source": "dax_shepard",
      "target": "jessica_biel"
    },
    {
      "source": "dax_shepard",
      "target": "chris_bosh"
    },
    {
      "source": "dax_shepard",
      "target": "russell_brand"
    },
    {
      "source": "dax_shepard",
      "target": "ufos"
    },
    {
      "source": "dax_shepard",
      "target": "bubba_wallace"
    },
    {
      "source": "dax_shepard",
      "target": "vincent_d'onofrio"
    },
    {
      "source": "dax_shepard",
      "target": "susan_stryker"
    },
    {
      "source": "dax_shepard",
      "target": "julianna_margulies"
    },
    {
      "source": "dax_shepard",
      "target": "yusef_salaam"
    },
    {
      "source": "dax_shepard",
      "target": "ethan_herisse"
    },
    {
      "source": "dax_shepard",
      "target": "daniel_kahneman"
    },
    {
      "source": "dax_shepard",
      "target": "jonathan_tucker"
    },
    {
      "source": "dax_shepard",
      "target": "prince_harry"
    },
    {
      "source": "dax_shepard",
      "target": "seth_rogen"
    },
    {
      "source": "dax_shepard",
      "target": "simulation_theorykwame_onwuachi"
    },
    {
      "source": "dax_shepard",
      "target": "kelly_osbourne"
    },
    {
      "source": "dax_shepard",
      "target": "alexi_pappas"
    },
    {
      "source": "dax_shepard",
      "target": "william_jackson_harper"
    },
    {
      "source": "dax_shepard",
      "target": "dorothy_brown"
    },
    {
      "source": "dax_shepard",
      "target": "andrew_yang"
    },
    {
      "source": "dax_shepard",
      "target": "macklemore"
    },
    {
      "source": "dax_shepard",
      "target": "michael_moss"
    },
    {
      "source": "dax_shepard",
      "target": "hank_azaria"
    },
    {
      "source": "dax_shepard",
      "target": "daniel_goleman"
    },
    {
      "source": "dax_shepard",
      "target": "lamorne_morris"
    },
    {
      "source": "dax_shepard",
      "target": "walter_isaacson"
    },
    {
      "source": "dax_shepard",
      "target": "rachel_bilson"
    },
    {
      "source": "dax_shepard",
      "target": "sam_pollard"
    },
    {
      "source": "dax_shepard",
      "target": "susan_liautaud"
    },
    {
      "source": "dax_shepard",
      "target": "robin_thicke"
    },
    {
      "source": "dax_shepard",
      "target": "ethan_kross"
    },
    {
      "source": "dax_shepard",
      "target": "ben_schwartz"
    },
    {
      "source": "dax_shepard",
      "target": "george_saunders"
    },
    {
      "source": "dax_shepard",
      "target": "rupert_grint"
    },
    {
      "source": "dax_shepard",
      "target": "michael_eric_dyson"
    },
    {
      "source": "dax_shepard",
      "target": "amy_poehler"
    },
    {
      "source": "dax_shepard",
      "target": "chad_sanders"
    },
    {
      "source": "dax_shepard",
      "target": "jane_goodall"
    },
    {
      "source": "dax_shepard",
      "target": "viggo_mortensen"
    },
    {
      "source": "dax_shepard",
      "target": "erin_meyer"
    },
    {
      "source": "dax_shepard",
      "target": "salma_hayek"
    },
    {
      "source": "dax_shepard",
      "target": "emily_morse"
    },
    {
      "source": "dax_shepard",
      "target": "jason_segel"
    },
    {
      "source": "dax_shepard",
      "target": "adam_grant_returns"
    },
    {
      "source": "dax_shepard",
      "target": "carey_mulligan"
    },
    {
      "source": "dax_shepard",
      "target": "robert_livingston"
    },
    {
      "source": "dax_shepard",
      "target": "jethro_bovingdon"
    },
    {
      "source": "dax_shepard",
      "target": "rob_corddry"
    },
    {
      "source": "dax_shepard",
      "target": "justin_timberlake"
    },
    {
      "source": "dax_shepard",
      "target": "jamil_zaki"
    },
    {
      "source": "dax_shepard",
      "target": "common"
    },
    {
      "source": "dax_shepard",
      "target": "brad_grossman"
    },
    {
      "source": "dax_shepard",
      "target": "randy_jackson"
    },
    {
      "source": "dax_shepard",
      "target": "sanjay_gupta_returns"
    },
    {
      "source": "dax_shepard",
      "target": "jackie_tohn"
    },
    {
      "source": "dax_shepard",
      "target": "john_o._brennan"
    },
    {
      "source": "dax_shepard",
      "target": "shawn_mendes"
    },
    {
      "source": "dax_shepard",
      "target": "dov_fox"
    },
    {
      "source": "dax_shepard",
      "target": "emmanuel_acho"
    },
    {
      "source": "dax_shepard",
      "target": "scott_kelly"
    },
    {
      "source": "dax_shepard",
      "target": "hillary_clinton"
    },
    {
      "source": "dax_shepard",
      "target": "susan_david"
    },
    {
      "source": "dax_shepard",
      "target": "jewel"
    },
    {
      "source": "dax_shepard",
      "target": "tristan_harris"
    },
    {
      "source": "dax_shepard",
      "target": "halsey"
    },
    {
      "source": "dax_shepard",
      "target": "kaley_cuoco"
    },
    {
      "source": "dax_shepard",
      "target": "yuval_harari_returns"
    },
    {
      "source": "dax_shepard",
      "target": "adam_brody"
    },
    {
      "source": "dax_shepard",
      "target": "joseph_laycock"
    },
    {
      "source": "dax_shepard",
      "target": "erin_geiger_smith"
    },
    {
      "source": "dax_shepard",
      "target": "chelsea_handler_returns"
    },
    {
      "source": "dax_shepard",
      "target": "isabel_wilkerson"
    },
    {
      "source": "dax_shepard",
      "target": "eric_lander"
    },
    {
      "source": "dax_shepard",
      "target": "sara_gilbert"
    },
    {
      "source": "dax_shepard",
      "target": "bob_woodward"
    },
    {
      "source": "dax_shepard",
      "target": "jon_bon_jovi"
    },
    {
      "source": "dax_shepard",
      "target": "aly_raisman"
    },
    {
      "source": "dax_shepard",
      "target": "sofia_coppola"
    },
    {
      "source": "dax_shepard",
      "target": "david_farrier"
    },
    {
      "source": "dax_shepard",
      "target": "sara_bareilles"
    },
    {
      "source": "dax_shepard",
      "target": "leah_plunkett"
    },
    {
      "source": "dax_shepard",
      "target": "keith_urban"
    },
    {
      "source": "dax_shepard",
      "target": "susan_burton"
    },
    {
      "source": "dax_shepard",
      "target": "tom_brady"
    },
    {
      "source": "dax_shepard",
      "target": "seth_macfarlane"
    },
    {
      "source": "dax_shepard",
      "target": "lenore_skenazy"
    },
    {
      "source": "dax_shepard",
      "target": "ellen_pompeo"
    },
    {
      "source": "dax_shepard",
      "target": "sean_penn"
    },
    {
      "source": "dax_shepard",
      "target": "michael_tubbs"
    },
    {
      "source": "dax_shepard",
      "target": "atul_gawande"
    },
    {
      "source": "dax_shepard",
      "target": "colin_jost"
    },
    {
      "source": "dax_shepard",
      "target": "bradley_edwards"
    },
    {
      "source": "dax_shepard",
      "target": "leslie_odom_jr."
    },
    {
      "source": "dax_shepard",
      "target": "angela_duckworth"
    },
    {
      "source": "dax_shepard",
      "target": "dave_franco"
    },
    {
      "source": "dax_shepard",
      "target": "travis_pastrana"
    },
    {
      "source": "dax_shepard",
      "target": "david_sinclair"
    },
    {
      "source": "dax_shepard",
      "target": "john_legend"
    },
    {
      "source": "dax_shepard",
      "target": "jud_brewer"
    },
    {
      "source": "dax_shepard",
      "target": "emily_mortimer"
    },
    {
      "source": "dax_shepard",
      "target": "jennifer_eberhardt"
    },
    {
      "source": "dax_shepard",
      "target": "nina_vasan"
    },
    {
      "source": "dax_shepard",
      "target": "juliette_lewis"
    },
    {
      "source": "dax_shepard",
      "target": "jeffrey_sachs"
    },
    {
      "source": "dax_shepard",
      "target": "blake_griffin"
    },
    {
      "source": "dax_shepard",
      "target": "malcolm_gladwell"
    },
    {
      "source": "dax_shepard",
      "target": "vivek_murthy"
    },
    {
      "source": "dax_shepard",
      "target": "beastie_boys"
    },
    {
      "source": "dax_shepard",
      "target": "alanis_morissette"
    },
    {
      "source": "dax_shepard",
      "target": "ibram_x._kendi"
    },
    {
      "source": "dax_shepard",
      "target": "bradley_whitford"
    },
    {
      "source": "dax_shepard",
      "target": "heather_mcghee"
    },
    {
      "source": "dax_shepard",
      "target": "jon_meacham"
    },
    {
      "source": "dax_shepard",
      "target": "melissa_mccarthy"
    },
    {
      "source": "dax_shepard",
      "target": "laurie_santos"
    },
    {
      "source": "dax_shepard",
      "target": "50_cent"
    },
    {
      "source": "dax_shepard",
      "target": "rajiv_shah"
    },
    {
      "source": "dax_shepard",
      "target": "america_ferrera"
    },
    {
      "source": "dax_shepard",
      "target": "dan_heath"
    },
    {
      "source": "dax_shepard",
      "target": "zo\u00eb_kravitz"
    },
    {
      "source": "dax_shepard",
      "target": "david_chang"
    },
    {
      "source": "dax_shepard",
      "target": "rob_lowe"
    },
    {
      "source": "dax_shepard",
      "target": "glennon_doyle"
    },
    {
      "source": "dax_shepard",
      "target": "sheryl_crow"
    },
    {
      "source": "dax_shepard",
      "target": "jessica_lahey"
    },
    {
      "source": "dax_shepard",
      "target": "ed_helms"
    },
    {
      "source": "dax_shepard",
      "target": "andrew_marantz"
    },
    {
      "source": "dax_shepard",
      "target": "joy_bryant_returns"
    },
    {
      "source": "dax_shepard",
      "target": "lydia_denworth"
    },
    {
      "source": "dax_shepard",
      "target": "sanjay_gupta_on_covid-19"
    },
    {
      "source": "dax_shepard",
      "target": "tom_silver"
    },
    {
      "source": "dax_shepard",
      "target": "lennon_parham"
    },
    {
      "source": "dax_shepard",
      "target": "adam_mosseri"
    },
    {
      "source": "dax_shepard",
      "target": "kumail_nanjiani"
    },
    {
      "source": "dax_shepard",
      "target": "rob_mcelhenney"
    },
    {
      "source": "dax_shepard",
      "target": "bj_fogg"
    },
    {
      "source": "dax_shepard",
      "target": "whitney_cummings"
    },
    {
      "source": "dax_shepard",
      "target": "peggy_orenstein"
    },
    {
      "source": "dax_shepard",
      "target": "ashton_kutcher_returns"
    },
    {
      "source": "dax_shepard",
      "target": "jason_de_le\u00f3n"
    },
    {
      "source": "dax_shepard",
      "target": "alison_brie"
    },
    {
      "source": "dax_shepard",
      "target": "monica"
    },
    {
      "source": "dax_shepard",
      "target": "dax_shepard"
    },
    {
      "source": "dax_shepard",
      "target": "ezra_klein"
    },
    {
      "source": "dax_shepard",
      "target": "introducing:_monica"
    },
    {
      "source": "dax_shepard",
      "target": "jess_love_boys"
    },
    {
      "source": "dax_shepard",
      "target": "josh_gad"
    },
    {
      "source": "dax_shepard",
      "target": "chris_voss"
    },
    {
      "source": "dax_shepard",
      "target": "will_arnett"
    },
    {
      "source": "dax_shepard",
      "target": "jared_cohen"
    },
    {
      "source": "dax_shepard",
      "target": "claire_danes"
    },
    {
      "source": "dax_shepard",
      "target": "dierks_bentley"
    },
    {
      "source": "dax_shepard",
      "target": "drew_carey"
    },
    {
      "source": "dax_shepard",
      "target": "sam_harris_returns"
    },
    {
      "source": "dax_shepard",
      "target": "january_jones"
    },
    {
      "source": "dax_shepard",
      "target": "ronan_farrow"
    },
    {
      "source": "dax_shepard",
      "target": "rainn_wilson"
    },
    {
      "source": "dax_shepard",
      "target": "keri_russell"
    },
    {
      "source": "dax_shepard",
      "target": "rhys_darby_(live)"
    },
    {
      "source": "dax_shepard",
      "target": "t.i."
    },
    {
      "source": "dax_shepard",
      "target": "sam_elliott"
    },
    {
      "source": "dax_shepard",
      "target": "laura_beil"
    },
    {
      "source": "dax_shepard",
      "target": "tony_hale"
    },
    {
      "source": "dax_shepard",
      "target": "martina_mcbride"
    },
    {
      "source": "dax_shepard",
      "target": "emilia_clarke"
    },
    {
      "source": "dax_shepard",
      "target": "jonathan_safran_foer"
    },
    {
      "source": "dax_shepard",
      "target": "judd_apatow"
    },
    {
      "source": "dax_shepard",
      "target": "richard_dawkins"
    },
    {
      "source": "dax_shepard",
      "target": "kate"
    },
    {
      "source": "dax_shepard",
      "target": "oliver_hudson"
    },
    {
      "source": "dax_shepard",
      "target": "liz_plank"
    },
    {
      "source": "dax_shepard",
      "target": "edward_nortonandrew_zimmern"
    },
    {
      "source": "dax_shepard",
      "target": "jim_jefferies"
    },
    {
      "source": "dax_shepard",
      "target": "nadine_burke_harris"
    },
    {
      "source": "dax_shepard",
      "target": "adam_devine"
    },
    {
      "source": "dax_shepard",
      "target": "lori_gottlieb"
    },
    {
      "source": "dax_shepard",
      "target": "the_avett_brothers"
    },
    {
      "source": "dax_shepard",
      "target": "monica_potter"
    },
    {
      "source": "dax_shepard",
      "target": "jim_gaffigan"
    },
    {
      "source": "dax_shepard",
      "target": "dave_asprey"
    },
    {
      "source": "dax_shepard",
      "target": "dog_the_bounty_hunter"
    },
    {
      "source": "dax_shepard",
      "target": "joseph_gordon-levitt"
    },
    {
      "source": "dax_shepard",
      "target": "pete_carroll"
    },
    {
      "source": "dax_shepard",
      "target": "kal_penn"
    },
    {
      "source": "dax_shepard",
      "target": "david_koechner"
    },
    {
      "source": "dax_shepard",
      "target": "beanie_feldstein"
    },
    {
      "source": "dax_shepard",
      "target": "steven_gundry"
    },
    {
      "source": "dax_shepard",
      "target": "danny_mcbride"
    },
    {
      "source": "dax_shepard",
      "target": "tal_ben-shahar"
    },
    {
      "source": "dax_shepard",
      "target": "busy_philipps"
    },
    {
      "source": "dax_shepard",
      "target": "peter_krause"
    },
    {
      "source": "dax_shepard",
      "target": "casey_affleck"
    },
    {
      "source": "dax_shepard",
      "target": "dan_savage"
    },
    {
      "source": "dax_shepard",
      "target": "ben_platt"
    },
    {
      "source": "dax_shepard",
      "target": "mayor_eric_garcetti"
    },
    {
      "source": "dax_shepard",
      "target": "lake_bell"
    },
    {
      "source": "dax_shepard",
      "target": "rahul_jandial"
    },
    {
      "source": "dax_shepard",
      "target": "fred_savage"
    },
    {
      "source": "dax_shepard",
      "target": "w._kamau_bell"
    },
    {
      "source": "dax_shepard",
      "target": "andy_richter"
    },
    {
      "source": "dax_shepard",
      "target": "jennifer_newsom"
    },
    {
      "source": "dax_shepard",
      "target": "bill_hader"
    },
    {
      "source": "dax_shepard",
      "target": "steve_madden"
    },
    {
      "source": "dax_shepard",
      "target": "aubrey_plaza"
    },
    {
      "source": "dax_shepard",
      "target": "alex_katehakis"
    },
    {
      "source": "dax_shepard",
      "target": "julia_louis-dreyfus"
    },
    {
      "source": "dax_shepard",
      "target": "david_walton"
    },
    {
      "source": "dax_shepard",
      "target": "jeff_garlin"
    },
    {
      "source": "dax_shepard",
      "target": "elizabeth_gilbert"
    },
    {
      "source": "dax_shepard",
      "target": "will_ferrell"
    },
    {
      "source": "dax_shepard",
      "target": "kumail_nanjiani"
    },
    {
      "source": "dax_shepard",
      "target": "samin_nosrat"
    },
    {
      "source": "dax_shepard",
      "target": "craig_t._nelson"
    },
    {
      "source": "dax_shepard",
      "target": "monica_padman"
    },
    {
      "source": "dax_shepard",
      "target": "justin_long"
    },
    {
      "source": "dax_shepard",
      "target": "bill_nye"
    },
    {
      "source": "dax_shepard",
      "target": "stephen_merchant"
    },
    {
      "source": "dax_shepard",
      "target": "eric_topol"
    },
    {
      "source": "dax_shepard",
      "target": "norah_jones"
    },
    {
      "source": "dax_shepard",
      "target": "michael_gervais"
    },
    {
      "source": "dax_shepard",
      "target": "will_forte"
    },
    {
      "source": "dax_shepard",
      "target": "sanjay_gupta"
    },
    {
      "source": "dax_shepard",
      "target": "adam_pally"
    },
    {
      "source": "dax_shepard",
      "target": "michael_rosenbaum"
    },
    {
      "source": "dax_shepard",
      "target": "john_kim"
    },
    {
      "source": "dax_shepard",
      "target": "chris_d'elia"
    },
    {
      "source": "dax_shepard",
      "target": "thomas_middleditch"
    },
    {
      "source": "dax_shepard",
      "target": "johann_hari"
    },
    {
      "source": "dax_shepard",
      "target": "evan_rachel_wood"
    },
    {
      "source": "dax_shepard",
      "target": "reshma_saujani"
    },
    {
      "source": "dax_shepard",
      "target": "pete_holmes"
    },
    {
      "source": "dax_shepard",
      "target": "john_gottman"
    },
    {
      "source": "dax_shepard",
      "target": "gillian_flynn"
    },
    {
      "source": "dax_shepard",
      "target": "chelsea_peretti"
    },
    {
      "source": "dax_shepard",
      "target": "jason_mantzoukas"
    },
    {
      "source": "dax_shepard",
      "target": "phil"
    },
    {
      "source": "dax_shepard",
      "target": "ryan_hansen"
    },
    {
      "source": "dax_shepard",
      "target": "todd_rose"
    },
    {
      "source": "dax_shepard",
      "target": "michael_pe\u00f1a"
    },
    {
      "source": "dax_shepard",
      "target": "bret_weinstein"
    },
    {
      "source": "dax_shepard",
      "target": "jay_leno"
    },
    {
      "source": "dax_shepard",
      "target": "lil_rel"
    },
    {
      "source": "dax_shepard",
      "target": "sarah_silverman"
    },
    {
      "source": "dax_shepard",
      "target": "scott_harrison"
    },
    {
      "source": "dax_shepard",
      "target": "josh_hutcherson"
    },
    {
      "source": "dax_shepard",
      "target": "josh_duhamel"
    },
    {
      "source": "dax_shepard",
      "target": "sean_hayes"
    },
    {
      "source": "dax_shepard",
      "target": "jason_biggs"
    },
    {
      "source": "dax_shepard",
      "target": "sophia_bush"
    },
    {
      "source": "dax_shepard",
      "target": "jonathan_haidt"
    },
    {
      "source": "dax_shepard",
      "target": "andrea_savage"
    },
    {
      "source": "dax_shepard",
      "target": "ethan_hawke"
    },
    {
      "source": "dax_shepard",
      "target": "conan_o'brien"
    },
    {
      "source": "dax_shepard",
      "target": "sam_harris"
    },
    {
      "source": "dax_shepard",
      "target": "debby_ryan"
    },
    {
      "source": "dax_shepard",
      "target": "gordon_keith"
    },
    {
      "source": "dax_shepard",
      "target": "ira_glass"
    },
    {
      "source": "dax_shepard",
      "target": "jerry_buting"
    },
    {
      "source": "dax_shepard",
      "target": "mark_duplass"
    },
    {
      "source": "dax_shepard",
      "target": "lena_dunhambren\u00e9_brown"
    },
    {
      "source": "dax_shepard",
      "target": "drew"
    },
    {
      "source": "dax_shepard",
      "target": "amy_schumer"
    },
    {
      "source": "dax_shepard",
      "target": "yuval_noah_harari"
    },
    {
      "source": "dax_shepard",
      "target": "wendi_mclendon-covey"
    },
    {
      "source": "dax_shepard",
      "target": "mike_schur"
    },
    {
      "source": "dax_shepard",
      "target": "d'arcy_carden"
    },
    {
      "source": "dax_shepard",
      "target": "ted_danson"
    },
    {
      "source": "dax_shepard",
      "target": "ike_barinholtz"
    },
    {
      "source": "dax_shepard",
      "target": "kathryn_hahn"
    },
    {
      "source": "dax_shepard",
      "target": "keith_morrison"
    },
    {
      "source": "dax_shepard",
      "target": "matthew_lillard"
    },
    {
      "source": "dax_shepard",
      "target": "jason_bateman"
    },
    {
      "source": "dax_shepard",
      "target": "colin_hanks"
    },
    {
      "source": "dax_shepard",
      "target": "allison_tolman"
    },
    {
      "source": "dax_shepard",
      "target": "jon_favreau"
    },
    {
      "source": "dax_shepard",
      "target": "david_harbour"
    },
    {
      "source": "dax_shepard",
      "target": "nick_kroll"
    },
    {
      "source": "dax_shepard",
      "target": "john_gourley"
    },
    {
      "source": "dax_shepard",
      "target": "zachary_carothers)"
    },
    {
      "source": "dax_shepard",
      "target": "laura_labo"
    },
    {
      "source": "dax_shepard",
      "target": "mae_whitman"
    },
    {
      "source": "dax_shepard",
      "target": "kaitlin_olson"
    },
    {
      "source": "dax_shepard",
      "target": "talib_kweli"
    },
    {
      "source": "dax_shepard",
      "target": "erika_christensen"
    },
    {
      "source": "dax_shepard",
      "target": "johnny_knoxville"
    },
    {
      "source": "dax_shepard",
      "target": "marc_maron"
    },
    {
      "source": "dax_shepard",
      "target": "bob_mervak"
    },
    {
      "source": "dax_shepard",
      "target": "joel_mchale"
    },
    {
      "source": "dax_shepard",
      "target": "chris_hardwick"
    },
    {
      "source": "dax_shepard",
      "target": "seth_green"
    },
    {
      "source": "dax_shepard",
      "target": "katie_couric"
    },
    {
      "source": "dax_shepard",
      "target": "lauren_graham"
    },
    {
      "source": "dax_shepard",
      "target": "zach_braff"
    },
    {
      "source": "dax_shepard",
      "target": "anna_faris"
    },
    {
      "source": "dax_shepard",
      "target": "van_hunt"
    },
    {
      "source": "dax_shepard",
      "target": "ellen_degeneres"
    },
    {
      "source": "dax_shepard",
      "target": "adam_scott"
    },
    {
      "source": "dax_shepard",
      "target": "pete_wentz"
    },
    {
      "source": "dax_shepard",
      "target": "joy_bryant"
    },
    {
      "source": "amanda_hirsch",
      "target": "sam_feher"
    },
    {
      "source": "amanda_hirsch",
      "target": "mandy_moore"
    },
    {
      "source": "amanda_hirsch",
      "target": "danielle_olivera"
    },
    {
      "source": "amanda_hirsch",
      "target": "olivia_flowers"
    },
    {
      "source": "amanda_hirsch",
      "target": "rita_ora"
    },
    {
      "source": "amanda_hirsch",
      "target": "ziwe"
    },
    {
      "source": "amanda_hirsch",
      "target": "alyson_stoner"
    },
    {
      "source": "amanda_hirsch",
      "target": "jvn"
    },
    {
      "source": "amanda_hirsch",
      "target": "tyler_cameron"
    },
    {
      "source": "amanda_hirsch",
      "target": "brynn_whitfield"
    },
    {
      "source": "amanda_hirsch",
      "target": "stacy_snyder"
    },
    {
      "source": "amanda_hirsch",
      "target": "charli_d'amelio"
    },
    {
      "source": "amanda_hirsch",
      "target": "bre_tiesi"
    },
    {
      "source": "amanda_hirsch",
      "target": "bella_twins"
    },
    {
      "source": "amanda_hirsch",
      "target": "elizabeth_chambers"
    },
    {
      "source": "amanda_hirsch",
      "target": "julia_haart"
    },
    {
      "source": "amanda_hirsch",
      "target": "jared_freid"
    },
    {
      "source": "amanda_hirsch",
      "target": "molly"
    },
    {
      "source": "amanda_hirsch",
      "target": "zach"
    },
    {
      "source": "amanda_hirsch",
      "target": "erin_dana_lichy"
    },
    {
      "source": "amanda_hirsch",
      "target": "cody_rigsby"
    },
    {
      "source": "amanda_hirsch",
      "target": "angie_pumps_sullivan"
    },
    {
      "source": "amanda_hirsch",
      "target": "jennifer_welch"
    },
    {
      "source": "amanda_hirsch",
      "target": "fortune_feimster"
    },
    {
      "source": "amanda_hirsch",
      "target": "bethenny_frankel"
    },
    {
      "source": "amanda_hirsch",
      "target": "maria_menounos"
    },
    {
      "source": "amanda_hirsch",
      "target": "eva_longoria"
    },
    {
      "source": "amanda_hirsch",
      "target": "jemima_kirke"
    },
    {
      "source": "amanda_hirsch",
      "target": "chrisell_stause"
    },
    {
      "source": "amanda_hirsch",
      "target": "lilly_singh"
    },
    {
      "source": "amanda_hirsch",
      "target": "andy_cohen"
    },
    {
      "source": "amanda_hirsch",
      "target": "zoe_lister_jones"
    },
    {
      "source": "amanda_hirsch",
      "target": "katie_maloney"
    },
    {
      "source": "amanda_hirsch",
      "target": "lindsay_hubbard"
    },
    {
      "source": "amanda_hirsch",
      "target": "carl_radke"
    },
    {
      "source": "amanda_hirsch",
      "target": "charlotte_lawrence"
    },
    {
      "source": "amanda_hirsch",
      "target": "mae_whitman"
    },
    {
      "source": "amanda_hirsch",
      "target": "sarah_shahi"
    },
    {
      "source": "amanda_hirsch",
      "target": "zach_braff"
    },
    {
      "source": "amanda_hirsch",
      "target": "sarah_michelle_gellar"
    },
    {
      "source": "amanda_hirsch",
      "target": "brianne_howey"
    },
    {
      "source": "amanda_hirsch",
      "target": "steve_howey"
    },
    {
      "source": "amanda_hirsch",
      "target": "ava_max"
    },
    {
      "source": "amanda_hirsch",
      "target": "sarah_lampert"
    },
    {
      "source": "amanda_hirsch",
      "target": "bill_lawrence"
    },
    {
      "source": "amanda_hirsch",
      "target": "christa_miller"
    },
    {
      "source": "amanda_hirsch",
      "target": "kaitlyn_bristowe"
    },
    {
      "source": "amanda_hirsch",
      "target": "robert_brotherton"
    },
    {
      "source": "amanda_hirsch",
      "target": "ra\u2019ed_saade"
    },
    {
      "source": "amanda_hirsch",
      "target": "remi_bader"
    },
    {
      "source": "amanda_hirsch",
      "target": "simon_huck"
    },
    {
      "source": "amanda_hirsch",
      "target": "idina_menzel"
    },
    {
      "source": "amanda_hirsch",
      "target": "amanda_kloots"
    },
    {
      "source": "amanda_hirsch",
      "target": "cole_barnett"
    },
    {
      "source": "amanda_hirsch",
      "target": "karamo_brown"
    },
    {
      "source": "amanda_hirsch",
      "target": "olivia_culpo"
    },
    {
      "source": "amanda_hirsch",
      "target": "tembi_locke"
    },
    {
      "source": "amanda_hirsch",
      "target": "amy_loughren"
    },
    {
      "source": "amanda_hirsch",
      "target": "ashley_tisdale"
    },
    {
      "source": "amanda_hirsch",
      "target": "jackson_white"
    },
    {
      "source": "amanda_hirsch",
      "target": "kelly_ripa"
    },
    {
      "source": "amanda_hirsch",
      "target": "stassi_schroeder"
    },
    {
      "source": "amanda_hirsch",
      "target": "kourtney_kardashian"
    },
    {
      "source": "amanda_hirsch",
      "target": "arielle_vandenberg"
    },
    {
      "source": "amanda_hirsch",
      "target": "meghan_trainor"
    },
    {
      "source": "amanda_hirsch",
      "target": "clayton_echard"
    },
    {
      "source": "amanda_hirsch",
      "target": "audrina_patridge"
    },
    {
      "source": "amanda_hirsch",
      "target": "aj_mclean"
    },
    {
      "source": "amanda_hirsch",
      "target": "kristin_cavallari"
    },
    {
      "source": "amanda_hirsch",
      "target": "hannah_berner"
    },
    {
      "source": "amanda_hirsch",
      "target": "busy_philipps"
    },
    {
      "source": "amanda_hirsch",
      "target": "heather_mcmahan"
    },
    {
      "source": "amanda_hirsch",
      "target": "leah_mcsweeney"
    },
    {
      "source": "amanda_hirsch",
      "target": "khlo\u00e9_kardashian"
    },
    {
      "source": "amanda_hirsch",
      "target": "emily_baker"
    },
    {
      "source": "amanda_hirsch",
      "target": "jenny_mollen"
    },
    {
      "source": "amanda_hirsch",
      "target": "mya_allen"
    },
    {
      "source": "amanda_hirsch",
      "target": "kim_kardashian"
    },
    {
      "source": "amanda_hirsch",
      "target": "the_birds_papaya"
    },
    {
      "source": "amanda_hirsch",
      "target": "jason_tartick"
    },
    {
      "source": "amanda_hirsch",
      "target": "pete__arielle_hirsch"
    },
    {
      "source": "amanda_hirsch",
      "target": "mrs_dow_jones"
    },
    {
      "source": "amanda_hirsch",
      "target": "scheana_shay"
    },
    {
      "source": "amanda_hirsch",
      "target": "julia_fox"
    },
    {
      "source": "amanda_hirsch",
      "target": "jamie_lynn"
    },
    {
      "source": "amanda_hirsch",
      "target": "davina_potratz"
    },
    {
      "source": "amanda_hirsch",
      "target": "emma_hernan"
    },
    {
      "source": "amanda_hirsch",
      "target": "lala_kent"
    },
    {
      "source": "amanda_hirsch",
      "target": "justin_anderson"
    },
    {
      "source": "amanda_hirsch",
      "target": "pete_davidson"
    },
    {
      "source": "amanda_hirsch",
      "target": "alyssa_amoroso"
    },
    {
      "source": "amanda_hirsch",
      "target": "jared_lipscomb"
    },
    {
      "source": "amanda_hirsch",
      "target": "maddison_brown"
    },
    {
      "source": "amanda_hirsch",
      "target": "addison_rae"
    },
    {
      "source": "amanda_hirsch",
      "target": "jade_roper_tolbert"
    },
    {
      "source": "amanda_hirsch",
      "target": "mystic_michaela"
    },
    {
      "source": "amanda_hirsch",
      "target": "kamanda"
    },
    {
      "source": "amanda_hirsch",
      "target": "bat_sheva_haart"
    },
    {
      "source": "amanda_hirsch",
      "target": "sami_sage"
    },
    {
      "source": "amanda_hirsch",
      "target": "nick_viall"
    },
    {
      "source": "amanda_hirsch",
      "target": "loren_brovarnik"
    },
    {
      "source": "amanda_hirsch",
      "target": "chrishell_stause"
    },
    {
      "source": "amanda_hirsch",
      "target": "andrea_lavinthal"
    },
    {
      "source": "amanda_hirsch",
      "target": "andrea_lopez"
    },
    {
      "source": "amanda_hirsch",
      "target": "pia_baroncini"
    },
    {
      "source": "amanda_hirsch",
      "target": "jackie_schimmel"
    },
    {
      "source": "amanda_hirsch",
      "target": "claire_holt"
    },
    {
      "source": "amanda_hirsch",
      "target": "erin_foster"
    },
    {
      "source": "amanda_hirsch",
      "target": "sara_foster"
    },
    {
      "source": "amanda_hirsch",
      "target": "comments_by_celebs"
    },
    {
      "source": "amanda_hirsch",
      "target": "justin_sylvester"
    },
    {
      "source": "amanda_hirsch",
      "target": "paige_desorbo"
    },
    {
      "source": "amanda_hirsch",
      "target": "victoria_larson"
    },
    {
      "source": "amanda_hirsch",
      "target": "carole_radziwill"
    },
    {
      "source": "amanda_hirsch",
      "target": "jackie_goldschneider"
    },
    {
      "source": "amanda_hirsch",
      "target": "chris_burns"
    },
    {
      "source": "amanda_hirsch",
      "target": "craig_conover"
    },
    {
      "source": "amanda_hirsch",
      "target": "violet_benson"
    },
    {
      "source": "amanda_hirsch",
      "target": "bekah_martinez"
    },
    {
      "source": "amanda_hirsch",
      "target": "taylor_strecker"
    },
    {
      "source": "amanda_hirsch",
      "target": "lilliana_vazquez"
    },
    {
      "source": "amanda_hirsch",
      "target": "shannon_ford"
    },
    {
      "source": "amanda_hirsch",
      "target": "blake_horstmann"
    },
    {
      "source": "amanda_hirsch",
      "target": "heather_rae_young"
    },
    {
      "source": "amanda_hirsch",
      "target": "tarek_el_moussa"
    },
    {
      "source": "amanda_hirsch",
      "target": "dylan_barbour"
    },
    {
      "source": "amanda_hirsch",
      "target": "reality_steve"
    },
    {
      "source": "amanda_hirsch",
      "target": "deuxmoi"
    },
    {
      "source": "amanda_hirsch",
      "target": "kate_casey"
    },
    {
      "source": "amanda_hirsch",
      "target": "ashley_i"
    },
    {
      "source": "amanda_hirsch",
      "target": "countess_luann_de_lesseps"
    },
    {
      "source": "amanda_hirsch",
      "target": "christine_quinn"
    },
    {
      "source": "amanda_hirsch",
      "target": "maya_vander"
    },
    {
      "source": "amanda_hirsch",
      "target": "francesca_farago"
    },
    {
      "source": "amanda_hirsch",
      "target": "mary_fitzgerald"
    },
    {
      "source": "amanda_hirsch",
      "target": "heather_mcdonald"
    },
    {
      "source": "amanda_hirsch",
      "target": "danica_dow"
    },
    {
      "source": "amanda_hirsch",
      "target": "luke_gulbranson"
    },
    {
      "source": "amanda_hirsch",
      "target": "katie_maloney"
    },
    {
      "source": "amanda_hirsch",
      "target": "daryn_carp"
    },
    {
      "source": "amanda_hirsch",
      "target": "perez_hilton"
    },
    {
      "source": "amanda_hirsch",
      "target": "jared_freid"
    },
    {
      "source": "amanda_hirsch",
      "target": "hannah_berner"
    },
    {
      "source": "amanda_hirsch",
      "target": "what_do_j.lo"
    },
    {
      "source": "amanda_hirsch",
      "target": "chris_appleton"
    },
    {
      "source": "amanda_hirsch",
      "target": "jackie"
    },
    {
      "source": "amanda_hirsch",
      "target": "the_daily_dish"
    },
    {
      "source": "amanda_hirsch",
      "target": "scheana_shay"
    },
    {
      "source": "amanda_hirsch",
      "target": "katie_maloney"
    },
    {
      "source": "amanda_hirsch",
      "target": "diana_espir"
    },
    {
      "source": "amanda_hirsch",
      "target": "bravo_historian"
    },
    {
      "source": "amanda_hirsch",
      "target": "justine_marjan"
    },
    {
      "source": "amanda_hirsch",
      "target": "rachael_o'brien"
    },
    {
      "source": "amanda_hirsch",
      "target": "danny_pellegrino"
    },
    {
      "source": "amanda_hirsch",
      "target": "anthony_lario"
    },
    {
      "source": "amanda_hirsch",
      "target": "katie_maloney"
    },
    {
      "source": "amanda_hirsch",
      "target": "enty_lawyer"
    },
    {
      "source": "amanda_hirsch",
      "target": "kelly_keegs"
    },
    {
      "source": "gary_brecka",
      "target": "gary_brecka"
    },
    {
      "source": "gary_brecka",
      "target": "gabrielle_lyon"
    },
    {
      "source": "gary_brecka",
      "target": "paul_barattiero"
    },
    {
      "source": "gary_brecka",
      "target": "carrie_carda_md"
    },
    {
      "source": "gary_brecka",
      "target": "jigar_gandhi"
    },
    {
      "source": "gary_brecka",
      "target": "cedric_gervais"
    },
    {
      "source": "gary_brecka",
      "target": "jeff_davidson"
    },
    {
      "source": "gary_brecka",
      "target": "steve_harvey"
    },
    {
      "source": "gary_brecka",
      "target": "steve_aoki"
    },
    {
      "source": "gary_brecka",
      "target": "stephen_a._smith"
    },
    {
      "source": "gary_brecka",
      "target": "david_grutman"
    },
    {
      "source": "gary_brecka",
      "target": "dana_white"
    },
    {
      "source": "patrick_bet-david",
      "target": "adam_sosnick"
    },
    {
      "source": "patrick_bet-david",
      "target": "tom_ellsworth"
    },
    {
      "source": "patrick_bet-david",
      "target": "incent_oshana"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_abramson"
    },
    {
      "source": "patrick_bet-david",
      "target": "bassem_youssef"
    },
    {
      "source": "patrick_bet-david",
      "target": "alina_habba"
    },
    {
      "source": "patrick_bet-david",
      "target": "colby_covington"
    },
    {
      "source": "patrick_bet-david",
      "target": "emily_austin"
    },
    {
      "source": "patrick_bet-david",
      "target": "kamaru_usman"
    },
    {
      "source": "patrick_bet-david",
      "target": "@realcharliekirk"
    },
    {
      "source": "patrick_bet-david",
      "target": "vivek_ramaswamy"
    },
    {
      "source": "patrick_bet-david",
      "target": "mar_mari_emmanuel"
    },
    {
      "source": "patrick_bet-david",
      "target": "george_janko"
    },
    {
      "source": "patrick_bet-david",
      "target": "chris_cuomo"
    },
    {
      "source": "patrick_bet-david",
      "target": "jeremy_boreing"
    },
    {
      "source": "patrick_bet-david",
      "target": "roger_stone"
    },
    {
      "source": "patrick_bet-david",
      "target": "judge_joe_brown"
    },
    {
      "source": "patrick_bet-david",
      "target": "terrell_owens"
    },
    {
      "source": "patrick_bet-david",
      "target": "ron_desantis"
    },
    {
      "source": "patrick_bet-david",
      "target": "ana_kasparian"
    },
    {
      "source": "patrick_bet-david",
      "target": "nouriel_roubini"
    },
    {
      "source": "patrick_bet-david",
      "target": "bob_woodson"
    },
    {
      "source": "patrick_bet-david",
      "target": "mike_baker"
    },
    {
      "source": "patrick_bet-david",
      "target": "charlie_kirk"
    },
    {
      "source": "patrick_bet-david",
      "target": "roseanne_barr"
    },
    {
      "source": "patrick_bet-david",
      "target": "tim_pool"
    },
    {
      "source": "patrick_bet-david",
      "target": "jimmy_dore"
    },
    {
      "source": "patrick_bet-david",
      "target": "ann_coulter"
    },
    {
      "source": "patrick_bet-david",
      "target": "liz_wheeler"
    },
    {
      "source": "patrick_bet-david",
      "target": "steve_schmidt"
    },
    {
      "source": "patrick_bet-david",
      "target": "kari_lake"
    },
    {
      "source": "patrick_bet-david",
      "target": "religious_roundtable"
    },
    {
      "source": "patrick_bet-david",
      "target": "russell_brand"
    },
    {
      "source": "patrick_bet-david",
      "target": "candace_owens"
    },
    {
      "source": "patrick_bet-david",
      "target": "larry_elder"
    },
    {
      "source": "patrick_bet-david",
      "target": "general_michael_flynn"
    },
    {
      "source": "patrick_bet-david",
      "target": "brian"
    },
    {
      "source": "patrick_bet-david",
      "target": "ed_krassenstein"
    },
    {
      "source": "patrick_bet-david",
      "target": "glenn_greenwald"
    },
    {
      "source": "patrick_bet-david",
      "target": "khabib_nurmagomedov"
    },
    {
      "source": "patrick_bet-david",
      "target": "avi_loeb"
    },
    {
      "source": "patrick_bet-david",
      "target": "francis_suarez"
    },
    {
      "source": "patrick_bet-david",
      "target": "graham_stephen"
    },
    {
      "source": "patrick_bet-david",
      "target": "cenk_uygur"
    },
    {
      "source": "patrick_bet-david",
      "target": "dave_smith"
    },
    {
      "source": "patrick_bet-david",
      "target": "anthony_weiner"
    },
    {
      "source": "patrick_bet-david",
      "target": "dave_rubin"
    },
    {
      "source": "patrick_bet-david",
      "target": "lauren_chen"
    },
    {
      "source": "patrick_bet-david",
      "target": "col._douglas_macgregor"
    },
    {
      "source": "patrick_bet-david",
      "target": "alex_jones"
    },
    {
      "source": "patrick_bet-david",
      "target": "konstantin_kisin"
    },
    {
      "source": "patrick_bet-david",
      "target": "peter_navarro"
    },
    {
      "source": "patrick_bet-david",
      "target": "patrick_bet-david"
    },
    {
      "source": "patrick_bet-david",
      "target": "maajid_nawaz"
    },
    {
      "source": "patrick_bet-david",
      "target": "elizabeth_pipko"
    },
    {
      "source": "patrick_bet-david",
      "target": "clay_travis"
    },
    {
      "source": "patrick_bet-david",
      "target": "buck_sexton"
    },
    {
      "source": "patrick_bet-david",
      "target": "mike_baker"
    },
    {
      "source": "patrick_bet-david",
      "target": "bjorn_lomborg"
    },
    {
      "source": "patrick_bet-david",
      "target": "allen_west"
    },
    {
      "source": "patrick_bet-david",
      "target": "frank_rodriguez"
    },
    {
      "source": "patrick_bet-david",
      "target": "barry_habib"
    },
    {
      "source": "patrick_bet-david",
      "target": "tucker_carlson"
    },
    {
      "source": "patrick_bet-david",
      "target": "ed_dowd"
    },
    {
      "source": "patrick_bet-david",
      "target": "steven_crowder"
    },
    {
      "source": "patrick_bet-david",
      "target": "yeonmi_park"
    },
    {
      "source": "patrick_bet-david",
      "target": "marian_tupy"
    },
    {
      "source": "patrick_bet-david",
      "target": "david_pakman"
    },
    {
      "source": "patrick_bet-david",
      "target": "kevin_o'leary"
    },
    {
      "source": "patrick_bet-david",
      "target": "bret_weinstein"
    },
    {
      "source": "patrick_bet-david",
      "target": "bryan_callen"
    },
    {
      "source": "patrick_bet-david",
      "target": "dennis_prager"
    },
    {
      "source": "patrick_bet-david",
      "target": "home_team"
    },
    {
      "source": "patrick_bet-david",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "patrick_bet-david",
      "target": "reza_aslan"
    },
    {
      "source": "patrick_bet-david",
      "target": "sam_sorbo"
    },
    {
      "source": "patrick_bet-david",
      "target": "destiny"
    },
    {
      "source": "patrick_bet-david",
      "target": "kyle_kulinski"
    },
    {
      "source": "patrick_bet-david",
      "target": "david_rubenstein"
    },
    {
      "source": "patrick_bet-david",
      "target": "bas_rutten"
    },
    {
      "source": "patrick_bet-david",
      "target": "michael_saylor"
    },
    {
      "source": "patrick_bet-david",
      "target": "andrew_schulz"
    },
    {
      "source": "patrick_bet-david",
      "target": "ari_fleischer"
    },
    {
      "source": "patrick_bet-david",
      "target": "kevin_sorbo"
    },
    {
      "source": "patrick_bet-david",
      "target": "mike_rowepatrick_bet-david"
    },
    {
      "source": "patrick_bet-david",
      "target": "rod_blagojevich"
    },
    {
      "source": "patrick_bet-david",
      "target": "dinesh_d'souza"
    },
    {
      "source": "patrick_bet-david",
      "target": "doug_ellin"
    },
    {
      "source": "patrick_bet-david",
      "target": "whitney_webb"
    },
    {
      "source": "patrick_bet-david",
      "target": "chet_hanx"
    },
    {
      "source": "patrick_bet-david",
      "target": "katie_hopkins"
    },
    {
      "source": "patrick_bet-david",
      "target": "curt_schilling"
    },
    {
      "source": "patrick_bet-david",
      "target": "lt._col._stuart_scheller"
    },
    {
      "source": "patrick_bet-david",
      "target": "nazanin_nour"
    },
    {
      "source": "patrick_bet-david",
      "target": "mike_rinder"
    },
    {
      "source": "patrick_bet-david",
      "target": "philip_mudd"
    },
    {
      "source": "patrick_bet-david",
      "target": "stuart_kaplan"
    },
    {
      "source": "patrick_bet-david",
      "target": "ricardo_aguilar"
    },
    {
      "source": "patrick_bet-david",
      "target": "scott_perry"
    },
    {
      "source": "patrick_bet-david",
      "target": "the_hodgetwins"
    },
    {
      "source": "patrick_bet-david",
      "target": "kerry_killinger"
    },
    {
      "source": "patrick_bet-david",
      "target": "papa_john"
    },
    {
      "source": "patrick_bet-david",
      "target": "richard_gage"
    },
    {
      "source": "patrick_bet-david",
      "target": "andrew_tate"
    },
    {
      "source": "patrick_bet-david",
      "target": "shaq"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_anderson"
    },
    {
      "source": "patrick_bet-david",
      "target": "adam_sosnick"
    },
    {
      "source": "patrick_bet-david",
      "target": "tom_ellsworth"
    },
    {
      "source": "patrick_bet-david",
      "target": "vincent_oshana"
    },
    {
      "source": "patrick_bet-david",
      "target": "andrew_bustamante"
    },
    {
      "source": "patrick_bet-david",
      "target": "father_vincent_lampert"
    },
    {
      "source": "patrick_bet-david",
      "target": "ben_carson"
    },
    {
      "source": "patrick_bet-david",
      "target": "royce_white"
    },
    {
      "source": "patrick_bet-david",
      "target": "zuby"
    },
    {
      "source": "patrick_bet-david",
      "target": "joe_walsh"
    },
    {
      "source": "patrick_bet-david",
      "target": "mat_best"
    },
    {
      "source": "patrick_bet-david",
      "target": "batya_ungar-sargon"
    },
    {
      "source": "patrick_bet-david",
      "target": "patrick_moore"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_paul_mac_issac"
    },
    {
      "source": "patrick_bet-david",
      "target": "rick_sanchez"
    },
    {
      "source": "patrick_bet-david",
      "target": "jedediah_bila"
    },
    {
      "source": "patrick_bet-david",
      "target": "ric_prado"
    },
    {
      "source": "patrick_bet-david",
      "target": "gad_saad"
    },
    {
      "source": "patrick_bet-david",
      "target": "michael_franzese"
    },
    {
      "source": "patrick_bet-david",
      "target": "catalina_lauf"
    },
    {
      "source": "patrick_bet-david",
      "target": "richard_werner"
    },
    {
      "source": "patrick_bet-david",
      "target": "peter_pry"
    },
    {
      "source": "patrick_bet-david",
      "target": "georges_st._pierre"
    },
    {
      "source": "patrick_bet-david",
      "target": "matt_walton"
    },
    {
      "source": "patrick_bet-david",
      "target": "roger_reaves"
    },
    {
      "source": "patrick_bet-david",
      "target": "paul_manafort"
    },
    {
      "source": "patrick_bet-david",
      "target": "diamond_dallas_page"
    },
    {
      "source": "patrick_bet-david",
      "target": "rick_macci"
    },
    {
      "source": "patrick_bet-david",
      "target": "tony_hinchcliffe"
    },
    {
      "source": "patrick_bet-david",
      "target": "ethan_suplee"
    },
    {
      "source": "patrick_bet-david",
      "target": "david_berlinski"
    },
    {
      "source": "patrick_bet-david",
      "target": "jo_jorgensen"
    },
    {
      "source": "patrick_bet-david",
      "target": "andrew_yang"
    },
    {
      "source": "patrick_bet-david",
      "target": "francis_ngannou"
    },
    {
      "source": "patrick_bet-david",
      "target": "kevin_farley"
    },
    {
      "source": "patrick_bet-david",
      "target": "ken_goldin"
    },
    {
      "source": "patrick_bet-david",
      "target": "will_witt"
    },
    {
      "source": "patrick_bet-david",
      "target": "leon_cooperman"
    },
    {
      "source": "patrick_bet-david",
      "target": "chris_hansen"
    },
    {
      "source": "patrick_bet-david",
      "target": "oliver_stone"
    },
    {
      "source": "patrick_bet-david",
      "target": "peter_mccullough"
    },
    {
      "source": "patrick_bet-david",
      "target": "jack_barsky"
    },
    {
      "source": "patrick_bet-david",
      "target": "gianni_russo"
    },
    {
      "source": "patrick_bet-david",
      "target": "jason_miller"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_perkins"
    },
    {
      "source": "patrick_bet-david",
      "target": "rollo_tomassi"
    },
    {
      "source": "patrick_bet-david",
      "target": "jordan_peterson"
    },
    {
      "source": "patrick_bet-david",
      "target": "mike_ritland"
    },
    {
      "source": "patrick_bet-david",
      "target": "johann_hari"
    },
    {
      "source": "patrick_bet-david",
      "target": "james_o'keefe"
    },
    {
      "source": "patrick_bet-david",
      "target": "christina_pushaw"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_stossel"
    },
    {
      "source": "patrick_bet-david",
      "target": "danielle_dimartino_booth"
    },
    {
      "source": "patrick_bet-david",
      "target": "rashad_evans"
    },
    {
      "source": "patrick_bet-david",
      "target": "seth_dillon"
    },
    {
      "source": "patrick_bet-david",
      "target": "nic_mckinley"
    },
    {
      "source": "patrick_bet-david",
      "target": "robert_malone"
    },
    {
      "source": "patrick_bet-david",
      "target": "brendan_schaub"
    },
    {
      "source": "patrick_bet-david",
      "target": "danielle_dimartino-booth"
    },
    {
      "source": "patrick_bet-david",
      "target": "john_e._deaton"
    },
    {
      "source": "patrick_bet-david",
      "target": "matt_zeller"
    },
    {
      "source": "patrick_bet-david",
      "target": "e.b._tucker"
    },
    {
      "source": "patrick_bet-david",
      "target": "kurt_wuckert_jr."
    },
    {
      "source": "patrick_bet-david",
      "target": "alec_baldwin"
    },
    {
      "source": "patrick_bet-david",
      "target": "tu_lam"
    },
    {
      "source": "patrick_bet-david",
      "target": "sammy_the_bull_gravano"
    },
    {
      "source": "patrick_bet-david",
      "target": "chazz_palminteri"
    },
    {
      "source": "patrick_bet-david",
      "target": "david_harris_jr."
    },
    {
      "source": "patrick_bet-david",
      "target": "general_spalding"
    },
    {
      "source": "patrick_bet-david",
      "target": "phil_heath"
    },
    {
      "source": "patrick_bet-david",
      "target": "meet_kevin"
    },
    {
      "source": "patrick_bet-david",
      "target": "bernard_kerik"
    },
    {
      "source": "patrick_bet-david",
      "target": "major_williams"
    },
    {
      "source": "patrick_bet-david",
      "target": "matt_sapaula"
    },
    {
      "source": "patrick_bet-david",
      "target": "bet-david_podcast"
    },
    {
      "source": "patrick_bet-david",
      "target": "patrick"
    },
    {
      "source": "patrick_bet-david",
      "target": "donald_trump"
    },
    {
      "source": "patrick_bet-david",
      "target": "steve_murphy"
    },
    {
      "source": "patrick_bet-david",
      "target": "robert_kiyosaki"
    },
    {
      "source": "patrick_bet-david",
      "target": "jerah_hutchins"
    },
    {
      "source": "lex_fridman",
      "target": "matthew_cox"
    },
    {
      "source": "lex_fridman",
      "target": "teddy_atlas"
    },
    {
      "source": "lex_fridman",
      "target": "jeff_bezos"
    },
    {
      "source": "lex_fridman",
      "target": "lee_cronin"
    },
    {
      "source": "lex_fridman",
      "target": "lisa_randall"
    },
    {
      "source": "lex_fridman",
      "target": "michael_malice"
    },
    {
      "source": "lex_fridman",
      "target": "john_mearsheimer"
    },
    {
      "source": "lex_fridman",
      "target": "elon_musk"
    },
    {
      "source": "lex_fridman",
      "target": "jared_kushner"
    },
    {
      "source": "lex_fridman",
      "target": "mark_zuckerberg"
    },
    {
      "source": "lex_fridman",
      "target": "greg_lukianoff"
    },
    {
      "source": "lex_fridman",
      "target": "james_sexton"
    },
    {
      "source": "lex_fridman",
      "target": "walter_isaacson"
    },
    {
      "source": "lex_fridman",
      "target": "neri_oxman"
    },
    {
      "source": "lex_fridman",
      "target": "andrew_huberman"
    },
    {
      "source": "lex_fridman",
      "target": "joscha_bach"
    },
    {
      "source": "lex_fridman",
      "target": "mohammed_el-kurd"
    },
    {
      "source": "lex_fridman",
      "target": "yuval_noah_harari"
    },
    {
      "source": "lex_fridman",
      "target": "benjamin_netanyahu"
    },
    {
      "source": "lex_fridman",
      "target": "robert_f._kennedy_jr"
    },
    {
      "source": "lex_fridman",
      "target": "george_hotz"
    },
    {
      "source": "lex_fridman",
      "target": "marc_andreessen"
    },
    {
      "source": "lex_fridman",
      "target": "jimmy_wales"
    },
    {
      "source": "lex_fridman",
      "target": "matthew_mcconaughey"
    },
    {
      "source": "lex_fridman",
      "target": "bert_kreischer"
    },
    {
      "source": "lex_fridman",
      "target": "chris_lattner"
    },
    {
      "source": "lex_fridman",
      "target": "neil_gershenfeld"
    },
    {
      "source": "lex_fridman",
      "target": "randall_kennedy"
    },
    {
      "source": "lex_fridman",
      "target": "anna_frebel"
    },
    {
      "source": "lex_fridman",
      "target": "harvey_silverglate"
    },
    {
      "source": "lex_fridman",
      "target": "stephen_wolfram"
    },
    {
      "source": "lex_fridman",
      "target": "david_pakman"
    },
    {
      "source": "lex_fridman",
      "target": "robert_playter"
    },
    {
      "source": "lex_fridman",
      "target": "manolis_kellis"
    },
    {
      "source": "lex_fridman",
      "target": "simone_giertz"
    },
    {
      "source": "lex_fridman",
      "target": "max_tegmark"
    },
    {
      "source": "lex_fridman",
      "target": "edward_frenkel"
    },
    {
      "source": "lex_fridman",
      "target": "paul_rosolie"
    },
    {
      "source": "lex_fridman",
      "target": "eliezer_yudkowsky"
    },
    {
      "source": "lex_fridman",
      "target": "sam_altman"
    },
    {
      "source": "lex_fridman",
      "target": "shannon_curry"
    },
    {
      "source": "lex_fridman",
      "target": "sam_harris"
    },
    {
      "source": "lex_fridman",
      "target": "chris_voss"
    },
    {
      "source": "lex_fridman",
      "target": "ginni_rometty"
    },
    {
      "source": "lex_fridman",
      "target": "aaron_smith-levin"
    },
    {
      "source": "lex_fridman",
      "target": "tim_urban"
    },
    {
      "source": "lex_fridman",
      "target": "andrew_strominger"
    },
    {
      "source": "lex_fridman",
      "target": "aella"
    },
    {
      "source": "lex_fridman",
      "target": "paul_conti"
    },
    {
      "source": "lex_fridman",
      "target": "tim_dodd"
    },
    {
      "source": "lex_fridman",
      "target": "david_kipping"
    },
    {
      "source": "lex_fridman",
      "target": "jeremi_suri"
    },
    {
      "source": "lex_fridman",
      "target": "dennis_whyte"
    },
    {
      "source": "lex_fridman",
      "target": "omar_suleiman"
    },
    {
      "source": "lex_fridman",
      "target": "mrbeast"
    },
    {
      "source": "lex_fridman",
      "target": "bet\u00fcl_ka\u00e7ar"
    },
    {
      "source": "lex_fridman",
      "target": "bhaskar_sunkara"
    },
    {
      "source": "lex_fridman",
      "target": "nathalie_cabrol"
    },
    {
      "source": "lex_fridman",
      "target": "ed_calderon"
    },
    {
      "source": "lex_fridman",
      "target": "coffeezilla"
    },
    {
      "source": "lex_fridman",
      "target": "noam_brown"
    },
    {
      "source": "lex_fridman",
      "target": "roger_gracie"
    },
    {
      "source": "lex_fridman",
      "target": "todd_howard"
    },
    {
      "source": "lex_fridman",
      "target": "guido_van_rossum"
    },
    {
      "source": "lex_fridman",
      "target": "chris_tarbell"
    },
    {
      "source": "lex_fridman",
      "target": "chamath_palihapitiya"
    },
    {
      "source": "lex_fridman",
      "target": "destiny"
    },
    {
      "source": "lex_fridman",
      "target": "ben_shapiro"
    },
    {
      "source": "lex_fridman",
      "target": "fiona_hill"
    },
    {
      "source": "lex_fridman",
      "target": "abbas_amanat"
    },
    {
      "source": "lex_fridman",
      "target": "andrej_karpathy"
    },
    {
      "source": "lex_fridman",
      "target": "kanye_'ye'_west"
    },
    {
      "source": "lex_fridman",
      "target": "balaji_srinivasan"
    },
    {
      "source": "lex_fridman",
      "target": "hikaru_nakamura"
    },
    {
      "source": "lex_fridman",
      "target": "kate_darling"
    },
    {
      "source": "lex_fridman",
      "target": "john_danaher"
    },
    {
      "source": "lex_fridman",
      "target": "gothamchess"
    },
    {
      "source": "lex_fridman",
      "target": "annaka_harris"
    },
    {
      "source": "lex_fridman",
      "target": "michael_levin"
    },
    {
      "source": "lex_fridman",
      "target": "daniel_negreanu"
    },
    {
      "source": "lex_fridman",
      "target": "will_sasso"
    },
    {
      "source": "lex_fridman",
      "target": "rana_el_kaliouby"
    },
    {
      "source": "lex_fridman",
      "target": "ray_kurzweil"
    },
    {
      "source": "lex_fridman",
      "target": "christopher_capozzola"
    },
    {
      "source": "lex_fridman",
      "target": "botez_sisters"
    },
    {
      "source": "lex_fridman",
      "target": "nick_lane"
    },
    {
      "source": "lex_fridman",
      "target": "john_vervaeke"
    },
    {
      "source": "lex_fridman",
      "target": "noam_chomsky"
    },
    {
      "source": "lex_fridman",
      "target": "magnus_carlsen"
    },
    {
      "source": "lex_fridman",
      "target": "liv_boeree"
    },
    {
      "source": "lex_fridman",
      "target": "jordan_peterson"
    },
    {
      "source": "lex_fridman",
      "target": "duncan_trussell"
    },
    {
      "source": "lex_fridman",
      "target": "magatte_wade"
    },
    {
      "source": "lex_fridman",
      "target": "brian_armstrong"
    },
    {
      "source": "lex_fridman",
      "target": "oriol_vinyals"
    },
    {
      "source": "lex_fridman",
      "target": "martin_rees"
    },
    {
      "source": "lex_fridman",
      "target": "bishop_robert_barron"
    },
    {
      "source": "lex_fridman",
      "target": "steve_keen"
    },
    {
      "source": "lex_fridman",
      "target": "richard_haier"
    },
    {
      "source": "lex_fridman",
      "target": "jack_barsky"
    },
    {
      "source": "lex_fridman",
      "target": "joe_rogan"
    },
    {
      "source": "lex_fridman",
      "target": "demis_hassabis"
    },
    {
      "source": "lex_fridman",
      "target": "susan_cain"
    },
    {
      "source": "lex_fridman",
      "target": "jonathan_reisman"
    },
    {
      "source": "lex_fridman",
      "target": "douglas_murray"
    },
    {
      "source": "lex_fridman",
      "target": "richard_wolff"
    },
    {
      "source": "lex_fridman",
      "target": "tony_fadell"
    },
    {
      "source": "lex_fridman",
      "target": "donald_hoffman"
    },
    {
      "source": "lex_fridman",
      "target": "robin_hanson"
    },
    {
      "source": "lex_fridman",
      "target": "jonathan_haidt"
    },
    {
      "source": "lex_fridman",
      "target": "dan_reynolds"
    },
    {
      "source": "lex_fridman",
      "target": "stephen_kotkin"
    },
    {
      "source": "lex_fridman",
      "target": "sarma_melngailis"
    },
    {
      "source": "lex_fridman",
      "target": "bobby_lee"
    },
    {
      "source": "lex_fridman",
      "target": "oliver_stone"
    },
    {
      "source": "lex_fridman",
      "target": "glenn_loury"
    },
    {
      "source": "lex_fridman",
      "target": "saifedean_ammous"
    },
    {
      "source": "lex_fridman",
      "target": "chris_mason"
    },
    {
      "source": "lex_fridman",
      "target": "david_buss"
    },
    {
      "source": "lex_fridman",
      "target": "grimes"
    },
    {
      "source": "lex_fridman",
      "target": "cristiano_amon"
    },
    {
      "source": "lex_fridman",
      "target": "skye_fitzgerald"
    },
    {
      "source": "lex_fridman",
      "target": "michael_saylor"
    },
    {
      "source": "lex_fridman",
      "target": "rick_rubin"
    },
    {
      "source": "lex_fridman",
      "target": "karl_deisseroth"
    },
    {
      "source": "lex_fridman",
      "target": "chris_blattman"
    },
    {
      "source": "lex_fridman",
      "target": "brett_johnson"
    },
    {
      "source": "lex_fridman",
      "target": "ariel_ekblaw"
    },
    {
      "source": "lex_fridman",
      "target": "david_wolpe"
    },
    {
      "source": "lex_fridman",
      "target": "robert_proctor"
    },
    {
      "source": "lex_fridman",
      "target": "nicole_perlroth"
    },
    {
      "source": "lex_fridman",
      "target": "devon_larratt"
    },
    {
      "source": "lex_fridman",
      "target": "john_abramson"
    },
    {
      "source": "lex_fridman",
      "target": "garry_nolan"
    },
    {
      "source": "lex_fridman",
      "target": "philip_goff"
    },
    {
      "source": "lex_fridman",
      "target": "thomas_tull"
    },
    {
      "source": "lex_fridman",
      "target": "yann_lecun"
    },
    {
      "source": "lex_fridman",
      "target": "brian_keating"
    },
    {
      "source": "lex_fridman",
      "target": "mark_normand"
    },
    {
      "source": "lex_fridman",
      "target": "jay_bhattacharya"
    },
    {
      "source": "lex_fridman",
      "target": "ray_dalio"
    },
    {
      "source": "lex_fridman",
      "target": "peter_wang"
    },
    {
      "source": "lex_fridman",
      "target": "albert_bourla"
    },
    {
      "source": "lex_fridman",
      "target": "norman_naimark"
    },
    {
      "source": "lex_fridman",
      "target": "jamie_metzl"
    },
    {
      "source": "lex_fridman",
      "target": "peter_woit"
    },
    {
      "source": "lex_fridman",
      "target": "tom_brands"
    },
    {
      "source": "lex_fridman",
      "target": "robert_crews"
    },
    {
      "source": "lex_fridman",
      "target": "kevin_systrom"
    },
    {
      "source": "lex_fridman",
      "target": "ben_askren"
    },
    {
      "source": "lex_fridman",
      "target": "boris_sofman"
    },
    {
      "source": "lex_fridman",
      "target": "neal_stephenson"
    },
    {
      "source": "lex_fridman",
      "target": "niall_ferguson"
    },
    {
      "source": "lex_fridman",
      "target": "francis_collins"
    },
    {
      "source": "lex_fridman",
      "target": "steve_viscelli"
    },
    {
      "source": "lex_fridman",
      "target": "jimmy_pedro"
    },
    {
      "source": "lex_fridman",
      "target": "michael_mina"
    },
    {
      "source": "lex_fridman",
      "target": "carl_hart"
    },
    {
      "source": "lex_fridman",
      "target": "brian_greene"
    },
    {
      "source": "lex_fridman",
      "target": "alex_gladstein"
    },
    {
      "source": "lex_fridman",
      "target": "kelsi_sheren"
    },
    {
      "source": "lex_fridman",
      "target": "richard_wrangham"
    },
    {
      "source": "lex_fridman",
      "target": "rza"
    },
    {
      "source": "lex_fridman",
      "target": "sean_kelly"
    },
    {
      "source": "lex_fridman",
      "target": "jo_boaler"
    },
    {
      "source": "lex_fridman",
      "target": "jeffrey_shainline"
    },
    {
      "source": "lex_fridman",
      "target": "travis_oliphant"
    },
    {
      "source": "lex_fridman",
      "target": "travis_stevens"
    },
    {
      "source": "lex_fridman",
      "target": "jay_mcclelland"
    },
    {
      "source": "lex_fridman",
      "target": "douglas_lenat"
    },
    {
      "source": "lex_fridman",
      "target": "niels_jorgensen"
    },
    {
      "source": "lex_fridman",
      "target": "donald_knuth"
    },
    {
      "source": "lex_fridman",
      "target": "jaron_lanier"
    },
    {
      "source": "lex_fridman",
      "target": "rodney_brooks"
    },
    {
      "source": "lex_fridman",
      "target": "vincent_racaniello"
    },
    {
      "source": "lex_fridman",
      "target": "wojciech_zaremba"
    },
    {
      "source": "lex_fridman",
      "target": "jed_buchwald"
    },
    {
      "source": "lex_fridman",
      "target": "barry_barish"
    },
    {
      "source": "lex_fridman",
      "target": "brian_muraresku"
    },
    {
      "source": "lex_fridman",
      "target": "ishan_misra"
    },
    {
      "source": "lex_fridman",
      "target": "zach_bitter"
    },
    {
      "source": "lex_fridman",
      "target": "cumrun_vafa"
    },
    {
      "source": "lex_fridman",
      "target": "anya_fernald"
    },
    {
      "source": "lex_fridman",
      "target": "rick_doblin"
    },
    {
      "source": "lex_fridman",
      "target": "konstantin_batygin"
    },
    {
      "source": "lex_fridman",
      "target": "roger_reaves"
    },
    {
      "source": "lex_fridman",
      "target": "sara_walker"
    },
    {
      "source": "lex_fridman",
      "target": "jocko_willink"
    },
    {
      "source": "lex_fridman",
      "target": "yeonmi_park"
    },
    {
      "source": "lex_fridman",
      "target": "clara_sousa-silva"
    },
    {
      "source": "lex_fridman",
      "target": "bret_weinstein"
    },
    {
      "source": "lex_fridman",
      "target": "rob_reid"
    },
    {
      "source": "lex_fridman",
      "target": "charles_hoskinson"
    },
    {
      "source": "lex_fridman",
      "target": "daniel_schmachtenberger"
    },
    {
      "source": "lex_fridman",
      "target": "jordan_ellenberg"
    },
    {
      "source": "lex_fridman",
      "target": "david_sinclair"
    },
    {
      "source": "lex_fridman",
      "target": "vitalik_buterin"
    },
    {
      "source": "lex_fridman",
      "target": "frank_wilczek"
    },
    {
      "source": "lex_fridman",
      "target": "bryan_johnson"
    },
    {
      "source": "lex_fridman",
      "target": "katherine_de_kleer"
    },
    {
      "source": "lex_fridman",
      "target": "po-shen_loh"
    },
    {
      "source": "lex_fridman",
      "target": "sergey_nazarov"
    },
    {
      "source": "lex_fridman",
      "target": "georges_st-pierre"
    },
    {
      "source": "lex_fridman",
      "target": "yaron_brook"
    },
    {
      "source": "lex_fridman",
      "target": "risto_miikkulainen"
    },
    {
      "source": "lex_fridman",
      "target": "robert_breedlove"
    },
    {
      "source": "lex_fridman",
      "target": "yannis_pappas"
    },
    {
      "source": "lex_fridman",
      "target": "tyler_cowen"
    },
    {
      "source": "lex_fridman",
      "target": "nic_carter"
    },
    {
      "source": "lex_fridman",
      "target": "ryan_schiller"
    },
    {
      "source": "lex_fridman",
      "target": "anthony_pompliano"
    },
    {
      "source": "lex_fridman",
      "target": "ronald_sullivan"
    },
    {
      "source": "lex_fridman",
      "target": "ryan_hall"
    },
    {
      "source": "lex_fridman",
      "target": "silvio_micali"
    },
    {
      "source": "lex_fridman",
      "target": "saagar_enjeti"
    },
    {
      "source": "lex_fridman",
      "target": "cal_newport"
    },
    {
      "source": "lex_fridman",
      "target": "josh_barnett"
    },
    {
      "source": "lex_fridman",
      "target": "eric_weinstein"
    },
    {
      "source": "lex_fridman",
      "target": "jim_keller"
    },
    {
      "source": "lex_fridman",
      "target": "jason_calacanis"
    },
    {
      "source": "lex_fridman",
      "target": "brendan_eich"
    },
    {
      "source": "lex_fridman",
      "target": "richard_craib"
    },
    {
      "source": "lex_fridman",
      "target": "zev_weinstein"
    },
    {
      "source": "lex_fridman",
      "target": "natalya_bailey"
    },
    {
      "source": "lex_fridman",
      "target": "tim_dillon"
    },
    {
      "source": "lex_fridman",
      "target": "lex_fridman"
    },
    {
      "source": "lex_fridman",
      "target": "avi_loeb"
    },
    {
      "source": "lex_fridman",
      "target": "dmitry_korkin"
    },
    {
      "source": "lex_fridman",
      "target": "dan_gable"
    },
    {
      "source": "lex_fridman",
      "target": "dan_kokotov"
    },
    {
      "source": "lex_fridman",
      "target": "diana_walsh_pasulka"
    },
    {
      "source": "lex_fridman",
      "target": "charles_isbell"
    },
    {
      "source": "lex_fridman",
      "target": "michael_littman"
    },
    {
      "source": "lex_fridman",
      "target": "dmitri_dolgov"
    },
    {
      "source": "lex_fridman",
      "target": "matthew_johnson"
    },
    {
      "source": "lex_fridman",
      "target": "john_clarke"
    },
    {
      "source": "lex_fridman",
      "target": "erik_brynjolfsson"
    },
    {
      "source": "lex_fridman",
      "target": "lisa_feldman_barrett"
    },
    {
      "source": "lex_fridman",
      "target": "alex_filippenko"
    },
    {
      "source": "lex_fridman",
      "target": "dan_carlin"
    },
    {
      "source": "lex_fridman",
      "target": "scott_aaronson"
    },
    {
      "source": "lex_fridman",
      "target": "james_gosling"
    },
    {
      "source": "lex_fridman",
      "target": "david_fravor"
    },
    {
      "source": "lex_fridman",
      "target": "lex_solo"
    },
    {
      "source": "lex_fridman",
      "target": "eugenia_kuyda"
    },
    {
      "source": "lex_fridman",
      "target": "francois_chollet"
    },
    {
      "source": "lex_fridman",
      "target": "david_eagleman"
    },
    {
      "source": "lex_fridman",
      "target": "grant_sanderson"
    },
    {
      "source": "lex_fridman",
      "target": "sheldon_solomon"
    },
    {
      "source": "lex_fridman",
      "target": "sara_seager"
    },
    {
      "source": "lex_fridman",
      "target": "dileep_george"
    },
    {
      "source": "lex_fridman",
      "target": "richard_karp"
    },
    {
      "source": "lex_fridman",
      "target": "jitendra_malik"
    },
    {
      "source": "lex_fridman",
      "target": "brian_kernighan"
    },
    {
      "source": "lex_fridman",
      "target": "sergey_levine"
    },
    {
      "source": "lex_fridman",
      "target": "peter_singer"
    },
    {
      "source": "lex_fridman",
      "target": "matt_botvinick"
    },
    {
      "source": "lex_fridman",
      "target": "robert_langer"
    },
    {
      "source": "lex_fridman",
      "target": "david_patterson"
    },
    {
      "source": "lex_fridman",
      "target": "ben_goertzel"
    },
    {
      "source": "lex_fridman",
      "target": "steven_pressfield"
    },
    {
      "source": "lex_fridman",
      "target": "karl_friston"
    },
    {
      "source": "lex_fridman",
      "target": "sertac_karaman"
    },
    {
      "source": "lex_fridman",
      "target": "stephen_schwarzman"
    },
    {
      "source": "lex_fridman",
      "target": "dawn_song"
    },
    {
      "source": "lex_fridman",
      "target": "ilya_sutskever"
    },
    {
      "source": "lex_fridman",
      "target": "daphne_koller"
    },
    {
      "source": "lex_fridman",
      "target": "harry_cliff"
    },
    {
      "source": "lex_fridman",
      "target": "jack_dorsey"
    },
    {
      "source": "lex_fridman",
      "target": "richard_dawkins"
    },
    {
      "source": "lex_fridman",
      "target": "david_silver"
    },
    {
      "source": "lex_fridman",
      "target": "roger_penrose"
    },
    {
      "source": "lex_fridman",
      "target": "nick_bostrom"
    },
    {
      "source": "lex_fridman",
      "target": "simon_sinek"
    },
    {
      "source": "lex_fridman",
      "target": "anca_dragan"
    },
    {
      "source": "lex_fridman",
      "target": "lee_smolin"
    },
    {
      "source": "lex_fridman",
      "target": "ann_druyan"
    },
    {
      "source": "lex_fridman",
      "target": "alex_garland"
    },
    {
      "source": "lex_fridman",
      "target": "john_hopfield"
    },
    {
      "source": "lex_fridman",
      "target": "marcus_hutter"
    },
    {
      "source": "lex_fridman",
      "target": "michael_i._jordan"
    },
    {
      "source": "lex_fridman",
      "target": "andrew_ng"
    },
    {
      "source": "lex_fridman",
      "target": "vladimir_vapnik"
    },
    {
      "source": "lex_fridman",
      "target": "david_chalmers"
    },
    {
      "source": "lex_fridman",
      "target": "cristos_goodrow"
    },
    {
      "source": "lex_fridman",
      "target": "paul_krugman"
    },
    {
      "source": "lex_fridman",
      "target": "ayanna_howard"
    },
    {
      "source": "lex_fridman",
      "target": "daniel_kahneman"
    },
    {
      "source": "lex_fridman",
      "target": "melanie_mitchell"
    },
    {
      "source": "lex_fridman",
      "target": "jim_gates"
    },
    {
      "source": "lex_fridman",
      "target": "sebastian_thrun"
    },
    {
      "source": "lex_fridman",
      "target": "michael_stevens"
    },
    {
      "source": "lex_fridman",
      "target": "rohit_prasad"
    },
    {
      "source": "lex_fridman",
      "target": "judea_pearl"
    },
    {
      "source": "lex_fridman",
      "target": "whitney_cummings"
    },
    {
      "source": "lex_fridman",
      "target": "gilbert_strang"
    },
    {
      "source": "lex_fridman",
      "target": "dava_newman"
    },
    {
      "source": "lex_fridman",
      "target": "michael_kearns"
    },
    {
      "source": "lex_fridman",
      "target": "bjarne_stroustrup"
    },
    {
      "source": "lex_fridman",
      "target": "sean_carroll"
    },
    {
      "source": "lex_fridman",
      "target": "garry_kasparov"
    },
    {
      "source": "lex_fridman",
      "target": "michio_kaku"
    },
    {
      "source": "lex_fridman",
      "target": "david_ferrucci"
    },
    {
      "source": "lex_fridman",
      "target": "gary_marcus"
    },
    {
      "source": "lex_fridman",
      "target": "peter_norvig"
    },
    {
      "source": "lex_fridman",
      "target": "leonard_susskind"
    },
    {
      "source": "lex_fridman",
      "target": "regina_barzilay"
    },
    {
      "source": "lex_fridman",
      "target": "colin_angle"
    },
    {
      "source": "lex_fridman",
      "target": "vijay_kumar"
    },
    {
      "source": "lex_fridman",
      "target": "jeremy_howard"
    },
    {
      "source": "lex_fridman",
      "target": "pamela_mccorduck"
    },
    {
      "source": "lex_fridman",
      "target": "keoki_jackson"
    },
    {
      "source": "lex_fridman",
      "target": "paola_arlotta"
    },
    {
      "source": "lex_fridman",
      "target": "kevin_scott"
    },
    {
      "source": "lex_fridman",
      "target": "gustav_soderstrom"
    },
    {
      "source": "lex_fridman",
      "target": "chris_urmson"
    },
    {
      "source": "lex_fridman",
      "target": "kai-fu_lee"
    },
    {
      "source": "lex_fridman",
      "target": "jeff_hawkins"
    },
    {
      "source": "lex_fridman",
      "target": "rosalind_picard"
    },
    {
      "source": "lex_fridman",
      "target": "gavin_miller"
    },
    {
      "source": "lex_fridman",
      "target": "rajat_monga"
    },
    {
      "source": "lex_fridman",
      "target": "ian_goodfellow"
    },
    {
      "source": "lex_fridman",
      "target": "greg_brockman"
    },
    {
      "source": "lex_fridman",
      "target": "leslie_kaelbling"
    },
    {
      "source": "lex_fridman",
      "target": "kyle_vogt"
    },
    {
      "source": "lex_fridman",
      "target": "tomaso_poggio"
    },
    {
      "source": "lex_fridman",
      "target": "tuomas_sandholm"
    },
    {
      "source": "lex_fridman",
      "target": "juergen_schmidhuber"
    },
    {
      "source": "lex_fridman",
      "target": "pieter_abbeel"
    },
    {
      "source": "lex_fridman",
      "target": "stuart_russell"
    },
    {
      "source": "lex_fridman",
      "target": "eric_schmidt"
    },
    {
      "source": "lex_fridman",
      "target": "jeff_atwood"
    },
    {
      "source": "lex_fridman",
      "target": "yoshua_bengio"
    },
    {
      "source": "lex_fridman",
      "target": "steven_pinker"
    },
    {
      "source": "lex_fridman",
      "target": "christof_koch"
    },
    {
      "source": "tana_mongeau",
      "target": "brooke"
    },
    {
      "source": "tana_mongeau",
      "target": "tana"
    },
    {
      "source": "tana_mongeau",
      "target": "trisha_paytas"
    },
    {
      "source": "tana_mongeau",
      "target": "matt_rife"
    },
    {
      "source": "tana_mongeau",
      "target": "hannah_berner"
    },
    {
      "source": "tana_mongeau",
      "target": "james_charles"
    },
    {
      "source": "tana_mongeau",
      "target": "mike_majlak"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_redban"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kirk_fox"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "the_regulars"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mark_normand"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "sam_tallent"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "howie_mandel"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "stavros_halkias"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tim_dillon"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "greg_fitzsimmons"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_smith"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "steveo"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adrienne_iapalucci"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ron_white"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "pauly_shore"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "duncan_trussell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "lil'_hobo"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "yannis_pappas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ryan_sickler"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mike_feeney"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kam_patterson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david_jolly"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "suga_sean_o'malley"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_list"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kim_congdon"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jamar_neighboors"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "phil_(adam_ray)"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "sam_tallent"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ric_flair"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "shane_gillis"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mark_normand"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "luis_j_gomez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "zac_amico"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "h._foley"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kevin_ryan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "roseanne"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david_koechner"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_derosa"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david_lucas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "post_malone"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kurt_metzger"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "thai_rivera"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_moses"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "matthew_broussard"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jim_norton"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "don_barris"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "rich_vos_-_adam_ray"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "trevor_wallace"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_simpson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ali_siddiq"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tom_segura_[10_year_anniversary]"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "theo_von"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_attell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jeff_ross"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "eleanor_kerrigan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "doug_stanhope"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_holtzman"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_edwards"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "pauly_shore"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "erik_griffin"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_fidance"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joy_hinchcliffe"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adam_ray"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "sam_tallent"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "big_jay_oakerson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kevin_ryan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "h_foley"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "yannis_pappas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ron_white"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "shane_gillis"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "bert_kreischer"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "whitney_cummings"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jim_norton"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tim_dillon"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "roseanne"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "chris_distefano"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "roseanne"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_moses"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "thai_rivera"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jim_florentine"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "punkie_johnson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "eddie_pepitone"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ali_macofsky"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tom_papa"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adam_ray"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_derosa"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "andrew_santino"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_edwards"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kim_congdon"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "sarah_weinshenk"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jessie_johnson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "luna_lucas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adam_eget"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_simpson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kurt_metzger"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "deadmau5"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "george_perez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tom_segura"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ryan_long"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "chris_faga"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "big_jay_oakerson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "luis_j_gomez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_smith"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_attell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_fidance"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "erik_griffin"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "deric_poston"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ehsan_ahmad"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "hans_kim"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "william_montgomery"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david_lucas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_attell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "greg_fitzsimmons"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_fidance"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "duncan_trussell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "josh_wolf"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mike_feeney"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ron_white"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_simpson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ryan_long"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "shane_gillis"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mark_normand"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ian_fidance"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "thai_rivera"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jeff_ross"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "annie_lederman"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "erik_griffin"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mary_lynn_rajskub"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "luis_j_gomez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "aaron_berg"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "shane_gillis"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mark_normand"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "the_montgomery's"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "pauly_shore"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "fahim_anwar"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ari_shaffir"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "chris_distefano"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "deric_poston"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "gary_clark_jr"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "duncan_trussell"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "doug_stanhope"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "michael_yo"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jake_shields"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_simpson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "rachel_wolfson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mat_edgar"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "monty_franklin"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jessie_johnson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "punkie_johnson"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dicey"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "josh_barnett"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "rich_vos"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "willie_hunter"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "freddie_gibbs"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_moses"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brendon_walsh"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "matt_fulchiron"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dave_smith"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "tony_hinchcliffe"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "danny_brown"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "benji_aflalo"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ehsan_ahmad"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ryan_j_ebelt"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "david_lucas"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dylan_sullivan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "william_montgomery"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "hans_kim"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "chris_tellez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "arielle_isaac_norman"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kim_congdon"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "justin_martindale"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jamar_neighbors"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "bert_kreischer"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "dom_irerra"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "shane_gillis"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mitch_burrow"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kyle_dunnigan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "kurt_metzger"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "alex_jones"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "christina_pazsitzky"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "eleanor_kerrigan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jimmy_shubert"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_holtzman"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "michael_lehrer"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "greg_fitzsimmons"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "pauly_shore"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "josh_martin"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "luis_j_gomez"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "zac_amico"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ron_white"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "russell_peters"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jessica_michelle_singleton"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "ali_macofsky"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "mark_normand"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "derric_poston"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adam_ray"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jade_catta-preta"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "donnell_rawlings"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "adam_eget"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "sara_weinshenk"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "jamar_neighbors"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "joe_rogan"
    },
    {
      "source": "tony_hinchcliffe",
      "target": "brian_moses"
    },
    {
      "source": "tig_notaro",
      "target": "fortune_feimster"
    },
    {
      "source": "tig_notaro",
      "target": "mae_martin"
    },
    {
      "source": "tig_notaro",
      "target": "sarah_silverman"
    },
    {
      "source": "tig_notaro",
      "target": "stephanie_allynne"
    },
    {
      "source": "tig_notaro",
      "target": "nina_west"
    },
    {
      "source": "tig_notaro",
      "target": "kenan_thompson"
    },
    {
      "source": "tig_notaro",
      "target": "lance_bass"
    },
    {
      "source": "tig_notaro",
      "target": "kim_dickens"
    },
    {
      "source": "tig_notaro",
      "target": "elliot_page"
    },
    {
      "source": "tig_notaro",
      "target": "neil_patrick_harris"
    },
    {
      "source": "tig_notaro",
      "target": "natalie_maines"
    },
    {
      "source": "tig_notaro",
      "target": "lil_rel_howery"
    },
    {
      "source": "tig_notaro",
      "target": "jamie_lee_curtis"
    },
    {
      "source": "tig_notaro",
      "target": "jimmy_fallon"
    },
    {
      "source": "tig_notaro",
      "target": "jameela_jamil"
    },
    {
      "source": "tig_notaro",
      "target": "chelsea_handler"
    },
    {
      "source": "tig_notaro",
      "target": "mike_birbiglia"
    },
    {
      "source": "tig_notaro",
      "target": "bella_ramsey"
    },
    {
      "source": "tig_notaro",
      "target": "stephen_colbert"
    },
    {
      "source": "tig_notaro",
      "target": "reese_witherspoon"
    },
    {
      "source": "tig_notaro",
      "target": "ty_burrell"
    },
    {
      "source": "tig_notaro",
      "target": "gabrielle_union"
    },
    {
      "source": "tig_notaro",
      "target": "sarah_paulson"
    },
    {
      "source": "nick_viall",
      "target": "gabby_windey"
    },
    {
      "source": "nick_viall",
      "target": "nick"
    },
    {
      "source": "nick_viall",
      "target": "clayton_echard"
    },
    {
      "source": "nick_viall",
      "target": "gypsy_rose_blanchard"
    },
    {
      "source": "nick_viall",
      "target": "ryan_anderson"
    },
    {
      "source": "nick_viall",
      "target": "katie_maloney"
    },
    {
      "source": "nick_viall",
      "target": "dayna_kathan"
    },
    {
      "source": "nick_viall",
      "target": "ciara_robinson"
    },
    {
      "source": "nick_viall",
      "target": "rachel_lindsay"
    },
    {
      "source": "nick_viall",
      "target": "josh"
    },
    {
      "source": "nick_viall",
      "target": "paige_peck"
    },
    {
      "source": "nick_viall",
      "target": "lewis_howes"
    },
    {
      "source": "nick_viall",
      "target": "justin_sylvester"
    },
    {
      "source": "nick_viall",
      "target": "charli_burnett"
    },
    {
      "source": "nick_viall",
      "target": "crystal_kung_minkoff"
    },
    {
      "source": "nick_viall",
      "target": "madeleine_byrne"
    },
    {
      "source": "nick_viall",
      "target": "phalisia"
    },
    {
      "source": "nick_viall",
      "target": "susie_evans"
    },
    {
      "source": "nick_viall",
      "target": "aly"
    },
    {
      "source": "nick_viall",
      "target": "aj"
    },
    {
      "source": "nick_viall",
      "target": "wells_adams"
    },
    {
      "source": "nick_viall",
      "target": "kamie_crawford"
    },
    {
      "source": "nick_viall",
      "target": "blac_chyna_(angela_white)"
    },
    {
      "source": "nick_viall",
      "target": "brooke"
    },
    {
      "source": "nick_viall",
      "target": "aricia"
    },
    {
      "source": "nick_viall",
      "target": "nikki_glaser"
    },
    {
      "source": "nick_viall",
      "target": "emily_longeretta"
    },
    {
      "source": "nick_viall",
      "target": "eli_rallo"
    },
    {
      "source": "nick_viall",
      "target": "heather_dubrow"
    },
    {
      "source": "nick_viall",
      "target": "izzy_zapata"
    },
    {
      "source": "nick_viall",
      "target": "amy_kaufman"
    },
    {
      "source": "nick_viall",
      "target": "raven-symon"
    },
    {
      "source": "nick_viall",
      "target": "miranda_maday"
    },
    {
      "source": "nick_viall",
      "target": "rachel_recchia"
    },
    {
      "source": "nick_viall",
      "target": "dustin_lynch"
    },
    {
      "source": "nick_viall",
      "target": "tyler_cameron"
    },
    {
      "source": "nick_viall",
      "target": "savannah_chrisley"
    },
    {
      "source": "nick_viall",
      "target": "natalie_joy"
    },
    {
      "source": "nick_viall",
      "target": "justin_glaze"
    },
    {
      "source": "nick_viall",
      "target": "emma_slater"
    },
    {
      "source": "nick_viall",
      "target": "bobby_berk"
    },
    {
      "source": "nick_viall",
      "target": "jojo_siwa"
    },
    {
      "source": "nick_viall",
      "target": "andrew_spencer"
    },
    {
      "source": "nick_viall",
      "target": "gina_kirschenheiter"
    },
    {
      "source": "nick_viall",
      "target": "manon_mathews"
    },
    {
      "source": "nick_viall",
      "target": "scott_evans"
    },
    {
      "source": "nick_viall",
      "target": "marie_forleo"
    },
    {
      "source": "nick_viall",
      "target": "cathy_kelley"
    },
    {
      "source": "nick_viall",
      "target": "girls_gotta_eat"
    },
    {
      "source": "nick_viall",
      "target": "arden_myrin"
    },
    {
      "source": "nick_viall",
      "target": "justin_long"
    },
    {
      "source": "nick_viall",
      "target": "eilise_guilfoyle"
    },
    {
      "source": "nick_viall",
      "target": "danielle_fishel_karp"
    },
    {
      "source": "nick_viall",
      "target": "brad_kearns"
    },
    {
      "source": "nick_viall",
      "target": "mary_(fitzgerald)_bonnet"
    },
    {
      "source": "nick_viall",
      "target": "g_flip"
    },
    {
      "source": "nick_viall",
      "target": "kate_aurthur"
    },
    {
      "source": "nick_viall",
      "target": "anjelah_johnson-reyes"
    },
    {
      "source": "nick_viall",
      "target": "chloe_veitch"
    },
    {
      "source": "nick_viall",
      "target": "dave_holmes"
    },
    {
      "source": "nick_viall",
      "target": "barbara_corcoran"
    },
    {
      "source": "nick_viall",
      "target": "johnny_lowe"
    },
    {
      "source": "nick_viall",
      "target": "ashley_gavin"
    },
    {
      "source": "nick_viall",
      "target": "ariel_frenkel"
    },
    {
      "source": "nick_viall",
      "target": "kristen_doute"
    },
    {
      "source": "nick_viall",
      "target": "rozzi"
    },
    {
      "source": "nick_viall",
      "target": "francesca_farago"
    },
    {
      "source": "nick_viall",
      "target": "jason_ritter"
    },
    {
      "source": "nick_viall",
      "target": "raven_ross"
    },
    {
      "source": "nick_viall",
      "target": "julia_cunningham"
    },
    {
      "source": "nick_viall",
      "target": "joey_zauzig"
    },
    {
      "source": "nick_viall",
      "target": "elizabeth_wagmeister"
    },
    {
      "source": "nick_viall",
      "target": "brad_goreski"
    },
    {
      "source": "nick_viall",
      "target": "ariana_madix"
    },
    {
      "source": "nick_viall",
      "target": "lisa_schwartz"
    },
    {
      "source": "nick_viall",
      "target": "justin_baldoni"
    },
    {
      "source": "nick_viall",
      "target": "keaton_milburn"
    },
    {
      "source": "nick_viall",
      "target": "maya_shankar"
    },
    {
      "source": "nick_viall",
      "target": "heath_hussar"
    },
    {
      "source": "nick_viall",
      "target": "chloe_bale"
    },
    {
      "source": "nick_viall",
      "target": "fortune_feimster"
    },
    {
      "source": "nick_viall",
      "target": "tara_schuster"
    },
    {
      "source": "nick_viall",
      "target": "serena_kerrigan"
    },
    {
      "source": "nick_viall",
      "target": "girlbosstown"
    },
    {
      "source": "nick_viall",
      "target": "jason_nash"
    },
    {
      "source": "nick_viall",
      "target": "jake_miller"
    },
    {
      "source": "nick_viall",
      "target": "nancy"
    },
    {
      "source": "nick_viall",
      "target": "bartise"
    },
    {
      "source": "nick_viall",
      "target": "and_raven"
    },
    {
      "source": "nick_viall",
      "target": "natasha_bure"
    },
    {
      "source": "nick_viall",
      "target": "tino_franco"
    },
    {
      "source": "nick_viall",
      "target": "kit_keenan"
    },
    {
      "source": "nick_viall",
      "target": "bri_springs"
    },
    {
      "source": "nick_viall",
      "target": "harry_jowsey"
    },
    {
      "source": "nick_viall",
      "target": "scheana_shay"
    },
    {
      "source": "nick_viall",
      "target": "camille_kostek"
    },
    {
      "source": "nick_viall",
      "target": "greg_grippo"
    },
    {
      "source": "nick_viall",
      "target": "ellie_zeiler"
    },
    {
      "source": "nick_viall",
      "target": "becca_moore"
    },
    {
      "source": "nick_viall",
      "target": "cheryl_burke"
    },
    {
      "source": "nick_viall",
      "target": "achieng_agutu"
    },
    {
      "source": "nick_viall",
      "target": "hayley_hasselhoff"
    },
    {
      "source": "nick_viall",
      "target": "holly_madison"
    },
    {
      "source": "nick_viall",
      "target": "hayley_orrantia"
    },
    {
      "source": "nick_viall",
      "target": "allison_raskin"
    },
    {
      "source": "nick_viall",
      "target": "audrina_patridge"
    },
    {
      "source": "nick_viall",
      "target": "hannah_berner"
    },
    {
      "source": "nick_viall",
      "target": "nick_lehmann"
    },
    {
      "source": "nick_viall",
      "target": "morgan_absher"
    },
    {
      "source": "nick_viall",
      "target": "brian_austin_green"
    },
    {
      "source": "nick_viall",
      "target": "sharna_burgess"
    },
    {
      "source": "nick_viall",
      "target": "kaitlyn_bristowe"
    },
    {
      "source": "nick_viall",
      "target": "sophia"
    },
    {
      "source": "nick_viall",
      "target": "sistine_stallone"
    },
    {
      "source": "nick_viall",
      "target": "peta_murgatroyd"
    },
    {
      "source": "nick_viall",
      "target": "madison_watkins"
    },
    {
      "source": "nick_viall",
      "target": "josh_peck"
    },
    {
      "source": "nick_viall",
      "target": "erika_priscilla"
    },
    {
      "source": "nick_viall",
      "target": "mary_fitzgerald"
    },
    {
      "source": "nick_viall",
      "target": "darcy"
    },
    {
      "source": "nick_viall",
      "target": "clayton"
    },
    {
      "source": "nick_viall",
      "target": "susie"
    },
    {
      "source": "nick_viall",
      "target": "kail_lowry"
    },
    {
      "source": "nick_viall",
      "target": "april_marie"
    },
    {
      "source": "nick_viall",
      "target": "chloe_cherry"
    },
    {
      "source": "nick_viall",
      "target": "andrea_russett"
    },
    {
      "source": "nick_viall",
      "target": "shayne"
    },
    {
      "source": "nick_viall",
      "target": "cathy_kelly"
    },
    {
      "source": "nick_viall",
      "target": "ali_barthwell"
    },
    {
      "source": "nick_viall",
      "target": "christina_harris"
    },
    {
      "source": "nick_viall",
      "target": "ashley_greene"
    },
    {
      "source": "nick_viall",
      "target": "jim_jefferies"
    },
    {
      "source": "nick_viall",
      "target": "deepti"
    },
    {
      "source": "nick_viall",
      "target": "shaina"
    },
    {
      "source": "nick_viall",
      "target": "elyse_myers"
    },
    {
      "source": "nick_viall",
      "target": "ryan"
    },
    {
      "source": "nick_viall",
      "target": "meghan_trainor"
    },
    {
      "source": "nick_viall",
      "target": "mariel_molino"
    },
    {
      "source": "nick_viall",
      "target": "taylor_tomlinson"
    },
    {
      "source": "nick_viall",
      "target": "greg_g"
    },
    {
      "source": "nick_viall",
      "target": "andrew_s"
    },
    {
      "source": "nick_viall",
      "target": "plus_clayton"
    },
    {
      "source": "nick_viall",
      "target": "alexandra_hunt"
    },
    {
      "source": "nick_viall",
      "target": "west_elm_caleb"
    },
    {
      "source": "nick_viall",
      "target": "morgan_cohen"
    },
    {
      "source": "nick_viall",
      "target": "hello_tefi"
    },
    {
      "source": "nick_viall",
      "target": "naz_perez"
    },
    {
      "source": "nick_viall",
      "target": "ian_wallace"
    },
    {
      "source": "nick_viall",
      "target": "rod_thill"
    },
    {
      "source": "nick_viall",
      "target": "tefi_pessoa"
    },
    {
      "source": "nick_viall",
      "target": "emma_gray"
    },
    {
      "source": "nick_viall",
      "target": "charly_jordan"
    },
    {
      "source": "nick_viall",
      "target": "amanda_hirsch"
    },
    {
      "source": "nick_viall",
      "target": "michelle_young"
    },
    {
      "source": "nick_viall",
      "target": "ali"
    },
    {
      "source": "nick_viall",
      "target": "amanda"
    },
    {
      "source": "nick_viall",
      "target": "diane_strachowski"
    },
    {
      "source": "nick_viall",
      "target": "glozell_green"
    },
    {
      "source": "nick_viall",
      "target": "zuri_hall"
    },
    {
      "source": "nick_viall",
      "target": "connor_wood"
    },
    {
      "source": "nick_viall",
      "target": "tim_simons"
    },
    {
      "source": "nick_viall",
      "target": "matt_walsh"
    },
    {
      "source": "nick_viall",
      "target": "remi_bader"
    },
    {
      "source": "nick_viall",
      "target": "ivan_hall"
    },
    {
      "source": "nick_viall",
      "target": "emily_didonato"
    },
    {
      "source": "nick_viall",
      "target": "manny_gutierrez"
    },
    {
      "source": "nick_viall",
      "target": "amelie_zilber"
    },
    {
      "source": "nick_viall",
      "target": "amen"
    },
    {
      "source": "nick_viall",
      "target": "christian_long"
    },
    {
      "source": "nick_viall",
      "target": "michael_allio"
    },
    {
      "source": "nick_viall",
      "target": "tyler_merritt"
    },
    {
      "source": "nick_viall",
      "target": "matt_king"
    },
    {
      "source": "nick_viall",
      "target": "lance_bass"
    },
    {
      "source": "nick_viall",
      "target": "cnco"
    },
    {
      "source": "nick_viall",
      "target": "mina_kimes"
    },
    {
      "source": "nick_viall",
      "target": "missi_pyle"
    },
    {
      "source": "nick_viall",
      "target": "tristan_watson"
    },
    {
      "source": "nick_viall",
      "target": "steve-o"
    },
    {
      "source": "nick_viall",
      "target": "max"
    },
    {
      "source": "nick_viall",
      "target": "dominic_monaghan"
    },
    {
      "source": "nick_viall",
      "target": "billy_boyd"
    },
    {
      "source": "nick_viall",
      "target": "katie_thurston"
    },
    {
      "source": "nick_viall",
      "target": "andy_grammer"
    },
    {
      "source": "nick_viall",
      "target": "chrishell_stause"
    },
    {
      "source": "nick_viall",
      "target": "tinx"
    },
    {
      "source": "nick_viall",
      "target": "heather_mcdonald"
    },
    {
      "source": "nick_viall",
      "target": "teddi_mellencamp"
    },
    {
      "source": "nick_viall",
      "target": "brian_baumgartner"
    },
    {
      "source": "nick_viall",
      "target": "ben_folds"
    },
    {
      "source": "nick_viall",
      "target": "molly_sims"
    },
    {
      "source": "nick_viall",
      "target": "sheila_kelley"
    },
    {
      "source": "nick_viall",
      "target": "christa_allen"
    },
    {
      "source": "nick_viall",
      "target": "kelly_osbourne"
    },
    {
      "source": "nick_viall",
      "target": "jeff_beacher"
    },
    {
      "source": "nick_viall",
      "target": "logan_ury"
    },
    {
      "source": "nick_viall",
      "target": "sarah_edmondson"
    },
    {
      "source": "nick_viall",
      "target": "nippy_from_the_vow"
    },
    {
      "source": "nick_viall",
      "target": "howie_mandel"
    },
    {
      "source": "nick_viall",
      "target": "jackelyn_shultz"
    },
    {
      "source": "nick_viall",
      "target": "jenna_zoe"
    },
    {
      "source": "nick_viall",
      "target": "maria_menounos"
    },
    {
      "source": "nick_viall",
      "target": "chris_medina"
    },
    {
      "source": "nick_viall",
      "target": "natasha_parker"
    },
    {
      "source": "nick_viall",
      "target": "laura_berman"
    },
    {
      "source": "nick_viall",
      "target": "jordan_weiss"
    },
    {
      "source": "nick_viall",
      "target": "kelly_mi_li"
    },
    {
      "source": "nick_viall",
      "target": "rachael_harris"
    },
    {
      "source": "nick_viall",
      "target": "ricky_williams"
    },
    {
      "source": "nick_viall",
      "target": "lauren_zima"
    },
    {
      "source": "nick_viall",
      "target": "alexandra_solomon"
    },
    {
      "source": "nick_viall",
      "target": "cazzie_david"
    },
    {
      "source": "nick_viall",
      "target": "noah_erb"
    },
    {
      "source": "nick_viall",
      "target": "kevin_dillon"
    },
    {
      "source": "nick_viall",
      "target": "doug_ellin"
    },
    {
      "source": "nick_viall",
      "target": "raven_gates"
    },
    {
      "source": "nick_viall",
      "target": "jodi_rodgers"
    },
    {
      "source": "nick_viall",
      "target": "russell_dickerson"
    },
    {
      "source": "nick_viall",
      "target": "lala_milan"
    },
    {
      "source": "nick_viall",
      "target": "joe_park"
    },
    {
      "source": "nick_viall",
      "target": "manny_mua"
    },
    {
      "source": "nick_viall",
      "target": "kalen_allen"
    },
    {
      "source": "nick_viall",
      "target": "sharleen_joynt"
    },
    {
      "source": "nick_viall",
      "target": "ryan_haddon"
    },
    {
      "source": "nick_viall",
      "target": "rob_mills"
    },
    {
      "source": "nick_viall",
      "target": "comments_by_celebs"
    },
    {
      "source": "nick_viall",
      "target": "daisy_fuentes"
    },
    {
      "source": "nick_viall",
      "target": "richard_marx"
    },
    {
      "source": "nick_viall",
      "target": "rachel_platten"
    },
    {
      "source": "nick_viall",
      "target": "jvckj_aka_jack_j"
    },
    {
      "source": "nick_viall",
      "target": "michael_moloney"
    },
    {
      "source": "nick_viall",
      "target": "esther_povitsky"
    },
    {
      "source": "nick_viall",
      "target": "victoria_fuller"
    },
    {
      "source": "nick_viall",
      "target": "nikki_ferrell"
    },
    {
      "source": "nick_viall",
      "target": "constance_nunes"
    },
    {
      "source": "nick_viall",
      "target": "kevin_hines"
    },
    {
      "source": "nick_viall",
      "target": "garcelle_beauvais"
    },
    {
      "source": "nick_viall",
      "target": "pastor_miles_mcpherson"
    },
    {
      "source": "nick_viall",
      "target": "jonathan_bennett"
    },
    {
      "source": "nick_viall",
      "target": "ali_manno_(fedotowsky)"
    },
    {
      "source": "nick_viall",
      "target": "paul_de_gelder"
    },
    {
      "source": "nick_viall",
      "target": "tal_ben-shahar"
    },
    {
      "source": "nick_viall",
      "target": "jp_rosenbaum"
    },
    {
      "source": "nick_viall",
      "target": "chris_kattan"
    },
    {
      "source": "nick_viall",
      "target": "reality_steve"
    },
    {
      "source": "nick_viall",
      "target": "candis_cayne"
    },
    {
      "source": "nick_viall",
      "target": "trista_sutter"
    },
    {
      "source": "nick_viall",
      "target": "trent_shelton"
    },
    {
      "source": "nick_viall",
      "target": "little_big_wells"
    },
    {
      "source": "nick_viall",
      "target": "kaitlynn_carter"
    },
    {
      "source": "nick_viall",
      "target": "sarah_colonna"
    },
    {
      "source": "nick_viall",
      "target": "ben_higgins"
    },
    {
      "source": "nick_viall",
      "target": "maria_viall"
    },
    {
      "source": "nick_viall",
      "target": "jill_moran"
    },
    {
      "source": "nick_viall",
      "target": "jared_haibon"
    },
    {
      "source": "nick_viall",
      "target": "tanner_tolbert"
    },
    {
      "source": "nick_viall",
      "target": "brett_vergara"
    },
    {
      "source": "nick_viall",
      "target": "sean"
    },
    {
      "source": "nick_viall",
      "target": "catherine"
    },
    {
      "source": "nick_viall",
      "target": "joe_thomas"
    },
    {
      "source": "nick_viall",
      "target": "adam_ray"
    },
    {
      "source": "nick_viall",
      "target": "meghan_tonjes"
    },
    {
      "source": "nick_viall",
      "target": "laura_marano"
    },
    {
      "source": "nick_viall",
      "target": "raja_kumari"
    },
    {
      "source": "nick_viall",
      "target": "claudia_oshry"
    },
    {
      "source": "nick_viall",
      "target": "paul_scheer"
    },
    {
      "source": "nick_viall",
      "target": "shan_boodram"
    },
    {
      "source": "nick_viall",
      "target": "chris_harrison"
    },
    {
      "source": "nick_viall",
      "target": "ginger_zee"
    },
    {
      "source": "nick_viall",
      "target": "jason_tartick"
    },
    {
      "source": "nick_viall",
      "target": "peter_weber"
    },
    {
      "source": "nick_viall",
      "target": "penn_jillette"
    },
    {
      "source": "nick_viall",
      "target": "hannah_ann"
    },
    {
      "source": "nick_viall",
      "target": "lady_gang"
    },
    {
      "source": "nick_viall",
      "target": "drew_scott"
    },
    {
      "source": "nick_viall",
      "target": "linda_phan"
    },
    {
      "source": "tom_segura",
      "target": "ryan_sickler"
    },
    {
      "source": "tom_segura",
      "target": "jessica_kirson"
    },
    {
      "source": "tom_segura",
      "target": "stavros_halkias"
    },
    {
      "source": "tom_segura",
      "target": "steve-o"
    },
    {
      "source": "tom_segura",
      "target": "colin_quinn"
    },
    {
      "source": "tom_segura",
      "target": "sam_morril"
    },
    {
      "source": "tom_segura",
      "target": "matt_rife"
    },
    {
      "source": "tom_segura",
      "target": "cipha_sounds"
    },
    {
      "source": "tom_segura",
      "target": "andrew_huberman"
    },
    {
      "source": "tom_segura",
      "target": "cory_henry"
    },
    {
      "source": "tom_segura",
      "target": "theo_von"
    },
    {
      "source": "tom_segura",
      "target": "rob_lowe"
    },
    {
      "source": "tom_segura",
      "target": "joel_mchale"
    },
    {
      "source": "tom_segura",
      "target": "kountry_wayne"
    },
    {
      "source": "tom_segura",
      "target": "ari_shaffir"
    },
    {
      "source": "tom_segura",
      "target": "tim_dillon"
    },
    {
      "source": "tom_segura",
      "target": "ryan_blaney"
    },
    {
      "source": "tom_segura",
      "target": "kevin_smith"
    },
    {
      "source": "tom_segura",
      "target": "jim_jefferies"
    },
    {
      "source": "tom_segura",
      "target": "yannis_pappas"
    },
    {
      "source": "tom_segura",
      "target": "big_jay_oakerson"
    },
    {
      "source": "tom_segura",
      "target": "bert_kreischer"
    },
    {
      "source": "tom_segura",
      "target": "chris_distefano"
    },
    {
      "source": "tom_segura",
      "target": "adam_devine"
    },
    {
      "source": "tom_segura",
      "target": "david_cross"
    },
    {
      "source": "tom_segura",
      "target": "howie_mandel"
    },
    {
      "source": "tom_segura",
      "target": "ryan_holiday"
    },
    {
      "source": "tom_segura",
      "target": "dana_carvey"
    },
    {
      "source": "tom_segura",
      "target": "adriana_chechik"
    },
    {
      "source": "tom_segura",
      "target": "tony_hawk"
    },
    {
      "source": "tom_segura",
      "target": "louis_c.k."
    },
    {
      "source": "tom_segura",
      "target": "nosteve-o"
    },
    {
      "source": "tom_segura",
      "target": "tom_segura"
    },
    {
      "source": "tom_segura",
      "target": "andrew_santino"
    },
    {
      "source": "tom_segura",
      "target": "drew"
    },
    {
      "source": "tom_segura",
      "target": "whitney_cummings"
    },
    {
      "source": "tom_segura",
      "target": "christina_p"
    },
    {
      "source": "tom_segura",
      "target": "bert_kreischer"
    },
    {
      "source": "ryan_sickler",
      "target": "bert_kreischer"
    },
    {
      "source": "ryan_sickler",
      "target": "mark_normand"
    },
    {
      "source": "ryan_sickler",
      "target": "tom_segura"
    },
    {
      "source": "ryan_sickler",
      "target": "ryan_sickler"
    },
    {
      "source": "jordan_b._peterson",
      "target": "scott_mcmahon"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ritchie_shoemaker"
    },
    {
      "source": "jordan_b._peterson",
      "target": "john_vervaeke"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jack_barsky"
    },
    {
      "source": "jordan_b._peterson",
      "target": "laurence_fox"
    },
    {
      "source": "jordan_b._peterson",
      "target": "terrence_keeley"
    },
    {
      "source": "jordan_b._peterson",
      "target": "adeel_khan"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jordan_peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "sam_harris"
    },
    {
      "source": "jordan_b._peterson",
      "target": "michael_malice"
    },
    {
      "source": "jordan_b._peterson",
      "target": "brett_johnson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "aaron_stark"
    },
    {
      "source": "jordan_b._peterson",
      "target": "niall_ferguson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "sarah_hill"
    },
    {
      "source": "jordan_b._peterson",
      "target": "matt_rife"
    },
    {
      "source": "jordan_b._peterson",
      "target": "saeed_al_nazari"
    },
    {
      "source": "jordan_b._peterson",
      "target": "josh"
    },
    {
      "source": "jordan_b._peterson",
      "target": "nick_alexander"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ambassador_robert_o'brien"
    },
    {
      "source": "jordan_b._peterson",
      "target": "kevin_roberts"
    },
    {
      "source": "jordan_b._peterson",
      "target": "frank_stronach"
    },
    {
      "source": "jordan_b._peterson",
      "target": "adam_smith"
    },
    {
      "source": "jordan_b._peterson",
      "target": "john_lennox"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tony_abbott"
    },
    {
      "source": "jordan_b._peterson",
      "target": "matt_taibbi"
    },
    {
      "source": "jordan_b._peterson",
      "target": "glenn_greenwald"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_sapolsky"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jeremy_boreing"
    },
    {
      "source": "jordan_b._peterson",
      "target": "greg_lukianoff"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rikki_schlott"
    },
    {
      "source": "jordan_b._peterson",
      "target": "donald_hoffman"
    },
    {
      "source": "jordan_b._peterson",
      "target": "miranda_devine"
    },
    {
      "source": "jordan_b._peterson",
      "target": "willie"
    },
    {
      "source": "jordan_b._peterson",
      "target": "korie_robertson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "peter_arcidiacono"
    },
    {
      "source": "jordan_b._peterson",
      "target": "chris_christie"
    },
    {
      "source": "jordan_b._peterson",
      "target": "oliver_anthony"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ellen_langer"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jbp_reacts_to_court_decision"
    },
    {
      "source": "jordan_b._peterson",
      "target": "vivek_ramaswamy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "helen_joyce"
    },
    {
      "source": "jordan_b._peterson",
      "target": "gad_saad"
    },
    {
      "source": "jordan_b._peterson",
      "target": "douglas_murray"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_bryce"
    },
    {
      "source": "jordan_b._peterson",
      "target": "eric_edmeades"
    },
    {
      "source": "jordan_b._peterson",
      "target": "andrew_doyle"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jim_caviezel"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tim_ballard"
    },
    {
      "source": "jordan_b._peterson",
      "target": "eric_metaxas"
    },
    {
      "source": "jordan_b._peterson",
      "target": "zach_lahn"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tamara_lich"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tammy_peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mike_pence"
    },
    {
      "source": "jordan_b._peterson",
      "target": "james_lindsay"
    },
    {
      "source": "jordan_b._peterson",
      "target": "steve_templeton"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jonathan_pageau"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_f._kennedy_jr."
    },
    {
      "source": "jordan_b._peterson",
      "target": "matt_walsh"
    },
    {
      "source": "jordan_b._peterson",
      "target": "senator_josh_hawley"
    },
    {
      "source": "jordan_b._peterson",
      "target": "peter_attia"
    },
    {
      "source": "jordan_b._peterson",
      "target": "nigel_biggar"
    },
    {
      "source": "jordan_b._peterson",
      "target": "anthony_furey"
    },
    {
      "source": "jordan_b._peterson",
      "target": "brian_roemmele"
    },
    {
      "source": "jordan_b._peterson",
      "target": "riley_gaines"
    },
    {
      "source": "jordan_b._peterson",
      "target": "karol_markowicz"
    },
    {
      "source": "jordan_b._peterson",
      "target": "david_zweig"
    },
    {
      "source": "jordan_b._peterson",
      "target": "peter_schiff"
    },
    {
      "source": "jordan_b._peterson",
      "target": "joe_hage"
    },
    {
      "source": "jordan_b._peterson",
      "target": "naomi_wolf"
    },
    {
      "source": "jordan_b._peterson",
      "target": "heather_mac_donald"
    },
    {
      "source": "jordan_b._peterson",
      "target": "scott_jensen"
    },
    {
      "source": "jordan_b._peterson",
      "target": "brian_keating"
    },
    {
      "source": "jordan_b._peterson",
      "target": "miriam_grossman_md"
    },
    {
      "source": "jordan_b._peterson",
      "target": "senator_mike_lee"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bj\u00f8rn_lomborg"
    },
    {
      "source": "jordan_b._peterson",
      "target": "derek_kreifels"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rafe_kelley"
    },
    {
      "source": "jordan_b._peterson",
      "target": "sara_stockton"
    },
    {
      "source": "jordan_b._peterson",
      "target": "michael_yon"
    },
    {
      "source": "jordan_b._peterson",
      "target": "eva_vlaardingerbroek"
    },
    {
      "source": "jordan_b._peterson",
      "target": "stephen_j_shaw"
    },
    {
      "source": "jordan_b._peterson",
      "target": "maajid_nawaz"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jeff_sandefer"
    },
    {
      "source": "jordan_b._peterson",
      "target": "christopher_rufo"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jayanta_bhattacharya"
    },
    {
      "source": "jordan_b._peterson",
      "target": "konstantin_kisin"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tulsi_gabbard"
    },
    {
      "source": "jordan_b._peterson",
      "target": "louise_perry"
    },
    {
      "source": "jordan_b._peterson",
      "target": "roy_sebag"
    },
    {
      "source": "jordan_b._peterson",
      "target": "judith_curry"
    },
    {
      "source": "jordan_b._peterson",
      "target": "daniel_higgins"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_o._pihl"
    },
    {
      "source": "jordan_b._peterson",
      "target": "del_paulhus"
    },
    {
      "source": "jordan_b._peterson",
      "target": "walter_russell_mead"
    },
    {
      "source": "jordan_b._peterson",
      "target": "victor_davis_hanson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "masih_alinejad"
    },
    {
      "source": "jordan_b._peterson",
      "target": "steven_koonin"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mikhaila_peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "richard_lindzen"
    },
    {
      "source": "jordan_b._peterson",
      "target": "chloe_cole"
    },
    {
      "source": "jordan_b._peterson",
      "target": "temple_grandin"
    },
    {
      "source": "jordan_b._peterson",
      "target": "amala_ekpunobi"
    },
    {
      "source": "jordan_b._peterson",
      "target": "stephanie_davies-arai"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bj\u00f8rn_lomborg"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robin_carhart-harris"
    },
    {
      "source": "jordan_b._peterson",
      "target": "john_anderson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "alex_epstein"
    },
    {
      "source": "jordan_b._peterson",
      "target": "pm-elect_benjamin_netanyahu"
    },
    {
      "source": "jordan_b._peterson",
      "target": "matt_ridley"
    },
    {
      "source": "jordan_b._peterson",
      "target": "congressman_mike_johnson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jim_keller"
    },
    {
      "source": "jordan_b._peterson",
      "target": "john_delony"
    },
    {
      "source": "jordan_b._peterson",
      "target": "danielle_smith"
    },
    {
      "source": "jordan_b._peterson",
      "target": "yoram_hazony"
    },
    {
      "source": "jordan_b._peterson",
      "target": "andrew_schulz"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jean_twenge"
    },
    {
      "source": "jordan_b._peterson",
      "target": "michael_franzese"
    },
    {
      "source": "jordan_b._peterson",
      "target": "newt_gingrich"
    },
    {
      "source": "jordan_b._peterson",
      "target": "dennis_mckenna"
    },
    {
      "source": "jordan_b._peterson",
      "target": "karl_friston"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mohammad_hijab"
    },
    {
      "source": "jordan_b._peterson",
      "target": "andrew_huberman"
    },
    {
      "source": "jordan_b._peterson",
      "target": "piers_morgan"
    },
    {
      "source": "jordan_b._peterson",
      "target": "alex_story"
    },
    {
      "source": "jordan_b._peterson",
      "target": "stella_assange"
    },
    {
      "source": "jordan_b._peterson",
      "target": "matthieu_pageau"
    },
    {
      "source": "jordan_b._peterson",
      "target": "peter_kreeft"
    },
    {
      "source": "jordan_b._peterson",
      "target": "eric_duhaime"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ron_dermer"
    },
    {
      "source": "jordan_b._peterson",
      "target": "dan_crenshaw"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ralph_schoellhammer"
    },
    {
      "source": "jordan_b._peterson",
      "target": "marian_tupy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "gale_pooley"
    },
    {
      "source": "jordan_b._peterson",
      "target": "leslyn_lewis"
    },
    {
      "source": "jordan_b._peterson",
      "target": "pageau"
    },
    {
      "source": "jordan_b._peterson",
      "target": "hurwitz"
    },
    {
      "source": "jordan_b._peterson",
      "target": "david_friedman"
    },
    {
      "source": "jordan_b._peterson",
      "target": "iain_mcgilchrist"
    },
    {
      "source": "jordan_b._peterson",
      "target": "vervaeke"
    },
    {
      "source": "jordan_b._peterson",
      "target": "larry_p._arnn"
    },
    {
      "source": "jordan_b._peterson",
      "target": "roman_baber"
    },
    {
      "source": "jordan_b._peterson",
      "target": "magatte_wade"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_trivers"
    },
    {
      "source": "jordan_b._peterson",
      "target": "frans_de_waal"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rod_dreher"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rex_murphy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "dave_rubin"
    },
    {
      "source": "jordan_b._peterson",
      "target": "adrian_wooldridge"
    },
    {
      "source": "jordan_b._peterson",
      "target": "walter_peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "warren_farrell"
    },
    {
      "source": "jordan_b._peterson",
      "target": "julian_peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "vishal_mangalwadi"
    },
    {
      "source": "jordan_b._peterson",
      "target": "richard_dawkins"
    },
    {
      "source": "jordan_b._peterson",
      "target": "hamza_yusuf"
    },
    {
      "source": "jordan_b._peterson",
      "target": "pierre_poilievre"
    },
    {
      "source": "jordan_b._peterson",
      "target": "franciscan_university"
    },
    {
      "source": "jordan_b._peterson",
      "target": "richard_wrangham"
    },
    {
      "source": "jordan_b._peterson",
      "target": "glenn_loury"
    },
    {
      "source": "jordan_b._peterson",
      "target": "roger_penrose"
    },
    {
      "source": "jordan_b._peterson",
      "target": "claire_lehmann"
    },
    {
      "source": "jordan_b._peterson",
      "target": "cambridge"
    },
    {
      "source": "jordan_b._peterson",
      "target": "john_mcwhorter"
    },
    {
      "source": "jordan_b._peterson",
      "target": "andy_ngo"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_greene"
    },
    {
      "source": "jordan_b._peterson",
      "target": "david_buss"
    },
    {
      "source": "jordan_b._peterson",
      "target": "pardy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "haskell"
    },
    {
      "source": "jordan_b._peterson",
      "target": "kay"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jimmy_carr"
    },
    {
      "source": "jordan_b._peterson",
      "target": "frederick_kagan"
    },
    {
      "source": "jordan_b._peterson",
      "target": "curt_jaimungal"
    },
    {
      "source": "jordan_b._peterson",
      "target": "greg_ellis"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jordan"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tammy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rav_arora"
    },
    {
      "source": "jordan_b._peterson",
      "target": "charles_joseph"
    },
    {
      "source": "jordan_b._peterson",
      "target": "norman_doidge"
    },
    {
      "source": "jordan_b._peterson",
      "target": "brian_peckford"
    },
    {
      "source": "jordan_b._peterson",
      "target": "chlo\u00e9_valdary"
    },
    {
      "source": "jordan_b._peterson",
      "target": "james_orr"
    },
    {
      "source": "jordan_b._peterson",
      "target": "arif_ahmed"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mikhail_avdeev"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bret_weinstein"
    },
    {
      "source": "jordan_b._peterson",
      "target": "heather_heying"
    },
    {
      "source": "jordan_b._peterson",
      "target": "word_on_fire"
    },
    {
      "source": "jordan_b._peterson",
      "target": "preston_manning"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mohammed_hijab"
    },
    {
      "source": "jordan_b._peterson",
      "target": "gregg_hurwitz"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rick_geddes"
    },
    {
      "source": "jordan_b._peterson",
      "target": "angus_fletcher"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bishop_barron"
    },
    {
      "source": "jordan_b._peterson",
      "target": "and_jonathan_pageau"
    },
    {
      "source": "jordan_b._peterson",
      "target": "saifedean_ammous"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mustafa_akyol"
    },
    {
      "source": "jordan_b._peterson",
      "target": "clay_routledge"
    },
    {
      "source": "jordan_b._peterson",
      "target": "steven_pinker"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jonathan_haidt"
    },
    {
      "source": "jordan_b._peterson",
      "target": "michael_shellenberger"
    },
    {
      "source": "jordan_b._peterson",
      "target": "mohamedou_ould_slahi"
    },
    {
      "source": "jordan_b._peterson",
      "target": "rob_henderson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "maxime_bernier"
    },
    {
      "source": "jordan_b._peterson",
      "target": "prager"
    },
    {
      "source": "jordan_b._peterson",
      "target": "carolla"
    },
    {
      "source": "jordan_b._peterson",
      "target": "robert_murphy"
    },
    {
      "source": "jordan_b._peterson",
      "target": "stephen_blackwood"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jordan_b._peterson"
    },
    {
      "source": "jordan_b._peterson",
      "target": "randy_thornhill"
    },
    {
      "source": "jordan_b._peterson",
      "target": "brian_muraresku"
    },
    {
      "source": "jordan_b._peterson",
      "target": "prof._carl_ruck"
    },
    {
      "source": "jordan_b._peterson",
      "target": "lawrence_krauss"
    },
    {
      "source": "jordan_b._peterson",
      "target": "lord_conrad_black"
    },
    {
      "source": "jordan_b._peterson",
      "target": "samuel_andreyev"
    },
    {
      "source": "jordan_b._peterson",
      "target": "scott_barry_kaufman"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bari_weiss"
    },
    {
      "source": "jordan_b._peterson",
      "target": "dr_rima_azar"
    },
    {
      "source": "jordan_b._peterson",
      "target": "yeonmi_park"
    },
    {
      "source": "jordan_b._peterson",
      "target": "richard_tremblay"
    },
    {
      "source": "jordan_b._peterson",
      "target": "theodore_dalrymple"
    },
    {
      "source": "jordan_b._peterson",
      "target": "anthony_daniels"
    },
    {
      "source": "jordan_b._peterson",
      "target": "stephen_fry"
    },
    {
      "source": "jordan_b._peterson",
      "target": "roland_griffiths"
    },
    {
      "source": "jordan_b._peterson",
      "target": "randall_wallace"
    },
    {
      "source": "jordan_b._peterson",
      "target": "paul_rossi"
    },
    {
      "source": "jordan_b._peterson",
      "target": "bjorn_lomborg"
    },
    {
      "source": "jordan_b._peterson",
      "target": "jocko_willink"
    },
    {
      "source": "jordan_b._peterson",
      "target": "abigail_shrier"
    },
    {
      "source": "jordan_b._peterson",
      "target": "ayaan_hirsi_ali"
    },
    {
      "source": "jordan_b._peterson",
      "target": "matthew_mcconaughey"
    },
    {
      "source": "jordan_b._peterson",
      "target": "chris_voss"
    },
    {
      "source": "jordan_b._peterson",
      "target": "wim_hof"
    },
    {
      "source": "jordan_b._peterson",
      "target": "coleman_hughes"
    },
    {
      "source": "jordan_b._peterson",
      "target": "tom_amarque"
    },
    {
      "source": "jordan_b._peterson",
      "target": "james_w_pennebaker"
    },
    {
      "source": "ben_shapiro",
      "target": "naftali_bennett"
    },
    {
      "source": "ben_shapiro",
      "target": "ted_cruz"
    },
    {
      "source": "ben_shapiro",
      "target": "thomas_sowell"
    },
    {
      "source": "ben_shapiro",
      "target": "rudy_rochman"
    },
    {
      "source": "ben_shapiro",
      "target": "doug_brunt"
    },
    {
      "source": "ben_shapiro",
      "target": "patrick_bet-david"
    },
    {
      "source": "ben_shapiro",
      "target": "chris_rufo"
    },
    {
      "source": "ben_shapiro",
      "target": "voddie_baucham"
    },
    {
      "source": "ben_shapiro",
      "target": "jocko_willink"
    },
    {
      "source": "ben_shapiro",
      "target": "gov._ron_desantis"
    },
    {
      "source": "ben_shapiro",
      "target": "andrew_klavan"
    },
    {
      "source": "ben_shapiro",
      "target": "glenn_greenwald"
    },
    {
      "source": "ben_shapiro",
      "target": "megyn_kelly"
    },
    {
      "source": "ben_shapiro",
      "target": "nick_rolovich"
    },
    {
      "source": "ben_shapiro",
      "target": "jair_bolsonaro"
    },
    {
      "source": "ben_shapiro",
      "target": "seth_dillon"
    },
    {
      "source": "ben_shapiro",
      "target": "benjamin_netanyahu"
    },
    {
      "source": "ben_shapiro",
      "target": "yoram_hazony"
    },
    {
      "source": "ben_shapiro",
      "target": "robert_kiyosaki"
    },
    {
      "source": "ben_shapiro",
      "target": "shapiro"
    },
    {
      "source": "ben_shapiro",
      "target": "peterson"
    },
    {
      "source": "ben_shapiro",
      "target": "matt_taibbi"
    },
    {
      "source": "ben_shapiro",
      "target": "jonathan_isaac"
    },
    {
      "source": "ben_shapiro",
      "target": "william_barr"
    },
    {
      "source": "ben_shapiro",
      "target": "bill_maher"
    },
    {
      "source": "ben_shapiro",
      "target": "avichal_garg"
    },
    {
      "source": "ben_shapiro",
      "target": "dave_ramsey"
    },
    {
      "source": "ben_shapiro",
      "target": "ron_desantis"
    },
    {
      "source": "ben_shapiro",
      "target": "eric_schmidt"
    },
    {
      "source": "ben_shapiro",
      "target": "bari_weiss"
    },
    {
      "source": "ben_shapiro",
      "target": "bret_weinstein"
    },
    {
      "source": "ben_shapiro",
      "target": "heather_heying"
    },
    {
      "source": "ben_shapiro",
      "target": "condoleezza_rice"
    },
    {
      "source": "ben_shapiro",
      "target": "russell_brand"
    },
    {
      "source": "ben_shapiro",
      "target": "david_horowitz"
    },
    {
      "source": "ben_shapiro",
      "target": "jordan_peterson"
    },
    {
      "source": "ben_shapiro",
      "target": "dave_portnoy"
    },
    {
      "source": "ben_shapiro",
      "target": "ben_shapiro"
    },
    {
      "source": "ben_shapiro",
      "target": "candace_owens"
    },
    {
      "source": "ben_shapiro",
      "target": "ayaan_hirsi_ali"
    },
    {
      "source": "ben_shapiro",
      "target": "dallas_sonnier"
    },
    {
      "source": "ben_shapiro",
      "target": "j.d._vance"
    },
    {
      "source": "ben_shapiro",
      "target": "abigail_shrier"
    },
    {
      "source": "ben_shapiro",
      "target": "tim_pool"
    },
    {
      "source": "ben_shapiro",
      "target": "victor_davis_hanson"
    },
    {
      "source": "ben_shapiro",
      "target": "shelby_steele"
    },
    {
      "source": "ben_shapiro",
      "target": "jared_kushner"
    },
    {
      "source": "ben_shapiro",
      "target": "jeremy_boreing"
    },
    {
      "source": "ben_shapiro",
      "target": "jon_voight"
    },
    {
      "source": "ben_shapiro",
      "target": "sarah_huckabee_sanders"
    },
    {
      "source": "ben_shapiro",
      "target": "joe_rogan"
    },
    {
      "source": "ben_shapiro",
      "target": "ravi_zacharias"
    },
    {
      "source": "ben_shapiro",
      "target": "michael_shermer"
    },
    {
      "source": "ben_shapiro",
      "target": "william_lane_craig"
    },
    {
      "source": "ben_shapiro",
      "target": "dave_rubin"
    },
    {
      "source": "ben_shapiro",
      "target": "franklin_graham"
    },
    {
      "source": "ben_shapiro",
      "target": "jason_blum"
    },
    {
      "source": "ben_shapiro",
      "target": "ezra_klein"
    },
    {
      "source": "ben_shapiro",
      "target": "alan_dershowitz"
    },
    {
      "source": "ben_shapiro",
      "target": "charlie_kirk"
    },
    {
      "source": "ben_shapiro",
      "target": "gloria_allred"
    },
    {
      "source": "ben_shapiro",
      "target": "kirk_cameron"
    },
    {
      "source": "ben_shapiro",
      "target": "frank_luntz"
    },
    {
      "source": "ben_shapiro",
      "target": "lila_rose"
    },
    {
      "source": "ben_shapiro",
      "target": "david_berlinski"
    },
    {
      "source": "ben_shapiro",
      "target": "rich_lowry"
    },
    {
      "source": "ben_shapiro",
      "target": "george_will"
    },
    {
      "source": "ben_shapiro",
      "target": "peter_robinson"
    },
    {
      "source": "ben_shapiro",
      "target": "preet_bharara"
    },
    {
      "source": "ben_shapiro",
      "target": "dana_perino"
    },
    {
      "source": "ben_shapiro",
      "target": "neil_degrasse_tyson"
    },
    {
      "source": "ben_shapiro",
      "target": "meghan_mccain"
    },
    {
      "source": "ben_shapiro",
      "target": "ramesh_ponnuru"
    },
    {
      "source": "ben_shapiro",
      "target": "kennedy"
    },
    {
      "source": "ben_shapiro",
      "target": "zuby"
    },
    {
      "source": "ben_shapiro",
      "target": "brian_keating"
    },
    {
      "source": "ben_shapiro",
      "target": "liz_wheeler"
    },
    {
      "source": "ben_shapiro",
      "target": "yaron_brook"
    },
    {
      "source": "ben_shapiro",
      "target": "piers_morgan"
    },
    {
      "source": "ben_shapiro",
      "target": "jonathan_safran_foer"
    },
    {
      "source": "ben_shapiro",
      "target": "michael_knowles"
    },
    {
      "source": "ben_shapiro",
      "target": "bret_easton_ellis"
    },
    {
      "source": "ben_shapiro",
      "target": "daniel_hannan"
    },
    {
      "source": "ben_shapiro",
      "target": "shannon_bream"
    },
    {
      "source": "ben_shapiro",
      "target": "david_barton"
    },
    {
      "source": "ben_shapiro",
      "target": "mark_levin"
    },
    {
      "source": "ben_shapiro",
      "target": "larry_wilmore"
    },
    {
      "source": "ben_shapiro",
      "target": "newt_gingrich"
    },
    {
      "source": "ben_shapiro",
      "target": "carly_fiorina"
    },
    {
      "source": "ben_shapiro",
      "target": "nikki_haley"
    },
    {
      "source": "ben_shapiro",
      "target": "allie_stuckey"
    },
    {
      "source": "ben_shapiro",
      "target": "dennis_miller"
    },
    {
      "source": "ben_shapiro",
      "target": "lauren_chen"
    },
    {
      "source": "ben_shapiro",
      "target": "andrew_yang"
    },
    {
      "source": "ben_shapiro",
      "target": "matt_walsh"
    },
    {
      "source": "ben_shapiro",
      "target": "stephen_c._meyer"
    },
    {
      "source": "ben_shapiro",
      "target": "phil_mcgraw"
    },
    {
      "source": "ben_shapiro",
      "target": "arthur_brooks"
    },
    {
      "source": "ben_shapiro",
      "target": "rep._dan_crenshaw"
    },
    {
      "source": "ben_shapiro",
      "target": "larry_elder"
    },
    {
      "source": "ben_shapiro",
      "target": "daniel_krauthammer"
    },
    {
      "source": "ben_shapiro",
      "target": "gary_sinise"
    },
    {
      "source": "ben_shapiro",
      "target": "lewis_howes"
    },
    {
      "source": "ben_shapiro",
      "target": "allen_west"
    },
    {
      "source": "ben_shapiro",
      "target": "heather_mac_donald"
    },
    {
      "source": "ben_shapiro",
      "target": "general_stanley_mcchrystal"
    },
    {
      "source": "ben_shapiro",
      "target": "bishop_robert_barron"
    },
    {
      "source": "ben_shapiro",
      "target": "david_limbaugh"
    },
    {
      "source": "ben_shapiro",
      "target": "pastor_john_macarthur"
    },
    {
      "source": "ben_shapiro",
      "target": "stephen_harper"
    },
    {
      "source": "ben_shapiro",
      "target": "john_stossel"
    },
    {
      "source": "ben_shapiro",
      "target": "tucker_carlson"
    },
    {
      "source": "ben_shapiro",
      "target": "scott_adams"
    },
    {
      "source": "ben_shapiro",
      "target": "jonathan_haidt"
    },
    {
      "source": "ben_shapiro",
      "target": "cameron_kasky"
    },
    {
      "source": "ben_shapiro",
      "target": "glenn_beck"
    },
    {
      "source": "ben_shapiro",
      "target": "steven_crowder"
    },
    {
      "source": "ben_shapiro",
      "target": "christina_hoff_sommers"
    },
    {
      "source": "ben_shapiro",
      "target": "edward_feser"
    },
    {
      "source": "ben_shapiro",
      "target": "clay_travis"
    },
    {
      "source": "ben_shapiro",
      "target": "greg_gutfeld"
    },
    {
      "source": "ben_shapiro",
      "target": "tai_lopez"
    },
    {
      "source": "ben_shapiro",
      "target": "david_mamet"
    },
    {
      "source": "ben_shapiro",
      "target": "mike_rowe"
    },
    {
      "source": "ben_shapiro",
      "target": "eric_weinstein"
    },
    {
      "source": "ben_shapiro",
      "target": "dennis_prager"
    },
    {
      "source": "ben_shapiro",
      "target": "sam_harris"
    },
    {
      "source": "ben_shapiro",
      "target": "adam_carolla"
    },
    {
      "source": "ben_shapiro",
      "target": "jason_whitlock"
    },
    {
      "source": "ben_shapiro",
      "target": "jonah_goldberg"
    },
    {
      "source": "ben_shapiro",
      "target": "drew_pinsky"
    },
    {
      "source": "ben_shapiro",
      "target": "jordan_b_peterson"
    },
    {
      "source": "jeremy_corbell",
      "target": "chris_chatman"
    },
    {
      "source": "jeremy_corbell",
      "target": "richard_dolan"
    },
    {
      "source": "jeremy_corbell",
      "target": "john_b._alexander"
    },
    {
      "source": "jeremy_corbell",
      "target": "chris_sharp"
    },
    {
      "source": "jeremy_corbell",
      "target": "col._phillip_corso"
    },
    {
      "source": "jeremy_corbell",
      "target": "joe_murgia"
    },
    {
      "source": "jeremy_corbell",
      "target": "rep._tim_burchett"
    },
    {
      "source": "jeremy_corbell",
      "target": "lacatski"
    },
    {
      "source": "jeremy_corbell",
      "target": "james_lacatski"
    },
    {
      "source": "jeremy_corbell",
      "target": "colm_kelleher"
    },
    {
      "source": "jeremy_corbell",
      "target": "chris_ramsay"
    },
    {
      "source": "jeremy_corbell",
      "target": "jules_urbach"
    },
    {
      "source": "jeremy_corbell",
      "target": "john_lear"
    },
    {
      "source": "jeremy_corbell",
      "target": "wayne_pacelle"
    },
    {
      "source": "jeremy_corbell",
      "target": "ross_coulthart"
    },
    {
      "source": "jeremy_corbell",
      "target": "bryce_zabel"
    },
    {
      "source": "jeremy_corbell",
      "target": "cdr_chad_underwood"
    },
    {
      "source": "jeremy_corbell",
      "target": "whitley_strieber"
    },
    {
      "source": "jeremy_corbell",
      "target": "david_grusch"
    },
    {
      "source": "jeremy_corbell",
      "target": "ben_schneider"
    },
    {
      "source": "jeremy_corbell",
      "target": "dave_foley"
    },
    {
      "source": "jeremy_corbell",
      "target": "john_long"
    },
    {
      "source": "jeremy_corbell",
      "target": "duncan_trussell"
    },
    {
      "source": "jeremy_corbell",
      "target": "john_jay_stratton"
    },
    {
      "source": "jeremy_corbell",
      "target": "john_gutierrez"
    },
    {
      "source": "jeremy_corbell",
      "target": "jeremy_corbell"
    },
    {
      "source": "jeremy_corbell",
      "target": "george_knapp"
    }
  ]
}

function App() {
  return (
    <div className="App">
        <ForceGraph3D
          graphData={myData}
          nodeAutoColorBy={d => d.color02}
          linkDirectionalArrowLength={3.5}
/*           linkDirectionalArrowRelPos={1}
          nodeThreeObject={node => {
            const sprite = new SpriteText(node.name);
            sprite.textHeight = 8;
            sprite.backgroundColor = node.color02;
            return sprite;
          }} */
        />
    </div>
  );
}

export default App;
